// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../bos/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../bos/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../bos/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%278%27 height=%278%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%2328a745%27 d=%27M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%274%27 height=%275%27 viewBox=%270 0 4 5%27%3e%3cpath fill=%27%23343a40%27 d=%27M2 0L0 2h4zm0 5L0 3h4z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%23dc3545%27 viewBox=%270 0 12 12%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath stroke-linejoin=%27round%27 d=%27M5.8 3.6h.4L6 6.5z%27/%3e%3ccircle cx=%276%27 cy=%278.2%27 r=%27.6%27 fill=%27%23dc3545%27 stroke=%27none%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%278%27 height=%278%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%23fff%27 d=%27M6.564.75l-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%274%27 height=%274%27 viewBox=%270 0 4 4%27%3e%3cpath stroke=%27%23fff%27 d=%27M0 2h4%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2730%27 height=%2730%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%280, 0, 0, 0.5%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2730%27 height=%2730%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%28255, 255, 255, 0.5%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27%23fff%27 width=%278%27 height=%278%27 viewBox=%270 0 8 8%27%3e%3cpath d=%27M5.25 0l-4 4 4 4 1.5-1.5L4.25 4l2.5-2.5L5.25 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27%23fff%27 width=%278%27 height=%278%27 viewBox=%270 0 8 8%27%3e%3cpath d=%27M2.75 0l-1.5 1.5L3.75 4l-2.5 2.5L2.75 8l4-4-4-4z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
:where(#widgetEditorDialog) {
  /*!
   * Bootstrap v4.6.2 (https://getbootstrap.com/)
   * Copyright 2011-2022 The Bootstrap Authors
   * Copyright 2011-2022 Twitter, Inc.
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   */
}
:where(#widgetEditorDialog) :root {
  --blue: #007bff;
  --indigo: #6610f2;
  --purple: #6f42c1;
  --pink: #e83e8c;
  --red: #dc3545;
  --orange: #fd7e14;
  --yellow: #ffc107;
  --green: #28a745;
  --teal: #20c997;
  --cyan: #17a2b8;
  --white: #fff;
  --gray: #6c757d;
  --gray-dark: #343a40;
  --primary: #007bff;
  --secondary: #6c757d;
  --success: #28a745;
  --info: #17a2b8;
  --warning: #ffc107;
  --danger: #dc3545;
  --light: #f8f9fa;
  --dark: #343a40;
  --breakpoint-xs: 0;
  --breakpoint-sm: 576px;
  --breakpoint-md: 768px;
  --breakpoint-lg: 992px;
  --breakpoint-xl: 1200px;
  --font-family-sans-serif: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", "Liberation Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  --font-family-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}
:where(#widgetEditorDialog) *,
:where(#widgetEditorDialog) *::before,
:where(#widgetEditorDialog) *::after {
  box-sizing: border-box;
}
:where(#widgetEditorDialog) html {
  font-family: sans-serif;
  line-height: 1.15;
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
:where(#widgetEditorDialog) article, :where(#widgetEditorDialog) aside, :where(#widgetEditorDialog) figcaption, :where(#widgetEditorDialog) figure, :where(#widgetEditorDialog) footer, :where(#widgetEditorDialog) header, :where(#widgetEditorDialog) hgroup, :where(#widgetEditorDialog) main, :where(#widgetEditorDialog) nav, :where(#widgetEditorDialog) section {
  display: block;
}
:where(#widgetEditorDialog) body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", "Liberation Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  text-align: left;
  background-color: #fff;
}
:where(#widgetEditorDialog) [tabindex="-1"]:focus:not(:focus-visible) {
  outline: 0 !important;
}
:where(#widgetEditorDialog) hr {
  box-sizing: content-box;
  height: 0;
  overflow: visible;
}
:where(#widgetEditorDialog) h1, :where(#widgetEditorDialog) h2, :where(#widgetEditorDialog) h3, :where(#widgetEditorDialog) h4, :where(#widgetEditorDialog) h5, :where(#widgetEditorDialog) h6 {
  margin-top: 0;
  margin-bottom: 0.5rem;
}
:where(#widgetEditorDialog) p {
  margin-top: 0;
  margin-bottom: 1rem;
}
:where(#widgetEditorDialog) abbr[title],
:where(#widgetEditorDialog) abbr[data-original-title] {
  text-decoration: underline;
  text-decoration: underline dotted;
  cursor: help;
  border-bottom: 0;
  text-decoration-skip-ink: none;
}
:where(#widgetEditorDialog) address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit;
}
:where(#widgetEditorDialog) ol,
:where(#widgetEditorDialog) ul,
:where(#widgetEditorDialog) dl {
  margin-top: 0;
  margin-bottom: 1rem;
}
:where(#widgetEditorDialog) ol ol,
:where(#widgetEditorDialog) ul ul,
:where(#widgetEditorDialog) ol ul,
:where(#widgetEditorDialog) ul ol {
  margin-bottom: 0;
}
:where(#widgetEditorDialog) dt {
  font-weight: 700;
}
:where(#widgetEditorDialog) dd {
  margin-bottom: 0.5rem;
  margin-left: 0;
}
:where(#widgetEditorDialog) blockquote {
  margin: 0 0 1rem;
}
:where(#widgetEditorDialog) b,
:where(#widgetEditorDialog) strong {
  font-weight: bolder;
}
:where(#widgetEditorDialog) small {
  font-size: 80%;
}
:where(#widgetEditorDialog) sub,
:where(#widgetEditorDialog) sup {
  position: relative;
  font-size: 75%;
  line-height: 0;
  vertical-align: baseline;
}
:where(#widgetEditorDialog) sub {
  bottom: -0.25em;
}
:where(#widgetEditorDialog) sup {
  top: -0.5em;
}
:where(#widgetEditorDialog) a {
  color: #007bff;
  text-decoration: none;
  background-color: transparent;
}
:where(#widgetEditorDialog) a:hover {
  color: rgb(0%, 33.7647058824%, 70%);
  text-decoration: underline;
}
:where(#widgetEditorDialog) a:not([href]):not([class]) {
  color: inherit;
  text-decoration: none;
}
:where(#widgetEditorDialog) a:not([href]):not([class]):hover {
  color: inherit;
  text-decoration: none;
}
:where(#widgetEditorDialog) pre,
:where(#widgetEditorDialog) code,
:where(#widgetEditorDialog) kbd,
:where(#widgetEditorDialog) samp {
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  font-size: 1em;
}
:where(#widgetEditorDialog) pre {
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  -ms-overflow-style: scrollbar;
}
:where(#widgetEditorDialog) figure {
  margin: 0 0 1rem;
}
:where(#widgetEditorDialog) img {
  vertical-align: middle;
  border-style: none;
}
:where(#widgetEditorDialog) svg {
  overflow: hidden;
  vertical-align: middle;
}
:where(#widgetEditorDialog) table {
  border-collapse: collapse;
}
:where(#widgetEditorDialog) caption {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  color: #6c757d;
  text-align: left;
  caption-side: bottom;
}
:where(#widgetEditorDialog) th {
  text-align: inherit;
  text-align: -webkit-match-parent;
}
:where(#widgetEditorDialog) label {
  display: inline-block;
  margin-bottom: 0.5rem;
}
:where(#widgetEditorDialog) button {
  border-radius: 0;
}
:where(#widgetEditorDialog) button:focus:not(:focus-visible) {
  outline: 0;
}
:where(#widgetEditorDialog) input,
:where(#widgetEditorDialog) button,
:where(#widgetEditorDialog) select,
:where(#widgetEditorDialog) optgroup,
:where(#widgetEditorDialog) textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}
:where(#widgetEditorDialog) button,
:where(#widgetEditorDialog) input {
  overflow: visible;
}
:where(#widgetEditorDialog) button,
:where(#widgetEditorDialog) select {
  text-transform: none;
}
:where(#widgetEditorDialog) [role=button] {
  cursor: pointer;
}
:where(#widgetEditorDialog) select {
  word-wrap: normal;
}
:where(#widgetEditorDialog) button,
:where(#widgetEditorDialog) [type=button],
:where(#widgetEditorDialog) [type=reset],
:where(#widgetEditorDialog) [type=submit] {
  -webkit-appearance: button;
}
:where(#widgetEditorDialog) button:not(:disabled),
:where(#widgetEditorDialog) [type=button]:not(:disabled),
:where(#widgetEditorDialog) [type=reset]:not(:disabled),
:where(#widgetEditorDialog) [type=submit]:not(:disabled) {
  cursor: pointer;
}
:where(#widgetEditorDialog) button::-moz-focus-inner,
:where(#widgetEditorDialog) [type=button]::-moz-focus-inner,
:where(#widgetEditorDialog) [type=reset]::-moz-focus-inner,
:where(#widgetEditorDialog) [type=submit]::-moz-focus-inner {
  padding: 0;
  border-style: none;
}
:where(#widgetEditorDialog) input[type=radio],
:where(#widgetEditorDialog) input[type=checkbox] {
  box-sizing: border-box;
  padding: 0;
}
:where(#widgetEditorDialog) textarea {
  overflow: auto;
  resize: vertical;
}
:where(#widgetEditorDialog) fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}
:where(#widgetEditorDialog) legend {
  display: block;
  width: 100%;
  max-width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  font-size: 1.5rem;
  line-height: inherit;
  color: inherit;
  white-space: normal;
}
:where(#widgetEditorDialog) progress {
  vertical-align: baseline;
}
:where(#widgetEditorDialog) [type=number]::-webkit-inner-spin-button,
:where(#widgetEditorDialog) [type=number]::-webkit-outer-spin-button {
  height: auto;
}
:where(#widgetEditorDialog) [type=search] {
  outline-offset: -2px;
  -webkit-appearance: none;
}
:where(#widgetEditorDialog) [type=search]::-webkit-search-decoration {
  -webkit-appearance: none;
}
:where(#widgetEditorDialog) ::-webkit-file-upload-button {
  font: inherit;
  -webkit-appearance: button;
}
:where(#widgetEditorDialog) output {
  display: inline-block;
}
:where(#widgetEditorDialog) summary {
  display: list-item;
  cursor: pointer;
}
:where(#widgetEditorDialog) template {
  display: none;
}
:where(#widgetEditorDialog) [hidden] {
  display: none !important;
}
:where(#widgetEditorDialog) h1, :where(#widgetEditorDialog) h2, :where(#widgetEditorDialog) h3, :where(#widgetEditorDialog) h4, :where(#widgetEditorDialog) h5, :where(#widgetEditorDialog) h6,
:where(#widgetEditorDialog) .h1, :where(#widgetEditorDialog) .h2, :where(#widgetEditorDialog) .h3, :where(#widgetEditorDialog) .h4, :where(#widgetEditorDialog) .h5, :where(#widgetEditorDialog) .h6 {
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
}
:where(#widgetEditorDialog) h1, :where(#widgetEditorDialog) .h1 {
  font-size: 2.5rem;
}
:where(#widgetEditorDialog) h2, :where(#widgetEditorDialog) .h2 {
  font-size: 2rem;
}
:where(#widgetEditorDialog) h3, :where(#widgetEditorDialog) .h3 {
  font-size: 1.75rem;
}
:where(#widgetEditorDialog) h4, :where(#widgetEditorDialog) .h4 {
  font-size: 1.5rem;
}
:where(#widgetEditorDialog) h5, :where(#widgetEditorDialog) .h5 {
  font-size: 1.25rem;
}
:where(#widgetEditorDialog) h6, :where(#widgetEditorDialog) .h6 {
  font-size: 1rem;
}
:where(#widgetEditorDialog) .lead {
  font-size: 1.25rem;
  font-weight: 300;
}
:where(#widgetEditorDialog) .display-1 {
  font-size: 6rem;
  font-weight: 300;
  line-height: 1.2;
}
:where(#widgetEditorDialog) .display-2 {
  font-size: 5.5rem;
  font-weight: 300;
  line-height: 1.2;
}
:where(#widgetEditorDialog) .display-3 {
  font-size: 4.5rem;
  font-weight: 300;
  line-height: 1.2;
}
:where(#widgetEditorDialog) .display-4 {
  font-size: 3.5rem;
  font-weight: 300;
  line-height: 1.2;
}
:where(#widgetEditorDialog) hr {
  margin-top: 1rem;
  margin-bottom: 1rem;
  border: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}
:where(#widgetEditorDialog) small,
:where(#widgetEditorDialog) .small {
  font-size: 0.875em;
  font-weight: 400;
}
:where(#widgetEditorDialog) mark,
:where(#widgetEditorDialog) .mark {
  padding: 0.2em;
  background-color: #fcf8e3;
}
:where(#widgetEditorDialog) .list-unstyled {
  padding-left: 0;
  list-style: none;
}
:where(#widgetEditorDialog) .list-inline {
  padding-left: 0;
  list-style: none;
}
:where(#widgetEditorDialog) .list-inline-item {
  display: inline-block;
}
:where(#widgetEditorDialog) .list-inline-item:not(:last-child) {
  margin-right: 0.5rem;
}
:where(#widgetEditorDialog) .initialism {
  font-size: 90%;
  text-transform: uppercase;
}
:where(#widgetEditorDialog) .blockquote {
  margin-bottom: 1rem;
  font-size: 1.25rem;
}
:where(#widgetEditorDialog) .blockquote-footer {
  display: block;
  font-size: 0.875em;
  color: #6c757d;
}
:where(#widgetEditorDialog) .blockquote-footer::before {
  content: "— ";
}
:where(#widgetEditorDialog) .img-fluid {
  max-width: 100%;
  height: auto;
}
:where(#widgetEditorDialog) .img-thumbnail {
  padding: 0.25rem;
  background-color: #fff;
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
  max-width: 100%;
  height: auto;
}
:where(#widgetEditorDialog) .figure {
  display: inline-block;
}
:where(#widgetEditorDialog) .figure-img {
  margin-bottom: 0.5rem;
  line-height: 1;
}
:where(#widgetEditorDialog) .figure-caption {
  font-size: 90%;
  color: #6c757d;
}
:where(#widgetEditorDialog) code {
  font-size: 87.5%;
  color: #e83e8c;
  word-wrap: break-word;
}
a > :where(#widgetEditorDialog) code {
  color: inherit;
}
:where(#widgetEditorDialog) kbd {
  padding: 0.2rem 0.4rem;
  font-size: 87.5%;
  color: #fff;
  background-color: #212529;
  border-radius: 0.2rem;
}
:where(#widgetEditorDialog) kbd kbd {
  padding: 0;
  font-size: 100%;
  font-weight: 700;
}
:where(#widgetEditorDialog) pre {
  display: block;
  font-size: 87.5%;
  color: #212529;
}
:where(#widgetEditorDialog) pre code {
  font-size: inherit;
  color: inherit;
  word-break: normal;
}
:where(#widgetEditorDialog) .pre-scrollable {
  max-height: 340px;
  overflow-y: scroll;
}
:where(#widgetEditorDialog) .container,
:where(#widgetEditorDialog) .container-fluid,
:where(#widgetEditorDialog) .container-xl,
:where(#widgetEditorDialog) .container-lg,
:where(#widgetEditorDialog) .container-md,
:where(#widgetEditorDialog) .container-sm {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}
@media (min-width: 576px) {
  :where(#widgetEditorDialog) .container-sm, :where(#widgetEditorDialog) .container {
    max-width: 540px;
  }
}
@media (min-width: 768px) {
  :where(#widgetEditorDialog) .container-md, :where(#widgetEditorDialog) .container-sm, :where(#widgetEditorDialog) .container {
    max-width: 720px;
  }
}
@media (min-width: 992px) {
  :where(#widgetEditorDialog) .container-lg, :where(#widgetEditorDialog) .container-md, :where(#widgetEditorDialog) .container-sm, :where(#widgetEditorDialog) .container {
    max-width: 960px;
  }
}
@media (min-width: 1200px) {
  :where(#widgetEditorDialog) .container-xl, :where(#widgetEditorDialog) .container-lg, :where(#widgetEditorDialog) .container-md, :where(#widgetEditorDialog) .container-sm, :where(#widgetEditorDialog) .container {
    max-width: 1140px;
  }
}
:where(#widgetEditorDialog) .row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
}
:where(#widgetEditorDialog) .no-gutters {
  margin-right: 0;
  margin-left: 0;
}
:where(#widgetEditorDialog) .no-gutters > .col,
:where(#widgetEditorDialog) .no-gutters > [class*=col-] {
  padding-right: 0;
  padding-left: 0;
}
:where(#widgetEditorDialog) .col-xl,
:where(#widgetEditorDialog) .col-xl-auto, :where(#widgetEditorDialog) .col-xl-12, :where(#widgetEditorDialog) .col-xl-11, :where(#widgetEditorDialog) .col-xl-10, :where(#widgetEditorDialog) .col-xl-9, :where(#widgetEditorDialog) .col-xl-8, :where(#widgetEditorDialog) .col-xl-7, :where(#widgetEditorDialog) .col-xl-6, :where(#widgetEditorDialog) .col-xl-5, :where(#widgetEditorDialog) .col-xl-4, :where(#widgetEditorDialog) .col-xl-3, :where(#widgetEditorDialog) .col-xl-2, :where(#widgetEditorDialog) .col-xl-1, :where(#widgetEditorDialog) .col-lg,
:where(#widgetEditorDialog) .col-lg-auto, :where(#widgetEditorDialog) .col-lg-12, :where(#widgetEditorDialog) .col-lg-11, :where(#widgetEditorDialog) .col-lg-10, :where(#widgetEditorDialog) .col-lg-9, :where(#widgetEditorDialog) .col-lg-8, :where(#widgetEditorDialog) .col-lg-7, :where(#widgetEditorDialog) .col-lg-6, :where(#widgetEditorDialog) .col-lg-5, :where(#widgetEditorDialog) .col-lg-4, :where(#widgetEditorDialog) .col-lg-3, :where(#widgetEditorDialog) .col-lg-2, :where(#widgetEditorDialog) .col-lg-1, :where(#widgetEditorDialog) .col-md,
:where(#widgetEditorDialog) .col-md-auto, :where(#widgetEditorDialog) .col-md-12, :where(#widgetEditorDialog) .col-md-11, :where(#widgetEditorDialog) .col-md-10, :where(#widgetEditorDialog) .col-md-9, :where(#widgetEditorDialog) .col-md-8, :where(#widgetEditorDialog) .col-md-7, :where(#widgetEditorDialog) .col-md-6, :where(#widgetEditorDialog) .col-md-5, :where(#widgetEditorDialog) .col-md-4, :where(#widgetEditorDialog) .col-md-3, :where(#widgetEditorDialog) .col-md-2, :where(#widgetEditorDialog) .col-md-1, :where(#widgetEditorDialog) .col-sm,
:where(#widgetEditorDialog) .col-sm-auto, :where(#widgetEditorDialog) .col-sm-12, :where(#widgetEditorDialog) .col-sm-11, :where(#widgetEditorDialog) .col-sm-10, :where(#widgetEditorDialog) .col-sm-9, :where(#widgetEditorDialog) .col-sm-8, :where(#widgetEditorDialog) .col-sm-7, :where(#widgetEditorDialog) .col-sm-6, :where(#widgetEditorDialog) .col-sm-5, :where(#widgetEditorDialog) .col-sm-4, :where(#widgetEditorDialog) .col-sm-3, :where(#widgetEditorDialog) .col-sm-2, :where(#widgetEditorDialog) .col-sm-1, :where(#widgetEditorDialog) .col,
:where(#widgetEditorDialog) .col-auto, :where(#widgetEditorDialog) .col-12, :where(#widgetEditorDialog) .col-11, :where(#widgetEditorDialog) .col-10, :where(#widgetEditorDialog) .col-9, :where(#widgetEditorDialog) .col-8, :where(#widgetEditorDialog) .col-7, :where(#widgetEditorDialog) .col-6, :where(#widgetEditorDialog) .col-5, :where(#widgetEditorDialog) .col-4, :where(#widgetEditorDialog) .col-3, :where(#widgetEditorDialog) .col-2, :where(#widgetEditorDialog) .col-1 {
  position: relative;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
}
:where(#widgetEditorDialog) .col {
  flex-basis: 0;
  flex-grow: 1;
  max-width: 100%;
}
:where(#widgetEditorDialog) .row-cols-1 > * {
  flex: 0 0 100%;
  max-width: 100%;
}
:where(#widgetEditorDialog) .row-cols-2 > * {
  flex: 0 0 50%;
  max-width: 50%;
}
:where(#widgetEditorDialog) .row-cols-3 > * {
  flex: 0 0 33.3333333333%;
  max-width: 33.3333333333%;
}
:where(#widgetEditorDialog) .row-cols-4 > * {
  flex: 0 0 25%;
  max-width: 25%;
}
:where(#widgetEditorDialog) .row-cols-5 > * {
  flex: 0 0 20%;
  max-width: 20%;
}
:where(#widgetEditorDialog) .row-cols-6 > * {
  flex: 0 0 16.6666666667%;
  max-width: 16.6666666667%;
}
:where(#widgetEditorDialog) .col-auto {
  flex: 0 0 auto;
  width: auto;
  max-width: 100%;
}
:where(#widgetEditorDialog) .col-1 {
  flex: 0 0 8.33333333%;
  max-width: 8.33333333%;
}
:where(#widgetEditorDialog) .col-2 {
  flex: 0 0 16.66666667%;
  max-width: 16.66666667%;
}
:where(#widgetEditorDialog) .col-3 {
  flex: 0 0 25%;
  max-width: 25%;
}
:where(#widgetEditorDialog) .col-4 {
  flex: 0 0 33.33333333%;
  max-width: 33.33333333%;
}
:where(#widgetEditorDialog) .col-5 {
  flex: 0 0 41.66666667%;
  max-width: 41.66666667%;
}
:where(#widgetEditorDialog) .col-6 {
  flex: 0 0 50%;
  max-width: 50%;
}
:where(#widgetEditorDialog) .col-7 {
  flex: 0 0 58.33333333%;
  max-width: 58.33333333%;
}
:where(#widgetEditorDialog) .col-8 {
  flex: 0 0 66.66666667%;
  max-width: 66.66666667%;
}
:where(#widgetEditorDialog) .col-9 {
  flex: 0 0 75%;
  max-width: 75%;
}
:where(#widgetEditorDialog) .col-10 {
  flex: 0 0 83.33333333%;
  max-width: 83.33333333%;
}
:where(#widgetEditorDialog) .col-11 {
  flex: 0 0 91.66666667%;
  max-width: 91.66666667%;
}
:where(#widgetEditorDialog) .col-12 {
  flex: 0 0 100%;
  max-width: 100%;
}
:where(#widgetEditorDialog) .order-first {
  order: -1;
}
:where(#widgetEditorDialog) .order-last {
  order: 13;
}
:where(#widgetEditorDialog) .order-0 {
  order: 0;
}
:where(#widgetEditorDialog) .order-1 {
  order: 1;
}
:where(#widgetEditorDialog) .order-2 {
  order: 2;
}
:where(#widgetEditorDialog) .order-3 {
  order: 3;
}
:where(#widgetEditorDialog) .order-4 {
  order: 4;
}
:where(#widgetEditorDialog) .order-5 {
  order: 5;
}
:where(#widgetEditorDialog) .order-6 {
  order: 6;
}
:where(#widgetEditorDialog) .order-7 {
  order: 7;
}
:where(#widgetEditorDialog) .order-8 {
  order: 8;
}
:where(#widgetEditorDialog) .order-9 {
  order: 9;
}
:where(#widgetEditorDialog) .order-10 {
  order: 10;
}
:where(#widgetEditorDialog) .order-11 {
  order: 11;
}
:where(#widgetEditorDialog) .order-12 {
  order: 12;
}
:where(#widgetEditorDialog) .offset-1 {
  margin-left: 8.33333333%;
}
:where(#widgetEditorDialog) .offset-2 {
  margin-left: 16.66666667%;
}
:where(#widgetEditorDialog) .offset-3 {
  margin-left: 25%;
}
:where(#widgetEditorDialog) .offset-4 {
  margin-left: 33.33333333%;
}
:where(#widgetEditorDialog) .offset-5 {
  margin-left: 41.66666667%;
}
:where(#widgetEditorDialog) .offset-6 {
  margin-left: 50%;
}
:where(#widgetEditorDialog) .offset-7 {
  margin-left: 58.33333333%;
}
:where(#widgetEditorDialog) .offset-8 {
  margin-left: 66.66666667%;
}
:where(#widgetEditorDialog) .offset-9 {
  margin-left: 75%;
}
:where(#widgetEditorDialog) .offset-10 {
  margin-left: 83.33333333%;
}
:where(#widgetEditorDialog) .offset-11 {
  margin-left: 91.66666667%;
}
@media (min-width: 576px) {
  :where(#widgetEditorDialog) .col-sm {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  :where(#widgetEditorDialog) .row-cols-sm-1 > * {
    flex: 0 0 100%;
    max-width: 100%;
  }
  :where(#widgetEditorDialog) .row-cols-sm-2 > * {
    flex: 0 0 50%;
    max-width: 50%;
  }
  :where(#widgetEditorDialog) .row-cols-sm-3 > * {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }
  :where(#widgetEditorDialog) .row-cols-sm-4 > * {
    flex: 0 0 25%;
    max-width: 25%;
  }
  :where(#widgetEditorDialog) .row-cols-sm-5 > * {
    flex: 0 0 20%;
    max-width: 20%;
  }
  :where(#widgetEditorDialog) .row-cols-sm-6 > * {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }
  :where(#widgetEditorDialog) .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }
  :where(#widgetEditorDialog) .col-sm-1 {
    flex: 0 0 8.33333333%;
    max-width: 8.33333333%;
  }
  :where(#widgetEditorDialog) .col-sm-2 {
    flex: 0 0 16.66666667%;
    max-width: 16.66666667%;
  }
  :where(#widgetEditorDialog) .col-sm-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }
  :where(#widgetEditorDialog) .col-sm-4 {
    flex: 0 0 33.33333333%;
    max-width: 33.33333333%;
  }
  :where(#widgetEditorDialog) .col-sm-5 {
    flex: 0 0 41.66666667%;
    max-width: 41.66666667%;
  }
  :where(#widgetEditorDialog) .col-sm-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  :where(#widgetEditorDialog) .col-sm-7 {
    flex: 0 0 58.33333333%;
    max-width: 58.33333333%;
  }
  :where(#widgetEditorDialog) .col-sm-8 {
    flex: 0 0 66.66666667%;
    max-width: 66.66666667%;
  }
  :where(#widgetEditorDialog) .col-sm-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }
  :where(#widgetEditorDialog) .col-sm-10 {
    flex: 0 0 83.33333333%;
    max-width: 83.33333333%;
  }
  :where(#widgetEditorDialog) .col-sm-11 {
    flex: 0 0 91.66666667%;
    max-width: 91.66666667%;
  }
  :where(#widgetEditorDialog) .col-sm-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  :where(#widgetEditorDialog) .order-sm-first {
    order: -1;
  }
  :where(#widgetEditorDialog) .order-sm-last {
    order: 13;
  }
  :where(#widgetEditorDialog) .order-sm-0 {
    order: 0;
  }
  :where(#widgetEditorDialog) .order-sm-1 {
    order: 1;
  }
  :where(#widgetEditorDialog) .order-sm-2 {
    order: 2;
  }
  :where(#widgetEditorDialog) .order-sm-3 {
    order: 3;
  }
  :where(#widgetEditorDialog) .order-sm-4 {
    order: 4;
  }
  :where(#widgetEditorDialog) .order-sm-5 {
    order: 5;
  }
  :where(#widgetEditorDialog) .order-sm-6 {
    order: 6;
  }
  :where(#widgetEditorDialog) .order-sm-7 {
    order: 7;
  }
  :where(#widgetEditorDialog) .order-sm-8 {
    order: 8;
  }
  :where(#widgetEditorDialog) .order-sm-9 {
    order: 9;
  }
  :where(#widgetEditorDialog) .order-sm-10 {
    order: 10;
  }
  :where(#widgetEditorDialog) .order-sm-11 {
    order: 11;
  }
  :where(#widgetEditorDialog) .order-sm-12 {
    order: 12;
  }
  :where(#widgetEditorDialog) .offset-sm-0 {
    margin-left: 0;
  }
  :where(#widgetEditorDialog) .offset-sm-1 {
    margin-left: 8.33333333%;
  }
  :where(#widgetEditorDialog) .offset-sm-2 {
    margin-left: 16.66666667%;
  }
  :where(#widgetEditorDialog) .offset-sm-3 {
    margin-left: 25%;
  }
  :where(#widgetEditorDialog) .offset-sm-4 {
    margin-left: 33.33333333%;
  }
  :where(#widgetEditorDialog) .offset-sm-5 {
    margin-left: 41.66666667%;
  }
  :where(#widgetEditorDialog) .offset-sm-6 {
    margin-left: 50%;
  }
  :where(#widgetEditorDialog) .offset-sm-7 {
    margin-left: 58.33333333%;
  }
  :where(#widgetEditorDialog) .offset-sm-8 {
    margin-left: 66.66666667%;
  }
  :where(#widgetEditorDialog) .offset-sm-9 {
    margin-left: 75%;
  }
  :where(#widgetEditorDialog) .offset-sm-10 {
    margin-left: 83.33333333%;
  }
  :where(#widgetEditorDialog) .offset-sm-11 {
    margin-left: 91.66666667%;
  }
}
@media (min-width: 768px) {
  :where(#widgetEditorDialog) .col-md {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  :where(#widgetEditorDialog) .row-cols-md-1 > * {
    flex: 0 0 100%;
    max-width: 100%;
  }
  :where(#widgetEditorDialog) .row-cols-md-2 > * {
    flex: 0 0 50%;
    max-width: 50%;
  }
  :where(#widgetEditorDialog) .row-cols-md-3 > * {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }
  :where(#widgetEditorDialog) .row-cols-md-4 > * {
    flex: 0 0 25%;
    max-width: 25%;
  }
  :where(#widgetEditorDialog) .row-cols-md-5 > * {
    flex: 0 0 20%;
    max-width: 20%;
  }
  :where(#widgetEditorDialog) .row-cols-md-6 > * {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }
  :where(#widgetEditorDialog) .col-md-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }
  :where(#widgetEditorDialog) .col-md-1 {
    flex: 0 0 8.33333333%;
    max-width: 8.33333333%;
  }
  :where(#widgetEditorDialog) .col-md-2 {
    flex: 0 0 16.66666667%;
    max-width: 16.66666667%;
  }
  :where(#widgetEditorDialog) .col-md-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }
  :where(#widgetEditorDialog) .col-md-4 {
    flex: 0 0 33.33333333%;
    max-width: 33.33333333%;
  }
  :where(#widgetEditorDialog) .col-md-5 {
    flex: 0 0 41.66666667%;
    max-width: 41.66666667%;
  }
  :where(#widgetEditorDialog) .col-md-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  :where(#widgetEditorDialog) .col-md-7 {
    flex: 0 0 58.33333333%;
    max-width: 58.33333333%;
  }
  :where(#widgetEditorDialog) .col-md-8 {
    flex: 0 0 66.66666667%;
    max-width: 66.66666667%;
  }
  :where(#widgetEditorDialog) .col-md-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }
  :where(#widgetEditorDialog) .col-md-10 {
    flex: 0 0 83.33333333%;
    max-width: 83.33333333%;
  }
  :where(#widgetEditorDialog) .col-md-11 {
    flex: 0 0 91.66666667%;
    max-width: 91.66666667%;
  }
  :where(#widgetEditorDialog) .col-md-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  :where(#widgetEditorDialog) .order-md-first {
    order: -1;
  }
  :where(#widgetEditorDialog) .order-md-last {
    order: 13;
  }
  :where(#widgetEditorDialog) .order-md-0 {
    order: 0;
  }
  :where(#widgetEditorDialog) .order-md-1 {
    order: 1;
  }
  :where(#widgetEditorDialog) .order-md-2 {
    order: 2;
  }
  :where(#widgetEditorDialog) .order-md-3 {
    order: 3;
  }
  :where(#widgetEditorDialog) .order-md-4 {
    order: 4;
  }
  :where(#widgetEditorDialog) .order-md-5 {
    order: 5;
  }
  :where(#widgetEditorDialog) .order-md-6 {
    order: 6;
  }
  :where(#widgetEditorDialog) .order-md-7 {
    order: 7;
  }
  :where(#widgetEditorDialog) .order-md-8 {
    order: 8;
  }
  :where(#widgetEditorDialog) .order-md-9 {
    order: 9;
  }
  :where(#widgetEditorDialog) .order-md-10 {
    order: 10;
  }
  :where(#widgetEditorDialog) .order-md-11 {
    order: 11;
  }
  :where(#widgetEditorDialog) .order-md-12 {
    order: 12;
  }
  :where(#widgetEditorDialog) .offset-md-0 {
    margin-left: 0;
  }
  :where(#widgetEditorDialog) .offset-md-1 {
    margin-left: 8.33333333%;
  }
  :where(#widgetEditorDialog) .offset-md-2 {
    margin-left: 16.66666667%;
  }
  :where(#widgetEditorDialog) .offset-md-3 {
    margin-left: 25%;
  }
  :where(#widgetEditorDialog) .offset-md-4 {
    margin-left: 33.33333333%;
  }
  :where(#widgetEditorDialog) .offset-md-5 {
    margin-left: 41.66666667%;
  }
  :where(#widgetEditorDialog) .offset-md-6 {
    margin-left: 50%;
  }
  :where(#widgetEditorDialog) .offset-md-7 {
    margin-left: 58.33333333%;
  }
  :where(#widgetEditorDialog) .offset-md-8 {
    margin-left: 66.66666667%;
  }
  :where(#widgetEditorDialog) .offset-md-9 {
    margin-left: 75%;
  }
  :where(#widgetEditorDialog) .offset-md-10 {
    margin-left: 83.33333333%;
  }
  :where(#widgetEditorDialog) .offset-md-11 {
    margin-left: 91.66666667%;
  }
}
@media (min-width: 992px) {
  :where(#widgetEditorDialog) .col-lg {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  :where(#widgetEditorDialog) .row-cols-lg-1 > * {
    flex: 0 0 100%;
    max-width: 100%;
  }
  :where(#widgetEditorDialog) .row-cols-lg-2 > * {
    flex: 0 0 50%;
    max-width: 50%;
  }
  :where(#widgetEditorDialog) .row-cols-lg-3 > * {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }
  :where(#widgetEditorDialog) .row-cols-lg-4 > * {
    flex: 0 0 25%;
    max-width: 25%;
  }
  :where(#widgetEditorDialog) .row-cols-lg-5 > * {
    flex: 0 0 20%;
    max-width: 20%;
  }
  :where(#widgetEditorDialog) .row-cols-lg-6 > * {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }
  :where(#widgetEditorDialog) .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }
  :where(#widgetEditorDialog) .col-lg-1 {
    flex: 0 0 8.33333333%;
    max-width: 8.33333333%;
  }
  :where(#widgetEditorDialog) .col-lg-2 {
    flex: 0 0 16.66666667%;
    max-width: 16.66666667%;
  }
  :where(#widgetEditorDialog) .col-lg-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }
  :where(#widgetEditorDialog) .col-lg-4 {
    flex: 0 0 33.33333333%;
    max-width: 33.33333333%;
  }
  :where(#widgetEditorDialog) .col-lg-5 {
    flex: 0 0 41.66666667%;
    max-width: 41.66666667%;
  }
  :where(#widgetEditorDialog) .col-lg-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  :where(#widgetEditorDialog) .col-lg-7 {
    flex: 0 0 58.33333333%;
    max-width: 58.33333333%;
  }
  :where(#widgetEditorDialog) .col-lg-8 {
    flex: 0 0 66.66666667%;
    max-width: 66.66666667%;
  }
  :where(#widgetEditorDialog) .col-lg-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }
  :where(#widgetEditorDialog) .col-lg-10 {
    flex: 0 0 83.33333333%;
    max-width: 83.33333333%;
  }
  :where(#widgetEditorDialog) .col-lg-11 {
    flex: 0 0 91.66666667%;
    max-width: 91.66666667%;
  }
  :where(#widgetEditorDialog) .col-lg-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  :where(#widgetEditorDialog) .order-lg-first {
    order: -1;
  }
  :where(#widgetEditorDialog) .order-lg-last {
    order: 13;
  }
  :where(#widgetEditorDialog) .order-lg-0 {
    order: 0;
  }
  :where(#widgetEditorDialog) .order-lg-1 {
    order: 1;
  }
  :where(#widgetEditorDialog) .order-lg-2 {
    order: 2;
  }
  :where(#widgetEditorDialog) .order-lg-3 {
    order: 3;
  }
  :where(#widgetEditorDialog) .order-lg-4 {
    order: 4;
  }
  :where(#widgetEditorDialog) .order-lg-5 {
    order: 5;
  }
  :where(#widgetEditorDialog) .order-lg-6 {
    order: 6;
  }
  :where(#widgetEditorDialog) .order-lg-7 {
    order: 7;
  }
  :where(#widgetEditorDialog) .order-lg-8 {
    order: 8;
  }
  :where(#widgetEditorDialog) .order-lg-9 {
    order: 9;
  }
  :where(#widgetEditorDialog) .order-lg-10 {
    order: 10;
  }
  :where(#widgetEditorDialog) .order-lg-11 {
    order: 11;
  }
  :where(#widgetEditorDialog) .order-lg-12 {
    order: 12;
  }
  :where(#widgetEditorDialog) .offset-lg-0 {
    margin-left: 0;
  }
  :where(#widgetEditorDialog) .offset-lg-1 {
    margin-left: 8.33333333%;
  }
  :where(#widgetEditorDialog) .offset-lg-2 {
    margin-left: 16.66666667%;
  }
  :where(#widgetEditorDialog) .offset-lg-3 {
    margin-left: 25%;
  }
  :where(#widgetEditorDialog) .offset-lg-4 {
    margin-left: 33.33333333%;
  }
  :where(#widgetEditorDialog) .offset-lg-5 {
    margin-left: 41.66666667%;
  }
  :where(#widgetEditorDialog) .offset-lg-6 {
    margin-left: 50%;
  }
  :where(#widgetEditorDialog) .offset-lg-7 {
    margin-left: 58.33333333%;
  }
  :where(#widgetEditorDialog) .offset-lg-8 {
    margin-left: 66.66666667%;
  }
  :where(#widgetEditorDialog) .offset-lg-9 {
    margin-left: 75%;
  }
  :where(#widgetEditorDialog) .offset-lg-10 {
    margin-left: 83.33333333%;
  }
  :where(#widgetEditorDialog) .offset-lg-11 {
    margin-left: 91.66666667%;
  }
}
@media (min-width: 1200px) {
  :where(#widgetEditorDialog) .col-xl {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  :where(#widgetEditorDialog) .row-cols-xl-1 > * {
    flex: 0 0 100%;
    max-width: 100%;
  }
  :where(#widgetEditorDialog) .row-cols-xl-2 > * {
    flex: 0 0 50%;
    max-width: 50%;
  }
  :where(#widgetEditorDialog) .row-cols-xl-3 > * {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }
  :where(#widgetEditorDialog) .row-cols-xl-4 > * {
    flex: 0 0 25%;
    max-width: 25%;
  }
  :where(#widgetEditorDialog) .row-cols-xl-5 > * {
    flex: 0 0 20%;
    max-width: 20%;
  }
  :where(#widgetEditorDialog) .row-cols-xl-6 > * {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }
  :where(#widgetEditorDialog) .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }
  :where(#widgetEditorDialog) .col-xl-1 {
    flex: 0 0 8.33333333%;
    max-width: 8.33333333%;
  }
  :where(#widgetEditorDialog) .col-xl-2 {
    flex: 0 0 16.66666667%;
    max-width: 16.66666667%;
  }
  :where(#widgetEditorDialog) .col-xl-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }
  :where(#widgetEditorDialog) .col-xl-4 {
    flex: 0 0 33.33333333%;
    max-width: 33.33333333%;
  }
  :where(#widgetEditorDialog) .col-xl-5 {
    flex: 0 0 41.66666667%;
    max-width: 41.66666667%;
  }
  :where(#widgetEditorDialog) .col-xl-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  :where(#widgetEditorDialog) .col-xl-7 {
    flex: 0 0 58.33333333%;
    max-width: 58.33333333%;
  }
  :where(#widgetEditorDialog) .col-xl-8 {
    flex: 0 0 66.66666667%;
    max-width: 66.66666667%;
  }
  :where(#widgetEditorDialog) .col-xl-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }
  :where(#widgetEditorDialog) .col-xl-10 {
    flex: 0 0 83.33333333%;
    max-width: 83.33333333%;
  }
  :where(#widgetEditorDialog) .col-xl-11 {
    flex: 0 0 91.66666667%;
    max-width: 91.66666667%;
  }
  :where(#widgetEditorDialog) .col-xl-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  :where(#widgetEditorDialog) .order-xl-first {
    order: -1;
  }
  :where(#widgetEditorDialog) .order-xl-last {
    order: 13;
  }
  :where(#widgetEditorDialog) .order-xl-0 {
    order: 0;
  }
  :where(#widgetEditorDialog) .order-xl-1 {
    order: 1;
  }
  :where(#widgetEditorDialog) .order-xl-2 {
    order: 2;
  }
  :where(#widgetEditorDialog) .order-xl-3 {
    order: 3;
  }
  :where(#widgetEditorDialog) .order-xl-4 {
    order: 4;
  }
  :where(#widgetEditorDialog) .order-xl-5 {
    order: 5;
  }
  :where(#widgetEditorDialog) .order-xl-6 {
    order: 6;
  }
  :where(#widgetEditorDialog) .order-xl-7 {
    order: 7;
  }
  :where(#widgetEditorDialog) .order-xl-8 {
    order: 8;
  }
  :where(#widgetEditorDialog) .order-xl-9 {
    order: 9;
  }
  :where(#widgetEditorDialog) .order-xl-10 {
    order: 10;
  }
  :where(#widgetEditorDialog) .order-xl-11 {
    order: 11;
  }
  :where(#widgetEditorDialog) .order-xl-12 {
    order: 12;
  }
  :where(#widgetEditorDialog) .offset-xl-0 {
    margin-left: 0;
  }
  :where(#widgetEditorDialog) .offset-xl-1 {
    margin-left: 8.33333333%;
  }
  :where(#widgetEditorDialog) .offset-xl-2 {
    margin-left: 16.66666667%;
  }
  :where(#widgetEditorDialog) .offset-xl-3 {
    margin-left: 25%;
  }
  :where(#widgetEditorDialog) .offset-xl-4 {
    margin-left: 33.33333333%;
  }
  :where(#widgetEditorDialog) .offset-xl-5 {
    margin-left: 41.66666667%;
  }
  :where(#widgetEditorDialog) .offset-xl-6 {
    margin-left: 50%;
  }
  :where(#widgetEditorDialog) .offset-xl-7 {
    margin-left: 58.33333333%;
  }
  :where(#widgetEditorDialog) .offset-xl-8 {
    margin-left: 66.66666667%;
  }
  :where(#widgetEditorDialog) .offset-xl-9 {
    margin-left: 75%;
  }
  :where(#widgetEditorDialog) .offset-xl-10 {
    margin-left: 83.33333333%;
  }
  :where(#widgetEditorDialog) .offset-xl-11 {
    margin-left: 91.66666667%;
  }
}
:where(#widgetEditorDialog) .table {
  width: 100%;
  margin-bottom: 1rem;
  color: #212529;
}
:where(#widgetEditorDialog) .table th,
:where(#widgetEditorDialog) .table td {
  padding: 0.75rem;
  vertical-align: top;
  border-top: 1px solid #dee2e6;
}
:where(#widgetEditorDialog) .table thead th {
  vertical-align: bottom;
  border-bottom: 2px solid #dee2e6;
}
:where(#widgetEditorDialog) .table tbody + tbody {
  border-top: 2px solid #dee2e6;
}
:where(#widgetEditorDialog) .table-sm th,
:where(#widgetEditorDialog) .table-sm td {
  padding: 0.3rem;
}
:where(#widgetEditorDialog) .table-bordered {
  border: 1px solid #dee2e6;
}
:where(#widgetEditorDialog) .table-bordered th,
:where(#widgetEditorDialog) .table-bordered td {
  border: 1px solid #dee2e6;
}
:where(#widgetEditorDialog) .table-bordered thead th,
:where(#widgetEditorDialog) .table-bordered thead td {
  border-bottom-width: 2px;
}
:where(#widgetEditorDialog) .table-borderless th,
:where(#widgetEditorDialog) .table-borderless td,
:where(#widgetEditorDialog) .table-borderless thead th,
:where(#widgetEditorDialog) .table-borderless tbody + tbody {
  border: 0;
}
:where(#widgetEditorDialog) .table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.05);
}
:where(#widgetEditorDialog) .table-hover tbody tr:hover {
  color: #212529;
  background-color: rgba(0, 0, 0, 0.075);
}
:where(#widgetEditorDialog) .table-primary,
:where(#widgetEditorDialog) .table-primary > th,
:where(#widgetEditorDialog) .table-primary > td {
  background-color: rgb(72%, 85.5058823529%, 100%);
}
:where(#widgetEditorDialog) .table-primary th,
:where(#widgetEditorDialog) .table-primary td,
:where(#widgetEditorDialog) .table-primary thead th,
:where(#widgetEditorDialog) .table-primary tbody + tbody {
  border-color: rgb(48%, 73.0823529412%, 100%);
}
:where(#widgetEditorDialog) .table-hover .table-primary:hover {
  background-color: rgb(62%, 80.3294117647%, 100%);
}
:where(#widgetEditorDialog) .table-hover .table-primary:hover > td,
:where(#widgetEditorDialog) .table-hover .table-primary:hover > th {
  background-color: rgb(62%, 80.3294117647%, 100%);
}
:where(#widgetEditorDialog) .table-secondary,
:where(#widgetEditorDialog) .table-secondary > th,
:where(#widgetEditorDialog) .table-secondary > td {
  background-color: rgb(83.8588235294%, 84.8470588235%, 85.7254901961%);
}
:where(#widgetEditorDialog) .table-secondary th,
:where(#widgetEditorDialog) .table-secondary td,
:where(#widgetEditorDialog) .table-secondary thead th,
:where(#widgetEditorDialog) .table-secondary tbody + tbody {
  border-color: rgb(70.0235294118%, 71.8588235294%, 73.4901960784%);
}
:where(#widgetEditorDialog) .table-hover .table-secondary:hover {
  background-color: rgb(78.5519643236%, 79.865109365%, 81.0323494019%);
}
:where(#widgetEditorDialog) .table-hover .table-secondary:hover > td,
:where(#widgetEditorDialog) .table-hover .table-secondary:hover > th {
  background-color: rgb(78.5519643236%, 79.865109365%, 81.0323494019%);
}
:where(#widgetEditorDialog) .table-success,
:where(#widgetEditorDialog) .table-success > th,
:where(#widgetEditorDialog) .table-success > td {
  background-color: rgb(76.3921568627%, 90.337254902%, 79.5764705882%);
}
:where(#widgetEditorDialog) .table-success th,
:where(#widgetEditorDialog) .table-success td,
:where(#widgetEditorDialog) .table-success thead th,
:where(#widgetEditorDialog) .table-success tbody + tbody {
  border-color: rgb(56.1568627451%, 82.0549019608%, 62.0705882353%);
}
:where(#widgetEditorDialog) .table-hover .table-success:hover {
  background-color: rgb(69.2964472918%, 87.4329644729%, 73.4378567268%);
}
:where(#widgetEditorDialog) .table-hover .table-success:hover > td,
:where(#widgetEditorDialog) .table-hover .table-success:hover > th {
  background-color: rgb(69.2964472918%, 87.4329644729%, 73.4378567268%);
}
:where(#widgetEditorDialog) .table-info,
:where(#widgetEditorDialog) .table-info > th,
:where(#widgetEditorDialog) .table-info > td {
  background-color: rgb(74.5254901961%, 89.7882352941%, 92.2039215686%);
}
:where(#widgetEditorDialog) .table-info th,
:where(#widgetEditorDialog) .table-info td,
:where(#widgetEditorDialog) .table-info thead th,
:where(#widgetEditorDialog) .table-info tbody + tbody {
  border-color: rgb(52.6901960784%, 81.0352941176%, 85.5215686275%);
}
:where(#widgetEditorDialog) .table-hover .table-info:hover {
  background-color: rgb(66.8687245195%, 86.7189283634%, 89.8606872452%);
}
:where(#widgetEditorDialog) .table-hover .table-info:hover > td,
:where(#widgetEditorDialog) .table-hover .table-info:hover > th {
  background-color: rgb(66.8687245195%, 86.7189283634%, 89.8606872452%);
}
:where(#widgetEditorDialog) .table-warning,
:where(#widgetEditorDialog) .table-warning > th,
:where(#widgetEditorDialog) .table-warning > td {
  background-color: rgb(100%, 93.1921568627%, 72.768627451%);
}
:where(#widgetEditorDialog) .table-warning th,
:where(#widgetEditorDialog) .table-warning td,
:where(#widgetEditorDialog) .table-warning thead th,
:where(#widgetEditorDialog) .table-warning tbody + tbody {
  border-color: rgb(100%, 87.3568627451%, 49.4274509804%);
}
:where(#widgetEditorDialog) .table-hover .table-warning:hover {
  background-color: rgb(100%, 90.6921568627%, 62.768627451%);
}
:where(#widgetEditorDialog) .table-hover .table-warning:hover > td,
:where(#widgetEditorDialog) .table-hover .table-warning:hover > th {
  background-color: rgb(100%, 90.6921568627%, 62.768627451%);
}
:where(#widgetEditorDialog) .table-danger,
:where(#widgetEditorDialog) .table-danger > th,
:where(#widgetEditorDialog) .table-danger > td {
  background-color: rgb(96.1568627451%, 77.8196078431%, 79.5764705882%);
}
:where(#widgetEditorDialog) .table-danger th,
:where(#widgetEditorDialog) .table-danger td,
:where(#widgetEditorDialog) .table-danger thead th,
:where(#widgetEditorDialog) .table-danger tbody + tbody {
  border-color: rgb(92.862745098%, 58.8078431373%, 62.0705882353%);
}
:where(#widgetEditorDialog) .table-hover .table-danger:hover {
  background-color: rgb(94.6800694962%, 69.2964010921%, 71.7283693224%);
}
:where(#widgetEditorDialog) .table-hover .table-danger:hover > td,
:where(#widgetEditorDialog) .table-hover .table-danger:hover > th {
  background-color: rgb(94.6800694962%, 69.2964010921%, 71.7283693224%);
}
:where(#widgetEditorDialog) .table-light,
:where(#widgetEditorDialog) .table-light > th,
:where(#widgetEditorDialog) .table-light > td {
  background-color: rgb(99.231372549%, 99.3411764706%, 99.4509803922%);
}
:where(#widgetEditorDialog) .table-light th,
:where(#widgetEditorDialog) .table-light td,
:where(#widgetEditorDialog) .table-light thead th,
:where(#widgetEditorDialog) .table-light tbody + tbody {
  border-color: rgb(98.5725490196%, 98.7764705882%, 98.9803921569%);
}
:where(#widgetEditorDialog) .table-hover .table-light:hover {
  background-color: rgb(93.3980392157%, 94.3411764706%, 95.2843137255%);
}
:where(#widgetEditorDialog) .table-hover .table-light:hover > td,
:where(#widgetEditorDialog) .table-hover .table-light:hover > th {
  background-color: rgb(93.3980392157%, 94.3411764706%, 95.2843137255%);
}
:where(#widgetEditorDialog) .table-dark,
:where(#widgetEditorDialog) .table-dark > th,
:where(#widgetEditorDialog) .table-dark > td {
  background-color: rgb(77.7098039216%, 78.368627451%, 79.0274509804%);
}
:where(#widgetEditorDialog) .table-dark th,
:where(#widgetEditorDialog) .table-dark td,
:where(#widgetEditorDialog) .table-dark thead th,
:where(#widgetEditorDialog) .table-dark tbody + tbody {
  border-color: rgb(58.6039215686%, 59.8274509804%, 61.0509803922%);
}
:where(#widgetEditorDialog) .table-hover .table-dark:hover {
  background-color: rgb(72.5575196576%, 73.368627451%, 74.1797352444%);
}
:where(#widgetEditorDialog) .table-hover .table-dark:hover > td,
:where(#widgetEditorDialog) .table-hover .table-dark:hover > th {
  background-color: rgb(72.5575196576%, 73.368627451%, 74.1797352444%);
}
:where(#widgetEditorDialog) .table-active,
:where(#widgetEditorDialog) .table-active > th,
:where(#widgetEditorDialog) .table-active > td {
  background-color: rgba(0, 0, 0, 0.075);
}
:where(#widgetEditorDialog) .table-hover .table-active:hover {
  background-color: rgba(0, 0, 0, 0.075);
}
:where(#widgetEditorDialog) .table-hover .table-active:hover > td,
:where(#widgetEditorDialog) .table-hover .table-active:hover > th {
  background-color: rgba(0, 0, 0, 0.075);
}
:where(#widgetEditorDialog) .table .thead-dark th {
  color: #fff;
  background-color: #343a40;
  border-color: rgb(27.1162947938%, 30.2450980392%, 33.3739012847%);
}
:where(#widgetEditorDialog) .table .thead-light th {
  color: #495057;
  background-color: #e9ecef;
  border-color: #dee2e6;
}
:where(#widgetEditorDialog) .table-dark {
  color: #fff;
  background-color: #343a40;
}
:where(#widgetEditorDialog) .table-dark th,
:where(#widgetEditorDialog) .table-dark td,
:where(#widgetEditorDialog) .table-dark thead th {
  border-color: rgb(27.1162947938%, 30.2450980392%, 33.3739012847%);
}
:where(#widgetEditorDialog) .table-dark.table-bordered {
  border: 0;
}
:where(#widgetEditorDialog) .table-dark.table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(255, 255, 255, 0.05);
}
:where(#widgetEditorDialog) .table-dark.table-hover tbody tr:hover {
  color: #fff;
  background-color: rgba(255, 255, 255, 0.075);
}
@media (max-width: 575.98px) {
  :where(#widgetEditorDialog) .table-responsive-sm {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  :where(#widgetEditorDialog) .table-responsive-sm > .table-bordered {
    border: 0;
  }
}
@media (max-width: 767.98px) {
  :where(#widgetEditorDialog) .table-responsive-md {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  :where(#widgetEditorDialog) .table-responsive-md > .table-bordered {
    border: 0;
  }
}
@media (max-width: 991.98px) {
  :where(#widgetEditorDialog) .table-responsive-lg {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  :where(#widgetEditorDialog) .table-responsive-lg > .table-bordered {
    border: 0;
  }
}
@media (max-width: 1199.98px) {
  :where(#widgetEditorDialog) .table-responsive-xl {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  :where(#widgetEditorDialog) .table-responsive-xl > .table-bordered {
    border: 0;
  }
}
:where(#widgetEditorDialog) .table-responsive {
  display: block;
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}
:where(#widgetEditorDialog) .table-responsive > .table-bordered {
  border: 0;
}
:where(#widgetEditorDialog) .form-control {
  display: block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  :where(#widgetEditorDialog) .form-control {
    transition: none;
  }
}
:where(#widgetEditorDialog) .form-control::-ms-expand {
  background-color: transparent;
  border: 0;
}
:where(#widgetEditorDialog) .form-control:focus {
  color: #495057;
  background-color: #fff;
  border-color: rgb(50%, 74.1176470588%, 100%);
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}
:where(#widgetEditorDialog) .form-control::placeholder {
  color: #6c757d;
  opacity: 1;
}
:where(#widgetEditorDialog) .form-control:disabled, :where(#widgetEditorDialog) .form-control[readonly] {
  background-color: #e9ecef;
  opacity: 1;
}
:where(#widgetEditorDialog) input[type=date].form-control,
:where(#widgetEditorDialog) input[type=time].form-control,
:where(#widgetEditorDialog) input[type=datetime-local].form-control,
:where(#widgetEditorDialog) input[type=month].form-control {
  appearance: none;
}
:where(#widgetEditorDialog) select.form-control:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 #495057;
}
:where(#widgetEditorDialog) select.form-control:focus::-ms-value {
  color: #495057;
  background-color: #fff;
}
:where(#widgetEditorDialog) .form-control-file,
:where(#widgetEditorDialog) .form-control-range {
  display: block;
  width: 100%;
}
:where(#widgetEditorDialog) .col-form-label {
  padding-top: calc(0.375rem + 1px);
  padding-bottom: calc(0.375rem + 1px);
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5;
}
:where(#widgetEditorDialog) .col-form-label-lg {
  padding-top: calc(0.5rem + 1px);
  padding-bottom: calc(0.5rem + 1px);
  font-size: 1.25rem;
  line-height: 1.5;
}
:where(#widgetEditorDialog) .col-form-label-sm {
  padding-top: calc(0.25rem + 1px);
  padding-bottom: calc(0.25rem + 1px);
  font-size: 0.875rem;
  line-height: 1.5;
}
:where(#widgetEditorDialog) .form-control-plaintext {
  display: block;
  width: 100%;
  padding: 0.375rem 0;
  margin-bottom: 0;
  font-size: 1rem;
  line-height: 1.5;
  color: #212529;
  background-color: transparent;
  border: solid transparent;
  border-width: 1px 0;
}
:where(#widgetEditorDialog) .form-control-plaintext.form-control-sm, :where(#widgetEditorDialog) .form-control-plaintext.form-control-lg {
  padding-right: 0;
  padding-left: 0;
}
:where(#widgetEditorDialog) .form-control-sm {
  height: calc(1.5em + 0.5rem + 2px);
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.2rem;
}
:where(#widgetEditorDialog) .form-control-lg {
  height: calc(1.5em + 1rem + 2px);
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  line-height: 1.5;
  border-radius: 0.3rem;
}
:where(#widgetEditorDialog) select.form-control[size], :where(#widgetEditorDialog) select.form-control[multiple] {
  height: auto;
}
:where(#widgetEditorDialog) textarea.form-control {
  height: auto;
}
:where(#widgetEditorDialog) .form-group {
  margin-bottom: 1rem;
}
:where(#widgetEditorDialog) .form-text {
  display: block;
  margin-top: 0.25rem;
}
:where(#widgetEditorDialog) .form-row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -5px;
  margin-left: -5px;
}
:where(#widgetEditorDialog) .form-row > .col,
:where(#widgetEditorDialog) .form-row > [class*=col-] {
  padding-right: 5px;
  padding-left: 5px;
}
:where(#widgetEditorDialog) .form-check {
  position: relative;
  display: block;
  padding-left: 1.25rem;
}
:where(#widgetEditorDialog) .form-check-input {
  position: absolute;
  margin-top: 0.3rem;
  margin-left: -1.25rem;
}
:where(#widgetEditorDialog) .form-check-input[disabled] ~ .form-check-label, :where(#widgetEditorDialog) .form-check-input:disabled ~ .form-check-label {
  color: #6c757d;
}
:where(#widgetEditorDialog) .form-check-label {
  margin-bottom: 0;
}
:where(#widgetEditorDialog) .form-check-inline {
  display: inline-flex;
  align-items: center;
  padding-left: 0;
  margin-right: 0.75rem;
}
:where(#widgetEditorDialog) .form-check-inline .form-check-input {
  position: static;
  margin-top: 0;
  margin-right: 0.3125rem;
  margin-left: 0;
}
:where(#widgetEditorDialog) .valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #28a745;
}
:where(#widgetEditorDialog) .valid-tooltip {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  line-height: 1.5;
  color: #fff;
  background-color: rgba(40, 167, 69, 0.9);
  border-radius: 0.25rem;
}
.form-row > .col > :where(#widgetEditorDialog) .valid-tooltip, .form-row > [class*=col-] > :where(#widgetEditorDialog) .valid-tooltip {
  left: 5px;
}
.was-validated :where(#widgetEditorDialog):valid ~ .valid-feedback,
.was-validated :where(#widgetEditorDialog):valid ~ .valid-tooltip, :where(#widgetEditorDialog).is-valid ~ .valid-feedback,
:where(#widgetEditorDialog).is-valid ~ .valid-tooltip {
  display: block;
}
.was-validated :where(#widgetEditorDialog) .form-control:valid, :where(#widgetEditorDialog) .form-control.is-valid {
  border-color: #28a745;
  padding-right: calc(1.5em + 0.75rem) !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated :where(#widgetEditorDialog) .form-control:valid:focus, :where(#widgetEditorDialog) .form-control.is-valid:focus {
  border-color: #28a745;
  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);
}
.was-validated :where(#widgetEditorDialog) select.form-control:valid, :where(#widgetEditorDialog) select.form-control.is-valid {
  padding-right: 3rem !important;
  background-position: right 1.5rem center;
}
.was-validated :where(#widgetEditorDialog) textarea.form-control:valid, :where(#widgetEditorDialog) textarea.form-control.is-valid {
  padding-right: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);
}
.was-validated :where(#widgetEditorDialog) .custom-select:valid, :where(#widgetEditorDialog) .custom-select.is-valid {
  border-color: #28a745;
  padding-right: calc(0.75em + 2.3125rem) !important;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) right 0.75rem center/8px 10px no-repeat, #fff url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center right 1.75rem/calc(0.75em + 0.375rem) calc(0.75em + 0.375rem) no-repeat;
}
.was-validated :where(#widgetEditorDialog) .custom-select:valid:focus, :where(#widgetEditorDialog) .custom-select.is-valid:focus {
  border-color: #28a745;
  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);
}
.was-validated :where(#widgetEditorDialog) .form-check-input:valid ~ .form-check-label, :where(#widgetEditorDialog) .form-check-input.is-valid ~ .form-check-label {
  color: #28a745;
}
.was-validated :where(#widgetEditorDialog) .form-check-input:valid ~ .valid-feedback,
.was-validated :where(#widgetEditorDialog) .form-check-input:valid ~ .valid-tooltip, :where(#widgetEditorDialog) .form-check-input.is-valid ~ .valid-feedback,
:where(#widgetEditorDialog) .form-check-input.is-valid ~ .valid-tooltip {
  display: block;
}
.was-validated :where(#widgetEditorDialog) .custom-control-input:valid ~ .custom-control-label, :where(#widgetEditorDialog) .custom-control-input.is-valid ~ .custom-control-label {
  color: #28a745;
}
.was-validated :where(#widgetEditorDialog) .custom-control-input:valid ~ .custom-control-label::before, :where(#widgetEditorDialog) .custom-control-input.is-valid ~ .custom-control-label::before {
  border-color: #28a745;
}
.was-validated :where(#widgetEditorDialog) .custom-control-input:valid:checked ~ .custom-control-label::before, :where(#widgetEditorDialog) .custom-control-input.is-valid:checked ~ .custom-control-label::before {
  border-color: rgb(20.2728047741%, 80.9036658142%, 34.1176470588%);
  background-color: rgb(20.2728047741%, 80.9036658142%, 34.1176470588%);
}
.was-validated :where(#widgetEditorDialog) .custom-control-input:valid:focus ~ .custom-control-label::before, :where(#widgetEditorDialog) .custom-control-input.is-valid:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);
}
.was-validated :where(#widgetEditorDialog) .custom-control-input:valid:focus:not(:checked) ~ .custom-control-label::before, :where(#widgetEditorDialog) .custom-control-input.is-valid:focus:not(:checked) ~ .custom-control-label::before {
  border-color: #28a745;
}
.was-validated :where(#widgetEditorDialog) .custom-file-input:valid ~ .custom-file-label, :where(#widgetEditorDialog) .custom-file-input.is-valid ~ .custom-file-label {
  border-color: #28a745;
}
.was-validated :where(#widgetEditorDialog) .custom-file-input:valid:focus ~ .custom-file-label, :where(#widgetEditorDialog) .custom-file-input.is-valid:focus ~ .custom-file-label {
  border-color: #28a745;
  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);
}
:where(#widgetEditorDialog) .invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #dc3545;
}
:where(#widgetEditorDialog) .invalid-tooltip {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  line-height: 1.5;
  color: #fff;
  background-color: rgba(220, 53, 69, 0.9);
  border-radius: 0.25rem;
}
.form-row > .col > :where(#widgetEditorDialog) .invalid-tooltip, .form-row > [class*=col-] > :where(#widgetEditorDialog) .invalid-tooltip {
  left: 5px;
}
.was-validated :where(#widgetEditorDialog):invalid ~ .invalid-feedback,
.was-validated :where(#widgetEditorDialog):invalid ~ .invalid-tooltip, :where(#widgetEditorDialog).is-invalid ~ .invalid-feedback,
:where(#widgetEditorDialog).is-invalid ~ .invalid-tooltip {
  display: block;
}
.was-validated :where(#widgetEditorDialog) .form-control:invalid, :where(#widgetEditorDialog) .form-control.is-invalid {
  border-color: #dc3545;
  padding-right: calc(1.5em + 0.75rem) !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated :where(#widgetEditorDialog) .form-control:invalid:focus, :where(#widgetEditorDialog) .form-control.is-invalid:focus {
  border-color: #dc3545;
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
}
.was-validated :where(#widgetEditorDialog) select.form-control:invalid, :where(#widgetEditorDialog) select.form-control.is-invalid {
  padding-right: 3rem !important;
  background-position: right 1.5rem center;
}
.was-validated :where(#widgetEditorDialog) textarea.form-control:invalid, :where(#widgetEditorDialog) textarea.form-control.is-invalid {
  padding-right: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);
}
.was-validated :where(#widgetEditorDialog) .custom-select:invalid, :where(#widgetEditorDialog) .custom-select.is-invalid {
  border-color: #dc3545;
  padding-right: calc(0.75em + 2.3125rem) !important;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) right 0.75rem center/8px 10px no-repeat, #fff url(${___CSS_LOADER_URL_REPLACEMENT_2___}) center right 1.75rem/calc(0.75em + 0.375rem) calc(0.75em + 0.375rem) no-repeat;
}
.was-validated :where(#widgetEditorDialog) .custom-select:invalid:focus, :where(#widgetEditorDialog) .custom-select.is-invalid:focus {
  border-color: #dc3545;
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
}
.was-validated :where(#widgetEditorDialog) .form-check-input:invalid ~ .form-check-label, :where(#widgetEditorDialog) .form-check-input.is-invalid ~ .form-check-label {
  color: #dc3545;
}
.was-validated :where(#widgetEditorDialog) .form-check-input:invalid ~ .invalid-feedback,
.was-validated :where(#widgetEditorDialog) .form-check-input:invalid ~ .invalid-tooltip, :where(#widgetEditorDialog) .form-check-input.is-invalid ~ .invalid-feedback,
:where(#widgetEditorDialog) .form-check-input.is-invalid ~ .invalid-tooltip {
  display: block;
}
.was-validated :where(#widgetEditorDialog) .custom-control-input:invalid ~ .custom-control-label, :where(#widgetEditorDialog) .custom-control-input.is-invalid ~ .custom-control-label {
  color: #dc3545;
}
.was-validated :where(#widgetEditorDialog) .custom-control-input:invalid ~ .custom-control-label::before, :where(#widgetEditorDialog) .custom-control-input.is-invalid ~ .custom-control-label::before {
  border-color: #dc3545;
}
.was-validated :where(#widgetEditorDialog) .custom-control-input:invalid:checked ~ .custom-control-label::before, :where(#widgetEditorDialog) .custom-control-input.is-invalid:checked ~ .custom-control-label::before {
  border-color: rgb(89.2280963018%, 37.8307272276%, 42.7550260611%);
  background-color: rgb(89.2280963018%, 37.8307272276%, 42.7550260611%);
}
.was-validated :where(#widgetEditorDialog) .custom-control-input:invalid:focus ~ .custom-control-label::before, :where(#widgetEditorDialog) .custom-control-input.is-invalid:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
}
.was-validated :where(#widgetEditorDialog) .custom-control-input:invalid:focus:not(:checked) ~ .custom-control-label::before, :where(#widgetEditorDialog) .custom-control-input.is-invalid:focus:not(:checked) ~ .custom-control-label::before {
  border-color: #dc3545;
}
.was-validated :where(#widgetEditorDialog) .custom-file-input:invalid ~ .custom-file-label, :where(#widgetEditorDialog) .custom-file-input.is-invalid ~ .custom-file-label {
  border-color: #dc3545;
}
.was-validated :where(#widgetEditorDialog) .custom-file-input:invalid:focus ~ .custom-file-label, :where(#widgetEditorDialog) .custom-file-input.is-invalid:focus ~ .custom-file-label {
  border-color: #dc3545;
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
}
:where(#widgetEditorDialog) .form-inline {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
}
:where(#widgetEditorDialog) .form-inline .form-check {
  width: 100%;
}
@media (min-width: 576px) {
  :where(#widgetEditorDialog) .form-inline label {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 0;
  }
  :where(#widgetEditorDialog) .form-inline .form-group {
    display: flex;
    flex: 0 0 auto;
    flex-flow: row wrap;
    align-items: center;
    margin-bottom: 0;
  }
  :where(#widgetEditorDialog) .form-inline .form-control {
    display: inline-block;
    width: auto;
    vertical-align: middle;
  }
  :where(#widgetEditorDialog) .form-inline .form-control-plaintext {
    display: inline-block;
  }
  :where(#widgetEditorDialog) .form-inline .input-group,
  :where(#widgetEditorDialog) .form-inline .custom-select {
    width: auto;
  }
  :where(#widgetEditorDialog) .form-inline .form-check {
    display: flex;
    align-items: center;
    justify-content: center;
    width: auto;
    padding-left: 0;
  }
  :where(#widgetEditorDialog) .form-inline .form-check-input {
    position: relative;
    flex-shrink: 0;
    margin-top: 0;
    margin-right: 0.25rem;
    margin-left: 0;
  }
  :where(#widgetEditorDialog) .form-inline .custom-control {
    align-items: center;
    justify-content: center;
  }
  :where(#widgetEditorDialog) .form-inline .custom-control-label {
    margin-bottom: 0;
  }
}
:where(#widgetEditorDialog) .btn {
  display: inline-block;
  font-weight: 400;
  color: #212529;
  text-align: center;
  vertical-align: middle;
  user-select: none;
  background-color: transparent;
  border: 1px solid transparent;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  border-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  :where(#widgetEditorDialog) .btn {
    transition: none;
  }
}
:where(#widgetEditorDialog) .btn:hover {
  color: #212529;
  text-decoration: none;
}
:where(#widgetEditorDialog) .btn:focus, :where(#widgetEditorDialog) .btn.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}
:where(#widgetEditorDialog) .btn.disabled, :where(#widgetEditorDialog) .btn:disabled {
  opacity: 0.65;
}
:where(#widgetEditorDialog) .btn:not(:disabled):not(.disabled) {
  cursor: pointer;
}
:where(#widgetEditorDialog) a.btn.disabled,
:where(#widgetEditorDialog) fieldset:disabled a.btn {
  pointer-events: none;
}
:where(#widgetEditorDialog) .btn-primary {
  color: #fff;
  background-color: #007bff;
  border-color: #007bff;
}
:where(#widgetEditorDialog) .btn-primary:hover {
  color: #fff;
  background-color: rgb(0%, 41%, 85%);
  border-color: rgb(0%, 38.5882352941%, 80%);
}
:where(#widgetEditorDialog) .btn-primary:focus, :where(#widgetEditorDialog) .btn-primary.focus {
  color: #fff;
  background-color: rgb(0%, 41%, 85%);
  border-color: rgb(0%, 38.5882352941%, 80%);
  box-shadow: 0 0 0 0.2rem rgba(15%, 56%, 100%, 0.5);
}
:where(#widgetEditorDialog) .btn-primary.disabled, :where(#widgetEditorDialog) .btn-primary:disabled {
  color: #fff;
  background-color: #007bff;
  border-color: #007bff;
}
:where(#widgetEditorDialog) .btn-primary:not(:disabled):not(.disabled):active, :where(#widgetEditorDialog) .btn-primary:not(:disabled):not(.disabled).active, .show > :where(#widgetEditorDialog) .btn-primary.dropdown-toggle {
  color: #fff;
  background-color: rgb(0%, 38.5882352941%, 80%);
  border-color: rgb(0%, 36.1764705882%, 75%);
}
:where(#widgetEditorDialog) .btn-primary:not(:disabled):not(.disabled):active:focus, :where(#widgetEditorDialog) .btn-primary:not(:disabled):not(.disabled).active:focus, .show > :where(#widgetEditorDialog) .btn-primary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(15%, 56%, 100%, 0.5);
}
:where(#widgetEditorDialog) .btn-secondary {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
}
:where(#widgetEditorDialog) .btn-secondary:hover {
  color: #fff;
  background-color: rgb(35.4001514769%, 38.3501641%, 40.9723975427%);
  border-color: rgb(33.0825549104%, 35.8394344862%, 38.2899941092%);
}
:where(#widgetEditorDialog) .btn-secondary:focus, :where(#widgetEditorDialog) .btn-secondary.focus {
  color: #fff;
  background-color: rgb(35.4001514769%, 38.3501641%, 40.9723975427%);
  border-color: rgb(33.0825549104%, 35.8394344862%, 38.2899941092%);
  box-shadow: 0 0 0 0.2rem rgba(51%, 54%, 56.6666666667%, 0.5);
}
:where(#widgetEditorDialog) .btn-secondary.disabled, :where(#widgetEditorDialog) .btn-secondary:disabled {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
}
:where(#widgetEditorDialog) .btn-secondary:not(:disabled):not(.disabled):active, :where(#widgetEditorDialog) .btn-secondary:not(:disabled):not(.disabled).active, .show > :where(#widgetEditorDialog) .btn-secondary.dropdown-toggle {
  color: #fff;
  background-color: rgb(33.0825549104%, 35.8394344862%, 38.2899941092%);
  border-color: rgb(30.7649583439%, 33.3287048725%, 35.6075906758%);
}
:where(#widgetEditorDialog) .btn-secondary:not(:disabled):not(.disabled):active:focus, :where(#widgetEditorDialog) .btn-secondary:not(:disabled):not(.disabled).active:focus, .show > :where(#widgetEditorDialog) .btn-secondary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(51%, 54%, 56.6666666667%, 0.5);
}
:where(#widgetEditorDialog) .btn-success {
  color: #fff;
  background-color: #28a745;
  border-color: #28a745;
}
:where(#widgetEditorDialog) .btn-success:hover {
  color: #fff;
  background-color: rgb(12.7877237852%, 53.3887468031%, 22.0588235294%);
  border-color: rgb(11.8215402103%, 49.3549303779%, 20.3921568627%);
}
:where(#widgetEditorDialog) .btn-success:focus, :where(#widgetEditorDialog) .btn-success.focus {
  color: #fff;
  background-color: rgb(12.7877237852%, 53.3887468031%, 22.0588235294%);
  border-color: rgb(11.8215402103%, 49.3549303779%, 20.3921568627%);
  box-shadow: 0 0 0 0.2rem rgba(28.3333333333%, 70.6666666667%, 38%, 0.5);
}
:where(#widgetEditorDialog) .btn-success.disabled, :where(#widgetEditorDialog) .btn-success:disabled {
  color: #fff;
  background-color: #28a745;
  border-color: #28a745;
}
:where(#widgetEditorDialog) .btn-success:not(:disabled):not(.disabled):active, :where(#widgetEditorDialog) .btn-success:not(:disabled):not(.disabled).active, .show > :where(#widgetEditorDialog) .btn-success.dropdown-toggle {
  color: #fff;
  background-color: rgb(11.8215402103%, 49.3549303779%, 20.3921568627%);
  border-color: rgb(10.8553566354%, 45.3211139528%, 18.7254901961%);
}
:where(#widgetEditorDialog) .btn-success:not(:disabled):not(.disabled):active:focus, :where(#widgetEditorDialog) .btn-success:not(:disabled):not(.disabled).active:focus, .show > :where(#widgetEditorDialog) .btn-success.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(28.3333333333%, 70.6666666667%, 38%, 0.5);
}
:where(#widgetEditorDialog) .btn-info {
  color: #fff;
  background-color: #17a2b8;
  border-color: #17a2b8;
}
:where(#widgetEditorDialog) .btn-info:hover {
  color: #fff;
  background-color: rgb(7.3529411765%, 51.7902813299%, 58.8235294118%);
  border-color: rgb(6.7973856209%, 47.8772378517%, 54.3790849673%);
}
:where(#widgetEditorDialog) .btn-info:focus, :where(#widgetEditorDialog) .btn-info.focus {
  color: #fff;
  background-color: rgb(7.3529411765%, 51.7902813299%, 58.8235294118%);
  border-color: rgb(6.7973856209%, 47.8772378517%, 54.3790849673%);
  box-shadow: 0 0 0 0.2rem rgba(22.6666666667%, 69%, 76.3333333333%, 0.5);
}
:where(#widgetEditorDialog) .btn-info.disabled, :where(#widgetEditorDialog) .btn-info:disabled {
  color: #fff;
  background-color: #17a2b8;
  border-color: #17a2b8;
}
:where(#widgetEditorDialog) .btn-info:not(:disabled):not(.disabled):active, :where(#widgetEditorDialog) .btn-info:not(:disabled):not(.disabled).active, .show > :where(#widgetEditorDialog) .btn-info.dropdown-toggle {
  color: #fff;
  background-color: rgb(6.7973856209%, 47.8772378517%, 54.3790849673%);
  border-color: rgb(6.2418300654%, 43.9641943734%, 49.9346405229%);
}
:where(#widgetEditorDialog) .btn-info:not(:disabled):not(.disabled):active:focus, :where(#widgetEditorDialog) .btn-info:not(:disabled):not(.disabled).active:focus, .show > :where(#widgetEditorDialog) .btn-info.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(22.6666666667%, 69%, 76.3333333333%, 0.5);
}
:where(#widgetEditorDialog) .btn-warning {
  color: #212529;
  background-color: #ffc107;
  border-color: #ffc107;
}
:where(#widgetEditorDialog) .btn-warning:hover {
  color: #212529;
  background-color: rgb(87.7450980392%, 65.8088235294%, 0%);
  border-color: rgb(82.7450980392%, 62.0588235294%, 0%);
}
:where(#widgetEditorDialog) .btn-warning:focus, :where(#widgetEditorDialog) .btn-warning.focus {
  color: #212529;
  background-color: rgb(87.7450980392%, 65.8088235294%, 0%);
  border-color: rgb(82.7450980392%, 62.0588235294%, 0%);
  box-shadow: 0 0 0 0.2rem rgba(86.9411764706%, 66.5098039216%, 4.7450980392%, 0.5);
}
:where(#widgetEditorDialog) .btn-warning.disabled, :where(#widgetEditorDialog) .btn-warning:disabled {
  color: #212529;
  background-color: #ffc107;
  border-color: #ffc107;
}
:where(#widgetEditorDialog) .btn-warning:not(:disabled):not(.disabled):active, :where(#widgetEditorDialog) .btn-warning:not(:disabled):not(.disabled).active, .show > :where(#widgetEditorDialog) .btn-warning.dropdown-toggle {
  color: #212529;
  background-color: rgb(82.7450980392%, 62.0588235294%, 0%);
  border-color: rgb(77.7450980392%, 58.3088235294%, 0%);
}
:where(#widgetEditorDialog) .btn-warning:not(:disabled):not(.disabled):active:focus, :where(#widgetEditorDialog) .btn-warning:not(:disabled):not(.disabled).active:focus, .show > :where(#widgetEditorDialog) .btn-warning.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(86.9411764706%, 66.5098039216%, 4.7450980392%, 0.5);
}
:where(#widgetEditorDialog) .btn-danger {
  color: #fff;
  background-color: #dc3545;
  border-color: #dc3545;
}
:where(#widgetEditorDialog) .btn-danger:hover {
  color: #fff;
  background-color: rgb(78.46363862%, 13.5951849094%, 19.8101265823%);
  border-color: rgb(74.2020352445%, 12.8567882849%, 18.7341772152%);
}
:where(#widgetEditorDialog) .btn-danger:focus, :where(#widgetEditorDialog) .btn-danger.focus {
  color: #fff;
  background-color: rgb(78.46363862%, 13.5951849094%, 19.8101265823%);
  border-color: rgb(74.2020352445%, 12.8567882849%, 18.7341772152%);
  box-shadow: 0 0 0 0.2rem rgba(88.3333333333%, 32.6666666667%, 38%, 0.5);
}
:where(#widgetEditorDialog) .btn-danger.disabled, :where(#widgetEditorDialog) .btn-danger:disabled {
  color: #fff;
  background-color: #dc3545;
  border-color: #dc3545;
}
:where(#widgetEditorDialog) .btn-danger:not(:disabled):not(.disabled):active, :where(#widgetEditorDialog) .btn-danger:not(:disabled):not(.disabled).active, .show > :where(#widgetEditorDialog) .btn-danger.dropdown-toggle {
  color: #fff;
  background-color: rgb(74.2020352445%, 12.8567882849%, 18.7341772152%);
  border-color: rgb(69.940431869%, 12.1183916605%, 17.6582278481%);
}
:where(#widgetEditorDialog) .btn-danger:not(:disabled):not(.disabled):active:focus, :where(#widgetEditorDialog) .btn-danger:not(:disabled):not(.disabled).active:focus, .show > :where(#widgetEditorDialog) .btn-danger.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(88.3333333333%, 32.6666666667%, 38%, 0.5);
}
:where(#widgetEditorDialog) .btn-light {
  color: #212529;
  background-color: #f8f9fa;
  border-color: #f8f9fa;
}
:where(#widgetEditorDialog) .btn-light:hover {
  color: #212529;
  background-color: rgb(88.5049019608%, 90.1470588235%, 91.7892156863%);
  border-color: rgb(85.5882352941%, 87.6470588235%, 89.7058823529%);
}
:where(#widgetEditorDialog) .btn-light:focus, :where(#widgetEditorDialog) .btn-light.focus {
  color: #212529;
  background-color: rgb(88.5049019608%, 90.1470588235%, 91.7892156863%);
  border-color: rgb(85.5882352941%, 87.6470588235%, 89.7058823529%);
  box-shadow: 0 0 0 0.2rem rgba(84.6078431373%, 85.1764705882%, 85.7450980392%, 0.5);
}
:where(#widgetEditorDialog) .btn-light.disabled, :where(#widgetEditorDialog) .btn-light:disabled {
  color: #212529;
  background-color: #f8f9fa;
  border-color: #f8f9fa;
}
:where(#widgetEditorDialog) .btn-light:not(:disabled):not(.disabled):active, :where(#widgetEditorDialog) .btn-light:not(:disabled):not(.disabled).active, .show > :where(#widgetEditorDialog) .btn-light.dropdown-toggle {
  color: #212529;
  background-color: rgb(85.5882352941%, 87.6470588235%, 89.7058823529%);
  border-color: rgb(82.6715686275%, 85.1470588235%, 87.6225490196%);
}
:where(#widgetEditorDialog) .btn-light:not(:disabled):not(.disabled):active:focus, :where(#widgetEditorDialog) .btn-light:not(:disabled):not(.disabled).active:focus, .show > :where(#widgetEditorDialog) .btn-light.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(84.6078431373%, 85.1764705882%, 85.7450980392%, 0.5);
}
:where(#widgetEditorDialog) .btn-dark {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
:where(#widgetEditorDialog) .btn-dark:hover {
  color: #fff;
  background-color: rgb(13.6680189317%, 15.2450980392%, 16.8221771467%);
  border-color: rgb(11.4266396214%, 12.7450980392%, 14.0635564571%);
}
:where(#widgetEditorDialog) .btn-dark:focus, :where(#widgetEditorDialog) .btn-dark.focus {
  color: #fff;
  background-color: rgb(13.6680189317%, 15.2450980392%, 16.8221771467%);
  border-color: rgb(11.4266396214%, 12.7450980392%, 14.0635564571%);
  box-shadow: 0 0 0 0.2rem rgba(32.3333333333%, 34.3333333333%, 36.3333333333%, 0.5);
}
:where(#widgetEditorDialog) .btn-dark.disabled, :where(#widgetEditorDialog) .btn-dark:disabled {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
:where(#widgetEditorDialog) .btn-dark:not(:disabled):not(.disabled):active, :where(#widgetEditorDialog) .btn-dark:not(:disabled):not(.disabled).active, .show > :where(#widgetEditorDialog) .btn-dark.dropdown-toggle {
  color: #fff;
  background-color: rgb(11.4266396214%, 12.7450980392%, 14.0635564571%);
  border-color: rgb(9.185260311%, 10.2450980392%, 11.3049357674%);
}
:where(#widgetEditorDialog) .btn-dark:not(:disabled):not(.disabled):active:focus, :where(#widgetEditorDialog) .btn-dark:not(:disabled):not(.disabled).active:focus, .show > :where(#widgetEditorDialog) .btn-dark.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(32.3333333333%, 34.3333333333%, 36.3333333333%, 0.5);
}
:where(#widgetEditorDialog) .btn-outline-primary {
  color: #007bff;
  border-color: #007bff;
}
:where(#widgetEditorDialog) .btn-outline-primary:hover {
  color: #fff;
  background-color: #007bff;
  border-color: #007bff;
}
:where(#widgetEditorDialog) .btn-outline-primary:focus, :where(#widgetEditorDialog) .btn-outline-primary.focus {
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.5);
}
:where(#widgetEditorDialog) .btn-outline-primary.disabled, :where(#widgetEditorDialog) .btn-outline-primary:disabled {
  color: #007bff;
  background-color: transparent;
}
:where(#widgetEditorDialog) .btn-outline-primary:not(:disabled):not(.disabled):active, :where(#widgetEditorDialog) .btn-outline-primary:not(:disabled):not(.disabled).active, .show > :where(#widgetEditorDialog) .btn-outline-primary.dropdown-toggle {
  color: #fff;
  background-color: #007bff;
  border-color: #007bff;
}
:where(#widgetEditorDialog) .btn-outline-primary:not(:disabled):not(.disabled):active:focus, :where(#widgetEditorDialog) .btn-outline-primary:not(:disabled):not(.disabled).active:focus, .show > :where(#widgetEditorDialog) .btn-outline-primary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.5);
}
:where(#widgetEditorDialog) .btn-outline-secondary {
  color: #6c757d;
  border-color: #6c757d;
}
:where(#widgetEditorDialog) .btn-outline-secondary:hover {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
}
:where(#widgetEditorDialog) .btn-outline-secondary:focus, :where(#widgetEditorDialog) .btn-outline-secondary.focus {
  box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.5);
}
:where(#widgetEditorDialog) .btn-outline-secondary.disabled, :where(#widgetEditorDialog) .btn-outline-secondary:disabled {
  color: #6c757d;
  background-color: transparent;
}
:where(#widgetEditorDialog) .btn-outline-secondary:not(:disabled):not(.disabled):active, :where(#widgetEditorDialog) .btn-outline-secondary:not(:disabled):not(.disabled).active, .show > :where(#widgetEditorDialog) .btn-outline-secondary.dropdown-toggle {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
}
:where(#widgetEditorDialog) .btn-outline-secondary:not(:disabled):not(.disabled):active:focus, :where(#widgetEditorDialog) .btn-outline-secondary:not(:disabled):not(.disabled).active:focus, .show > :where(#widgetEditorDialog) .btn-outline-secondary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.5);
}
:where(#widgetEditorDialog) .btn-outline-success {
  color: #28a745;
  border-color: #28a745;
}
:where(#widgetEditorDialog) .btn-outline-success:hover {
  color: #fff;
  background-color: #28a745;
  border-color: #28a745;
}
:where(#widgetEditorDialog) .btn-outline-success:focus, :where(#widgetEditorDialog) .btn-outline-success.focus {
  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.5);
}
:where(#widgetEditorDialog) .btn-outline-success.disabled, :where(#widgetEditorDialog) .btn-outline-success:disabled {
  color: #28a745;
  background-color: transparent;
}
:where(#widgetEditorDialog) .btn-outline-success:not(:disabled):not(.disabled):active, :where(#widgetEditorDialog) .btn-outline-success:not(:disabled):not(.disabled).active, .show > :where(#widgetEditorDialog) .btn-outline-success.dropdown-toggle {
  color: #fff;
  background-color: #28a745;
  border-color: #28a745;
}
:where(#widgetEditorDialog) .btn-outline-success:not(:disabled):not(.disabled):active:focus, :where(#widgetEditorDialog) .btn-outline-success:not(:disabled):not(.disabled).active:focus, .show > :where(#widgetEditorDialog) .btn-outline-success.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.5);
}
:where(#widgetEditorDialog) .btn-outline-info {
  color: #17a2b8;
  border-color: #17a2b8;
}
:where(#widgetEditorDialog) .btn-outline-info:hover {
  color: #fff;
  background-color: #17a2b8;
  border-color: #17a2b8;
}
:where(#widgetEditorDialog) .btn-outline-info:focus, :where(#widgetEditorDialog) .btn-outline-info.focus {
  box-shadow: 0 0 0 0.2rem rgba(23, 162, 184, 0.5);
}
:where(#widgetEditorDialog) .btn-outline-info.disabled, :where(#widgetEditorDialog) .btn-outline-info:disabled {
  color: #17a2b8;
  background-color: transparent;
}
:where(#widgetEditorDialog) .btn-outline-info:not(:disabled):not(.disabled):active, :where(#widgetEditorDialog) .btn-outline-info:not(:disabled):not(.disabled).active, .show > :where(#widgetEditorDialog) .btn-outline-info.dropdown-toggle {
  color: #fff;
  background-color: #17a2b8;
  border-color: #17a2b8;
}
:where(#widgetEditorDialog) .btn-outline-info:not(:disabled):not(.disabled):active:focus, :where(#widgetEditorDialog) .btn-outline-info:not(:disabled):not(.disabled).active:focus, .show > :where(#widgetEditorDialog) .btn-outline-info.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(23, 162, 184, 0.5);
}
:where(#widgetEditorDialog) .btn-outline-warning {
  color: #ffc107;
  border-color: #ffc107;
}
:where(#widgetEditorDialog) .btn-outline-warning:hover {
  color: #212529;
  background-color: #ffc107;
  border-color: #ffc107;
}
:where(#widgetEditorDialog) .btn-outline-warning:focus, :where(#widgetEditorDialog) .btn-outline-warning.focus {
  box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.5);
}
:where(#widgetEditorDialog) .btn-outline-warning.disabled, :where(#widgetEditorDialog) .btn-outline-warning:disabled {
  color: #ffc107;
  background-color: transparent;
}
:where(#widgetEditorDialog) .btn-outline-warning:not(:disabled):not(.disabled):active, :where(#widgetEditorDialog) .btn-outline-warning:not(:disabled):not(.disabled).active, .show > :where(#widgetEditorDialog) .btn-outline-warning.dropdown-toggle {
  color: #212529;
  background-color: #ffc107;
  border-color: #ffc107;
}
:where(#widgetEditorDialog) .btn-outline-warning:not(:disabled):not(.disabled):active:focus, :where(#widgetEditorDialog) .btn-outline-warning:not(:disabled):not(.disabled).active:focus, .show > :where(#widgetEditorDialog) .btn-outline-warning.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.5);
}
:where(#widgetEditorDialog) .btn-outline-danger {
  color: #dc3545;
  border-color: #dc3545;
}
:where(#widgetEditorDialog) .btn-outline-danger:hover {
  color: #fff;
  background-color: #dc3545;
  border-color: #dc3545;
}
:where(#widgetEditorDialog) .btn-outline-danger:focus, :where(#widgetEditorDialog) .btn-outline-danger.focus {
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.5);
}
:where(#widgetEditorDialog) .btn-outline-danger.disabled, :where(#widgetEditorDialog) .btn-outline-danger:disabled {
  color: #dc3545;
  background-color: transparent;
}
:where(#widgetEditorDialog) .btn-outline-danger:not(:disabled):not(.disabled):active, :where(#widgetEditorDialog) .btn-outline-danger:not(:disabled):not(.disabled).active, .show > :where(#widgetEditorDialog) .btn-outline-danger.dropdown-toggle {
  color: #fff;
  background-color: #dc3545;
  border-color: #dc3545;
}
:where(#widgetEditorDialog) .btn-outline-danger:not(:disabled):not(.disabled):active:focus, :where(#widgetEditorDialog) .btn-outline-danger:not(:disabled):not(.disabled).active:focus, .show > :where(#widgetEditorDialog) .btn-outline-danger.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.5);
}
:where(#widgetEditorDialog) .btn-outline-light {
  color: #f8f9fa;
  border-color: #f8f9fa;
}
:where(#widgetEditorDialog) .btn-outline-light:hover {
  color: #212529;
  background-color: #f8f9fa;
  border-color: #f8f9fa;
}
:where(#widgetEditorDialog) .btn-outline-light:focus, :where(#widgetEditorDialog) .btn-outline-light.focus {
  box-shadow: 0 0 0 0.2rem rgba(248, 249, 250, 0.5);
}
:where(#widgetEditorDialog) .btn-outline-light.disabled, :where(#widgetEditorDialog) .btn-outline-light:disabled {
  color: #f8f9fa;
  background-color: transparent;
}
:where(#widgetEditorDialog) .btn-outline-light:not(:disabled):not(.disabled):active, :where(#widgetEditorDialog) .btn-outline-light:not(:disabled):not(.disabled).active, .show > :where(#widgetEditorDialog) .btn-outline-light.dropdown-toggle {
  color: #212529;
  background-color: #f8f9fa;
  border-color: #f8f9fa;
}
:where(#widgetEditorDialog) .btn-outline-light:not(:disabled):not(.disabled):active:focus, :where(#widgetEditorDialog) .btn-outline-light:not(:disabled):not(.disabled).active:focus, .show > :where(#widgetEditorDialog) .btn-outline-light.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(248, 249, 250, 0.5);
}
:where(#widgetEditorDialog) .btn-outline-dark {
  color: #343a40;
  border-color: #343a40;
}
:where(#widgetEditorDialog) .btn-outline-dark:hover {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
:where(#widgetEditorDialog) .btn-outline-dark:focus, :where(#widgetEditorDialog) .btn-outline-dark.focus {
  box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}
:where(#widgetEditorDialog) .btn-outline-dark.disabled, :where(#widgetEditorDialog) .btn-outline-dark:disabled {
  color: #343a40;
  background-color: transparent;
}
:where(#widgetEditorDialog) .btn-outline-dark:not(:disabled):not(.disabled):active, :where(#widgetEditorDialog) .btn-outline-dark:not(:disabled):not(.disabled).active, .show > :where(#widgetEditorDialog) .btn-outline-dark.dropdown-toggle {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
:where(#widgetEditorDialog) .btn-outline-dark:not(:disabled):not(.disabled):active:focus, :where(#widgetEditorDialog) .btn-outline-dark:not(:disabled):not(.disabled).active:focus, .show > :where(#widgetEditorDialog) .btn-outline-dark.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}
:where(#widgetEditorDialog) .btn-link {
  font-weight: 400;
  color: #007bff;
  text-decoration: none;
}
:where(#widgetEditorDialog) .btn-link:hover {
  color: rgb(0%, 33.7647058824%, 70%);
  text-decoration: underline;
}
:where(#widgetEditorDialog) .btn-link:focus, :where(#widgetEditorDialog) .btn-link.focus {
  text-decoration: underline;
}
:where(#widgetEditorDialog) .btn-link:disabled, :where(#widgetEditorDialog) .btn-link.disabled {
  color: #6c757d;
  pointer-events: none;
}
:where(#widgetEditorDialog) .btn-lg, :where(#widgetEditorDialog) .btn-group-lg > .btn {
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  line-height: 1.5;
  border-radius: 0.3rem;
}
:where(#widgetEditorDialog) .btn-sm, :where(#widgetEditorDialog) .btn-group-sm > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.2rem;
}
:where(#widgetEditorDialog) .btn-block {
  display: block;
  width: 100%;
}
:where(#widgetEditorDialog) .btn-block + .btn-block {
  margin-top: 0.5rem;
}
:where(#widgetEditorDialog) input[type=submit].btn-block,
:where(#widgetEditorDialog) input[type=reset].btn-block,
:where(#widgetEditorDialog) input[type=button].btn-block {
  width: 100%;
}
:where(#widgetEditorDialog) .fade {
  transition: opacity 0.15s linear;
}
@media (prefers-reduced-motion: reduce) {
  :where(#widgetEditorDialog) .fade {
    transition: none;
  }
}
:where(#widgetEditorDialog) .fade:not(.show) {
  opacity: 0;
}
:where(#widgetEditorDialog) .collapse:not(.show) {
  display: none;
}
:where(#widgetEditorDialog) .collapsing {
  position: relative;
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  :where(#widgetEditorDialog) .collapsing {
    transition: none;
  }
}
:where(#widgetEditorDialog) .collapsing.width {
  width: 0;
  height: auto;
  transition: width 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  :where(#widgetEditorDialog) .collapsing.width {
    transition: none;
  }
}
:where(#widgetEditorDialog) .dropup,
:where(#widgetEditorDialog) .dropright,
:where(#widgetEditorDialog) .dropdown,
:where(#widgetEditorDialog) .dropleft {
  position: relative;
}
:where(#widgetEditorDialog) .dropdown-toggle {
  white-space: nowrap;
}
:where(#widgetEditorDialog) .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}
:where(#widgetEditorDialog) .dropdown-toggle:empty::after {
  margin-left: 0;
}
:where(#widgetEditorDialog) .dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  display: none;
  float: left;
  min-width: 10rem;
  padding: 0.5rem 0;
  margin: 0.125rem 0 0;
  font-size: 1rem;
  color: #212529;
  text-align: left;
  list-style: none;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;
}
:where(#widgetEditorDialog) .dropdown-menu-left {
  right: auto;
  left: 0;
}
:where(#widgetEditorDialog) .dropdown-menu-right {
  right: 0;
  left: auto;
}
@media (min-width: 576px) {
  :where(#widgetEditorDialog) .dropdown-menu-sm-left {
    right: auto;
    left: 0;
  }
  :where(#widgetEditorDialog) .dropdown-menu-sm-right {
    right: 0;
    left: auto;
  }
}
@media (min-width: 768px) {
  :where(#widgetEditorDialog) .dropdown-menu-md-left {
    right: auto;
    left: 0;
  }
  :where(#widgetEditorDialog) .dropdown-menu-md-right {
    right: 0;
    left: auto;
  }
}
@media (min-width: 992px) {
  :where(#widgetEditorDialog) .dropdown-menu-lg-left {
    right: auto;
    left: 0;
  }
  :where(#widgetEditorDialog) .dropdown-menu-lg-right {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1200px) {
  :where(#widgetEditorDialog) .dropdown-menu-xl-left {
    right: auto;
    left: 0;
  }
  :where(#widgetEditorDialog) .dropdown-menu-xl-right {
    right: 0;
    left: auto;
  }
}
:where(#widgetEditorDialog) .dropup .dropdown-menu {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: 0.125rem;
}
:where(#widgetEditorDialog) .dropup .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0;
  border-right: 0.3em solid transparent;
  border-bottom: 0.3em solid;
  border-left: 0.3em solid transparent;
}
:where(#widgetEditorDialog) .dropup .dropdown-toggle:empty::after {
  margin-left: 0;
}
:where(#widgetEditorDialog) .dropright .dropdown-menu {
  top: 0;
  right: auto;
  left: 100%;
  margin-top: 0;
  margin-left: 0.125rem;
}
:where(#widgetEditorDialog) .dropright .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0;
  border-bottom: 0.3em solid transparent;
  border-left: 0.3em solid;
}
:where(#widgetEditorDialog) .dropright .dropdown-toggle:empty::after {
  margin-left: 0;
}
:where(#widgetEditorDialog) .dropright .dropdown-toggle::after {
  vertical-align: 0;
}
:where(#widgetEditorDialog) .dropleft .dropdown-menu {
  top: 0;
  right: 100%;
  left: auto;
  margin-top: 0;
  margin-right: 0.125rem;
}
:where(#widgetEditorDialog) .dropleft .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
}
:where(#widgetEditorDialog) .dropleft .dropdown-toggle::after {
  display: none;
}
:where(#widgetEditorDialog) .dropleft .dropdown-toggle::before {
  display: inline-block;
  margin-right: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0.3em solid;
  border-bottom: 0.3em solid transparent;
}
:where(#widgetEditorDialog) .dropleft .dropdown-toggle:empty::after {
  margin-left: 0;
}
:where(#widgetEditorDialog) .dropleft .dropdown-toggle::before {
  vertical-align: 0;
}
:where(#widgetEditorDialog) .dropdown-menu[x-placement^=top], :where(#widgetEditorDialog) .dropdown-menu[x-placement^=right], :where(#widgetEditorDialog) .dropdown-menu[x-placement^=bottom], :where(#widgetEditorDialog) .dropdown-menu[x-placement^=left] {
  right: auto;
  bottom: auto;
}
:where(#widgetEditorDialog) .dropdown-divider {
  height: 0;
  margin: 0.5rem 0;
  overflow: hidden;
  border-top: 1px solid #e9ecef;
}
:where(#widgetEditorDialog) .dropdown-item {
  display: block;
  width: 100%;
  padding: 0.25rem 1.5rem;
  clear: both;
  font-weight: 400;
  color: #212529;
  text-align: inherit;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
}
:where(#widgetEditorDialog) .dropdown-item:hover, :where(#widgetEditorDialog) .dropdown-item:focus {
  color: rgb(8.4817170111%, 9.5098039216%, 10.537890832%);
  text-decoration: none;
  background-color: #e9ecef;
}
:where(#widgetEditorDialog) .dropdown-item.active, :where(#widgetEditorDialog) .dropdown-item:active {
  color: #fff;
  text-decoration: none;
  background-color: #007bff;
}
:where(#widgetEditorDialog) .dropdown-item.disabled, :where(#widgetEditorDialog) .dropdown-item:disabled {
  color: #adb5bd;
  pointer-events: none;
  background-color: transparent;
}
:where(#widgetEditorDialog) .dropdown-menu.show {
  display: block;
}
:where(#widgetEditorDialog) .dropdown-header {
  display: block;
  padding: 0.5rem 1.5rem;
  margin-bottom: 0;
  font-size: 0.875rem;
  color: #6c757d;
  white-space: nowrap;
}
:where(#widgetEditorDialog) .dropdown-item-text {
  display: block;
  padding: 0.25rem 1.5rem;
  color: #212529;
}
:where(#widgetEditorDialog) .btn-group,
:where(#widgetEditorDialog) .btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}
:where(#widgetEditorDialog) .btn-group > .btn,
:where(#widgetEditorDialog) .btn-group-vertical > .btn {
  position: relative;
  flex: 1 1 auto;
}
:where(#widgetEditorDialog) .btn-group > .btn:hover,
:where(#widgetEditorDialog) .btn-group-vertical > .btn:hover {
  z-index: 1;
}
:where(#widgetEditorDialog) .btn-group > .btn:focus, :where(#widgetEditorDialog) .btn-group > .btn:active, :where(#widgetEditorDialog) .btn-group > .btn.active,
:where(#widgetEditorDialog) .btn-group-vertical > .btn:focus,
:where(#widgetEditorDialog) .btn-group-vertical > .btn:active,
:where(#widgetEditorDialog) .btn-group-vertical > .btn.active {
  z-index: 1;
}
:where(#widgetEditorDialog) .btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
:where(#widgetEditorDialog) .btn-toolbar .input-group {
  width: auto;
}
:where(#widgetEditorDialog) .btn-group > .btn:not(:first-child),
:where(#widgetEditorDialog) .btn-group > .btn-group:not(:first-child) {
  margin-left: -1px;
}
:where(#widgetEditorDialog) .btn-group > .btn:not(:last-child):not(.dropdown-toggle),
:where(#widgetEditorDialog) .btn-group > .btn-group:not(:last-child) > .btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
:where(#widgetEditorDialog) .btn-group > .btn:not(:first-child),
:where(#widgetEditorDialog) .btn-group > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
:where(#widgetEditorDialog) .dropdown-toggle-split {
  padding-right: 0.5625rem;
  padding-left: 0.5625rem;
}
:where(#widgetEditorDialog) .dropdown-toggle-split::after, .dropup :where(#widgetEditorDialog) .dropdown-toggle-split::after, .dropright :where(#widgetEditorDialog) .dropdown-toggle-split::after {
  margin-left: 0;
}
.dropleft :where(#widgetEditorDialog) .dropdown-toggle-split::before {
  margin-right: 0;
}
:where(#widgetEditorDialog) .btn-sm + .dropdown-toggle-split, :where(#widgetEditorDialog) .btn-group-sm > .btn + .dropdown-toggle-split {
  padding-right: 0.375rem;
  padding-left: 0.375rem;
}
:where(#widgetEditorDialog) .btn-lg + .dropdown-toggle-split, :where(#widgetEditorDialog) .btn-group-lg > .btn + .dropdown-toggle-split {
  padding-right: 0.75rem;
  padding-left: 0.75rem;
}
:where(#widgetEditorDialog) .btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
:where(#widgetEditorDialog) .btn-group-vertical > .btn,
:where(#widgetEditorDialog) .btn-group-vertical > .btn-group {
  width: 100%;
}
:where(#widgetEditorDialog) .btn-group-vertical > .btn:not(:first-child),
:where(#widgetEditorDialog) .btn-group-vertical > .btn-group:not(:first-child) {
  margin-top: -1px;
}
:where(#widgetEditorDialog) .btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),
:where(#widgetEditorDialog) .btn-group-vertical > .btn-group:not(:last-child) > .btn {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
:where(#widgetEditorDialog) .btn-group-vertical > .btn:not(:first-child),
:where(#widgetEditorDialog) .btn-group-vertical > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
:where(#widgetEditorDialog) .btn-group-toggle > .btn,
:where(#widgetEditorDialog) .btn-group-toggle > .btn-group > .btn {
  margin-bottom: 0;
}
:where(#widgetEditorDialog) .btn-group-toggle > .btn input[type=radio],
:where(#widgetEditorDialog) .btn-group-toggle > .btn input[type=checkbox],
:where(#widgetEditorDialog) .btn-group-toggle > .btn-group > .btn input[type=radio],
:where(#widgetEditorDialog) .btn-group-toggle > .btn-group > .btn input[type=checkbox] {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}
:where(#widgetEditorDialog) .input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}
:where(#widgetEditorDialog) .input-group > .form-control,
:where(#widgetEditorDialog) .input-group > .form-control-plaintext,
:where(#widgetEditorDialog) .input-group > .custom-select,
:where(#widgetEditorDialog) .input-group > .custom-file {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
  margin-bottom: 0;
}
:where(#widgetEditorDialog) .input-group > .form-control + .form-control,
:where(#widgetEditorDialog) .input-group > .form-control + .custom-select,
:where(#widgetEditorDialog) .input-group > .form-control + .custom-file,
:where(#widgetEditorDialog) .input-group > .form-control-plaintext + .form-control,
:where(#widgetEditorDialog) .input-group > .form-control-plaintext + .custom-select,
:where(#widgetEditorDialog) .input-group > .form-control-plaintext + .custom-file,
:where(#widgetEditorDialog) .input-group > .custom-select + .form-control,
:where(#widgetEditorDialog) .input-group > .custom-select + .custom-select,
:where(#widgetEditorDialog) .input-group > .custom-select + .custom-file,
:where(#widgetEditorDialog) .input-group > .custom-file + .form-control,
:where(#widgetEditorDialog) .input-group > .custom-file + .custom-select,
:where(#widgetEditorDialog) .input-group > .custom-file + .custom-file {
  margin-left: -1px;
}
:where(#widgetEditorDialog) .input-group > .form-control:focus,
:where(#widgetEditorDialog) .input-group > .custom-select:focus,
:where(#widgetEditorDialog) .input-group > .custom-file .custom-file-input:focus ~ .custom-file-label {
  z-index: 3;
}
:where(#widgetEditorDialog) .input-group > .custom-file .custom-file-input:focus {
  z-index: 4;
}
:where(#widgetEditorDialog) .input-group > .form-control:not(:first-child),
:where(#widgetEditorDialog) .input-group > .custom-select:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
:where(#widgetEditorDialog) .input-group > .custom-file {
  display: flex;
  align-items: center;
}
:where(#widgetEditorDialog) .input-group > .custom-file:not(:last-child) .custom-file-label, :where(#widgetEditorDialog) .input-group > .custom-file:not(:last-child) .custom-file-label::after {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
:where(#widgetEditorDialog) .input-group > .custom-file:not(:first-child) .custom-file-label {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
:where(#widgetEditorDialog) .input-group:not(.has-validation) > .form-control:not(:last-child),
:where(#widgetEditorDialog) .input-group:not(.has-validation) > .custom-select:not(:last-child),
:where(#widgetEditorDialog) .input-group:not(.has-validation) > .custom-file:not(:last-child) .custom-file-label,
:where(#widgetEditorDialog) .input-group:not(.has-validation) > .custom-file:not(:last-child) .custom-file-label::after {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
:where(#widgetEditorDialog) .input-group.has-validation > .form-control:nth-last-child(n+3),
:where(#widgetEditorDialog) .input-group.has-validation > .custom-select:nth-last-child(n+3),
:where(#widgetEditorDialog) .input-group.has-validation > .custom-file:nth-last-child(n+3) .custom-file-label,
:where(#widgetEditorDialog) .input-group.has-validation > .custom-file:nth-last-child(n+3) .custom-file-label::after {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
:where(#widgetEditorDialog) .input-group-prepend,
:where(#widgetEditorDialog) .input-group-append {
  display: flex;
}
:where(#widgetEditorDialog) .input-group-prepend .btn,
:where(#widgetEditorDialog) .input-group-append .btn {
  position: relative;
  z-index: 2;
}
:where(#widgetEditorDialog) .input-group-prepend .btn:focus,
:where(#widgetEditorDialog) .input-group-append .btn:focus {
  z-index: 3;
}
:where(#widgetEditorDialog) .input-group-prepend .btn + .btn,
:where(#widgetEditorDialog) .input-group-prepend .btn + .input-group-text,
:where(#widgetEditorDialog) .input-group-prepend .input-group-text + .input-group-text,
:where(#widgetEditorDialog) .input-group-prepend .input-group-text + .btn,
:where(#widgetEditorDialog) .input-group-append .btn + .btn,
:where(#widgetEditorDialog) .input-group-append .btn + .input-group-text,
:where(#widgetEditorDialog) .input-group-append .input-group-text + .input-group-text,
:where(#widgetEditorDialog) .input-group-append .input-group-text + .btn {
  margin-left: -1px;
}
:where(#widgetEditorDialog) .input-group-prepend {
  margin-right: -1px;
}
:where(#widgetEditorDialog) .input-group-append {
  margin-left: -1px;
}
:where(#widgetEditorDialog) .input-group-text {
  display: flex;
  align-items: center;
  padding: 0.375rem 0.75rem;
  margin-bottom: 0;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  text-align: center;
  white-space: nowrap;
  background-color: #e9ecef;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}
:where(#widgetEditorDialog) .input-group-text input[type=radio],
:where(#widgetEditorDialog) .input-group-text input[type=checkbox] {
  margin-top: 0;
}
:where(#widgetEditorDialog) .input-group-lg > .form-control:not(textarea),
:where(#widgetEditorDialog) .input-group-lg > .custom-select {
  height: calc(1.5em + 1rem + 2px);
}
:where(#widgetEditorDialog) .input-group-lg > .form-control,
:where(#widgetEditorDialog) .input-group-lg > .custom-select,
:where(#widgetEditorDialog) .input-group-lg > .input-group-prepend > .input-group-text,
:where(#widgetEditorDialog) .input-group-lg > .input-group-append > .input-group-text,
:where(#widgetEditorDialog) .input-group-lg > .input-group-prepend > .btn,
:where(#widgetEditorDialog) .input-group-lg > .input-group-append > .btn {
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  line-height: 1.5;
  border-radius: 0.3rem;
}
:where(#widgetEditorDialog) .input-group-sm > .form-control:not(textarea),
:where(#widgetEditorDialog) .input-group-sm > .custom-select {
  height: calc(1.5em + 0.5rem + 2px);
}
:where(#widgetEditorDialog) .input-group-sm > .form-control,
:where(#widgetEditorDialog) .input-group-sm > .custom-select,
:where(#widgetEditorDialog) .input-group-sm > .input-group-prepend > .input-group-text,
:where(#widgetEditorDialog) .input-group-sm > .input-group-append > .input-group-text,
:where(#widgetEditorDialog) .input-group-sm > .input-group-prepend > .btn,
:where(#widgetEditorDialog) .input-group-sm > .input-group-append > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.2rem;
}
:where(#widgetEditorDialog) .input-group-lg > .custom-select,
:where(#widgetEditorDialog) .input-group-sm > .custom-select {
  padding-right: 1.75rem;
}
:where(#widgetEditorDialog) .input-group > .input-group-prepend > .btn,
:where(#widgetEditorDialog) .input-group > .input-group-prepend > .input-group-text,
:where(#widgetEditorDialog) .input-group:not(.has-validation) > .input-group-append:not(:last-child) > .btn,
:where(#widgetEditorDialog) .input-group:not(.has-validation) > .input-group-append:not(:last-child) > .input-group-text,
:where(#widgetEditorDialog) .input-group.has-validation > .input-group-append:nth-last-child(n+3) > .btn,
:where(#widgetEditorDialog) .input-group.has-validation > .input-group-append:nth-last-child(n+3) > .input-group-text,
:where(#widgetEditorDialog) .input-group > .input-group-append:last-child > .btn:not(:last-child):not(.dropdown-toggle),
:where(#widgetEditorDialog) .input-group > .input-group-append:last-child > .input-group-text:not(:last-child) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
:where(#widgetEditorDialog) .input-group > .input-group-append > .btn,
:where(#widgetEditorDialog) .input-group > .input-group-append > .input-group-text,
:where(#widgetEditorDialog) .input-group > .input-group-prepend:not(:first-child) > .btn,
:where(#widgetEditorDialog) .input-group > .input-group-prepend:not(:first-child) > .input-group-text,
:where(#widgetEditorDialog) .input-group > .input-group-prepend:first-child > .btn:not(:first-child),
:where(#widgetEditorDialog) .input-group > .input-group-prepend:first-child > .input-group-text:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
:where(#widgetEditorDialog) .custom-control {
  position: relative;
  z-index: 1;
  display: block;
  min-height: 1.5rem;
  padding-left: 1.5rem;
  print-color-adjust: exact;
}
:where(#widgetEditorDialog) .custom-control-inline {
  display: inline-flex;
  margin-right: 1rem;
}
:where(#widgetEditorDialog) .custom-control-input {
  position: absolute;
  left: 0;
  z-index: -1;
  width: 1rem;
  height: 1.25rem;
  opacity: 0;
}
:where(#widgetEditorDialog) .custom-control-input:checked ~ .custom-control-label::before {
  color: #fff;
  border-color: #007bff;
  background-color: #007bff;
}
:where(#widgetEditorDialog) .custom-control-input:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}
:where(#widgetEditorDialog) .custom-control-input:focus:not(:checked) ~ .custom-control-label::before {
  border-color: rgb(50%, 74.1176470588%, 100%);
}
:where(#widgetEditorDialog) .custom-control-input:not(:disabled):active ~ .custom-control-label::before {
  color: #fff;
  background-color: rgb(70%, 84.4705882353%, 100%);
  border-color: rgb(70%, 84.4705882353%, 100%);
}
:where(#widgetEditorDialog) .custom-control-input[disabled] ~ .custom-control-label, :where(#widgetEditorDialog) .custom-control-input:disabled ~ .custom-control-label {
  color: #6c757d;
}
:where(#widgetEditorDialog) .custom-control-input[disabled] ~ .custom-control-label::before, :where(#widgetEditorDialog) .custom-control-input:disabled ~ .custom-control-label::before {
  background-color: #e9ecef;
}
:where(#widgetEditorDialog) .custom-control-label {
  position: relative;
  margin-bottom: 0;
  vertical-align: top;
}
:where(#widgetEditorDialog) .custom-control-label::before {
  position: absolute;
  top: 0.25rem;
  left: -1.5rem;
  display: block;
  width: 1rem;
  height: 1rem;
  pointer-events: none;
  content: "";
  background-color: #fff;
  border: 1px solid #adb5bd;
}
:where(#widgetEditorDialog) .custom-control-label::after {
  position: absolute;
  top: 0.25rem;
  left: -1.5rem;
  display: block;
  width: 1rem;
  height: 1rem;
  content: "";
  background: 50%/50% 50% no-repeat;
}
:where(#widgetEditorDialog) .custom-checkbox .custom-control-label::before {
  border-radius: 0.25rem;
}
:where(#widgetEditorDialog) .custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
:where(#widgetEditorDialog) .custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::before {
  border-color: #007bff;
  background-color: #007bff;
}
:where(#widgetEditorDialog) .custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
:where(#widgetEditorDialog) .custom-checkbox .custom-control-input:disabled:checked ~ .custom-control-label::before {
  background-color: rgba(0, 123, 255, 0.5);
}
:where(#widgetEditorDialog) .custom-checkbox .custom-control-input:disabled:indeterminate ~ .custom-control-label::before {
  background-color: rgba(0, 123, 255, 0.5);
}
:where(#widgetEditorDialog) .custom-radio .custom-control-label::before {
  border-radius: 50%;
}
:where(#widgetEditorDialog) .custom-radio .custom-control-input:checked ~ .custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}
:where(#widgetEditorDialog) .custom-radio .custom-control-input:disabled:checked ~ .custom-control-label::before {
  background-color: rgba(0, 123, 255, 0.5);
}
:where(#widgetEditorDialog) .custom-switch {
  padding-left: 2.25rem;
}
:where(#widgetEditorDialog) .custom-switch .custom-control-label::before {
  left: -2.25rem;
  width: 1.75rem;
  pointer-events: all;
  border-radius: 0.5rem;
}
:where(#widgetEditorDialog) .custom-switch .custom-control-label::after {
  top: calc(0.25rem + 2px);
  left: calc(-2.25rem + 2px);
  width: calc(1rem - 4px);
  height: calc(1rem - 4px);
  background-color: #adb5bd;
  border-radius: 0.5rem;
  transition: transform 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  :where(#widgetEditorDialog) .custom-switch .custom-control-label::after {
    transition: none;
  }
}
:where(#widgetEditorDialog) .custom-switch .custom-control-input:checked ~ .custom-control-label::after {
  background-color: #fff;
  transform: translateX(0.75rem);
}
:where(#widgetEditorDialog) .custom-switch .custom-control-input:disabled:checked ~ .custom-control-label::before {
  background-color: rgba(0, 123, 255, 0.5);
}
:where(#widgetEditorDialog) .custom-select {
  display: inline-block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 1.75rem 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  vertical-align: middle;
  background: #fff url(${___CSS_LOADER_URL_REPLACEMENT_1___}) right 0.75rem center/8px 10px no-repeat;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  appearance: none;
}
:where(#widgetEditorDialog) .custom-select:focus {
  border-color: rgb(50%, 74.1176470588%, 100%);
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}
:where(#widgetEditorDialog) .custom-select:focus::-ms-value {
  color: #495057;
  background-color: #fff;
}
:where(#widgetEditorDialog) .custom-select[multiple], :where(#widgetEditorDialog) .custom-select[size]:not([size="1"]) {
  height: auto;
  padding-right: 0.75rem;
  background-image: none;
}
:where(#widgetEditorDialog) .custom-select:disabled {
  color: #6c757d;
  background-color: #e9ecef;
}
:where(#widgetEditorDialog) .custom-select::-ms-expand {
  display: none;
}
:where(#widgetEditorDialog) .custom-select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 #495057;
}
:where(#widgetEditorDialog) .custom-select-sm {
  height: calc(1.5em + 0.5rem + 2px);
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  font-size: 0.875rem;
}
:where(#widgetEditorDialog) .custom-select-lg {
  height: calc(1.5em + 1rem + 2px);
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
  font-size: 1.25rem;
}
:where(#widgetEditorDialog) .custom-file {
  position: relative;
  display: inline-block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  margin-bottom: 0;
}
:where(#widgetEditorDialog) .custom-file-input {
  position: relative;
  z-index: 2;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  margin: 0;
  overflow: hidden;
  opacity: 0;
}
:where(#widgetEditorDialog) .custom-file-input:focus ~ .custom-file-label {
  border-color: rgb(50%, 74.1176470588%, 100%);
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}
:where(#widgetEditorDialog) .custom-file-input[disabled] ~ .custom-file-label, :where(#widgetEditorDialog) .custom-file-input:disabled ~ .custom-file-label {
  background-color: #e9ecef;
}
:where(#widgetEditorDialog) .custom-file-input:lang(en) ~ .custom-file-label::after {
  content: "Browse";
}
:where(#widgetEditorDialog) .custom-file-input ~ .custom-file-label[data-browse]::after {
  content: attr(data-browse);
}
:where(#widgetEditorDialog) .custom-file-label {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  overflow: hidden;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}
:where(#widgetEditorDialog) .custom-file-label::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 3;
  display: block;
  height: calc(1.5em + 0.75rem);
  padding: 0.375rem 0.75rem;
  line-height: 1.5;
  color: #495057;
  content: "Browse";
  background-color: #e9ecef;
  border-left: inherit;
  border-radius: 0 0.25rem 0.25rem 0;
}
:where(#widgetEditorDialog) .custom-range {
  width: 100%;
  height: 1.4rem;
  padding: 0;
  background-color: transparent;
  appearance: none;
}
:where(#widgetEditorDialog) .custom-range:focus {
  outline: 0;
}
:where(#widgetEditorDialog) .custom-range:focus::-webkit-slider-thumb {
  box-shadow: 0 0 0 1px #fff, 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}
:where(#widgetEditorDialog) .custom-range:focus::-moz-range-thumb {
  box-shadow: 0 0 0 1px #fff, 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}
:where(#widgetEditorDialog) .custom-range:focus::-ms-thumb {
  box-shadow: 0 0 0 1px #fff, 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}
:where(#widgetEditorDialog) .custom-range::-moz-focus-outer {
  border: 0;
}
:where(#widgetEditorDialog) .custom-range::-webkit-slider-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: -0.25rem;
  background-color: #007bff;
  border: 0;
  border-radius: 1rem;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  :where(#widgetEditorDialog) .custom-range::-webkit-slider-thumb {
    transition: none;
  }
}
:where(#widgetEditorDialog) .custom-range::-webkit-slider-thumb {
  appearance: none;
}
:where(#widgetEditorDialog) .custom-range::-webkit-slider-thumb:active {
  background-color: rgb(70%, 84.4705882353%, 100%);
}
:where(#widgetEditorDialog) .custom-range::-webkit-slider-runnable-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: #dee2e6;
  border-color: transparent;
  border-radius: 1rem;
}
:where(#widgetEditorDialog) .custom-range::-moz-range-thumb {
  width: 1rem;
  height: 1rem;
  background-color: #007bff;
  border: 0;
  border-radius: 1rem;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  :where(#widgetEditorDialog) .custom-range::-moz-range-thumb {
    transition: none;
  }
}
:where(#widgetEditorDialog) .custom-range::-moz-range-thumb {
  appearance: none;
}
:where(#widgetEditorDialog) .custom-range::-moz-range-thumb:active {
  background-color: rgb(70%, 84.4705882353%, 100%);
}
:where(#widgetEditorDialog) .custom-range::-moz-range-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: #dee2e6;
  border-color: transparent;
  border-radius: 1rem;
}
:where(#widgetEditorDialog) .custom-range::-ms-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: 0;
  margin-right: 0.2rem;
  margin-left: 0.2rem;
  background-color: #007bff;
  border: 0;
  border-radius: 1rem;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  :where(#widgetEditorDialog) .custom-range::-ms-thumb {
    transition: none;
  }
}
:where(#widgetEditorDialog) .custom-range::-ms-thumb {
  appearance: none;
}
:where(#widgetEditorDialog) .custom-range::-ms-thumb:active {
  background-color: rgb(70%, 84.4705882353%, 100%);
}
:where(#widgetEditorDialog) .custom-range::-ms-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: transparent;
  border-color: transparent;
  border-width: 0.5rem;
}
:where(#widgetEditorDialog) .custom-range::-ms-fill-lower {
  background-color: #dee2e6;
  border-radius: 1rem;
}
:where(#widgetEditorDialog) .custom-range::-ms-fill-upper {
  margin-right: 15px;
  background-color: #dee2e6;
  border-radius: 1rem;
}
:where(#widgetEditorDialog) .custom-range:disabled::-webkit-slider-thumb {
  background-color: #adb5bd;
}
:where(#widgetEditorDialog) .custom-range:disabled::-webkit-slider-runnable-track {
  cursor: default;
}
:where(#widgetEditorDialog) .custom-range:disabled::-moz-range-thumb {
  background-color: #adb5bd;
}
:where(#widgetEditorDialog) .custom-range:disabled::-moz-range-track {
  cursor: default;
}
:where(#widgetEditorDialog) .custom-range:disabled::-ms-thumb {
  background-color: #adb5bd;
}
:where(#widgetEditorDialog) .custom-control-label::before,
:where(#widgetEditorDialog) .custom-file-label,
:where(#widgetEditorDialog) .custom-select {
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  :where(#widgetEditorDialog) .custom-control-label::before,
  :where(#widgetEditorDialog) .custom-file-label,
  :where(#widgetEditorDialog) .custom-select {
    transition: none;
  }
}
:where(#widgetEditorDialog) .nav {
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}
:where(#widgetEditorDialog) .nav-link {
  display: block;
  padding: 0.5rem 1rem;
}
:where(#widgetEditorDialog) .nav-link:hover, :where(#widgetEditorDialog) .nav-link:focus {
  text-decoration: none;
}
:where(#widgetEditorDialog) .nav-link.disabled {
  color: #6c757d;
  pointer-events: none;
  cursor: default;
}
:where(#widgetEditorDialog) .nav-tabs {
  border-bottom: 1px solid #dee2e6;
}
:where(#widgetEditorDialog) .nav-tabs .nav-link {
  margin-bottom: -1px;
  background-color: transparent;
  border: 1px solid transparent;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}
:where(#widgetEditorDialog) .nav-tabs .nav-link:hover, :where(#widgetEditorDialog) .nav-tabs .nav-link:focus {
  isolation: isolate;
  border-color: #e9ecef #e9ecef #dee2e6;
}
:where(#widgetEditorDialog) .nav-tabs .nav-link.disabled {
  color: #6c757d;
  background-color: transparent;
  border-color: transparent;
}
:where(#widgetEditorDialog) .nav-tabs .nav-link.active,
:where(#widgetEditorDialog) .nav-tabs .nav-item.show .nav-link {
  color: #495057;
  background-color: #fff;
  border-color: #dee2e6 #dee2e6 #fff;
}
:where(#widgetEditorDialog) .nav-tabs .dropdown-menu {
  margin-top: -1px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
:where(#widgetEditorDialog) .nav-pills .nav-link {
  background: none;
  border: 0;
  border-radius: 0.25rem;
}
:where(#widgetEditorDialog) .nav-pills .nav-link.active,
:where(#widgetEditorDialog) .nav-pills .show > .nav-link {
  color: #fff;
  background-color: #007bff;
}
:where(#widgetEditorDialog) .nav-fill > .nav-link,
:where(#widgetEditorDialog) .nav-fill .nav-item {
  flex: 1 1 auto;
  text-align: center;
}
:where(#widgetEditorDialog) .nav-justified > .nav-link,
:where(#widgetEditorDialog) .nav-justified .nav-item {
  flex-basis: 0;
  flex-grow: 1;
  text-align: center;
}
:where(#widgetEditorDialog) .tab-content > .tab-pane {
  display: none;
}
:where(#widgetEditorDialog) .tab-content > .active {
  display: block;
}
:where(#widgetEditorDialog) .navbar {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 1rem;
}
:where(#widgetEditorDialog) .navbar .container,
:where(#widgetEditorDialog) .navbar .container-fluid,
:where(#widgetEditorDialog) .navbar .container-sm,
:where(#widgetEditorDialog) .navbar .container-md,
:where(#widgetEditorDialog) .navbar .container-lg,
:where(#widgetEditorDialog) .navbar .container-xl {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
}
:where(#widgetEditorDialog) .navbar-brand {
  display: inline-block;
  padding-top: 0.3125rem;
  padding-bottom: 0.3125rem;
  margin-right: 1rem;
  font-size: 1.25rem;
  line-height: inherit;
  white-space: nowrap;
}
:where(#widgetEditorDialog) .navbar-brand:hover, :where(#widgetEditorDialog) .navbar-brand:focus {
  text-decoration: none;
}
:where(#widgetEditorDialog) .navbar-nav {
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}
:where(#widgetEditorDialog) .navbar-nav .nav-link {
  padding-right: 0;
  padding-left: 0;
}
:where(#widgetEditorDialog) .navbar-nav .dropdown-menu {
  position: static;
  float: none;
}
:where(#widgetEditorDialog) .navbar-text {
  display: inline-block;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
:where(#widgetEditorDialog) .navbar-collapse {
  flex-basis: 100%;
  flex-grow: 1;
  align-items: center;
}
:where(#widgetEditorDialog) .navbar-toggler {
  padding: 0.25rem 0.75rem;
  font-size: 1.25rem;
  line-height: 1;
  background-color: transparent;
  border: 1px solid transparent;
  border-radius: 0.25rem;
}
:where(#widgetEditorDialog) .navbar-toggler:hover, :where(#widgetEditorDialog) .navbar-toggler:focus {
  text-decoration: none;
}
:where(#widgetEditorDialog) .navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  content: "";
  background: 50%/100% 100% no-repeat;
}
:where(#widgetEditorDialog) .navbar-nav-scroll {
  max-height: 75vh;
  overflow-y: auto;
}
@media (max-width: 575.98px) {
  :where(#widgetEditorDialog) .navbar-expand-sm > .container,
  :where(#widgetEditorDialog) .navbar-expand-sm > .container-fluid,
  :where(#widgetEditorDialog) .navbar-expand-sm > .container-sm,
  :where(#widgetEditorDialog) .navbar-expand-sm > .container-md,
  :where(#widgetEditorDialog) .navbar-expand-sm > .container-lg,
  :where(#widgetEditorDialog) .navbar-expand-sm > .container-xl {
    padding-right: 0;
    padding-left: 0;
  }
}
@media (min-width: 576px) {
  :where(#widgetEditorDialog) .navbar-expand-sm {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }
  :where(#widgetEditorDialog) .navbar-expand-sm .navbar-nav {
    flex-direction: row;
  }
  :where(#widgetEditorDialog) .navbar-expand-sm .navbar-nav .dropdown-menu {
    position: absolute;
  }
  :where(#widgetEditorDialog) .navbar-expand-sm .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  :where(#widgetEditorDialog) .navbar-expand-sm > .container,
  :where(#widgetEditorDialog) .navbar-expand-sm > .container-fluid,
  :where(#widgetEditorDialog) .navbar-expand-sm > .container-sm,
  :where(#widgetEditorDialog) .navbar-expand-sm > .container-md,
  :where(#widgetEditorDialog) .navbar-expand-sm > .container-lg,
  :where(#widgetEditorDialog) .navbar-expand-sm > .container-xl {
    flex-wrap: nowrap;
  }
  :where(#widgetEditorDialog) .navbar-expand-sm .navbar-nav-scroll {
    overflow: visible;
  }
  :where(#widgetEditorDialog) .navbar-expand-sm .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  :where(#widgetEditorDialog) .navbar-expand-sm .navbar-toggler {
    display: none;
  }
}
@media (max-width: 767.98px) {
  :where(#widgetEditorDialog) .navbar-expand-md > .container,
  :where(#widgetEditorDialog) .navbar-expand-md > .container-fluid,
  :where(#widgetEditorDialog) .navbar-expand-md > .container-sm,
  :where(#widgetEditorDialog) .navbar-expand-md > .container-md,
  :where(#widgetEditorDialog) .navbar-expand-md > .container-lg,
  :where(#widgetEditorDialog) .navbar-expand-md > .container-xl {
    padding-right: 0;
    padding-left: 0;
  }
}
@media (min-width: 768px) {
  :where(#widgetEditorDialog) .navbar-expand-md {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }
  :where(#widgetEditorDialog) .navbar-expand-md .navbar-nav {
    flex-direction: row;
  }
  :where(#widgetEditorDialog) .navbar-expand-md .navbar-nav .dropdown-menu {
    position: absolute;
  }
  :where(#widgetEditorDialog) .navbar-expand-md .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  :where(#widgetEditorDialog) .navbar-expand-md > .container,
  :where(#widgetEditorDialog) .navbar-expand-md > .container-fluid,
  :where(#widgetEditorDialog) .navbar-expand-md > .container-sm,
  :where(#widgetEditorDialog) .navbar-expand-md > .container-md,
  :where(#widgetEditorDialog) .navbar-expand-md > .container-lg,
  :where(#widgetEditorDialog) .navbar-expand-md > .container-xl {
    flex-wrap: nowrap;
  }
  :where(#widgetEditorDialog) .navbar-expand-md .navbar-nav-scroll {
    overflow: visible;
  }
  :where(#widgetEditorDialog) .navbar-expand-md .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  :where(#widgetEditorDialog) .navbar-expand-md .navbar-toggler {
    display: none;
  }
}
@media (max-width: 991.98px) {
  :where(#widgetEditorDialog) .navbar-expand-lg > .container,
  :where(#widgetEditorDialog) .navbar-expand-lg > .container-fluid,
  :where(#widgetEditorDialog) .navbar-expand-lg > .container-sm,
  :where(#widgetEditorDialog) .navbar-expand-lg > .container-md,
  :where(#widgetEditorDialog) .navbar-expand-lg > .container-lg,
  :where(#widgetEditorDialog) .navbar-expand-lg > .container-xl {
    padding-right: 0;
    padding-left: 0;
  }
}
@media (min-width: 992px) {
  :where(#widgetEditorDialog) .navbar-expand-lg {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }
  :where(#widgetEditorDialog) .navbar-expand-lg .navbar-nav {
    flex-direction: row;
  }
  :where(#widgetEditorDialog) .navbar-expand-lg .navbar-nav .dropdown-menu {
    position: absolute;
  }
  :where(#widgetEditorDialog) .navbar-expand-lg .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  :where(#widgetEditorDialog) .navbar-expand-lg > .container,
  :where(#widgetEditorDialog) .navbar-expand-lg > .container-fluid,
  :where(#widgetEditorDialog) .navbar-expand-lg > .container-sm,
  :where(#widgetEditorDialog) .navbar-expand-lg > .container-md,
  :where(#widgetEditorDialog) .navbar-expand-lg > .container-lg,
  :where(#widgetEditorDialog) .navbar-expand-lg > .container-xl {
    flex-wrap: nowrap;
  }
  :where(#widgetEditorDialog) .navbar-expand-lg .navbar-nav-scroll {
    overflow: visible;
  }
  :where(#widgetEditorDialog) .navbar-expand-lg .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  :where(#widgetEditorDialog) .navbar-expand-lg .navbar-toggler {
    display: none;
  }
}
@media (max-width: 1199.98px) {
  :where(#widgetEditorDialog) .navbar-expand-xl > .container,
  :where(#widgetEditorDialog) .navbar-expand-xl > .container-fluid,
  :where(#widgetEditorDialog) .navbar-expand-xl > .container-sm,
  :where(#widgetEditorDialog) .navbar-expand-xl > .container-md,
  :where(#widgetEditorDialog) .navbar-expand-xl > .container-lg,
  :where(#widgetEditorDialog) .navbar-expand-xl > .container-xl {
    padding-right: 0;
    padding-left: 0;
  }
}
@media (min-width: 1200px) {
  :where(#widgetEditorDialog) .navbar-expand-xl {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }
  :where(#widgetEditorDialog) .navbar-expand-xl .navbar-nav {
    flex-direction: row;
  }
  :where(#widgetEditorDialog) .navbar-expand-xl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  :where(#widgetEditorDialog) .navbar-expand-xl .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  :where(#widgetEditorDialog) .navbar-expand-xl > .container,
  :where(#widgetEditorDialog) .navbar-expand-xl > .container-fluid,
  :where(#widgetEditorDialog) .navbar-expand-xl > .container-sm,
  :where(#widgetEditorDialog) .navbar-expand-xl > .container-md,
  :where(#widgetEditorDialog) .navbar-expand-xl > .container-lg,
  :where(#widgetEditorDialog) .navbar-expand-xl > .container-xl {
    flex-wrap: nowrap;
  }
  :where(#widgetEditorDialog) .navbar-expand-xl .navbar-nav-scroll {
    overflow: visible;
  }
  :where(#widgetEditorDialog) .navbar-expand-xl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  :where(#widgetEditorDialog) .navbar-expand-xl .navbar-toggler {
    display: none;
  }
}
:where(#widgetEditorDialog) .navbar-expand > .container,
:where(#widgetEditorDialog) .navbar-expand > .container-fluid,
:where(#widgetEditorDialog) .navbar-expand > .container-sm,
:where(#widgetEditorDialog) .navbar-expand > .container-md,
:where(#widgetEditorDialog) .navbar-expand > .container-lg,
:where(#widgetEditorDialog) .navbar-expand > .container-xl {
  padding-right: 0;
  padding-left: 0;
}
:where(#widgetEditorDialog) .navbar-expand {
  flex-flow: row nowrap;
  justify-content: flex-start;
}
:where(#widgetEditorDialog) .navbar-expand .navbar-nav {
  flex-direction: row;
}
:where(#widgetEditorDialog) .navbar-expand .navbar-nav .dropdown-menu {
  position: absolute;
}
:where(#widgetEditorDialog) .navbar-expand .navbar-nav .nav-link {
  padding-right: 0.5rem;
  padding-left: 0.5rem;
}
:where(#widgetEditorDialog) .navbar-expand > .container,
:where(#widgetEditorDialog) .navbar-expand > .container-fluid,
:where(#widgetEditorDialog) .navbar-expand > .container-sm,
:where(#widgetEditorDialog) .navbar-expand > .container-md,
:where(#widgetEditorDialog) .navbar-expand > .container-lg,
:where(#widgetEditorDialog) .navbar-expand > .container-xl {
  flex-wrap: nowrap;
}
:where(#widgetEditorDialog) .navbar-expand .navbar-nav-scroll {
  overflow: visible;
}
:where(#widgetEditorDialog) .navbar-expand .navbar-collapse {
  display: flex !important;
  flex-basis: auto;
}
:where(#widgetEditorDialog) .navbar-expand .navbar-toggler {
  display: none;
}
:where(#widgetEditorDialog) .navbar-light .navbar-brand {
  color: rgba(0, 0, 0, 0.9);
}
:where(#widgetEditorDialog) .navbar-light .navbar-brand:hover, :where(#widgetEditorDialog) .navbar-light .navbar-brand:focus {
  color: rgba(0, 0, 0, 0.9);
}
:where(#widgetEditorDialog) .navbar-light .navbar-nav .nav-link {
  color: rgba(0, 0, 0, 0.5);
}
:where(#widgetEditorDialog) .navbar-light .navbar-nav .nav-link:hover, :where(#widgetEditorDialog) .navbar-light .navbar-nav .nav-link:focus {
  color: rgba(0, 0, 0, 0.7);
}
:where(#widgetEditorDialog) .navbar-light .navbar-nav .nav-link.disabled {
  color: rgba(0, 0, 0, 0.3);
}
:where(#widgetEditorDialog) .navbar-light .navbar-nav .show > .nav-link,
:where(#widgetEditorDialog) .navbar-light .navbar-nav .active > .nav-link,
:where(#widgetEditorDialog) .navbar-light .navbar-nav .nav-link.show,
:where(#widgetEditorDialog) .navbar-light .navbar-nav .nav-link.active {
  color: rgba(0, 0, 0, 0.9);
}
:where(#widgetEditorDialog) .navbar-light .navbar-toggler {
  color: rgba(0, 0, 0, 0.5);
  border-color: rgba(0, 0, 0, 0.1);
}
:where(#widgetEditorDialog) .navbar-light .navbar-toggler-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}
:where(#widgetEditorDialog) .navbar-light .navbar-text {
  color: rgba(0, 0, 0, 0.5);
}
:where(#widgetEditorDialog) .navbar-light .navbar-text a {
  color: rgba(0, 0, 0, 0.9);
}
:where(#widgetEditorDialog) .navbar-light .navbar-text a:hover, :where(#widgetEditorDialog) .navbar-light .navbar-text a:focus {
  color: rgba(0, 0, 0, 0.9);
}
:where(#widgetEditorDialog) .navbar-dark .navbar-brand {
  color: #fff;
}
:where(#widgetEditorDialog) .navbar-dark .navbar-brand:hover, :where(#widgetEditorDialog) .navbar-dark .navbar-brand:focus {
  color: #fff;
}
:where(#widgetEditorDialog) .navbar-dark .navbar-nav .nav-link {
  color: rgba(255, 255, 255, 0.5);
}
:where(#widgetEditorDialog) .navbar-dark .navbar-nav .nav-link:hover, :where(#widgetEditorDialog) .navbar-dark .navbar-nav .nav-link:focus {
  color: rgba(255, 255, 255, 0.75);
}
:where(#widgetEditorDialog) .navbar-dark .navbar-nav .nav-link.disabled {
  color: rgba(255, 255, 255, 0.25);
}
:where(#widgetEditorDialog) .navbar-dark .navbar-nav .show > .nav-link,
:where(#widgetEditorDialog) .navbar-dark .navbar-nav .active > .nav-link,
:where(#widgetEditorDialog) .navbar-dark .navbar-nav .nav-link.show,
:where(#widgetEditorDialog) .navbar-dark .navbar-nav .nav-link.active {
  color: #fff;
}
:where(#widgetEditorDialog) .navbar-dark .navbar-toggler {
  color: rgba(255, 255, 255, 0.5);
  border-color: rgba(255, 255, 255, 0.1);
}
:where(#widgetEditorDialog) .navbar-dark .navbar-toggler-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}
:where(#widgetEditorDialog) .navbar-dark .navbar-text {
  color: rgba(255, 255, 255, 0.5);
}
:where(#widgetEditorDialog) .navbar-dark .navbar-text a {
  color: #fff;
}
:where(#widgetEditorDialog) .navbar-dark .navbar-text a:hover, :where(#widgetEditorDialog) .navbar-dark .navbar-text a:focus {
  color: #fff;
}
:where(#widgetEditorDialog) .card {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem;
}
:where(#widgetEditorDialog) .card > hr {
  margin-right: 0;
  margin-left: 0;
}
:where(#widgetEditorDialog) .card > .list-group {
  border-top: inherit;
  border-bottom: inherit;
}
:where(#widgetEditorDialog) .card > .list-group:first-child {
  border-top-width: 0;
  border-top-left-radius: calc(0.25rem - 1px);
  border-top-right-radius: calc(0.25rem - 1px);
}
:where(#widgetEditorDialog) .card > .list-group:last-child {
  border-bottom-width: 0;
  border-bottom-right-radius: calc(0.25rem - 1px);
  border-bottom-left-radius: calc(0.25rem - 1px);
}
:where(#widgetEditorDialog) .card > .card-header + .list-group,
:where(#widgetEditorDialog) .card > .list-group + .card-footer {
  border-top: 0;
}
:where(#widgetEditorDialog) .card-body {
  flex: 1 1 auto;
  min-height: 1px;
  padding: 1.25rem;
}
:where(#widgetEditorDialog) .card-title {
  margin-bottom: 0.75rem;
}
:where(#widgetEditorDialog) .card-subtitle {
  margin-top: -0.375rem;
  margin-bottom: 0;
}
:where(#widgetEditorDialog) .card-text:last-child {
  margin-bottom: 0;
}
:where(#widgetEditorDialog) .card-link:hover {
  text-decoration: none;
}
:where(#widgetEditorDialog) .card-link + .card-link {
  margin-left: 1.25rem;
}
:where(#widgetEditorDialog) .card-header {
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  background-color: rgba(0, 0, 0, 0.03);
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
}
:where(#widgetEditorDialog) .card-header:first-child {
  border-radius: calc(0.25rem - 1px) calc(0.25rem - 1px) 0 0;
}
:where(#widgetEditorDialog) .card-footer {
  padding: 0.75rem 1.25rem;
  background-color: rgba(0, 0, 0, 0.03);
  border-top: 1px solid rgba(0, 0, 0, 0.125);
}
:where(#widgetEditorDialog) .card-footer:last-child {
  border-radius: 0 0 calc(0.25rem - 1px) calc(0.25rem - 1px);
}
:where(#widgetEditorDialog) .card-header-tabs {
  margin-right: -0.625rem;
  margin-bottom: -0.75rem;
  margin-left: -0.625rem;
  border-bottom: 0;
}
:where(#widgetEditorDialog) .card-header-pills {
  margin-right: -0.625rem;
  margin-left: -0.625rem;
}
:where(#widgetEditorDialog) .card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 1.25rem;
  border-radius: calc(0.25rem - 1px);
}
:where(#widgetEditorDialog) .card-img,
:where(#widgetEditorDialog) .card-img-top,
:where(#widgetEditorDialog) .card-img-bottom {
  flex-shrink: 0;
  width: 100%;
}
:where(#widgetEditorDialog) .card-img,
:where(#widgetEditorDialog) .card-img-top {
  border-top-left-radius: calc(0.25rem - 1px);
  border-top-right-radius: calc(0.25rem - 1px);
}
:where(#widgetEditorDialog) .card-img,
:where(#widgetEditorDialog) .card-img-bottom {
  border-bottom-right-radius: calc(0.25rem - 1px);
  border-bottom-left-radius: calc(0.25rem - 1px);
}
:where(#widgetEditorDialog) .card-deck .card {
  margin-bottom: 15px;
}
@media (min-width: 576px) {
  :where(#widgetEditorDialog) .card-deck {
    display: flex;
    flex-flow: row wrap;
    margin-right: -15px;
    margin-left: -15px;
  }
  :where(#widgetEditorDialog) .card-deck .card {
    flex: 1 0 0%;
    margin-right: 15px;
    margin-bottom: 0;
    margin-left: 15px;
  }
}
:where(#widgetEditorDialog) .card-group > .card {
  margin-bottom: 15px;
}
@media (min-width: 576px) {
  :where(#widgetEditorDialog) .card-group {
    display: flex;
    flex-flow: row wrap;
  }
  :where(#widgetEditorDialog) .card-group > .card {
    flex: 1 0 0%;
    margin-bottom: 0;
  }
  :where(#widgetEditorDialog) .card-group > .card + .card {
    margin-left: 0;
    border-left: 0;
  }
  :where(#widgetEditorDialog) .card-group > .card:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  :where(#widgetEditorDialog) .card-group > .card:not(:last-child) .card-img-top,
  :where(#widgetEditorDialog) .card-group > .card:not(:last-child) .card-header {
    border-top-right-radius: 0;
  }
  :where(#widgetEditorDialog) .card-group > .card:not(:last-child) .card-img-bottom,
  :where(#widgetEditorDialog) .card-group > .card:not(:last-child) .card-footer {
    border-bottom-right-radius: 0;
  }
  :where(#widgetEditorDialog) .card-group > .card:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  :where(#widgetEditorDialog) .card-group > .card:not(:first-child) .card-img-top,
  :where(#widgetEditorDialog) .card-group > .card:not(:first-child) .card-header {
    border-top-left-radius: 0;
  }
  :where(#widgetEditorDialog) .card-group > .card:not(:first-child) .card-img-bottom,
  :where(#widgetEditorDialog) .card-group > .card:not(:first-child) .card-footer {
    border-bottom-left-radius: 0;
  }
}
:where(#widgetEditorDialog) .card-columns .card {
  margin-bottom: 0.75rem;
}
@media (min-width: 576px) {
  :where(#widgetEditorDialog) .card-columns {
    column-count: 3;
    column-gap: 1.25rem;
    orphans: 1;
    widows: 1;
  }
  :where(#widgetEditorDialog) .card-columns .card {
    display: inline-block;
    width: 100%;
  }
}
:where(#widgetEditorDialog) .accordion {
  overflow-anchor: none;
}
:where(#widgetEditorDialog) .accordion > .card {
  overflow: hidden;
}
:where(#widgetEditorDialog) .accordion > .card:not(:last-of-type) {
  border-bottom: 0;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
:where(#widgetEditorDialog) .accordion > .card:not(:first-of-type) {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
:where(#widgetEditorDialog) .accordion > .card > .card-header {
  border-radius: 0;
  margin-bottom: -1px;
}
:where(#widgetEditorDialog) .breadcrumb {
  display: flex;
  flex-wrap: wrap;
  padding: 0.75rem 1rem;
  margin-bottom: 1rem;
  list-style: none;
  background-color: #e9ecef;
  border-radius: 0.25rem;
}
:where(#widgetEditorDialog) .breadcrumb-item + .breadcrumb-item {
  padding-left: 0.5rem;
}
:where(#widgetEditorDialog) .breadcrumb-item + .breadcrumb-item::before {
  float: left;
  padding-right: 0.5rem;
  color: #6c757d;
  content: "/";
}
:where(#widgetEditorDialog) .breadcrumb-item + .breadcrumb-item:hover::before {
  text-decoration: underline;
}
:where(#widgetEditorDialog) .breadcrumb-item + .breadcrumb-item:hover::before {
  text-decoration: none;
}
:where(#widgetEditorDialog) .breadcrumb-item.active {
  color: #6c757d;
}
:where(#widgetEditorDialog) .pagination {
  display: flex;
  padding-left: 0;
  list-style: none;
  border-radius: 0.25rem;
}
:where(#widgetEditorDialog) .page-link {
  position: relative;
  display: block;
  padding: 0.5rem 0.75rem;
  margin-left: -1px;
  line-height: 1.25;
  color: #007bff;
  background-color: #fff;
  border: 1px solid #dee2e6;
}
:where(#widgetEditorDialog) .page-link:hover {
  z-index: 2;
  color: rgb(0%, 33.7647058824%, 70%);
  text-decoration: none;
  background-color: #e9ecef;
  border-color: #dee2e6;
}
:where(#widgetEditorDialog) .page-link:focus {
  z-index: 3;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}
:where(#widgetEditorDialog) .page-item:first-child .page-link {
  margin-left: 0;
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
:where(#widgetEditorDialog) .page-item:last-child .page-link {
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}
:where(#widgetEditorDialog) .page-item.active .page-link {
  z-index: 3;
  color: #fff;
  background-color: #007bff;
  border-color: #007bff;
}
:where(#widgetEditorDialog) .page-item.disabled .page-link {
  color: #6c757d;
  pointer-events: none;
  cursor: auto;
  background-color: #fff;
  border-color: #dee2e6;
}
:where(#widgetEditorDialog) .pagination-lg .page-link {
  padding: 0.75rem 1.5rem;
  font-size: 1.25rem;
  line-height: 1.5;
}
:where(#widgetEditorDialog) .pagination-lg .page-item:first-child .page-link {
  border-top-left-radius: 0.3rem;
  border-bottom-left-radius: 0.3rem;
}
:where(#widgetEditorDialog) .pagination-lg .page-item:last-child .page-link {
  border-top-right-radius: 0.3rem;
  border-bottom-right-radius: 0.3rem;
}
:where(#widgetEditorDialog) .pagination-sm .page-link {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
}
:where(#widgetEditorDialog) .pagination-sm .page-item:first-child .page-link {
  border-top-left-radius: 0.2rem;
  border-bottom-left-radius: 0.2rem;
}
:where(#widgetEditorDialog) .pagination-sm .page-item:last-child .page-link {
  border-top-right-radius: 0.2rem;
  border-bottom-right-radius: 0.2rem;
}
:where(#widgetEditorDialog) .badge {
  display: inline-block;
  padding: 0.25em 0.4em;
  font-size: 75%;
  font-weight: 700;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  :where(#widgetEditorDialog) .badge {
    transition: none;
  }
}
a:where(#widgetEditorDialog) .badge:hover, a:where(#widgetEditorDialog) .badge:focus {
  text-decoration: none;
}

:where(#widgetEditorDialog) .badge:empty {
  display: none;
}
:where(#widgetEditorDialog) .btn .badge {
  position: relative;
  top: -1px;
}
:where(#widgetEditorDialog) .badge-pill {
  padding-right: 0.6em;
  padding-left: 0.6em;
  border-radius: 10rem;
}
:where(#widgetEditorDialog) .badge-primary {
  color: #fff;
  background-color: #007bff;
}
a:where(#widgetEditorDialog) .badge-primary:hover, a:where(#widgetEditorDialog) .badge-primary:focus {
  color: #fff;
  background-color: rgb(0%, 38.5882352941%, 80%);
}
a:where(#widgetEditorDialog) .badge-primary:focus, a:where(#widgetEditorDialog) .badge-primary.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.5);
}

:where(#widgetEditorDialog) .badge-secondary {
  color: #fff;
  background-color: #6c757d;
}
a:where(#widgetEditorDialog) .badge-secondary:hover, a:where(#widgetEditorDialog) .badge-secondary:focus {
  color: #fff;
  background-color: rgb(33.0825549104%, 35.8394344862%, 38.2899941092%);
}
a:where(#widgetEditorDialog) .badge-secondary:focus, a:where(#widgetEditorDialog) .badge-secondary.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.5);
}

:where(#widgetEditorDialog) .badge-success {
  color: #fff;
  background-color: #28a745;
}
a:where(#widgetEditorDialog) .badge-success:hover, a:where(#widgetEditorDialog) .badge-success:focus {
  color: #fff;
  background-color: rgb(11.8215402103%, 49.3549303779%, 20.3921568627%);
}
a:where(#widgetEditorDialog) .badge-success:focus, a:where(#widgetEditorDialog) .badge-success.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.5);
}

:where(#widgetEditorDialog) .badge-info {
  color: #fff;
  background-color: #17a2b8;
}
a:where(#widgetEditorDialog) .badge-info:hover, a:where(#widgetEditorDialog) .badge-info:focus {
  color: #fff;
  background-color: rgb(6.7973856209%, 47.8772378517%, 54.3790849673%);
}
a:where(#widgetEditorDialog) .badge-info:focus, a:where(#widgetEditorDialog) .badge-info.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(23, 162, 184, 0.5);
}

:where(#widgetEditorDialog) .badge-warning {
  color: #212529;
  background-color: #ffc107;
}
a:where(#widgetEditorDialog) .badge-warning:hover, a:where(#widgetEditorDialog) .badge-warning:focus {
  color: #212529;
  background-color: rgb(82.7450980392%, 62.0588235294%, 0%);
}
a:where(#widgetEditorDialog) .badge-warning:focus, a:where(#widgetEditorDialog) .badge-warning.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.5);
}

:where(#widgetEditorDialog) .badge-danger {
  color: #fff;
  background-color: #dc3545;
}
a:where(#widgetEditorDialog) .badge-danger:hover, a:where(#widgetEditorDialog) .badge-danger:focus {
  color: #fff;
  background-color: rgb(74.2020352445%, 12.8567882849%, 18.7341772152%);
}
a:where(#widgetEditorDialog) .badge-danger:focus, a:where(#widgetEditorDialog) .badge-danger.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.5);
}

:where(#widgetEditorDialog) .badge-light {
  color: #212529;
  background-color: #f8f9fa;
}
a:where(#widgetEditorDialog) .badge-light:hover, a:where(#widgetEditorDialog) .badge-light:focus {
  color: #212529;
  background-color: rgb(85.5882352941%, 87.6470588235%, 89.7058823529%);
}
a:where(#widgetEditorDialog) .badge-light:focus, a:where(#widgetEditorDialog) .badge-light.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(248, 249, 250, 0.5);
}

:where(#widgetEditorDialog) .badge-dark {
  color: #fff;
  background-color: #343a40;
}
a:where(#widgetEditorDialog) .badge-dark:hover, a:where(#widgetEditorDialog) .badge-dark:focus {
  color: #fff;
  background-color: rgb(11.4266396214%, 12.7450980392%, 14.0635564571%);
}
a:where(#widgetEditorDialog) .badge-dark:focus, a:where(#widgetEditorDialog) .badge-dark.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}

:where(#widgetEditorDialog) .jumbotron {
  padding: 2rem 1rem;
  margin-bottom: 2rem;
  background-color: #e9ecef;
  border-radius: 0.3rem;
}
@media (min-width: 576px) {
  :where(#widgetEditorDialog) .jumbotron {
    padding: 4rem 2rem;
  }
}
:where(#widgetEditorDialog) .jumbotron-fluid {
  padding-right: 0;
  padding-left: 0;
  border-radius: 0;
}
:where(#widgetEditorDialog) .alert {
  position: relative;
  padding: 0.75rem 1.25rem;
  margin-bottom: 1rem;
  border: 1px solid transparent;
  border-radius: 0.25rem;
}
:where(#widgetEditorDialog) .alert-heading {
  color: inherit;
}
:where(#widgetEditorDialog) .alert-link {
  font-weight: 700;
}
:where(#widgetEditorDialog) .alert-dismissible {
  padding-right: 4rem;
}
:where(#widgetEditorDialog) .alert-dismissible .close {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  padding: 0.75rem 1.25rem;
  color: inherit;
}
:where(#widgetEditorDialog) .alert-primary {
  color: rgb(0%, 25.0823529412%, 52%);
  background-color: rgb(80%, 89.6470588235%, 100%);
  border-color: rgb(72%, 85.5058823529%, 100%);
}
:where(#widgetEditorDialog) .alert-primary hr {
  border-top-color: rgb(62%, 80.3294117647%, 100%);
}
:where(#widgetEditorDialog) .alert-primary .alert-link {
  color: rgb(0%, 15.4352941176%, 32%);
}
:where(#widgetEditorDialog) .alert-secondary {
  color: rgb(22.0235294118%, 23.8588235294%, 25.4901960784%);
  background-color: rgb(88.4705882353%, 89.1764705882%, 89.8039215686%);
  border-color: rgb(83.8588235294%, 84.8470588235%, 85.7254901961%);
}
:where(#widgetEditorDialog) .alert-secondary hr {
  border-top-color: rgb(78.5519643236%, 79.865109365%, 81.0323494019%);
}
:where(#widgetEditorDialog) .alert-secondary .alert-link {
  color: rgb(12.7531431457%, 13.8159050745%, 14.7605823445%);
}
:where(#widgetEditorDialog) .alert-success {
  color: rgb(8.1568627451%, 34.0549019608%, 14.0705882353%);
  background-color: rgb(83.137254902%, 93.0980392157%, 85.4117647059%);
  border-color: rgb(76.3921568627%, 90.337254902%, 79.5764705882%);
}
:where(#widgetEditorDialog) .alert-success hr {
  border-top-color: rgb(69.2964472918%, 87.4329644729%, 73.4378567268%);
}
:where(#widgetEditorDialog) .alert-success .alert-link {
  color: rgb(4.2921284456%, 17.9196362603%, 7.4039215686%);
}
:where(#widgetEditorDialog) .alert-info {
  color: rgb(4.6901960784%, 33.0352941176%, 37.5215686275%);
  background-color: rgb(81.8039215686%, 92.7058823529%, 94.431372549%);
  border-color: rgb(74.5254901961%, 89.7882352941%, 92.2039215686%);
}
:where(#widgetEditorDialog) .alert-info hr {
  border-top-color: rgb(66.8687245195%, 86.7189283634%, 89.8606872452%);
}
:where(#widgetEditorDialog) .alert-info .alert-link {
  color: rgb(2.4679738562%, 17.3831202046%, 19.7437908497%);
}
:where(#widgetEditorDialog) .alert-warning {
  color: rgb(52%, 39.3568627451%, 1.4274509804%);
  background-color: rgb(100%, 95.137254902%, 80.5490196078%);
  border-color: rgb(100%, 93.1921568627%, 72.768627451%);
}
:where(#widgetEditorDialog) .alert-warning hr {
  border-top-color: rgb(100%, 90.6921568627%, 62.768627451%);
}
:where(#widgetEditorDialog) .alert-warning .alert-link {
  color: rgb(32.534351145%, 24.6240383176%, 0.8930998354%);
}
:where(#widgetEditorDialog) .alert-danger {
  color: rgb(44.862745098%, 10.8078431373%, 14.0705882353%);
  background-color: rgb(97.2549019608%, 84.1568627451%, 85.4117647059%);
  border-color: rgb(96.1568627451%, 77.8196078431%, 79.5764705882%);
}
:where(#widgetEditorDialog) .alert-danger hr {
  border-top-color: rgb(94.6800694962%, 69.2964010921%, 71.7283693224%);
}
:where(#widgetEditorDialog) .alert-danger .alert-link {
  color: rgb(28.7455289808%, 6.9250592545%, 9.0156431803%);
}
:where(#widgetEditorDialog) .alert-light {
  color: rgb(50.5725490196%, 50.7764705882%, 50.9803921569%);
  background-color: rgb(99.4509803922%, 99.5294117647%, 99.6078431373%);
  border-color: rgb(99.231372549%, 99.3411764706%, 99.4509803922%);
}
:where(#widgetEditorDialog) .alert-light hr {
  border-top-color: rgb(93.3980392157%, 94.3411764706%, 95.2843137255%);
}
:where(#widgetEditorDialog) .alert-light .alert-link {
  color: rgb(40.6075432085%, 40.7764705882%, 40.945397968%);
}
:where(#widgetEditorDialog) .alert-dark {
  color: rgb(10.6039215686%, 11.8274509804%, 13.0509803922%);
  background-color: rgb(84.0784313725%, 84.5490196078%, 85.0196078431%);
  border-color: rgb(77.7098039216%, 78.368627451%, 79.0274509804%);
}
:where(#widgetEditorDialog) .alert-dark hr {
  border-top-color: rgb(72.5575196576%, 73.368627451%, 74.1797352444%);
}
:where(#widgetEditorDialog) .alert-dark .alert-link {
  color: rgb(1.6384043272%, 1.8274509804%, 2.0164976335%);
}
@keyframes progress-bar-stripes {
  from {
    background-position: 1rem 0;
  }
  to {
    background-position: 0 0;
  }
}
:where(#widgetEditorDialog) .progress {
  display: flex;
  height: 1rem;
  overflow: hidden;
  line-height: 0;
  font-size: 0.75rem;
  background-color: #e9ecef;
  border-radius: 0.25rem;
}
:where(#widgetEditorDialog) .progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  color: #fff;
  text-align: center;
  white-space: nowrap;
  background-color: #007bff;
  transition: width 0.6s ease;
}
@media (prefers-reduced-motion: reduce) {
  :where(#widgetEditorDialog) .progress-bar {
    transition: none;
  }
}
:where(#widgetEditorDialog) .progress-bar-striped {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: 1rem 1rem;
}
:where(#widgetEditorDialog) .progress-bar-animated {
  animation: 1s linear infinite progress-bar-stripes;
}
@media (prefers-reduced-motion: reduce) {
  :where(#widgetEditorDialog) .progress-bar-animated {
    animation: none;
  }
}
:where(#widgetEditorDialog) .media {
  display: flex;
  align-items: flex-start;
}
:where(#widgetEditorDialog) .media-body {
  flex: 1;
}
:where(#widgetEditorDialog) .list-group {
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  border-radius: 0.25rem;
}
:where(#widgetEditorDialog) .list-group-item-action {
  width: 100%;
  color: #495057;
  text-align: inherit;
}
:where(#widgetEditorDialog) .list-group-item-action:hover, :where(#widgetEditorDialog) .list-group-item-action:focus {
  z-index: 1;
  color: #495057;
  text-decoration: none;
  background-color: #f8f9fa;
}
:where(#widgetEditorDialog) .list-group-item-action:active {
  color: #212529;
  background-color: #e9ecef;
}
:where(#widgetEditorDialog) .list-group-item {
  position: relative;
  display: block;
  padding: 0.75rem 1.25rem;
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.125);
}
:where(#widgetEditorDialog) .list-group-item:first-child {
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
}
:where(#widgetEditorDialog) .list-group-item:last-child {
  border-bottom-right-radius: inherit;
  border-bottom-left-radius: inherit;
}
:where(#widgetEditorDialog) .list-group-item.disabled, :where(#widgetEditorDialog) .list-group-item:disabled {
  color: #6c757d;
  pointer-events: none;
  background-color: #fff;
}
:where(#widgetEditorDialog) .list-group-item.active {
  z-index: 2;
  color: #fff;
  background-color: #007bff;
  border-color: #007bff;
}
:where(#widgetEditorDialog) .list-group-item + :where(#widgetEditorDialog) .list-group-item {
  border-top-width: 0;
}
:where(#widgetEditorDialog) .list-group-item + :where(#widgetEditorDialog) .list-group-item.active {
  margin-top: -1px;
  border-top-width: 1px;
}
:where(#widgetEditorDialog) .list-group-horizontal {
  flex-direction: row;
}
:where(#widgetEditorDialog) .list-group-horizontal > .list-group-item:first-child {
  border-bottom-left-radius: 0.25rem;
  border-top-right-radius: 0;
}
:where(#widgetEditorDialog) .list-group-horizontal > .list-group-item:last-child {
  border-top-right-radius: 0.25rem;
  border-bottom-left-radius: 0;
}
:where(#widgetEditorDialog) .list-group-horizontal > .list-group-item.active {
  margin-top: 0;
}
:where(#widgetEditorDialog) .list-group-horizontal > .list-group-item + .list-group-item {
  border-top-width: 1px;
  border-left-width: 0;
}
:where(#widgetEditorDialog) .list-group-horizontal > .list-group-item + .list-group-item.active {
  margin-left: -1px;
  border-left-width: 1px;
}
@media (min-width: 576px) {
  :where(#widgetEditorDialog) .list-group-horizontal-sm {
    flex-direction: row;
  }
  :where(#widgetEditorDialog) .list-group-horizontal-sm > .list-group-item:first-child {
    border-bottom-left-radius: 0.25rem;
    border-top-right-radius: 0;
  }
  :where(#widgetEditorDialog) .list-group-horizontal-sm > .list-group-item:last-child {
    border-top-right-radius: 0.25rem;
    border-bottom-left-radius: 0;
  }
  :where(#widgetEditorDialog) .list-group-horizontal-sm > .list-group-item.active {
    margin-top: 0;
  }
  :where(#widgetEditorDialog) .list-group-horizontal-sm > .list-group-item + .list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }
  :where(#widgetEditorDialog) .list-group-horizontal-sm > .list-group-item + .list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}
@media (min-width: 768px) {
  :where(#widgetEditorDialog) .list-group-horizontal-md {
    flex-direction: row;
  }
  :where(#widgetEditorDialog) .list-group-horizontal-md > .list-group-item:first-child {
    border-bottom-left-radius: 0.25rem;
    border-top-right-radius: 0;
  }
  :where(#widgetEditorDialog) .list-group-horizontal-md > .list-group-item:last-child {
    border-top-right-radius: 0.25rem;
    border-bottom-left-radius: 0;
  }
  :where(#widgetEditorDialog) .list-group-horizontal-md > .list-group-item.active {
    margin-top: 0;
  }
  :where(#widgetEditorDialog) .list-group-horizontal-md > .list-group-item + .list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }
  :where(#widgetEditorDialog) .list-group-horizontal-md > .list-group-item + .list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}
@media (min-width: 992px) {
  :where(#widgetEditorDialog) .list-group-horizontal-lg {
    flex-direction: row;
  }
  :where(#widgetEditorDialog) .list-group-horizontal-lg > .list-group-item:first-child {
    border-bottom-left-radius: 0.25rem;
    border-top-right-radius: 0;
  }
  :where(#widgetEditorDialog) .list-group-horizontal-lg > .list-group-item:last-child {
    border-top-right-radius: 0.25rem;
    border-bottom-left-radius: 0;
  }
  :where(#widgetEditorDialog) .list-group-horizontal-lg > .list-group-item.active {
    margin-top: 0;
  }
  :where(#widgetEditorDialog) .list-group-horizontal-lg > .list-group-item + .list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }
  :where(#widgetEditorDialog) .list-group-horizontal-lg > .list-group-item + .list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}
@media (min-width: 1200px) {
  :where(#widgetEditorDialog) .list-group-horizontal-xl {
    flex-direction: row;
  }
  :where(#widgetEditorDialog) .list-group-horizontal-xl > .list-group-item:first-child {
    border-bottom-left-radius: 0.25rem;
    border-top-right-radius: 0;
  }
  :where(#widgetEditorDialog) .list-group-horizontal-xl > .list-group-item:last-child {
    border-top-right-radius: 0.25rem;
    border-bottom-left-radius: 0;
  }
  :where(#widgetEditorDialog) .list-group-horizontal-xl > .list-group-item.active {
    margin-top: 0;
  }
  :where(#widgetEditorDialog) .list-group-horizontal-xl > .list-group-item + .list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }
  :where(#widgetEditorDialog) .list-group-horizontal-xl > .list-group-item + .list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}
:where(#widgetEditorDialog) .list-group-flush {
  border-radius: 0;
}
:where(#widgetEditorDialog) .list-group-flush > .list-group-item {
  border-width: 0 0 1px;
}
:where(#widgetEditorDialog) .list-group-flush > .list-group-item:last-child {
  border-bottom-width: 0;
}
:where(#widgetEditorDialog) .list-group-item-primary {
  color: rgb(0%, 25.0823529412%, 52%);
  background-color: rgb(72%, 85.5058823529%, 100%);
}
:where(#widgetEditorDialog) .list-group-item-primary.list-group-item-action:hover, :where(#widgetEditorDialog) .list-group-item-primary.list-group-item-action:focus {
  color: rgb(0%, 25.0823529412%, 52%);
  background-color: rgb(62%, 80.3294117647%, 100%);
}
:where(#widgetEditorDialog) .list-group-item-primary.list-group-item-action.active {
  color: #fff;
  background-color: rgb(0%, 25.0823529412%, 52%);
  border-color: rgb(0%, 25.0823529412%, 52%);
}
:where(#widgetEditorDialog) .list-group-item-secondary {
  color: rgb(22.0235294118%, 23.8588235294%, 25.4901960784%);
  background-color: rgb(83.8588235294%, 84.8470588235%, 85.7254901961%);
}
:where(#widgetEditorDialog) .list-group-item-secondary.list-group-item-action:hover, :where(#widgetEditorDialog) .list-group-item-secondary.list-group-item-action:focus {
  color: rgb(22.0235294118%, 23.8588235294%, 25.4901960784%);
  background-color: rgb(78.5519643236%, 79.865109365%, 81.0323494019%);
}
:where(#widgetEditorDialog) .list-group-item-secondary.list-group-item-action.active {
  color: #fff;
  background-color: rgb(22.0235294118%, 23.8588235294%, 25.4901960784%);
  border-color: rgb(22.0235294118%, 23.8588235294%, 25.4901960784%);
}
:where(#widgetEditorDialog) .list-group-item-success {
  color: rgb(8.1568627451%, 34.0549019608%, 14.0705882353%);
  background-color: rgb(76.3921568627%, 90.337254902%, 79.5764705882%);
}
:where(#widgetEditorDialog) .list-group-item-success.list-group-item-action:hover, :where(#widgetEditorDialog) .list-group-item-success.list-group-item-action:focus {
  color: rgb(8.1568627451%, 34.0549019608%, 14.0705882353%);
  background-color: rgb(69.2964472918%, 87.4329644729%, 73.4378567268%);
}
:where(#widgetEditorDialog) .list-group-item-success.list-group-item-action.active {
  color: #fff;
  background-color: rgb(8.1568627451%, 34.0549019608%, 14.0705882353%);
  border-color: rgb(8.1568627451%, 34.0549019608%, 14.0705882353%);
}
:where(#widgetEditorDialog) .list-group-item-info {
  color: rgb(4.6901960784%, 33.0352941176%, 37.5215686275%);
  background-color: rgb(74.5254901961%, 89.7882352941%, 92.2039215686%);
}
:where(#widgetEditorDialog) .list-group-item-info.list-group-item-action:hover, :where(#widgetEditorDialog) .list-group-item-info.list-group-item-action:focus {
  color: rgb(4.6901960784%, 33.0352941176%, 37.5215686275%);
  background-color: rgb(66.8687245195%, 86.7189283634%, 89.8606872452%);
}
:where(#widgetEditorDialog) .list-group-item-info.list-group-item-action.active {
  color: #fff;
  background-color: rgb(4.6901960784%, 33.0352941176%, 37.5215686275%);
  border-color: rgb(4.6901960784%, 33.0352941176%, 37.5215686275%);
}
:where(#widgetEditorDialog) .list-group-item-warning {
  color: rgb(52%, 39.3568627451%, 1.4274509804%);
  background-color: rgb(100%, 93.1921568627%, 72.768627451%);
}
:where(#widgetEditorDialog) .list-group-item-warning.list-group-item-action:hover, :where(#widgetEditorDialog) .list-group-item-warning.list-group-item-action:focus {
  color: rgb(52%, 39.3568627451%, 1.4274509804%);
  background-color: rgb(100%, 90.6921568627%, 62.768627451%);
}
:where(#widgetEditorDialog) .list-group-item-warning.list-group-item-action.active {
  color: #fff;
  background-color: rgb(52%, 39.3568627451%, 1.4274509804%);
  border-color: rgb(52%, 39.3568627451%, 1.4274509804%);
}
:where(#widgetEditorDialog) .list-group-item-danger {
  color: rgb(44.862745098%, 10.8078431373%, 14.0705882353%);
  background-color: rgb(96.1568627451%, 77.8196078431%, 79.5764705882%);
}
:where(#widgetEditorDialog) .list-group-item-danger.list-group-item-action:hover, :where(#widgetEditorDialog) .list-group-item-danger.list-group-item-action:focus {
  color: rgb(44.862745098%, 10.8078431373%, 14.0705882353%);
  background-color: rgb(94.6800694962%, 69.2964010921%, 71.7283693224%);
}
:where(#widgetEditorDialog) .list-group-item-danger.list-group-item-action.active {
  color: #fff;
  background-color: rgb(44.862745098%, 10.8078431373%, 14.0705882353%);
  border-color: rgb(44.862745098%, 10.8078431373%, 14.0705882353%);
}
:where(#widgetEditorDialog) .list-group-item-light {
  color: rgb(50.5725490196%, 50.7764705882%, 50.9803921569%);
  background-color: rgb(99.231372549%, 99.3411764706%, 99.4509803922%);
}
:where(#widgetEditorDialog) .list-group-item-light.list-group-item-action:hover, :where(#widgetEditorDialog) .list-group-item-light.list-group-item-action:focus {
  color: rgb(50.5725490196%, 50.7764705882%, 50.9803921569%);
  background-color: rgb(93.3980392157%, 94.3411764706%, 95.2843137255%);
}
:where(#widgetEditorDialog) .list-group-item-light.list-group-item-action.active {
  color: #fff;
  background-color: rgb(50.5725490196%, 50.7764705882%, 50.9803921569%);
  border-color: rgb(50.5725490196%, 50.7764705882%, 50.9803921569%);
}
:where(#widgetEditorDialog) .list-group-item-dark {
  color: rgb(10.6039215686%, 11.8274509804%, 13.0509803922%);
  background-color: rgb(77.7098039216%, 78.368627451%, 79.0274509804%);
}
:where(#widgetEditorDialog) .list-group-item-dark.list-group-item-action:hover, :where(#widgetEditorDialog) .list-group-item-dark.list-group-item-action:focus {
  color: rgb(10.6039215686%, 11.8274509804%, 13.0509803922%);
  background-color: rgb(72.5575196576%, 73.368627451%, 74.1797352444%);
}
:where(#widgetEditorDialog) .list-group-item-dark.list-group-item-action.active {
  color: #fff;
  background-color: rgb(10.6039215686%, 11.8274509804%, 13.0509803922%);
  border-color: rgb(10.6039215686%, 11.8274509804%, 13.0509803922%);
}
:where(#widgetEditorDialog) .close {
  float: right;
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1;
  color: #000;
  text-shadow: 0 1px 0 #fff;
  opacity: 0.5;
}
:where(#widgetEditorDialog) .close:hover {
  color: #000;
  text-decoration: none;
}
:where(#widgetEditorDialog) .close:not(:disabled):not(.disabled):hover, :where(#widgetEditorDialog) .close:not(:disabled):not(.disabled):focus {
  opacity: 0.75;
}
:where(#widgetEditorDialog) button.close {
  padding: 0;
  background-color: transparent;
  border: 0;
}
:where(#widgetEditorDialog) a.close.disabled {
  pointer-events: none;
}
:where(#widgetEditorDialog) .toast {
  flex-basis: 350px;
  max-width: 350px;
  font-size: 0.875rem;
  background-color: rgba(255, 255, 255, 0.85);
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.1);
  box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, 0.1);
  opacity: 0;
  border-radius: 0.25rem;
}
:where(#widgetEditorDialog) .toast:not(:last-child) {
  margin-bottom: 0.75rem;
}
:where(#widgetEditorDialog) .toast.showing {
  opacity: 1;
}
:where(#widgetEditorDialog) .toast.show {
  display: block;
  opacity: 1;
}
:where(#widgetEditorDialog) .toast.hide {
  display: none;
}
:where(#widgetEditorDialog) .toast-header {
  display: flex;
  align-items: center;
  padding: 0.25rem 0.75rem;
  color: #6c757d;
  background-color: rgba(255, 255, 255, 0.85);
  background-clip: padding-box;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  border-top-left-radius: calc(0.25rem - 1px);
  border-top-right-radius: calc(0.25rem - 1px);
}
:where(#widgetEditorDialog) .toast-body {
  padding: 0.75rem;
}
:where(#widgetEditorDialog) .modal-open {
  overflow: hidden;
}
:where(#widgetEditorDialog) .modal-open .modal {
  overflow-x: hidden;
  overflow-y: auto;
}
:where(#widgetEditorDialog) .modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1050;
  display: none;
  width: 100%;
  height: 100%;
  overflow: hidden;
  outline: 0;
}
:where(#widgetEditorDialog) .modal-dialog {
  position: relative;
  width: auto;
  margin: 0.5rem;
  pointer-events: none;
}
.modal.fade :where(#widgetEditorDialog) .modal-dialog {
  transition: transform 0.3s ease-out;
}
@media (prefers-reduced-motion: reduce) {
  .modal.fade :where(#widgetEditorDialog) .modal-dialog {
    transition: none;
  }
}
.modal.fade :where(#widgetEditorDialog) .modal-dialog {
  transform: translate(0, -50px);
}
.modal.show :where(#widgetEditorDialog) .modal-dialog {
  transform: none;
}
.modal.modal-static :where(#widgetEditorDialog) .modal-dialog {
  transform: scale(1.02);
}
:where(#widgetEditorDialog) .modal-dialog-scrollable {
  display: flex;
  max-height: calc(100% - 1rem);
}
:where(#widgetEditorDialog) .modal-dialog-scrollable .modal-content {
  max-height: calc(100vh - 1rem);
  overflow: hidden;
}
:where(#widgetEditorDialog) .modal-dialog-scrollable .modal-header,
:where(#widgetEditorDialog) .modal-dialog-scrollable .modal-footer {
  flex-shrink: 0;
}
:where(#widgetEditorDialog) .modal-dialog-scrollable .modal-body {
  overflow-y: auto;
}
:where(#widgetEditorDialog) .modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - 1rem);
}
:where(#widgetEditorDialog) .modal-dialog-centered::before {
  display: block;
  height: calc(100vh - 1rem);
  height: min-content;
  content: "";
}
:where(#widgetEditorDialog) .modal-dialog-centered.modal-dialog-scrollable {
  flex-direction: column;
  justify-content: center;
  height: 100%;
}
:where(#widgetEditorDialog) .modal-dialog-centered.modal-dialog-scrollable .modal-content {
  max-height: none;
}
:where(#widgetEditorDialog) .modal-dialog-centered.modal-dialog-scrollable::before {
  content: none;
}
:where(#widgetEditorDialog) .modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  pointer-events: auto;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 0.3rem;
  outline: 0;
}
:where(#widgetEditorDialog) .modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: #000;
}
:where(#widgetEditorDialog) .modal-backdrop.fade {
  opacity: 0;
}
:where(#widgetEditorDialog) .modal-backdrop.show {
  opacity: 0.5;
}
:where(#widgetEditorDialog) .modal-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 1rem 1rem;
  border-bottom: 1px solid #dee2e6;
  border-top-left-radius: calc(0.3rem - 1px);
  border-top-right-radius: calc(0.3rem - 1px);
}
:where(#widgetEditorDialog) .modal-header .close {
  padding: 1rem 1rem;
  margin: -1rem -1rem -1rem auto;
}
:where(#widgetEditorDialog) .modal-title {
  margin-bottom: 0;
  line-height: 1.5;
}
:where(#widgetEditorDialog) .modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: 1rem;
}
:where(#widgetEditorDialog) .modal-footer {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  padding: 0.75rem;
  border-top: 1px solid #dee2e6;
  border-bottom-right-radius: calc(0.3rem - 1px);
  border-bottom-left-radius: calc(0.3rem - 1px);
}
:where(#widgetEditorDialog) .modal-footer > * {
  margin: 0.25rem;
}
:where(#widgetEditorDialog) .modal-scrollbar-measure {
  position: absolute;
  top: -9999px;
  width: 50px;
  height: 50px;
  overflow: scroll;
}
@media (min-width: 576px) {
  :where(#widgetEditorDialog) .modal-dialog {
    max-width: 500px;
    margin: 1.75rem auto;
  }
  :where(#widgetEditorDialog) .modal-dialog-scrollable {
    max-height: calc(100% - 3.5rem);
  }
  :where(#widgetEditorDialog) .modal-dialog-scrollable .modal-content {
    max-height: calc(100vh - 3.5rem);
  }
  :where(#widgetEditorDialog) .modal-dialog-centered {
    min-height: calc(100% - 3.5rem);
  }
  :where(#widgetEditorDialog) .modal-dialog-centered::before {
    height: calc(100vh - 3.5rem);
    height: min-content;
  }
  :where(#widgetEditorDialog) .modal-sm {
    max-width: 300px;
  }
}
@media (min-width: 992px) {
  :where(#widgetEditorDialog) .modal-lg,
  :where(#widgetEditorDialog) .modal-xl {
    max-width: 800px;
  }
}
@media (min-width: 1200px) {
  :where(#widgetEditorDialog) .modal-xl {
    max-width: 1140px;
  }
}
:where(#widgetEditorDialog) .tooltip {
  position: absolute;
  z-index: 1070;
  display: block;
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", "Liberation Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: 0.875rem;
  word-wrap: break-word;
  opacity: 0;
}
:where(#widgetEditorDialog) .tooltip.show {
  opacity: 0.9;
}
:where(#widgetEditorDialog) .tooltip .arrow {
  position: absolute;
  display: block;
  width: 0.8rem;
  height: 0.4rem;
}
:where(#widgetEditorDialog) .tooltip .arrow::before {
  position: absolute;
  content: "";
  border-color: transparent;
  border-style: solid;
}
:where(#widgetEditorDialog) .bs-tooltip-top, :where(#widgetEditorDialog) .bs-tooltip-auto[x-placement^=top] {
  padding: 0.4rem 0;
}
:where(#widgetEditorDialog) .bs-tooltip-top .arrow, :where(#widgetEditorDialog) .bs-tooltip-auto[x-placement^=top] .arrow {
  bottom: 0;
}
:where(#widgetEditorDialog) .bs-tooltip-top .arrow::before, :where(#widgetEditorDialog) .bs-tooltip-auto[x-placement^=top] .arrow::before {
  top: 0;
  border-width: 0.4rem 0.4rem 0;
  border-top-color: #000;
}
:where(#widgetEditorDialog) .bs-tooltip-right, :where(#widgetEditorDialog) .bs-tooltip-auto[x-placement^=right] {
  padding: 0 0.4rem;
}
:where(#widgetEditorDialog) .bs-tooltip-right .arrow, :where(#widgetEditorDialog) .bs-tooltip-auto[x-placement^=right] .arrow {
  left: 0;
  width: 0.4rem;
  height: 0.8rem;
}
:where(#widgetEditorDialog) .bs-tooltip-right .arrow::before, :where(#widgetEditorDialog) .bs-tooltip-auto[x-placement^=right] .arrow::before {
  right: 0;
  border-width: 0.4rem 0.4rem 0.4rem 0;
  border-right-color: #000;
}
:where(#widgetEditorDialog) .bs-tooltip-bottom, :where(#widgetEditorDialog) .bs-tooltip-auto[x-placement^=bottom] {
  padding: 0.4rem 0;
}
:where(#widgetEditorDialog) .bs-tooltip-bottom .arrow, :where(#widgetEditorDialog) .bs-tooltip-auto[x-placement^=bottom] .arrow {
  top: 0;
}
:where(#widgetEditorDialog) .bs-tooltip-bottom .arrow::before, :where(#widgetEditorDialog) .bs-tooltip-auto[x-placement^=bottom] .arrow::before {
  bottom: 0;
  border-width: 0 0.4rem 0.4rem;
  border-bottom-color: #000;
}
:where(#widgetEditorDialog) .bs-tooltip-left, :where(#widgetEditorDialog) .bs-tooltip-auto[x-placement^=left] {
  padding: 0 0.4rem;
}
:where(#widgetEditorDialog) .bs-tooltip-left .arrow, :where(#widgetEditorDialog) .bs-tooltip-auto[x-placement^=left] .arrow {
  right: 0;
  width: 0.4rem;
  height: 0.8rem;
}
:where(#widgetEditorDialog) .bs-tooltip-left .arrow::before, :where(#widgetEditorDialog) .bs-tooltip-auto[x-placement^=left] .arrow::before {
  left: 0;
  border-width: 0.4rem 0 0.4rem 0.4rem;
  border-left-color: #000;
}
:where(#widgetEditorDialog) .tooltip-inner {
  max-width: 200px;
  padding: 0.25rem 0.5rem;
  color: #fff;
  text-align: center;
  background-color: #000;
  border-radius: 0.25rem;
}
:where(#widgetEditorDialog) .popover {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1060;
  display: block;
  max-width: 276px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", "Liberation Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: 0.875rem;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 0.3rem;
}
:where(#widgetEditorDialog) .popover .arrow {
  position: absolute;
  display: block;
  width: 1rem;
  height: 0.5rem;
  margin: 0 0.3rem;
}
:where(#widgetEditorDialog) .popover .arrow::before, :where(#widgetEditorDialog) .popover .arrow::after {
  position: absolute;
  display: block;
  content: "";
  border-color: transparent;
  border-style: solid;
}
:where(#widgetEditorDialog) .bs-popover-top, :where(#widgetEditorDialog) .bs-popover-auto[x-placement^=top] {
  margin-bottom: 0.5rem;
}
:where(#widgetEditorDialog) .bs-popover-top > .arrow, :where(#widgetEditorDialog) .bs-popover-auto[x-placement^=top] > .arrow {
  bottom: calc(-0.5rem - 1px);
}
:where(#widgetEditorDialog) .bs-popover-top > .arrow::before, :where(#widgetEditorDialog) .bs-popover-auto[x-placement^=top] > .arrow::before {
  bottom: 0;
  border-width: 0.5rem 0.5rem 0;
  border-top-color: rgba(0, 0, 0, 0.25);
}
:where(#widgetEditorDialog) .bs-popover-top > .arrow::after, :where(#widgetEditorDialog) .bs-popover-auto[x-placement^=top] > .arrow::after {
  bottom: 1px;
  border-width: 0.5rem 0.5rem 0;
  border-top-color: #fff;
}
:where(#widgetEditorDialog) .bs-popover-right, :where(#widgetEditorDialog) .bs-popover-auto[x-placement^=right] {
  margin-left: 0.5rem;
}
:where(#widgetEditorDialog) .bs-popover-right > .arrow, :where(#widgetEditorDialog) .bs-popover-auto[x-placement^=right] > .arrow {
  left: calc(-0.5rem - 1px);
  width: 0.5rem;
  height: 1rem;
  margin: 0.3rem 0;
}
:where(#widgetEditorDialog) .bs-popover-right > .arrow::before, :where(#widgetEditorDialog) .bs-popover-auto[x-placement^=right] > .arrow::before {
  left: 0;
  border-width: 0.5rem 0.5rem 0.5rem 0;
  border-right-color: rgba(0, 0, 0, 0.25);
}
:where(#widgetEditorDialog) .bs-popover-right > .arrow::after, :where(#widgetEditorDialog) .bs-popover-auto[x-placement^=right] > .arrow::after {
  left: 1px;
  border-width: 0.5rem 0.5rem 0.5rem 0;
  border-right-color: #fff;
}
:where(#widgetEditorDialog) .bs-popover-bottom, :where(#widgetEditorDialog) .bs-popover-auto[x-placement^=bottom] {
  margin-top: 0.5rem;
}
:where(#widgetEditorDialog) .bs-popover-bottom > .arrow, :where(#widgetEditorDialog) .bs-popover-auto[x-placement^=bottom] > .arrow {
  top: calc(-0.5rem - 1px);
}
:where(#widgetEditorDialog) .bs-popover-bottom > .arrow::before, :where(#widgetEditorDialog) .bs-popover-auto[x-placement^=bottom] > .arrow::before {
  top: 0;
  border-width: 0 0.5rem 0.5rem 0.5rem;
  border-bottom-color: rgba(0, 0, 0, 0.25);
}
:where(#widgetEditorDialog) .bs-popover-bottom > .arrow::after, :where(#widgetEditorDialog) .bs-popover-auto[x-placement^=bottom] > .arrow::after {
  top: 1px;
  border-width: 0 0.5rem 0.5rem 0.5rem;
  border-bottom-color: #fff;
}
:where(#widgetEditorDialog) .bs-popover-bottom .popover-header::before, :where(#widgetEditorDialog) .bs-popover-auto[x-placement^=bottom] .popover-header::before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: 1rem;
  margin-left: -0.5rem;
  content: "";
  border-bottom: 1px solid rgb(97%, 97%, 97%);
}
:where(#widgetEditorDialog) .bs-popover-left, :where(#widgetEditorDialog) .bs-popover-auto[x-placement^=left] {
  margin-right: 0.5rem;
}
:where(#widgetEditorDialog) .bs-popover-left > .arrow, :where(#widgetEditorDialog) .bs-popover-auto[x-placement^=left] > .arrow {
  right: calc(-0.5rem - 1px);
  width: 0.5rem;
  height: 1rem;
  margin: 0.3rem 0;
}
:where(#widgetEditorDialog) .bs-popover-left > .arrow::before, :where(#widgetEditorDialog) .bs-popover-auto[x-placement^=left] > .arrow::before {
  right: 0;
  border-width: 0.5rem 0 0.5rem 0.5rem;
  border-left-color: rgba(0, 0, 0, 0.25);
}
:where(#widgetEditorDialog) .bs-popover-left > .arrow::after, :where(#widgetEditorDialog) .bs-popover-auto[x-placement^=left] > .arrow::after {
  right: 1px;
  border-width: 0.5rem 0 0.5rem 0.5rem;
  border-left-color: #fff;
}
:where(#widgetEditorDialog) .popover-header {
  padding: 0.5rem 0.75rem;
  margin-bottom: 0;
  font-size: 1rem;
  background-color: rgb(97%, 97%, 97%);
  border-bottom: 1px solid rgb(92%, 92%, 92%);
  border-top-left-radius: calc(0.3rem - 1px);
  border-top-right-radius: calc(0.3rem - 1px);
}
:where(#widgetEditorDialog) .popover-header:empty {
  display: none;
}
:where(#widgetEditorDialog) .popover-body {
  padding: 0.5rem 0.75rem;
  color: #212529;
}
:where(#widgetEditorDialog) .carousel {
  position: relative;
}
:where(#widgetEditorDialog) .carousel.pointer-event {
  touch-action: pan-y;
}
:where(#widgetEditorDialog) .carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden;
}
:where(#widgetEditorDialog) .carousel-inner::after {
  display: block;
  clear: both;
  content: "";
}
:where(#widgetEditorDialog) .carousel-item {
  position: relative;
  display: none;
  float: left;
  width: 100%;
  margin-right: -100%;
  backface-visibility: hidden;
  transition: transform 0.6s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  :where(#widgetEditorDialog) .carousel-item {
    transition: none;
  }
}
:where(#widgetEditorDialog) .carousel-item.active,
:where(#widgetEditorDialog) .carousel-item-next,
:where(#widgetEditorDialog) .carousel-item-prev {
  display: block;
}
:where(#widgetEditorDialog) .carousel-item-next:not(.carousel-item-left),
:where(#widgetEditorDialog) .active.carousel-item-right {
  transform: translateX(100%);
}
:where(#widgetEditorDialog) .carousel-item-prev:not(.carousel-item-right),
:where(#widgetEditorDialog) .active.carousel-item-left {
  transform: translateX(-100%);
}
:where(#widgetEditorDialog) .carousel-fade .carousel-item {
  opacity: 0;
  transition-property: opacity;
  transform: none;
}
:where(#widgetEditorDialog) .carousel-fade .carousel-item.active,
:where(#widgetEditorDialog) .carousel-fade .carousel-item-next.carousel-item-left,
:where(#widgetEditorDialog) .carousel-fade .carousel-item-prev.carousel-item-right {
  z-index: 1;
  opacity: 1;
}
:where(#widgetEditorDialog) .carousel-fade .active.carousel-item-left,
:where(#widgetEditorDialog) .carousel-fade .active.carousel-item-right {
  z-index: 0;
  opacity: 0;
  transition: opacity 0s 0.6s;
}
@media (prefers-reduced-motion: reduce) {
  :where(#widgetEditorDialog) .carousel-fade .active.carousel-item-left,
  :where(#widgetEditorDialog) .carousel-fade .active.carousel-item-right {
    transition: none;
  }
}
:where(#widgetEditorDialog) .carousel-control-prev,
:where(#widgetEditorDialog) .carousel-control-next {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15%;
  padding: 0;
  color: #fff;
  text-align: center;
  background: none;
  border: 0;
  opacity: 0.5;
  transition: opacity 0.15s ease;
}
@media (prefers-reduced-motion: reduce) {
  :where(#widgetEditorDialog) .carousel-control-prev,
  :where(#widgetEditorDialog) .carousel-control-next {
    transition: none;
  }
}
:where(#widgetEditorDialog) .carousel-control-prev:hover, :where(#widgetEditorDialog) .carousel-control-prev:focus,
:where(#widgetEditorDialog) .carousel-control-next:hover,
:where(#widgetEditorDialog) .carousel-control-next:focus {
  color: #fff;
  text-decoration: none;
  outline: 0;
  opacity: 0.9;
}
:where(#widgetEditorDialog) .carousel-control-prev {
  left: 0;
}
:where(#widgetEditorDialog) .carousel-control-next {
  right: 0;
}
:where(#widgetEditorDialog) .carousel-control-prev-icon,
:where(#widgetEditorDialog) .carousel-control-next-icon {
  display: inline-block;
  width: 20px;
  height: 20px;
  background: 50%/100% 100% no-repeat;
}
:where(#widgetEditorDialog) .carousel-control-prev-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}
:where(#widgetEditorDialog) .carousel-control-next-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
}
:where(#widgetEditorDialog) .carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 15;
  display: flex;
  justify-content: center;
  padding-left: 0;
  margin-right: 15%;
  margin-left: 15%;
  list-style: none;
}
:where(#widgetEditorDialog) .carousel-indicators li {
  box-sizing: content-box;
  flex: 0 1 auto;
  width: 30px;
  height: 3px;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: #fff;
  background-clip: padding-box;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  opacity: 0.5;
  transition: opacity 0.6s ease;
}
@media (prefers-reduced-motion: reduce) {
  :where(#widgetEditorDialog) .carousel-indicators li {
    transition: none;
  }
}
:where(#widgetEditorDialog) .carousel-indicators .active {
  opacity: 1;
}
:where(#widgetEditorDialog) .carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 20px;
  left: 15%;
  z-index: 10;
  padding-top: 20px;
  padding-bottom: 20px;
  color: #fff;
  text-align: center;
}
@keyframes spinner-border {
  to {
    transform: rotate(360deg);
  }
}
:where(#widgetEditorDialog) .spinner-border {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  vertical-align: -0.125em;
  border: 0.25em solid currentcolor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: 0.75s linear infinite spinner-border;
}
:where(#widgetEditorDialog) .spinner-border-sm {
  width: 1rem;
  height: 1rem;
  border-width: 0.2em;
}
@keyframes spinner-grow {
  0% {
    transform: scale(0);
  }
  50% {
    opacity: 1;
    transform: none;
  }
}
:where(#widgetEditorDialog) .spinner-grow {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  vertical-align: -0.125em;
  background-color: currentcolor;
  border-radius: 50%;
  opacity: 0;
  animation: 0.75s linear infinite spinner-grow;
}
:where(#widgetEditorDialog) .spinner-grow-sm {
  width: 1rem;
  height: 1rem;
}
@media (prefers-reduced-motion: reduce) {
  :where(#widgetEditorDialog) .spinner-border,
  :where(#widgetEditorDialog) .spinner-grow {
    animation-duration: 1.5s;
  }
}
:where(#widgetEditorDialog) .align-baseline {
  vertical-align: baseline !important;
}
:where(#widgetEditorDialog) .align-top {
  vertical-align: top !important;
}
:where(#widgetEditorDialog) .align-middle {
  vertical-align: middle !important;
}
:where(#widgetEditorDialog) .align-bottom {
  vertical-align: bottom !important;
}
:where(#widgetEditorDialog) .align-text-bottom {
  vertical-align: text-bottom !important;
}
:where(#widgetEditorDialog) .align-text-top {
  vertical-align: text-top !important;
}
:where(#widgetEditorDialog) .bg-primary {
  background-color: #007bff !important;
}
:where(#widgetEditorDialog) a.bg-primary:hover, :where(#widgetEditorDialog) a.bg-primary:focus,
:where(#widgetEditorDialog) button.bg-primary:hover,
:where(#widgetEditorDialog) button.bg-primary:focus {
  background-color: rgb(0%, 38.5882352941%, 80%) !important;
}
:where(#widgetEditorDialog) .bg-secondary {
  background-color: #6c757d !important;
}
:where(#widgetEditorDialog) a.bg-secondary:hover, :where(#widgetEditorDialog) a.bg-secondary:focus,
:where(#widgetEditorDialog) button.bg-secondary:hover,
:where(#widgetEditorDialog) button.bg-secondary:focus {
  background-color: rgb(33.0825549104%, 35.8394344862%, 38.2899941092%) !important;
}
:where(#widgetEditorDialog) .bg-success {
  background-color: #28a745 !important;
}
:where(#widgetEditorDialog) a.bg-success:hover, :where(#widgetEditorDialog) a.bg-success:focus,
:where(#widgetEditorDialog) button.bg-success:hover,
:where(#widgetEditorDialog) button.bg-success:focus {
  background-color: rgb(11.8215402103%, 49.3549303779%, 20.3921568627%) !important;
}
:where(#widgetEditorDialog) .bg-info {
  background-color: #17a2b8 !important;
}
:where(#widgetEditorDialog) a.bg-info:hover, :where(#widgetEditorDialog) a.bg-info:focus,
:where(#widgetEditorDialog) button.bg-info:hover,
:where(#widgetEditorDialog) button.bg-info:focus {
  background-color: rgb(6.7973856209%, 47.8772378517%, 54.3790849673%) !important;
}
:where(#widgetEditorDialog) .bg-warning {
  background-color: #ffc107 !important;
}
:where(#widgetEditorDialog) a.bg-warning:hover, :where(#widgetEditorDialog) a.bg-warning:focus,
:where(#widgetEditorDialog) button.bg-warning:hover,
:where(#widgetEditorDialog) button.bg-warning:focus {
  background-color: rgb(82.7450980392%, 62.0588235294%, 0%) !important;
}
:where(#widgetEditorDialog) .bg-danger {
  background-color: #dc3545 !important;
}
:where(#widgetEditorDialog) a.bg-danger:hover, :where(#widgetEditorDialog) a.bg-danger:focus,
:where(#widgetEditorDialog) button.bg-danger:hover,
:where(#widgetEditorDialog) button.bg-danger:focus {
  background-color: rgb(74.2020352445%, 12.8567882849%, 18.7341772152%) !important;
}
:where(#widgetEditorDialog) .bg-light {
  background-color: #f8f9fa !important;
}
:where(#widgetEditorDialog) a.bg-light:hover, :where(#widgetEditorDialog) a.bg-light:focus,
:where(#widgetEditorDialog) button.bg-light:hover,
:where(#widgetEditorDialog) button.bg-light:focus {
  background-color: rgb(85.5882352941%, 87.6470588235%, 89.7058823529%) !important;
}
:where(#widgetEditorDialog) .bg-dark {
  background-color: #343a40 !important;
}
:where(#widgetEditorDialog) a.bg-dark:hover, :where(#widgetEditorDialog) a.bg-dark:focus,
:where(#widgetEditorDialog) button.bg-dark:hover,
:where(#widgetEditorDialog) button.bg-dark:focus {
  background-color: rgb(11.4266396214%, 12.7450980392%, 14.0635564571%) !important;
}
:where(#widgetEditorDialog) .bg-white {
  background-color: #fff !important;
}
:where(#widgetEditorDialog) .bg-transparent {
  background-color: transparent !important;
}
:where(#widgetEditorDialog) .border {
  border: 1px solid #dee2e6 !important;
}
:where(#widgetEditorDialog) .border-top {
  border-top: 1px solid #dee2e6 !important;
}
:where(#widgetEditorDialog) .border-right {
  border-right: 1px solid #dee2e6 !important;
}
:where(#widgetEditorDialog) .border-bottom {
  border-bottom: 1px solid #dee2e6 !important;
}
:where(#widgetEditorDialog) .border-left {
  border-left: 1px solid #dee2e6 !important;
}
:where(#widgetEditorDialog) .border-0 {
  border: 0 !important;
}
:where(#widgetEditorDialog) .border-top-0 {
  border-top: 0 !important;
}
:where(#widgetEditorDialog) .border-right-0 {
  border-right: 0 !important;
}
:where(#widgetEditorDialog) .border-bottom-0 {
  border-bottom: 0 !important;
}
:where(#widgetEditorDialog) .border-left-0 {
  border-left: 0 !important;
}
:where(#widgetEditorDialog) .border-primary {
  border-color: #007bff !important;
}
:where(#widgetEditorDialog) .border-secondary {
  border-color: #6c757d !important;
}
:where(#widgetEditorDialog) .border-success {
  border-color: #28a745 !important;
}
:where(#widgetEditorDialog) .border-info {
  border-color: #17a2b8 !important;
}
:where(#widgetEditorDialog) .border-warning {
  border-color: #ffc107 !important;
}
:where(#widgetEditorDialog) .border-danger {
  border-color: #dc3545 !important;
}
:where(#widgetEditorDialog) .border-light {
  border-color: #f8f9fa !important;
}
:where(#widgetEditorDialog) .border-dark {
  border-color: #343a40 !important;
}
:where(#widgetEditorDialog) .border-white {
  border-color: #fff !important;
}
:where(#widgetEditorDialog) .rounded-sm {
  border-radius: 0.2rem !important;
}
:where(#widgetEditorDialog) .rounded {
  border-radius: 0.25rem !important;
}
:where(#widgetEditorDialog) .rounded-top {
  border-top-left-radius: 0.25rem !important;
  border-top-right-radius: 0.25rem !important;
}
:where(#widgetEditorDialog) .rounded-right {
  border-top-right-radius: 0.25rem !important;
  border-bottom-right-radius: 0.25rem !important;
}
:where(#widgetEditorDialog) .rounded-bottom {
  border-bottom-right-radius: 0.25rem !important;
  border-bottom-left-radius: 0.25rem !important;
}
:where(#widgetEditorDialog) .rounded-left {
  border-top-left-radius: 0.25rem !important;
  border-bottom-left-radius: 0.25rem !important;
}
:where(#widgetEditorDialog) .rounded-lg {
  border-radius: 0.3rem !important;
}
:where(#widgetEditorDialog) .rounded-circle {
  border-radius: 50% !important;
}
:where(#widgetEditorDialog) .rounded-pill {
  border-radius: 50rem !important;
}
:where(#widgetEditorDialog) .rounded-0 {
  border-radius: 0 !important;
}
:where(#widgetEditorDialog) .clearfix::after {
  display: block;
  clear: both;
  content: "";
}
:where(#widgetEditorDialog) .d-none {
  display: none !important;
}
:where(#widgetEditorDialog) .d-inline {
  display: inline !important;
}
:where(#widgetEditorDialog) .d-inline-block {
  display: inline-block !important;
}
:where(#widgetEditorDialog) .d-block {
  display: block !important;
}
:where(#widgetEditorDialog) .d-table {
  display: table !important;
}
:where(#widgetEditorDialog) .d-table-row {
  display: table-row !important;
}
:where(#widgetEditorDialog) .d-table-cell {
  display: table-cell !important;
}
:where(#widgetEditorDialog) .d-flex {
  display: flex !important;
}
:where(#widgetEditorDialog) .d-inline-flex {
  display: inline-flex !important;
}
@media (min-width: 576px) {
  :where(#widgetEditorDialog) .d-sm-none {
    display: none !important;
  }
  :where(#widgetEditorDialog) .d-sm-inline {
    display: inline !important;
  }
  :where(#widgetEditorDialog) .d-sm-inline-block {
    display: inline-block !important;
  }
  :where(#widgetEditorDialog) .d-sm-block {
    display: block !important;
  }
  :where(#widgetEditorDialog) .d-sm-table {
    display: table !important;
  }
  :where(#widgetEditorDialog) .d-sm-table-row {
    display: table-row !important;
  }
  :where(#widgetEditorDialog) .d-sm-table-cell {
    display: table-cell !important;
  }
  :where(#widgetEditorDialog) .d-sm-flex {
    display: flex !important;
  }
  :where(#widgetEditorDialog) .d-sm-inline-flex {
    display: inline-flex !important;
  }
}
@media (min-width: 768px) {
  :where(#widgetEditorDialog) .d-md-none {
    display: none !important;
  }
  :where(#widgetEditorDialog) .d-md-inline {
    display: inline !important;
  }
  :where(#widgetEditorDialog) .d-md-inline-block {
    display: inline-block !important;
  }
  :where(#widgetEditorDialog) .d-md-block {
    display: block !important;
  }
  :where(#widgetEditorDialog) .d-md-table {
    display: table !important;
  }
  :where(#widgetEditorDialog) .d-md-table-row {
    display: table-row !important;
  }
  :where(#widgetEditorDialog) .d-md-table-cell {
    display: table-cell !important;
  }
  :where(#widgetEditorDialog) .d-md-flex {
    display: flex !important;
  }
  :where(#widgetEditorDialog) .d-md-inline-flex {
    display: inline-flex !important;
  }
}
@media (min-width: 992px) {
  :where(#widgetEditorDialog) .d-lg-none {
    display: none !important;
  }
  :where(#widgetEditorDialog) .d-lg-inline {
    display: inline !important;
  }
  :where(#widgetEditorDialog) .d-lg-inline-block {
    display: inline-block !important;
  }
  :where(#widgetEditorDialog) .d-lg-block {
    display: block !important;
  }
  :where(#widgetEditorDialog) .d-lg-table {
    display: table !important;
  }
  :where(#widgetEditorDialog) .d-lg-table-row {
    display: table-row !important;
  }
  :where(#widgetEditorDialog) .d-lg-table-cell {
    display: table-cell !important;
  }
  :where(#widgetEditorDialog) .d-lg-flex {
    display: flex !important;
  }
  :where(#widgetEditorDialog) .d-lg-inline-flex {
    display: inline-flex !important;
  }
}
@media (min-width: 1200px) {
  :where(#widgetEditorDialog) .d-xl-none {
    display: none !important;
  }
  :where(#widgetEditorDialog) .d-xl-inline {
    display: inline !important;
  }
  :where(#widgetEditorDialog) .d-xl-inline-block {
    display: inline-block !important;
  }
  :where(#widgetEditorDialog) .d-xl-block {
    display: block !important;
  }
  :where(#widgetEditorDialog) .d-xl-table {
    display: table !important;
  }
  :where(#widgetEditorDialog) .d-xl-table-row {
    display: table-row !important;
  }
  :where(#widgetEditorDialog) .d-xl-table-cell {
    display: table-cell !important;
  }
  :where(#widgetEditorDialog) .d-xl-flex {
    display: flex !important;
  }
  :where(#widgetEditorDialog) .d-xl-inline-flex {
    display: inline-flex !important;
  }
}
@media print {
  :where(#widgetEditorDialog) .d-print-none {
    display: none !important;
  }
  :where(#widgetEditorDialog) .d-print-inline {
    display: inline !important;
  }
  :where(#widgetEditorDialog) .d-print-inline-block {
    display: inline-block !important;
  }
  :where(#widgetEditorDialog) .d-print-block {
    display: block !important;
  }
  :where(#widgetEditorDialog) .d-print-table {
    display: table !important;
  }
  :where(#widgetEditorDialog) .d-print-table-row {
    display: table-row !important;
  }
  :where(#widgetEditorDialog) .d-print-table-cell {
    display: table-cell !important;
  }
  :where(#widgetEditorDialog) .d-print-flex {
    display: flex !important;
  }
  :where(#widgetEditorDialog) .d-print-inline-flex {
    display: inline-flex !important;
  }
}
:where(#widgetEditorDialog) .embed-responsive {
  position: relative;
  display: block;
  width: 100%;
  padding: 0;
  overflow: hidden;
}
:where(#widgetEditorDialog) .embed-responsive::before {
  display: block;
  content: "";
}
:where(#widgetEditorDialog) .embed-responsive .embed-responsive-item,
:where(#widgetEditorDialog) .embed-responsive iframe,
:where(#widgetEditorDialog) .embed-responsive embed,
:where(#widgetEditorDialog) .embed-responsive object,
:where(#widgetEditorDialog) .embed-responsive video {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}
:where(#widgetEditorDialog) .embed-responsive-21by9::before {
  padding-top: 42.85714286%;
}
:where(#widgetEditorDialog) .embed-responsive-16by9::before {
  padding-top: 56.25%;
}
:where(#widgetEditorDialog) .embed-responsive-4by3::before {
  padding-top: 75%;
}
:where(#widgetEditorDialog) .embed-responsive-1by1::before {
  padding-top: 100%;
}
:where(#widgetEditorDialog) .flex-row {
  flex-direction: row !important;
}
:where(#widgetEditorDialog) .flex-column {
  flex-direction: column !important;
}
:where(#widgetEditorDialog) .flex-row-reverse {
  flex-direction: row-reverse !important;
}
:where(#widgetEditorDialog) .flex-column-reverse {
  flex-direction: column-reverse !important;
}
:where(#widgetEditorDialog) .flex-wrap {
  flex-wrap: wrap !important;
}
:where(#widgetEditorDialog) .flex-nowrap {
  flex-wrap: nowrap !important;
}
:where(#widgetEditorDialog) .flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}
:where(#widgetEditorDialog) .flex-fill {
  flex: 1 1 auto !important;
}
:where(#widgetEditorDialog) .flex-grow-0 {
  flex-grow: 0 !important;
}
:where(#widgetEditorDialog) .flex-grow-1 {
  flex-grow: 1 !important;
}
:where(#widgetEditorDialog) .flex-shrink-0 {
  flex-shrink: 0 !important;
}
:where(#widgetEditorDialog) .flex-shrink-1 {
  flex-shrink: 1 !important;
}
:where(#widgetEditorDialog) .justify-content-start {
  justify-content: flex-start !important;
}
:where(#widgetEditorDialog) .justify-content-end {
  justify-content: flex-end !important;
}
:where(#widgetEditorDialog) .justify-content-center {
  justify-content: center !important;
}
:where(#widgetEditorDialog) .justify-content-between {
  justify-content: space-between !important;
}
:where(#widgetEditorDialog) .justify-content-around {
  justify-content: space-around !important;
}
:where(#widgetEditorDialog) .align-items-start {
  align-items: flex-start !important;
}
:where(#widgetEditorDialog) .align-items-end {
  align-items: flex-end !important;
}
:where(#widgetEditorDialog) .align-items-center {
  align-items: center !important;
}
:where(#widgetEditorDialog) .align-items-baseline {
  align-items: baseline !important;
}
:where(#widgetEditorDialog) .align-items-stretch {
  align-items: stretch !important;
}
:where(#widgetEditorDialog) .align-content-start {
  align-content: flex-start !important;
}
:where(#widgetEditorDialog) .align-content-end {
  align-content: flex-end !important;
}
:where(#widgetEditorDialog) .align-content-center {
  align-content: center !important;
}
:where(#widgetEditorDialog) .align-content-between {
  align-content: space-between !important;
}
:where(#widgetEditorDialog) .align-content-around {
  align-content: space-around !important;
}
:where(#widgetEditorDialog) .align-content-stretch {
  align-content: stretch !important;
}
:where(#widgetEditorDialog) .align-self-auto {
  align-self: auto !important;
}
:where(#widgetEditorDialog) .align-self-start {
  align-self: flex-start !important;
}
:where(#widgetEditorDialog) .align-self-end {
  align-self: flex-end !important;
}
:where(#widgetEditorDialog) .align-self-center {
  align-self: center !important;
}
:where(#widgetEditorDialog) .align-self-baseline {
  align-self: baseline !important;
}
:where(#widgetEditorDialog) .align-self-stretch {
  align-self: stretch !important;
}
@media (min-width: 576px) {
  :where(#widgetEditorDialog) .flex-sm-row {
    flex-direction: row !important;
  }
  :where(#widgetEditorDialog) .flex-sm-column {
    flex-direction: column !important;
  }
  :where(#widgetEditorDialog) .flex-sm-row-reverse {
    flex-direction: row-reverse !important;
  }
  :where(#widgetEditorDialog) .flex-sm-column-reverse {
    flex-direction: column-reverse !important;
  }
  :where(#widgetEditorDialog) .flex-sm-wrap {
    flex-wrap: wrap !important;
  }
  :where(#widgetEditorDialog) .flex-sm-nowrap {
    flex-wrap: nowrap !important;
  }
  :where(#widgetEditorDialog) .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  :where(#widgetEditorDialog) .flex-sm-fill {
    flex: 1 1 auto !important;
  }
  :where(#widgetEditorDialog) .flex-sm-grow-0 {
    flex-grow: 0 !important;
  }
  :where(#widgetEditorDialog) .flex-sm-grow-1 {
    flex-grow: 1 !important;
  }
  :where(#widgetEditorDialog) .flex-sm-shrink-0 {
    flex-shrink: 0 !important;
  }
  :where(#widgetEditorDialog) .flex-sm-shrink-1 {
    flex-shrink: 1 !important;
  }
  :where(#widgetEditorDialog) .justify-content-sm-start {
    justify-content: flex-start !important;
  }
  :where(#widgetEditorDialog) .justify-content-sm-end {
    justify-content: flex-end !important;
  }
  :where(#widgetEditorDialog) .justify-content-sm-center {
    justify-content: center !important;
  }
  :where(#widgetEditorDialog) .justify-content-sm-between {
    justify-content: space-between !important;
  }
  :where(#widgetEditorDialog) .justify-content-sm-around {
    justify-content: space-around !important;
  }
  :where(#widgetEditorDialog) .align-items-sm-start {
    align-items: flex-start !important;
  }
  :where(#widgetEditorDialog) .align-items-sm-end {
    align-items: flex-end !important;
  }
  :where(#widgetEditorDialog) .align-items-sm-center {
    align-items: center !important;
  }
  :where(#widgetEditorDialog) .align-items-sm-baseline {
    align-items: baseline !important;
  }
  :where(#widgetEditorDialog) .align-items-sm-stretch {
    align-items: stretch !important;
  }
  :where(#widgetEditorDialog) .align-content-sm-start {
    align-content: flex-start !important;
  }
  :where(#widgetEditorDialog) .align-content-sm-end {
    align-content: flex-end !important;
  }
  :where(#widgetEditorDialog) .align-content-sm-center {
    align-content: center !important;
  }
  :where(#widgetEditorDialog) .align-content-sm-between {
    align-content: space-between !important;
  }
  :where(#widgetEditorDialog) .align-content-sm-around {
    align-content: space-around !important;
  }
  :where(#widgetEditorDialog) .align-content-sm-stretch {
    align-content: stretch !important;
  }
  :where(#widgetEditorDialog) .align-self-sm-auto {
    align-self: auto !important;
  }
  :where(#widgetEditorDialog) .align-self-sm-start {
    align-self: flex-start !important;
  }
  :where(#widgetEditorDialog) .align-self-sm-end {
    align-self: flex-end !important;
  }
  :where(#widgetEditorDialog) .align-self-sm-center {
    align-self: center !important;
  }
  :where(#widgetEditorDialog) .align-self-sm-baseline {
    align-self: baseline !important;
  }
  :where(#widgetEditorDialog) .align-self-sm-stretch {
    align-self: stretch !important;
  }
}
@media (min-width: 768px) {
  :where(#widgetEditorDialog) .flex-md-row {
    flex-direction: row !important;
  }
  :where(#widgetEditorDialog) .flex-md-column {
    flex-direction: column !important;
  }
  :where(#widgetEditorDialog) .flex-md-row-reverse {
    flex-direction: row-reverse !important;
  }
  :where(#widgetEditorDialog) .flex-md-column-reverse {
    flex-direction: column-reverse !important;
  }
  :where(#widgetEditorDialog) .flex-md-wrap {
    flex-wrap: wrap !important;
  }
  :where(#widgetEditorDialog) .flex-md-nowrap {
    flex-wrap: nowrap !important;
  }
  :where(#widgetEditorDialog) .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  :where(#widgetEditorDialog) .flex-md-fill {
    flex: 1 1 auto !important;
  }
  :where(#widgetEditorDialog) .flex-md-grow-0 {
    flex-grow: 0 !important;
  }
  :where(#widgetEditorDialog) .flex-md-grow-1 {
    flex-grow: 1 !important;
  }
  :where(#widgetEditorDialog) .flex-md-shrink-0 {
    flex-shrink: 0 !important;
  }
  :where(#widgetEditorDialog) .flex-md-shrink-1 {
    flex-shrink: 1 !important;
  }
  :where(#widgetEditorDialog) .justify-content-md-start {
    justify-content: flex-start !important;
  }
  :where(#widgetEditorDialog) .justify-content-md-end {
    justify-content: flex-end !important;
  }
  :where(#widgetEditorDialog) .justify-content-md-center {
    justify-content: center !important;
  }
  :where(#widgetEditorDialog) .justify-content-md-between {
    justify-content: space-between !important;
  }
  :where(#widgetEditorDialog) .justify-content-md-around {
    justify-content: space-around !important;
  }
  :where(#widgetEditorDialog) .align-items-md-start {
    align-items: flex-start !important;
  }
  :where(#widgetEditorDialog) .align-items-md-end {
    align-items: flex-end !important;
  }
  :where(#widgetEditorDialog) .align-items-md-center {
    align-items: center !important;
  }
  :where(#widgetEditorDialog) .align-items-md-baseline {
    align-items: baseline !important;
  }
  :where(#widgetEditorDialog) .align-items-md-stretch {
    align-items: stretch !important;
  }
  :where(#widgetEditorDialog) .align-content-md-start {
    align-content: flex-start !important;
  }
  :where(#widgetEditorDialog) .align-content-md-end {
    align-content: flex-end !important;
  }
  :where(#widgetEditorDialog) .align-content-md-center {
    align-content: center !important;
  }
  :where(#widgetEditorDialog) .align-content-md-between {
    align-content: space-between !important;
  }
  :where(#widgetEditorDialog) .align-content-md-around {
    align-content: space-around !important;
  }
  :where(#widgetEditorDialog) .align-content-md-stretch {
    align-content: stretch !important;
  }
  :where(#widgetEditorDialog) .align-self-md-auto {
    align-self: auto !important;
  }
  :where(#widgetEditorDialog) .align-self-md-start {
    align-self: flex-start !important;
  }
  :where(#widgetEditorDialog) .align-self-md-end {
    align-self: flex-end !important;
  }
  :where(#widgetEditorDialog) .align-self-md-center {
    align-self: center !important;
  }
  :where(#widgetEditorDialog) .align-self-md-baseline {
    align-self: baseline !important;
  }
  :where(#widgetEditorDialog) .align-self-md-stretch {
    align-self: stretch !important;
  }
}
@media (min-width: 992px) {
  :where(#widgetEditorDialog) .flex-lg-row {
    flex-direction: row !important;
  }
  :where(#widgetEditorDialog) .flex-lg-column {
    flex-direction: column !important;
  }
  :where(#widgetEditorDialog) .flex-lg-row-reverse {
    flex-direction: row-reverse !important;
  }
  :where(#widgetEditorDialog) .flex-lg-column-reverse {
    flex-direction: column-reverse !important;
  }
  :where(#widgetEditorDialog) .flex-lg-wrap {
    flex-wrap: wrap !important;
  }
  :where(#widgetEditorDialog) .flex-lg-nowrap {
    flex-wrap: nowrap !important;
  }
  :where(#widgetEditorDialog) .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  :where(#widgetEditorDialog) .flex-lg-fill {
    flex: 1 1 auto !important;
  }
  :where(#widgetEditorDialog) .flex-lg-grow-0 {
    flex-grow: 0 !important;
  }
  :where(#widgetEditorDialog) .flex-lg-grow-1 {
    flex-grow: 1 !important;
  }
  :where(#widgetEditorDialog) .flex-lg-shrink-0 {
    flex-shrink: 0 !important;
  }
  :where(#widgetEditorDialog) .flex-lg-shrink-1 {
    flex-shrink: 1 !important;
  }
  :where(#widgetEditorDialog) .justify-content-lg-start {
    justify-content: flex-start !important;
  }
  :where(#widgetEditorDialog) .justify-content-lg-end {
    justify-content: flex-end !important;
  }
  :where(#widgetEditorDialog) .justify-content-lg-center {
    justify-content: center !important;
  }
  :where(#widgetEditorDialog) .justify-content-lg-between {
    justify-content: space-between !important;
  }
  :where(#widgetEditorDialog) .justify-content-lg-around {
    justify-content: space-around !important;
  }
  :where(#widgetEditorDialog) .align-items-lg-start {
    align-items: flex-start !important;
  }
  :where(#widgetEditorDialog) .align-items-lg-end {
    align-items: flex-end !important;
  }
  :where(#widgetEditorDialog) .align-items-lg-center {
    align-items: center !important;
  }
  :where(#widgetEditorDialog) .align-items-lg-baseline {
    align-items: baseline !important;
  }
  :where(#widgetEditorDialog) .align-items-lg-stretch {
    align-items: stretch !important;
  }
  :where(#widgetEditorDialog) .align-content-lg-start {
    align-content: flex-start !important;
  }
  :where(#widgetEditorDialog) .align-content-lg-end {
    align-content: flex-end !important;
  }
  :where(#widgetEditorDialog) .align-content-lg-center {
    align-content: center !important;
  }
  :where(#widgetEditorDialog) .align-content-lg-between {
    align-content: space-between !important;
  }
  :where(#widgetEditorDialog) .align-content-lg-around {
    align-content: space-around !important;
  }
  :where(#widgetEditorDialog) .align-content-lg-stretch {
    align-content: stretch !important;
  }
  :where(#widgetEditorDialog) .align-self-lg-auto {
    align-self: auto !important;
  }
  :where(#widgetEditorDialog) .align-self-lg-start {
    align-self: flex-start !important;
  }
  :where(#widgetEditorDialog) .align-self-lg-end {
    align-self: flex-end !important;
  }
  :where(#widgetEditorDialog) .align-self-lg-center {
    align-self: center !important;
  }
  :where(#widgetEditorDialog) .align-self-lg-baseline {
    align-self: baseline !important;
  }
  :where(#widgetEditorDialog) .align-self-lg-stretch {
    align-self: stretch !important;
  }
}
@media (min-width: 1200px) {
  :where(#widgetEditorDialog) .flex-xl-row {
    flex-direction: row !important;
  }
  :where(#widgetEditorDialog) .flex-xl-column {
    flex-direction: column !important;
  }
  :where(#widgetEditorDialog) .flex-xl-row-reverse {
    flex-direction: row-reverse !important;
  }
  :where(#widgetEditorDialog) .flex-xl-column-reverse {
    flex-direction: column-reverse !important;
  }
  :where(#widgetEditorDialog) .flex-xl-wrap {
    flex-wrap: wrap !important;
  }
  :where(#widgetEditorDialog) .flex-xl-nowrap {
    flex-wrap: nowrap !important;
  }
  :where(#widgetEditorDialog) .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  :where(#widgetEditorDialog) .flex-xl-fill {
    flex: 1 1 auto !important;
  }
  :where(#widgetEditorDialog) .flex-xl-grow-0 {
    flex-grow: 0 !important;
  }
  :where(#widgetEditorDialog) .flex-xl-grow-1 {
    flex-grow: 1 !important;
  }
  :where(#widgetEditorDialog) .flex-xl-shrink-0 {
    flex-shrink: 0 !important;
  }
  :where(#widgetEditorDialog) .flex-xl-shrink-1 {
    flex-shrink: 1 !important;
  }
  :where(#widgetEditorDialog) .justify-content-xl-start {
    justify-content: flex-start !important;
  }
  :where(#widgetEditorDialog) .justify-content-xl-end {
    justify-content: flex-end !important;
  }
  :where(#widgetEditorDialog) .justify-content-xl-center {
    justify-content: center !important;
  }
  :where(#widgetEditorDialog) .justify-content-xl-between {
    justify-content: space-between !important;
  }
  :where(#widgetEditorDialog) .justify-content-xl-around {
    justify-content: space-around !important;
  }
  :where(#widgetEditorDialog) .align-items-xl-start {
    align-items: flex-start !important;
  }
  :where(#widgetEditorDialog) .align-items-xl-end {
    align-items: flex-end !important;
  }
  :where(#widgetEditorDialog) .align-items-xl-center {
    align-items: center !important;
  }
  :where(#widgetEditorDialog) .align-items-xl-baseline {
    align-items: baseline !important;
  }
  :where(#widgetEditorDialog) .align-items-xl-stretch {
    align-items: stretch !important;
  }
  :where(#widgetEditorDialog) .align-content-xl-start {
    align-content: flex-start !important;
  }
  :where(#widgetEditorDialog) .align-content-xl-end {
    align-content: flex-end !important;
  }
  :where(#widgetEditorDialog) .align-content-xl-center {
    align-content: center !important;
  }
  :where(#widgetEditorDialog) .align-content-xl-between {
    align-content: space-between !important;
  }
  :where(#widgetEditorDialog) .align-content-xl-around {
    align-content: space-around !important;
  }
  :where(#widgetEditorDialog) .align-content-xl-stretch {
    align-content: stretch !important;
  }
  :where(#widgetEditorDialog) .align-self-xl-auto {
    align-self: auto !important;
  }
  :where(#widgetEditorDialog) .align-self-xl-start {
    align-self: flex-start !important;
  }
  :where(#widgetEditorDialog) .align-self-xl-end {
    align-self: flex-end !important;
  }
  :where(#widgetEditorDialog) .align-self-xl-center {
    align-self: center !important;
  }
  :where(#widgetEditorDialog) .align-self-xl-baseline {
    align-self: baseline !important;
  }
  :where(#widgetEditorDialog) .align-self-xl-stretch {
    align-self: stretch !important;
  }
}
:where(#widgetEditorDialog) .float-left {
  float: left !important;
}
:where(#widgetEditorDialog) .float-right {
  float: right !important;
}
:where(#widgetEditorDialog) .float-none {
  float: none !important;
}
@media (min-width: 576px) {
  :where(#widgetEditorDialog) .float-sm-left {
    float: left !important;
  }
  :where(#widgetEditorDialog) .float-sm-right {
    float: right !important;
  }
  :where(#widgetEditorDialog) .float-sm-none {
    float: none !important;
  }
}
@media (min-width: 768px) {
  :where(#widgetEditorDialog) .float-md-left {
    float: left !important;
  }
  :where(#widgetEditorDialog) .float-md-right {
    float: right !important;
  }
  :where(#widgetEditorDialog) .float-md-none {
    float: none !important;
  }
}
@media (min-width: 992px) {
  :where(#widgetEditorDialog) .float-lg-left {
    float: left !important;
  }
  :where(#widgetEditorDialog) .float-lg-right {
    float: right !important;
  }
  :where(#widgetEditorDialog) .float-lg-none {
    float: none !important;
  }
}
@media (min-width: 1200px) {
  :where(#widgetEditorDialog) .float-xl-left {
    float: left !important;
  }
  :where(#widgetEditorDialog) .float-xl-right {
    float: right !important;
  }
  :where(#widgetEditorDialog) .float-xl-none {
    float: none !important;
  }
}
:where(#widgetEditorDialog) .user-select-all {
  user-select: all !important;
}
:where(#widgetEditorDialog) .user-select-auto {
  user-select: auto !important;
}
:where(#widgetEditorDialog) .user-select-none {
  user-select: none !important;
}
:where(#widgetEditorDialog) .overflow-auto {
  overflow: auto !important;
}
:where(#widgetEditorDialog) .overflow-hidden {
  overflow: hidden !important;
}
:where(#widgetEditorDialog) .position-static {
  position: static !important;
}
:where(#widgetEditorDialog) .position-relative {
  position: relative !important;
}
:where(#widgetEditorDialog) .position-absolute {
  position: absolute !important;
}
:where(#widgetEditorDialog) .position-fixed {
  position: fixed !important;
}
:where(#widgetEditorDialog) .position-sticky {
  position: sticky !important;
}
:where(#widgetEditorDialog) .fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
}
:where(#widgetEditorDialog) .fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}
@supports (position: sticky) {
  :where(#widgetEditorDialog) .sticky-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
}
:where(#widgetEditorDialog) .sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
:where(#widgetEditorDialog) .sr-only-focusable:active, :where(#widgetEditorDialog) .sr-only-focusable:focus {
  position: static;
  width: auto;
  height: auto;
  overflow: visible;
  clip: auto;
  white-space: normal;
}
:where(#widgetEditorDialog) .shadow-sm {
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;
}
:where(#widgetEditorDialog) .shadow {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
}
:where(#widgetEditorDialog) .shadow-lg {
  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175) !important;
}
:where(#widgetEditorDialog) .shadow-none {
  box-shadow: none !important;
}
:where(#widgetEditorDialog) .w-25 {
  width: 25% !important;
}
:where(#widgetEditorDialog) .w-50 {
  width: 50% !important;
}
:where(#widgetEditorDialog) .w-75 {
  width: 75% !important;
}
:where(#widgetEditorDialog) .w-100 {
  width: 100% !important;
}
:where(#widgetEditorDialog) .w-auto {
  width: auto !important;
}
:where(#widgetEditorDialog) .h-25 {
  height: 25% !important;
}
:where(#widgetEditorDialog) .h-50 {
  height: 50% !important;
}
:where(#widgetEditorDialog) .h-75 {
  height: 75% !important;
}
:where(#widgetEditorDialog) .h-100 {
  height: 100% !important;
}
:where(#widgetEditorDialog) .h-auto {
  height: auto !important;
}
:where(#widgetEditorDialog) .mw-100 {
  max-width: 100% !important;
}
:where(#widgetEditorDialog) .mh-100 {
  max-height: 100% !important;
}
:where(#widgetEditorDialog) .min-vw-100 {
  min-width: 100vw !important;
}
:where(#widgetEditorDialog) .min-vh-100 {
  min-height: 100vh !important;
}
:where(#widgetEditorDialog) .vw-100 {
  width: 100vw !important;
}
:where(#widgetEditorDialog) .vh-100 {
  height: 100vh !important;
}
:where(#widgetEditorDialog) .m-0 {
  margin: 0 !important;
}
:where(#widgetEditorDialog) .mt-0,
:where(#widgetEditorDialog) .my-0 {
  margin-top: 0 !important;
}
:where(#widgetEditorDialog) .mr-0,
:where(#widgetEditorDialog) .mx-0 {
  margin-right: 0 !important;
}
:where(#widgetEditorDialog) .mb-0,
:where(#widgetEditorDialog) .my-0 {
  margin-bottom: 0 !important;
}
:where(#widgetEditorDialog) .ml-0,
:where(#widgetEditorDialog) .mx-0 {
  margin-left: 0 !important;
}
:where(#widgetEditorDialog) .m-1 {
  margin: 0.25rem !important;
}
:where(#widgetEditorDialog) .mt-1,
:where(#widgetEditorDialog) .my-1 {
  margin-top: 0.25rem !important;
}
:where(#widgetEditorDialog) .mr-1,
:where(#widgetEditorDialog) .mx-1 {
  margin-right: 0.25rem !important;
}
:where(#widgetEditorDialog) .mb-1,
:where(#widgetEditorDialog) .my-1 {
  margin-bottom: 0.25rem !important;
}
:where(#widgetEditorDialog) .ml-1,
:where(#widgetEditorDialog) .mx-1 {
  margin-left: 0.25rem !important;
}
:where(#widgetEditorDialog) .m-2 {
  margin: 0.5rem !important;
}
:where(#widgetEditorDialog) .mt-2,
:where(#widgetEditorDialog) .my-2 {
  margin-top: 0.5rem !important;
}
:where(#widgetEditorDialog) .mr-2,
:where(#widgetEditorDialog) .mx-2 {
  margin-right: 0.5rem !important;
}
:where(#widgetEditorDialog) .mb-2,
:where(#widgetEditorDialog) .my-2 {
  margin-bottom: 0.5rem !important;
}
:where(#widgetEditorDialog) .ml-2,
:where(#widgetEditorDialog) .mx-2 {
  margin-left: 0.5rem !important;
}
:where(#widgetEditorDialog) .m-3 {
  margin: 1rem !important;
}
:where(#widgetEditorDialog) .mt-3,
:where(#widgetEditorDialog) .my-3 {
  margin-top: 1rem !important;
}
:where(#widgetEditorDialog) .mr-3,
:where(#widgetEditorDialog) .mx-3 {
  margin-right: 1rem !important;
}
:where(#widgetEditorDialog) .mb-3,
:where(#widgetEditorDialog) .my-3 {
  margin-bottom: 1rem !important;
}
:where(#widgetEditorDialog) .ml-3,
:where(#widgetEditorDialog) .mx-3 {
  margin-left: 1rem !important;
}
:where(#widgetEditorDialog) .m-4 {
  margin: 1.5rem !important;
}
:where(#widgetEditorDialog) .mt-4,
:where(#widgetEditorDialog) .my-4 {
  margin-top: 1.5rem !important;
}
:where(#widgetEditorDialog) .mr-4,
:where(#widgetEditorDialog) .mx-4 {
  margin-right: 1.5rem !important;
}
:where(#widgetEditorDialog) .mb-4,
:where(#widgetEditorDialog) .my-4 {
  margin-bottom: 1.5rem !important;
}
:where(#widgetEditorDialog) .ml-4,
:where(#widgetEditorDialog) .mx-4 {
  margin-left: 1.5rem !important;
}
:where(#widgetEditorDialog) .m-5 {
  margin: 3rem !important;
}
:where(#widgetEditorDialog) .mt-5,
:where(#widgetEditorDialog) .my-5 {
  margin-top: 3rem !important;
}
:where(#widgetEditorDialog) .mr-5,
:where(#widgetEditorDialog) .mx-5 {
  margin-right: 3rem !important;
}
:where(#widgetEditorDialog) .mb-5,
:where(#widgetEditorDialog) .my-5 {
  margin-bottom: 3rem !important;
}
:where(#widgetEditorDialog) .ml-5,
:where(#widgetEditorDialog) .mx-5 {
  margin-left: 3rem !important;
}
:where(#widgetEditorDialog) .p-0 {
  padding: 0 !important;
}
:where(#widgetEditorDialog) .pt-0,
:where(#widgetEditorDialog) .py-0 {
  padding-top: 0 !important;
}
:where(#widgetEditorDialog) .pr-0,
:where(#widgetEditorDialog) .px-0 {
  padding-right: 0 !important;
}
:where(#widgetEditorDialog) .pb-0,
:where(#widgetEditorDialog) .py-0 {
  padding-bottom: 0 !important;
}
:where(#widgetEditorDialog) .pl-0,
:where(#widgetEditorDialog) .px-0 {
  padding-left: 0 !important;
}
:where(#widgetEditorDialog) .p-1 {
  padding: 0.25rem !important;
}
:where(#widgetEditorDialog) .pt-1,
:where(#widgetEditorDialog) .py-1 {
  padding-top: 0.25rem !important;
}
:where(#widgetEditorDialog) .pr-1,
:where(#widgetEditorDialog) .px-1 {
  padding-right: 0.25rem !important;
}
:where(#widgetEditorDialog) .pb-1,
:where(#widgetEditorDialog) .py-1 {
  padding-bottom: 0.25rem !important;
}
:where(#widgetEditorDialog) .pl-1,
:where(#widgetEditorDialog) .px-1 {
  padding-left: 0.25rem !important;
}
:where(#widgetEditorDialog) .p-2 {
  padding: 0.5rem !important;
}
:where(#widgetEditorDialog) .pt-2,
:where(#widgetEditorDialog) .py-2 {
  padding-top: 0.5rem !important;
}
:where(#widgetEditorDialog) .pr-2,
:where(#widgetEditorDialog) .px-2 {
  padding-right: 0.5rem !important;
}
:where(#widgetEditorDialog) .pb-2,
:where(#widgetEditorDialog) .py-2 {
  padding-bottom: 0.5rem !important;
}
:where(#widgetEditorDialog) .pl-2,
:where(#widgetEditorDialog) .px-2 {
  padding-left: 0.5rem !important;
}
:where(#widgetEditorDialog) .p-3 {
  padding: 1rem !important;
}
:where(#widgetEditorDialog) .pt-3,
:where(#widgetEditorDialog) .py-3 {
  padding-top: 1rem !important;
}
:where(#widgetEditorDialog) .pr-3,
:where(#widgetEditorDialog) .px-3 {
  padding-right: 1rem !important;
}
:where(#widgetEditorDialog) .pb-3,
:where(#widgetEditorDialog) .py-3 {
  padding-bottom: 1rem !important;
}
:where(#widgetEditorDialog) .pl-3,
:where(#widgetEditorDialog) .px-3 {
  padding-left: 1rem !important;
}
:where(#widgetEditorDialog) .p-4 {
  padding: 1.5rem !important;
}
:where(#widgetEditorDialog) .pt-4,
:where(#widgetEditorDialog) .py-4 {
  padding-top: 1.5rem !important;
}
:where(#widgetEditorDialog) .pr-4,
:where(#widgetEditorDialog) .px-4 {
  padding-right: 1.5rem !important;
}
:where(#widgetEditorDialog) .pb-4,
:where(#widgetEditorDialog) .py-4 {
  padding-bottom: 1.5rem !important;
}
:where(#widgetEditorDialog) .pl-4,
:where(#widgetEditorDialog) .px-4 {
  padding-left: 1.5rem !important;
}
:where(#widgetEditorDialog) .p-5 {
  padding: 3rem !important;
}
:where(#widgetEditorDialog) .pt-5,
:where(#widgetEditorDialog) .py-5 {
  padding-top: 3rem !important;
}
:where(#widgetEditorDialog) .pr-5,
:where(#widgetEditorDialog) .px-5 {
  padding-right: 3rem !important;
}
:where(#widgetEditorDialog) .pb-5,
:where(#widgetEditorDialog) .py-5 {
  padding-bottom: 3rem !important;
}
:where(#widgetEditorDialog) .pl-5,
:where(#widgetEditorDialog) .px-5 {
  padding-left: 3rem !important;
}
:where(#widgetEditorDialog) .m-n1 {
  margin: -0.25rem !important;
}
:where(#widgetEditorDialog) .mt-n1,
:where(#widgetEditorDialog) .my-n1 {
  margin-top: -0.25rem !important;
}
:where(#widgetEditorDialog) .mr-n1,
:where(#widgetEditorDialog) .mx-n1 {
  margin-right: -0.25rem !important;
}
:where(#widgetEditorDialog) .mb-n1,
:where(#widgetEditorDialog) .my-n1 {
  margin-bottom: -0.25rem !important;
}
:where(#widgetEditorDialog) .ml-n1,
:where(#widgetEditorDialog) .mx-n1 {
  margin-left: -0.25rem !important;
}
:where(#widgetEditorDialog) .m-n2 {
  margin: -0.5rem !important;
}
:where(#widgetEditorDialog) .mt-n2,
:where(#widgetEditorDialog) .my-n2 {
  margin-top: -0.5rem !important;
}
:where(#widgetEditorDialog) .mr-n2,
:where(#widgetEditorDialog) .mx-n2 {
  margin-right: -0.5rem !important;
}
:where(#widgetEditorDialog) .mb-n2,
:where(#widgetEditorDialog) .my-n2 {
  margin-bottom: -0.5rem !important;
}
:where(#widgetEditorDialog) .ml-n2,
:where(#widgetEditorDialog) .mx-n2 {
  margin-left: -0.5rem !important;
}
:where(#widgetEditorDialog) .m-n3 {
  margin: -1rem !important;
}
:where(#widgetEditorDialog) .mt-n3,
:where(#widgetEditorDialog) .my-n3 {
  margin-top: -1rem !important;
}
:where(#widgetEditorDialog) .mr-n3,
:where(#widgetEditorDialog) .mx-n3 {
  margin-right: -1rem !important;
}
:where(#widgetEditorDialog) .mb-n3,
:where(#widgetEditorDialog) .my-n3 {
  margin-bottom: -1rem !important;
}
:where(#widgetEditorDialog) .ml-n3,
:where(#widgetEditorDialog) .mx-n3 {
  margin-left: -1rem !important;
}
:where(#widgetEditorDialog) .m-n4 {
  margin: -1.5rem !important;
}
:where(#widgetEditorDialog) .mt-n4,
:where(#widgetEditorDialog) .my-n4 {
  margin-top: -1.5rem !important;
}
:where(#widgetEditorDialog) .mr-n4,
:where(#widgetEditorDialog) .mx-n4 {
  margin-right: -1.5rem !important;
}
:where(#widgetEditorDialog) .mb-n4,
:where(#widgetEditorDialog) .my-n4 {
  margin-bottom: -1.5rem !important;
}
:where(#widgetEditorDialog) .ml-n4,
:where(#widgetEditorDialog) .mx-n4 {
  margin-left: -1.5rem !important;
}
:where(#widgetEditorDialog) .m-n5 {
  margin: -3rem !important;
}
:where(#widgetEditorDialog) .mt-n5,
:where(#widgetEditorDialog) .my-n5 {
  margin-top: -3rem !important;
}
:where(#widgetEditorDialog) .mr-n5,
:where(#widgetEditorDialog) .mx-n5 {
  margin-right: -3rem !important;
}
:where(#widgetEditorDialog) .mb-n5,
:where(#widgetEditorDialog) .my-n5 {
  margin-bottom: -3rem !important;
}
:where(#widgetEditorDialog) .ml-n5,
:where(#widgetEditorDialog) .mx-n5 {
  margin-left: -3rem !important;
}
:where(#widgetEditorDialog) .m-auto {
  margin: auto !important;
}
:where(#widgetEditorDialog) .mt-auto,
:where(#widgetEditorDialog) .my-auto {
  margin-top: auto !important;
}
:where(#widgetEditorDialog) .mr-auto,
:where(#widgetEditorDialog) .mx-auto {
  margin-right: auto !important;
}
:where(#widgetEditorDialog) .mb-auto,
:where(#widgetEditorDialog) .my-auto {
  margin-bottom: auto !important;
}
:where(#widgetEditorDialog) .ml-auto,
:where(#widgetEditorDialog) .mx-auto {
  margin-left: auto !important;
}
@media (min-width: 576px) {
  :where(#widgetEditorDialog) .m-sm-0 {
    margin: 0 !important;
  }
  :where(#widgetEditorDialog) .mt-sm-0,
  :where(#widgetEditorDialog) .my-sm-0 {
    margin-top: 0 !important;
  }
  :where(#widgetEditorDialog) .mr-sm-0,
  :where(#widgetEditorDialog) .mx-sm-0 {
    margin-right: 0 !important;
  }
  :where(#widgetEditorDialog) .mb-sm-0,
  :where(#widgetEditorDialog) .my-sm-0 {
    margin-bottom: 0 !important;
  }
  :where(#widgetEditorDialog) .ml-sm-0,
  :where(#widgetEditorDialog) .mx-sm-0 {
    margin-left: 0 !important;
  }
  :where(#widgetEditorDialog) .m-sm-1 {
    margin: 0.25rem !important;
  }
  :where(#widgetEditorDialog) .mt-sm-1,
  :where(#widgetEditorDialog) .my-sm-1 {
    margin-top: 0.25rem !important;
  }
  :where(#widgetEditorDialog) .mr-sm-1,
  :where(#widgetEditorDialog) .mx-sm-1 {
    margin-right: 0.25rem !important;
  }
  :where(#widgetEditorDialog) .mb-sm-1,
  :where(#widgetEditorDialog) .my-sm-1 {
    margin-bottom: 0.25rem !important;
  }
  :where(#widgetEditorDialog) .ml-sm-1,
  :where(#widgetEditorDialog) .mx-sm-1 {
    margin-left: 0.25rem !important;
  }
  :where(#widgetEditorDialog) .m-sm-2 {
    margin: 0.5rem !important;
  }
  :where(#widgetEditorDialog) .mt-sm-2,
  :where(#widgetEditorDialog) .my-sm-2 {
    margin-top: 0.5rem !important;
  }
  :where(#widgetEditorDialog) .mr-sm-2,
  :where(#widgetEditorDialog) .mx-sm-2 {
    margin-right: 0.5rem !important;
  }
  :where(#widgetEditorDialog) .mb-sm-2,
  :where(#widgetEditorDialog) .my-sm-2 {
    margin-bottom: 0.5rem !important;
  }
  :where(#widgetEditorDialog) .ml-sm-2,
  :where(#widgetEditorDialog) .mx-sm-2 {
    margin-left: 0.5rem !important;
  }
  :where(#widgetEditorDialog) .m-sm-3 {
    margin: 1rem !important;
  }
  :where(#widgetEditorDialog) .mt-sm-3,
  :where(#widgetEditorDialog) .my-sm-3 {
    margin-top: 1rem !important;
  }
  :where(#widgetEditorDialog) .mr-sm-3,
  :where(#widgetEditorDialog) .mx-sm-3 {
    margin-right: 1rem !important;
  }
  :where(#widgetEditorDialog) .mb-sm-3,
  :where(#widgetEditorDialog) .my-sm-3 {
    margin-bottom: 1rem !important;
  }
  :where(#widgetEditorDialog) .ml-sm-3,
  :where(#widgetEditorDialog) .mx-sm-3 {
    margin-left: 1rem !important;
  }
  :where(#widgetEditorDialog) .m-sm-4 {
    margin: 1.5rem !important;
  }
  :where(#widgetEditorDialog) .mt-sm-4,
  :where(#widgetEditorDialog) .my-sm-4 {
    margin-top: 1.5rem !important;
  }
  :where(#widgetEditorDialog) .mr-sm-4,
  :where(#widgetEditorDialog) .mx-sm-4 {
    margin-right: 1.5rem !important;
  }
  :where(#widgetEditorDialog) .mb-sm-4,
  :where(#widgetEditorDialog) .my-sm-4 {
    margin-bottom: 1.5rem !important;
  }
  :where(#widgetEditorDialog) .ml-sm-4,
  :where(#widgetEditorDialog) .mx-sm-4 {
    margin-left: 1.5rem !important;
  }
  :where(#widgetEditorDialog) .m-sm-5 {
    margin: 3rem !important;
  }
  :where(#widgetEditorDialog) .mt-sm-5,
  :where(#widgetEditorDialog) .my-sm-5 {
    margin-top: 3rem !important;
  }
  :where(#widgetEditorDialog) .mr-sm-5,
  :where(#widgetEditorDialog) .mx-sm-5 {
    margin-right: 3rem !important;
  }
  :where(#widgetEditorDialog) .mb-sm-5,
  :where(#widgetEditorDialog) .my-sm-5 {
    margin-bottom: 3rem !important;
  }
  :where(#widgetEditorDialog) .ml-sm-5,
  :where(#widgetEditorDialog) .mx-sm-5 {
    margin-left: 3rem !important;
  }
  :where(#widgetEditorDialog) .p-sm-0 {
    padding: 0 !important;
  }
  :where(#widgetEditorDialog) .pt-sm-0,
  :where(#widgetEditorDialog) .py-sm-0 {
    padding-top: 0 !important;
  }
  :where(#widgetEditorDialog) .pr-sm-0,
  :where(#widgetEditorDialog) .px-sm-0 {
    padding-right: 0 !important;
  }
  :where(#widgetEditorDialog) .pb-sm-0,
  :where(#widgetEditorDialog) .py-sm-0 {
    padding-bottom: 0 !important;
  }
  :where(#widgetEditorDialog) .pl-sm-0,
  :where(#widgetEditorDialog) .px-sm-0 {
    padding-left: 0 !important;
  }
  :where(#widgetEditorDialog) .p-sm-1 {
    padding: 0.25rem !important;
  }
  :where(#widgetEditorDialog) .pt-sm-1,
  :where(#widgetEditorDialog) .py-sm-1 {
    padding-top: 0.25rem !important;
  }
  :where(#widgetEditorDialog) .pr-sm-1,
  :where(#widgetEditorDialog) .px-sm-1 {
    padding-right: 0.25rem !important;
  }
  :where(#widgetEditorDialog) .pb-sm-1,
  :where(#widgetEditorDialog) .py-sm-1 {
    padding-bottom: 0.25rem !important;
  }
  :where(#widgetEditorDialog) .pl-sm-1,
  :where(#widgetEditorDialog) .px-sm-1 {
    padding-left: 0.25rem !important;
  }
  :where(#widgetEditorDialog) .p-sm-2 {
    padding: 0.5rem !important;
  }
  :where(#widgetEditorDialog) .pt-sm-2,
  :where(#widgetEditorDialog) .py-sm-2 {
    padding-top: 0.5rem !important;
  }
  :where(#widgetEditorDialog) .pr-sm-2,
  :where(#widgetEditorDialog) .px-sm-2 {
    padding-right: 0.5rem !important;
  }
  :where(#widgetEditorDialog) .pb-sm-2,
  :where(#widgetEditorDialog) .py-sm-2 {
    padding-bottom: 0.5rem !important;
  }
  :where(#widgetEditorDialog) .pl-sm-2,
  :where(#widgetEditorDialog) .px-sm-2 {
    padding-left: 0.5rem !important;
  }
  :where(#widgetEditorDialog) .p-sm-3 {
    padding: 1rem !important;
  }
  :where(#widgetEditorDialog) .pt-sm-3,
  :where(#widgetEditorDialog) .py-sm-3 {
    padding-top: 1rem !important;
  }
  :where(#widgetEditorDialog) .pr-sm-3,
  :where(#widgetEditorDialog) .px-sm-3 {
    padding-right: 1rem !important;
  }
  :where(#widgetEditorDialog) .pb-sm-3,
  :where(#widgetEditorDialog) .py-sm-3 {
    padding-bottom: 1rem !important;
  }
  :where(#widgetEditorDialog) .pl-sm-3,
  :where(#widgetEditorDialog) .px-sm-3 {
    padding-left: 1rem !important;
  }
  :where(#widgetEditorDialog) .p-sm-4 {
    padding: 1.5rem !important;
  }
  :where(#widgetEditorDialog) .pt-sm-4,
  :where(#widgetEditorDialog) .py-sm-4 {
    padding-top: 1.5rem !important;
  }
  :where(#widgetEditorDialog) .pr-sm-4,
  :where(#widgetEditorDialog) .px-sm-4 {
    padding-right: 1.5rem !important;
  }
  :where(#widgetEditorDialog) .pb-sm-4,
  :where(#widgetEditorDialog) .py-sm-4 {
    padding-bottom: 1.5rem !important;
  }
  :where(#widgetEditorDialog) .pl-sm-4,
  :where(#widgetEditorDialog) .px-sm-4 {
    padding-left: 1.5rem !important;
  }
  :where(#widgetEditorDialog) .p-sm-5 {
    padding: 3rem !important;
  }
  :where(#widgetEditorDialog) .pt-sm-5,
  :where(#widgetEditorDialog) .py-sm-5 {
    padding-top: 3rem !important;
  }
  :where(#widgetEditorDialog) .pr-sm-5,
  :where(#widgetEditorDialog) .px-sm-5 {
    padding-right: 3rem !important;
  }
  :where(#widgetEditorDialog) .pb-sm-5,
  :where(#widgetEditorDialog) .py-sm-5 {
    padding-bottom: 3rem !important;
  }
  :where(#widgetEditorDialog) .pl-sm-5,
  :where(#widgetEditorDialog) .px-sm-5 {
    padding-left: 3rem !important;
  }
  :where(#widgetEditorDialog) .m-sm-n1 {
    margin: -0.25rem !important;
  }
  :where(#widgetEditorDialog) .mt-sm-n1,
  :where(#widgetEditorDialog) .my-sm-n1 {
    margin-top: -0.25rem !important;
  }
  :where(#widgetEditorDialog) .mr-sm-n1,
  :where(#widgetEditorDialog) .mx-sm-n1 {
    margin-right: -0.25rem !important;
  }
  :where(#widgetEditorDialog) .mb-sm-n1,
  :where(#widgetEditorDialog) .my-sm-n1 {
    margin-bottom: -0.25rem !important;
  }
  :where(#widgetEditorDialog) .ml-sm-n1,
  :where(#widgetEditorDialog) .mx-sm-n1 {
    margin-left: -0.25rem !important;
  }
  :where(#widgetEditorDialog) .m-sm-n2 {
    margin: -0.5rem !important;
  }
  :where(#widgetEditorDialog) .mt-sm-n2,
  :where(#widgetEditorDialog) .my-sm-n2 {
    margin-top: -0.5rem !important;
  }
  :where(#widgetEditorDialog) .mr-sm-n2,
  :where(#widgetEditorDialog) .mx-sm-n2 {
    margin-right: -0.5rem !important;
  }
  :where(#widgetEditorDialog) .mb-sm-n2,
  :where(#widgetEditorDialog) .my-sm-n2 {
    margin-bottom: -0.5rem !important;
  }
  :where(#widgetEditorDialog) .ml-sm-n2,
  :where(#widgetEditorDialog) .mx-sm-n2 {
    margin-left: -0.5rem !important;
  }
  :where(#widgetEditorDialog) .m-sm-n3 {
    margin: -1rem !important;
  }
  :where(#widgetEditorDialog) .mt-sm-n3,
  :where(#widgetEditorDialog) .my-sm-n3 {
    margin-top: -1rem !important;
  }
  :where(#widgetEditorDialog) .mr-sm-n3,
  :where(#widgetEditorDialog) .mx-sm-n3 {
    margin-right: -1rem !important;
  }
  :where(#widgetEditorDialog) .mb-sm-n3,
  :where(#widgetEditorDialog) .my-sm-n3 {
    margin-bottom: -1rem !important;
  }
  :where(#widgetEditorDialog) .ml-sm-n3,
  :where(#widgetEditorDialog) .mx-sm-n3 {
    margin-left: -1rem !important;
  }
  :where(#widgetEditorDialog) .m-sm-n4 {
    margin: -1.5rem !important;
  }
  :where(#widgetEditorDialog) .mt-sm-n4,
  :where(#widgetEditorDialog) .my-sm-n4 {
    margin-top: -1.5rem !important;
  }
  :where(#widgetEditorDialog) .mr-sm-n4,
  :where(#widgetEditorDialog) .mx-sm-n4 {
    margin-right: -1.5rem !important;
  }
  :where(#widgetEditorDialog) .mb-sm-n4,
  :where(#widgetEditorDialog) .my-sm-n4 {
    margin-bottom: -1.5rem !important;
  }
  :where(#widgetEditorDialog) .ml-sm-n4,
  :where(#widgetEditorDialog) .mx-sm-n4 {
    margin-left: -1.5rem !important;
  }
  :where(#widgetEditorDialog) .m-sm-n5 {
    margin: -3rem !important;
  }
  :where(#widgetEditorDialog) .mt-sm-n5,
  :where(#widgetEditorDialog) .my-sm-n5 {
    margin-top: -3rem !important;
  }
  :where(#widgetEditorDialog) .mr-sm-n5,
  :where(#widgetEditorDialog) .mx-sm-n5 {
    margin-right: -3rem !important;
  }
  :where(#widgetEditorDialog) .mb-sm-n5,
  :where(#widgetEditorDialog) .my-sm-n5 {
    margin-bottom: -3rem !important;
  }
  :where(#widgetEditorDialog) .ml-sm-n5,
  :where(#widgetEditorDialog) .mx-sm-n5 {
    margin-left: -3rem !important;
  }
  :where(#widgetEditorDialog) .m-sm-auto {
    margin: auto !important;
  }
  :where(#widgetEditorDialog) .mt-sm-auto,
  :where(#widgetEditorDialog) .my-sm-auto {
    margin-top: auto !important;
  }
  :where(#widgetEditorDialog) .mr-sm-auto,
  :where(#widgetEditorDialog) .mx-sm-auto {
    margin-right: auto !important;
  }
  :where(#widgetEditorDialog) .mb-sm-auto,
  :where(#widgetEditorDialog) .my-sm-auto {
    margin-bottom: auto !important;
  }
  :where(#widgetEditorDialog) .ml-sm-auto,
  :where(#widgetEditorDialog) .mx-sm-auto {
    margin-left: auto !important;
  }
}
@media (min-width: 768px) {
  :where(#widgetEditorDialog) .m-md-0 {
    margin: 0 !important;
  }
  :where(#widgetEditorDialog) .mt-md-0,
  :where(#widgetEditorDialog) .my-md-0 {
    margin-top: 0 !important;
  }
  :where(#widgetEditorDialog) .mr-md-0,
  :where(#widgetEditorDialog) .mx-md-0 {
    margin-right: 0 !important;
  }
  :where(#widgetEditorDialog) .mb-md-0,
  :where(#widgetEditorDialog) .my-md-0 {
    margin-bottom: 0 !important;
  }
  :where(#widgetEditorDialog) .ml-md-0,
  :where(#widgetEditorDialog) .mx-md-0 {
    margin-left: 0 !important;
  }
  :where(#widgetEditorDialog) .m-md-1 {
    margin: 0.25rem !important;
  }
  :where(#widgetEditorDialog) .mt-md-1,
  :where(#widgetEditorDialog) .my-md-1 {
    margin-top: 0.25rem !important;
  }
  :where(#widgetEditorDialog) .mr-md-1,
  :where(#widgetEditorDialog) .mx-md-1 {
    margin-right: 0.25rem !important;
  }
  :where(#widgetEditorDialog) .mb-md-1,
  :where(#widgetEditorDialog) .my-md-1 {
    margin-bottom: 0.25rem !important;
  }
  :where(#widgetEditorDialog) .ml-md-1,
  :where(#widgetEditorDialog) .mx-md-1 {
    margin-left: 0.25rem !important;
  }
  :where(#widgetEditorDialog) .m-md-2 {
    margin: 0.5rem !important;
  }
  :where(#widgetEditorDialog) .mt-md-2,
  :where(#widgetEditorDialog) .my-md-2 {
    margin-top: 0.5rem !important;
  }
  :where(#widgetEditorDialog) .mr-md-2,
  :where(#widgetEditorDialog) .mx-md-2 {
    margin-right: 0.5rem !important;
  }
  :where(#widgetEditorDialog) .mb-md-2,
  :where(#widgetEditorDialog) .my-md-2 {
    margin-bottom: 0.5rem !important;
  }
  :where(#widgetEditorDialog) .ml-md-2,
  :where(#widgetEditorDialog) .mx-md-2 {
    margin-left: 0.5rem !important;
  }
  :where(#widgetEditorDialog) .m-md-3 {
    margin: 1rem !important;
  }
  :where(#widgetEditorDialog) .mt-md-3,
  :where(#widgetEditorDialog) .my-md-3 {
    margin-top: 1rem !important;
  }
  :where(#widgetEditorDialog) .mr-md-3,
  :where(#widgetEditorDialog) .mx-md-3 {
    margin-right: 1rem !important;
  }
  :where(#widgetEditorDialog) .mb-md-3,
  :where(#widgetEditorDialog) .my-md-3 {
    margin-bottom: 1rem !important;
  }
  :where(#widgetEditorDialog) .ml-md-3,
  :where(#widgetEditorDialog) .mx-md-3 {
    margin-left: 1rem !important;
  }
  :where(#widgetEditorDialog) .m-md-4 {
    margin: 1.5rem !important;
  }
  :where(#widgetEditorDialog) .mt-md-4,
  :where(#widgetEditorDialog) .my-md-4 {
    margin-top: 1.5rem !important;
  }
  :where(#widgetEditorDialog) .mr-md-4,
  :where(#widgetEditorDialog) .mx-md-4 {
    margin-right: 1.5rem !important;
  }
  :where(#widgetEditorDialog) .mb-md-4,
  :where(#widgetEditorDialog) .my-md-4 {
    margin-bottom: 1.5rem !important;
  }
  :where(#widgetEditorDialog) .ml-md-4,
  :where(#widgetEditorDialog) .mx-md-4 {
    margin-left: 1.5rem !important;
  }
  :where(#widgetEditorDialog) .m-md-5 {
    margin: 3rem !important;
  }
  :where(#widgetEditorDialog) .mt-md-5,
  :where(#widgetEditorDialog) .my-md-5 {
    margin-top: 3rem !important;
  }
  :where(#widgetEditorDialog) .mr-md-5,
  :where(#widgetEditorDialog) .mx-md-5 {
    margin-right: 3rem !important;
  }
  :where(#widgetEditorDialog) .mb-md-5,
  :where(#widgetEditorDialog) .my-md-5 {
    margin-bottom: 3rem !important;
  }
  :where(#widgetEditorDialog) .ml-md-5,
  :where(#widgetEditorDialog) .mx-md-5 {
    margin-left: 3rem !important;
  }
  :where(#widgetEditorDialog) .p-md-0 {
    padding: 0 !important;
  }
  :where(#widgetEditorDialog) .pt-md-0,
  :where(#widgetEditorDialog) .py-md-0 {
    padding-top: 0 !important;
  }
  :where(#widgetEditorDialog) .pr-md-0,
  :where(#widgetEditorDialog) .px-md-0 {
    padding-right: 0 !important;
  }
  :where(#widgetEditorDialog) .pb-md-0,
  :where(#widgetEditorDialog) .py-md-0 {
    padding-bottom: 0 !important;
  }
  :where(#widgetEditorDialog) .pl-md-0,
  :where(#widgetEditorDialog) .px-md-0 {
    padding-left: 0 !important;
  }
  :where(#widgetEditorDialog) .p-md-1 {
    padding: 0.25rem !important;
  }
  :where(#widgetEditorDialog) .pt-md-1,
  :where(#widgetEditorDialog) .py-md-1 {
    padding-top: 0.25rem !important;
  }
  :where(#widgetEditorDialog) .pr-md-1,
  :where(#widgetEditorDialog) .px-md-1 {
    padding-right: 0.25rem !important;
  }
  :where(#widgetEditorDialog) .pb-md-1,
  :where(#widgetEditorDialog) .py-md-1 {
    padding-bottom: 0.25rem !important;
  }
  :where(#widgetEditorDialog) .pl-md-1,
  :where(#widgetEditorDialog) .px-md-1 {
    padding-left: 0.25rem !important;
  }
  :where(#widgetEditorDialog) .p-md-2 {
    padding: 0.5rem !important;
  }
  :where(#widgetEditorDialog) .pt-md-2,
  :where(#widgetEditorDialog) .py-md-2 {
    padding-top: 0.5rem !important;
  }
  :where(#widgetEditorDialog) .pr-md-2,
  :where(#widgetEditorDialog) .px-md-2 {
    padding-right: 0.5rem !important;
  }
  :where(#widgetEditorDialog) .pb-md-2,
  :where(#widgetEditorDialog) .py-md-2 {
    padding-bottom: 0.5rem !important;
  }
  :where(#widgetEditorDialog) .pl-md-2,
  :where(#widgetEditorDialog) .px-md-2 {
    padding-left: 0.5rem !important;
  }
  :where(#widgetEditorDialog) .p-md-3 {
    padding: 1rem !important;
  }
  :where(#widgetEditorDialog) .pt-md-3,
  :where(#widgetEditorDialog) .py-md-3 {
    padding-top: 1rem !important;
  }
  :where(#widgetEditorDialog) .pr-md-3,
  :where(#widgetEditorDialog) .px-md-3 {
    padding-right: 1rem !important;
  }
  :where(#widgetEditorDialog) .pb-md-3,
  :where(#widgetEditorDialog) .py-md-3 {
    padding-bottom: 1rem !important;
  }
  :where(#widgetEditorDialog) .pl-md-3,
  :where(#widgetEditorDialog) .px-md-3 {
    padding-left: 1rem !important;
  }
  :where(#widgetEditorDialog) .p-md-4 {
    padding: 1.5rem !important;
  }
  :where(#widgetEditorDialog) .pt-md-4,
  :where(#widgetEditorDialog) .py-md-4 {
    padding-top: 1.5rem !important;
  }
  :where(#widgetEditorDialog) .pr-md-4,
  :where(#widgetEditorDialog) .px-md-4 {
    padding-right: 1.5rem !important;
  }
  :where(#widgetEditorDialog) .pb-md-4,
  :where(#widgetEditorDialog) .py-md-4 {
    padding-bottom: 1.5rem !important;
  }
  :where(#widgetEditorDialog) .pl-md-4,
  :where(#widgetEditorDialog) .px-md-4 {
    padding-left: 1.5rem !important;
  }
  :where(#widgetEditorDialog) .p-md-5 {
    padding: 3rem !important;
  }
  :where(#widgetEditorDialog) .pt-md-5,
  :where(#widgetEditorDialog) .py-md-5 {
    padding-top: 3rem !important;
  }
  :where(#widgetEditorDialog) .pr-md-5,
  :where(#widgetEditorDialog) .px-md-5 {
    padding-right: 3rem !important;
  }
  :where(#widgetEditorDialog) .pb-md-5,
  :where(#widgetEditorDialog) .py-md-5 {
    padding-bottom: 3rem !important;
  }
  :where(#widgetEditorDialog) .pl-md-5,
  :where(#widgetEditorDialog) .px-md-5 {
    padding-left: 3rem !important;
  }
  :where(#widgetEditorDialog) .m-md-n1 {
    margin: -0.25rem !important;
  }
  :where(#widgetEditorDialog) .mt-md-n1,
  :where(#widgetEditorDialog) .my-md-n1 {
    margin-top: -0.25rem !important;
  }
  :where(#widgetEditorDialog) .mr-md-n1,
  :where(#widgetEditorDialog) .mx-md-n1 {
    margin-right: -0.25rem !important;
  }
  :where(#widgetEditorDialog) .mb-md-n1,
  :where(#widgetEditorDialog) .my-md-n1 {
    margin-bottom: -0.25rem !important;
  }
  :where(#widgetEditorDialog) .ml-md-n1,
  :where(#widgetEditorDialog) .mx-md-n1 {
    margin-left: -0.25rem !important;
  }
  :where(#widgetEditorDialog) .m-md-n2 {
    margin: -0.5rem !important;
  }
  :where(#widgetEditorDialog) .mt-md-n2,
  :where(#widgetEditorDialog) .my-md-n2 {
    margin-top: -0.5rem !important;
  }
  :where(#widgetEditorDialog) .mr-md-n2,
  :where(#widgetEditorDialog) .mx-md-n2 {
    margin-right: -0.5rem !important;
  }
  :where(#widgetEditorDialog) .mb-md-n2,
  :where(#widgetEditorDialog) .my-md-n2 {
    margin-bottom: -0.5rem !important;
  }
  :where(#widgetEditorDialog) .ml-md-n2,
  :where(#widgetEditorDialog) .mx-md-n2 {
    margin-left: -0.5rem !important;
  }
  :where(#widgetEditorDialog) .m-md-n3 {
    margin: -1rem !important;
  }
  :where(#widgetEditorDialog) .mt-md-n3,
  :where(#widgetEditorDialog) .my-md-n3 {
    margin-top: -1rem !important;
  }
  :where(#widgetEditorDialog) .mr-md-n3,
  :where(#widgetEditorDialog) .mx-md-n3 {
    margin-right: -1rem !important;
  }
  :where(#widgetEditorDialog) .mb-md-n3,
  :where(#widgetEditorDialog) .my-md-n3 {
    margin-bottom: -1rem !important;
  }
  :where(#widgetEditorDialog) .ml-md-n3,
  :where(#widgetEditorDialog) .mx-md-n3 {
    margin-left: -1rem !important;
  }
  :where(#widgetEditorDialog) .m-md-n4 {
    margin: -1.5rem !important;
  }
  :where(#widgetEditorDialog) .mt-md-n4,
  :where(#widgetEditorDialog) .my-md-n4 {
    margin-top: -1.5rem !important;
  }
  :where(#widgetEditorDialog) .mr-md-n4,
  :where(#widgetEditorDialog) .mx-md-n4 {
    margin-right: -1.5rem !important;
  }
  :where(#widgetEditorDialog) .mb-md-n4,
  :where(#widgetEditorDialog) .my-md-n4 {
    margin-bottom: -1.5rem !important;
  }
  :where(#widgetEditorDialog) .ml-md-n4,
  :where(#widgetEditorDialog) .mx-md-n4 {
    margin-left: -1.5rem !important;
  }
  :where(#widgetEditorDialog) .m-md-n5 {
    margin: -3rem !important;
  }
  :where(#widgetEditorDialog) .mt-md-n5,
  :where(#widgetEditorDialog) .my-md-n5 {
    margin-top: -3rem !important;
  }
  :where(#widgetEditorDialog) .mr-md-n5,
  :where(#widgetEditorDialog) .mx-md-n5 {
    margin-right: -3rem !important;
  }
  :where(#widgetEditorDialog) .mb-md-n5,
  :where(#widgetEditorDialog) .my-md-n5 {
    margin-bottom: -3rem !important;
  }
  :where(#widgetEditorDialog) .ml-md-n5,
  :where(#widgetEditorDialog) .mx-md-n5 {
    margin-left: -3rem !important;
  }
  :where(#widgetEditorDialog) .m-md-auto {
    margin: auto !important;
  }
  :where(#widgetEditorDialog) .mt-md-auto,
  :where(#widgetEditorDialog) .my-md-auto {
    margin-top: auto !important;
  }
  :where(#widgetEditorDialog) .mr-md-auto,
  :where(#widgetEditorDialog) .mx-md-auto {
    margin-right: auto !important;
  }
  :where(#widgetEditorDialog) .mb-md-auto,
  :where(#widgetEditorDialog) .my-md-auto {
    margin-bottom: auto !important;
  }
  :where(#widgetEditorDialog) .ml-md-auto,
  :where(#widgetEditorDialog) .mx-md-auto {
    margin-left: auto !important;
  }
}
@media (min-width: 992px) {
  :where(#widgetEditorDialog) .m-lg-0 {
    margin: 0 !important;
  }
  :where(#widgetEditorDialog) .mt-lg-0,
  :where(#widgetEditorDialog) .my-lg-0 {
    margin-top: 0 !important;
  }
  :where(#widgetEditorDialog) .mr-lg-0,
  :where(#widgetEditorDialog) .mx-lg-0 {
    margin-right: 0 !important;
  }
  :where(#widgetEditorDialog) .mb-lg-0,
  :where(#widgetEditorDialog) .my-lg-0 {
    margin-bottom: 0 !important;
  }
  :where(#widgetEditorDialog) .ml-lg-0,
  :where(#widgetEditorDialog) .mx-lg-0 {
    margin-left: 0 !important;
  }
  :where(#widgetEditorDialog) .m-lg-1 {
    margin: 0.25rem !important;
  }
  :where(#widgetEditorDialog) .mt-lg-1,
  :where(#widgetEditorDialog) .my-lg-1 {
    margin-top: 0.25rem !important;
  }
  :where(#widgetEditorDialog) .mr-lg-1,
  :where(#widgetEditorDialog) .mx-lg-1 {
    margin-right: 0.25rem !important;
  }
  :where(#widgetEditorDialog) .mb-lg-1,
  :where(#widgetEditorDialog) .my-lg-1 {
    margin-bottom: 0.25rem !important;
  }
  :where(#widgetEditorDialog) .ml-lg-1,
  :where(#widgetEditorDialog) .mx-lg-1 {
    margin-left: 0.25rem !important;
  }
  :where(#widgetEditorDialog) .m-lg-2 {
    margin: 0.5rem !important;
  }
  :where(#widgetEditorDialog) .mt-lg-2,
  :where(#widgetEditorDialog) .my-lg-2 {
    margin-top: 0.5rem !important;
  }
  :where(#widgetEditorDialog) .mr-lg-2,
  :where(#widgetEditorDialog) .mx-lg-2 {
    margin-right: 0.5rem !important;
  }
  :where(#widgetEditorDialog) .mb-lg-2,
  :where(#widgetEditorDialog) .my-lg-2 {
    margin-bottom: 0.5rem !important;
  }
  :where(#widgetEditorDialog) .ml-lg-2,
  :where(#widgetEditorDialog) .mx-lg-2 {
    margin-left: 0.5rem !important;
  }
  :where(#widgetEditorDialog) .m-lg-3 {
    margin: 1rem !important;
  }
  :where(#widgetEditorDialog) .mt-lg-3,
  :where(#widgetEditorDialog) .my-lg-3 {
    margin-top: 1rem !important;
  }
  :where(#widgetEditorDialog) .mr-lg-3,
  :where(#widgetEditorDialog) .mx-lg-3 {
    margin-right: 1rem !important;
  }
  :where(#widgetEditorDialog) .mb-lg-3,
  :where(#widgetEditorDialog) .my-lg-3 {
    margin-bottom: 1rem !important;
  }
  :where(#widgetEditorDialog) .ml-lg-3,
  :where(#widgetEditorDialog) .mx-lg-3 {
    margin-left: 1rem !important;
  }
  :where(#widgetEditorDialog) .m-lg-4 {
    margin: 1.5rem !important;
  }
  :where(#widgetEditorDialog) .mt-lg-4,
  :where(#widgetEditorDialog) .my-lg-4 {
    margin-top: 1.5rem !important;
  }
  :where(#widgetEditorDialog) .mr-lg-4,
  :where(#widgetEditorDialog) .mx-lg-4 {
    margin-right: 1.5rem !important;
  }
  :where(#widgetEditorDialog) .mb-lg-4,
  :where(#widgetEditorDialog) .my-lg-4 {
    margin-bottom: 1.5rem !important;
  }
  :where(#widgetEditorDialog) .ml-lg-4,
  :where(#widgetEditorDialog) .mx-lg-4 {
    margin-left: 1.5rem !important;
  }
  :where(#widgetEditorDialog) .m-lg-5 {
    margin: 3rem !important;
  }
  :where(#widgetEditorDialog) .mt-lg-5,
  :where(#widgetEditorDialog) .my-lg-5 {
    margin-top: 3rem !important;
  }
  :where(#widgetEditorDialog) .mr-lg-5,
  :where(#widgetEditorDialog) .mx-lg-5 {
    margin-right: 3rem !important;
  }
  :where(#widgetEditorDialog) .mb-lg-5,
  :where(#widgetEditorDialog) .my-lg-5 {
    margin-bottom: 3rem !important;
  }
  :where(#widgetEditorDialog) .ml-lg-5,
  :where(#widgetEditorDialog) .mx-lg-5 {
    margin-left: 3rem !important;
  }
  :where(#widgetEditorDialog) .p-lg-0 {
    padding: 0 !important;
  }
  :where(#widgetEditorDialog) .pt-lg-0,
  :where(#widgetEditorDialog) .py-lg-0 {
    padding-top: 0 !important;
  }
  :where(#widgetEditorDialog) .pr-lg-0,
  :where(#widgetEditorDialog) .px-lg-0 {
    padding-right: 0 !important;
  }
  :where(#widgetEditorDialog) .pb-lg-0,
  :where(#widgetEditorDialog) .py-lg-0 {
    padding-bottom: 0 !important;
  }
  :where(#widgetEditorDialog) .pl-lg-0,
  :where(#widgetEditorDialog) .px-lg-0 {
    padding-left: 0 !important;
  }
  :where(#widgetEditorDialog) .p-lg-1 {
    padding: 0.25rem !important;
  }
  :where(#widgetEditorDialog) .pt-lg-1,
  :where(#widgetEditorDialog) .py-lg-1 {
    padding-top: 0.25rem !important;
  }
  :where(#widgetEditorDialog) .pr-lg-1,
  :where(#widgetEditorDialog) .px-lg-1 {
    padding-right: 0.25rem !important;
  }
  :where(#widgetEditorDialog) .pb-lg-1,
  :where(#widgetEditorDialog) .py-lg-1 {
    padding-bottom: 0.25rem !important;
  }
  :where(#widgetEditorDialog) .pl-lg-1,
  :where(#widgetEditorDialog) .px-lg-1 {
    padding-left: 0.25rem !important;
  }
  :where(#widgetEditorDialog) .p-lg-2 {
    padding: 0.5rem !important;
  }
  :where(#widgetEditorDialog) .pt-lg-2,
  :where(#widgetEditorDialog) .py-lg-2 {
    padding-top: 0.5rem !important;
  }
  :where(#widgetEditorDialog) .pr-lg-2,
  :where(#widgetEditorDialog) .px-lg-2 {
    padding-right: 0.5rem !important;
  }
  :where(#widgetEditorDialog) .pb-lg-2,
  :where(#widgetEditorDialog) .py-lg-2 {
    padding-bottom: 0.5rem !important;
  }
  :where(#widgetEditorDialog) .pl-lg-2,
  :where(#widgetEditorDialog) .px-lg-2 {
    padding-left: 0.5rem !important;
  }
  :where(#widgetEditorDialog) .p-lg-3 {
    padding: 1rem !important;
  }
  :where(#widgetEditorDialog) .pt-lg-3,
  :where(#widgetEditorDialog) .py-lg-3 {
    padding-top: 1rem !important;
  }
  :where(#widgetEditorDialog) .pr-lg-3,
  :where(#widgetEditorDialog) .px-lg-3 {
    padding-right: 1rem !important;
  }
  :where(#widgetEditorDialog) .pb-lg-3,
  :where(#widgetEditorDialog) .py-lg-3 {
    padding-bottom: 1rem !important;
  }
  :where(#widgetEditorDialog) .pl-lg-3,
  :where(#widgetEditorDialog) .px-lg-3 {
    padding-left: 1rem !important;
  }
  :where(#widgetEditorDialog) .p-lg-4 {
    padding: 1.5rem !important;
  }
  :where(#widgetEditorDialog) .pt-lg-4,
  :where(#widgetEditorDialog) .py-lg-4 {
    padding-top: 1.5rem !important;
  }
  :where(#widgetEditorDialog) .pr-lg-4,
  :where(#widgetEditorDialog) .px-lg-4 {
    padding-right: 1.5rem !important;
  }
  :where(#widgetEditorDialog) .pb-lg-4,
  :where(#widgetEditorDialog) .py-lg-4 {
    padding-bottom: 1.5rem !important;
  }
  :where(#widgetEditorDialog) .pl-lg-4,
  :where(#widgetEditorDialog) .px-lg-4 {
    padding-left: 1.5rem !important;
  }
  :where(#widgetEditorDialog) .p-lg-5 {
    padding: 3rem !important;
  }
  :where(#widgetEditorDialog) .pt-lg-5,
  :where(#widgetEditorDialog) .py-lg-5 {
    padding-top: 3rem !important;
  }
  :where(#widgetEditorDialog) .pr-lg-5,
  :where(#widgetEditorDialog) .px-lg-5 {
    padding-right: 3rem !important;
  }
  :where(#widgetEditorDialog) .pb-lg-5,
  :where(#widgetEditorDialog) .py-lg-5 {
    padding-bottom: 3rem !important;
  }
  :where(#widgetEditorDialog) .pl-lg-5,
  :where(#widgetEditorDialog) .px-lg-5 {
    padding-left: 3rem !important;
  }
  :where(#widgetEditorDialog) .m-lg-n1 {
    margin: -0.25rem !important;
  }
  :where(#widgetEditorDialog) .mt-lg-n1,
  :where(#widgetEditorDialog) .my-lg-n1 {
    margin-top: -0.25rem !important;
  }
  :where(#widgetEditorDialog) .mr-lg-n1,
  :where(#widgetEditorDialog) .mx-lg-n1 {
    margin-right: -0.25rem !important;
  }
  :where(#widgetEditorDialog) .mb-lg-n1,
  :where(#widgetEditorDialog) .my-lg-n1 {
    margin-bottom: -0.25rem !important;
  }
  :where(#widgetEditorDialog) .ml-lg-n1,
  :where(#widgetEditorDialog) .mx-lg-n1 {
    margin-left: -0.25rem !important;
  }
  :where(#widgetEditorDialog) .m-lg-n2 {
    margin: -0.5rem !important;
  }
  :where(#widgetEditorDialog) .mt-lg-n2,
  :where(#widgetEditorDialog) .my-lg-n2 {
    margin-top: -0.5rem !important;
  }
  :where(#widgetEditorDialog) .mr-lg-n2,
  :where(#widgetEditorDialog) .mx-lg-n2 {
    margin-right: -0.5rem !important;
  }
  :where(#widgetEditorDialog) .mb-lg-n2,
  :where(#widgetEditorDialog) .my-lg-n2 {
    margin-bottom: -0.5rem !important;
  }
  :where(#widgetEditorDialog) .ml-lg-n2,
  :where(#widgetEditorDialog) .mx-lg-n2 {
    margin-left: -0.5rem !important;
  }
  :where(#widgetEditorDialog) .m-lg-n3 {
    margin: -1rem !important;
  }
  :where(#widgetEditorDialog) .mt-lg-n3,
  :where(#widgetEditorDialog) .my-lg-n3 {
    margin-top: -1rem !important;
  }
  :where(#widgetEditorDialog) .mr-lg-n3,
  :where(#widgetEditorDialog) .mx-lg-n3 {
    margin-right: -1rem !important;
  }
  :where(#widgetEditorDialog) .mb-lg-n3,
  :where(#widgetEditorDialog) .my-lg-n3 {
    margin-bottom: -1rem !important;
  }
  :where(#widgetEditorDialog) .ml-lg-n3,
  :where(#widgetEditorDialog) .mx-lg-n3 {
    margin-left: -1rem !important;
  }
  :where(#widgetEditorDialog) .m-lg-n4 {
    margin: -1.5rem !important;
  }
  :where(#widgetEditorDialog) .mt-lg-n4,
  :where(#widgetEditorDialog) .my-lg-n4 {
    margin-top: -1.5rem !important;
  }
  :where(#widgetEditorDialog) .mr-lg-n4,
  :where(#widgetEditorDialog) .mx-lg-n4 {
    margin-right: -1.5rem !important;
  }
  :where(#widgetEditorDialog) .mb-lg-n4,
  :where(#widgetEditorDialog) .my-lg-n4 {
    margin-bottom: -1.5rem !important;
  }
  :where(#widgetEditorDialog) .ml-lg-n4,
  :where(#widgetEditorDialog) .mx-lg-n4 {
    margin-left: -1.5rem !important;
  }
  :where(#widgetEditorDialog) .m-lg-n5 {
    margin: -3rem !important;
  }
  :where(#widgetEditorDialog) .mt-lg-n5,
  :where(#widgetEditorDialog) .my-lg-n5 {
    margin-top: -3rem !important;
  }
  :where(#widgetEditorDialog) .mr-lg-n5,
  :where(#widgetEditorDialog) .mx-lg-n5 {
    margin-right: -3rem !important;
  }
  :where(#widgetEditorDialog) .mb-lg-n5,
  :where(#widgetEditorDialog) .my-lg-n5 {
    margin-bottom: -3rem !important;
  }
  :where(#widgetEditorDialog) .ml-lg-n5,
  :where(#widgetEditorDialog) .mx-lg-n5 {
    margin-left: -3rem !important;
  }
  :where(#widgetEditorDialog) .m-lg-auto {
    margin: auto !important;
  }
  :where(#widgetEditorDialog) .mt-lg-auto,
  :where(#widgetEditorDialog) .my-lg-auto {
    margin-top: auto !important;
  }
  :where(#widgetEditorDialog) .mr-lg-auto,
  :where(#widgetEditorDialog) .mx-lg-auto {
    margin-right: auto !important;
  }
  :where(#widgetEditorDialog) .mb-lg-auto,
  :where(#widgetEditorDialog) .my-lg-auto {
    margin-bottom: auto !important;
  }
  :where(#widgetEditorDialog) .ml-lg-auto,
  :where(#widgetEditorDialog) .mx-lg-auto {
    margin-left: auto !important;
  }
}
@media (min-width: 1200px) {
  :where(#widgetEditorDialog) .m-xl-0 {
    margin: 0 !important;
  }
  :where(#widgetEditorDialog) .mt-xl-0,
  :where(#widgetEditorDialog) .my-xl-0 {
    margin-top: 0 !important;
  }
  :where(#widgetEditorDialog) .mr-xl-0,
  :where(#widgetEditorDialog) .mx-xl-0 {
    margin-right: 0 !important;
  }
  :where(#widgetEditorDialog) .mb-xl-0,
  :where(#widgetEditorDialog) .my-xl-0 {
    margin-bottom: 0 !important;
  }
  :where(#widgetEditorDialog) .ml-xl-0,
  :where(#widgetEditorDialog) .mx-xl-0 {
    margin-left: 0 !important;
  }
  :where(#widgetEditorDialog) .m-xl-1 {
    margin: 0.25rem !important;
  }
  :where(#widgetEditorDialog) .mt-xl-1,
  :where(#widgetEditorDialog) .my-xl-1 {
    margin-top: 0.25rem !important;
  }
  :where(#widgetEditorDialog) .mr-xl-1,
  :where(#widgetEditorDialog) .mx-xl-1 {
    margin-right: 0.25rem !important;
  }
  :where(#widgetEditorDialog) .mb-xl-1,
  :where(#widgetEditorDialog) .my-xl-1 {
    margin-bottom: 0.25rem !important;
  }
  :where(#widgetEditorDialog) .ml-xl-1,
  :where(#widgetEditorDialog) .mx-xl-1 {
    margin-left: 0.25rem !important;
  }
  :where(#widgetEditorDialog) .m-xl-2 {
    margin: 0.5rem !important;
  }
  :where(#widgetEditorDialog) .mt-xl-2,
  :where(#widgetEditorDialog) .my-xl-2 {
    margin-top: 0.5rem !important;
  }
  :where(#widgetEditorDialog) .mr-xl-2,
  :where(#widgetEditorDialog) .mx-xl-2 {
    margin-right: 0.5rem !important;
  }
  :where(#widgetEditorDialog) .mb-xl-2,
  :where(#widgetEditorDialog) .my-xl-2 {
    margin-bottom: 0.5rem !important;
  }
  :where(#widgetEditorDialog) .ml-xl-2,
  :where(#widgetEditorDialog) .mx-xl-2 {
    margin-left: 0.5rem !important;
  }
  :where(#widgetEditorDialog) .m-xl-3 {
    margin: 1rem !important;
  }
  :where(#widgetEditorDialog) .mt-xl-3,
  :where(#widgetEditorDialog) .my-xl-3 {
    margin-top: 1rem !important;
  }
  :where(#widgetEditorDialog) .mr-xl-3,
  :where(#widgetEditorDialog) .mx-xl-3 {
    margin-right: 1rem !important;
  }
  :where(#widgetEditorDialog) .mb-xl-3,
  :where(#widgetEditorDialog) .my-xl-3 {
    margin-bottom: 1rem !important;
  }
  :where(#widgetEditorDialog) .ml-xl-3,
  :where(#widgetEditorDialog) .mx-xl-3 {
    margin-left: 1rem !important;
  }
  :where(#widgetEditorDialog) .m-xl-4 {
    margin: 1.5rem !important;
  }
  :where(#widgetEditorDialog) .mt-xl-4,
  :where(#widgetEditorDialog) .my-xl-4 {
    margin-top: 1.5rem !important;
  }
  :where(#widgetEditorDialog) .mr-xl-4,
  :where(#widgetEditorDialog) .mx-xl-4 {
    margin-right: 1.5rem !important;
  }
  :where(#widgetEditorDialog) .mb-xl-4,
  :where(#widgetEditorDialog) .my-xl-4 {
    margin-bottom: 1.5rem !important;
  }
  :where(#widgetEditorDialog) .ml-xl-4,
  :where(#widgetEditorDialog) .mx-xl-4 {
    margin-left: 1.5rem !important;
  }
  :where(#widgetEditorDialog) .m-xl-5 {
    margin: 3rem !important;
  }
  :where(#widgetEditorDialog) .mt-xl-5,
  :where(#widgetEditorDialog) .my-xl-5 {
    margin-top: 3rem !important;
  }
  :where(#widgetEditorDialog) .mr-xl-5,
  :where(#widgetEditorDialog) .mx-xl-5 {
    margin-right: 3rem !important;
  }
  :where(#widgetEditorDialog) .mb-xl-5,
  :where(#widgetEditorDialog) .my-xl-5 {
    margin-bottom: 3rem !important;
  }
  :where(#widgetEditorDialog) .ml-xl-5,
  :where(#widgetEditorDialog) .mx-xl-5 {
    margin-left: 3rem !important;
  }
  :where(#widgetEditorDialog) .p-xl-0 {
    padding: 0 !important;
  }
  :where(#widgetEditorDialog) .pt-xl-0,
  :where(#widgetEditorDialog) .py-xl-0 {
    padding-top: 0 !important;
  }
  :where(#widgetEditorDialog) .pr-xl-0,
  :where(#widgetEditorDialog) .px-xl-0 {
    padding-right: 0 !important;
  }
  :where(#widgetEditorDialog) .pb-xl-0,
  :where(#widgetEditorDialog) .py-xl-0 {
    padding-bottom: 0 !important;
  }
  :where(#widgetEditorDialog) .pl-xl-0,
  :where(#widgetEditorDialog) .px-xl-0 {
    padding-left: 0 !important;
  }
  :where(#widgetEditorDialog) .p-xl-1 {
    padding: 0.25rem !important;
  }
  :where(#widgetEditorDialog) .pt-xl-1,
  :where(#widgetEditorDialog) .py-xl-1 {
    padding-top: 0.25rem !important;
  }
  :where(#widgetEditorDialog) .pr-xl-1,
  :where(#widgetEditorDialog) .px-xl-1 {
    padding-right: 0.25rem !important;
  }
  :where(#widgetEditorDialog) .pb-xl-1,
  :where(#widgetEditorDialog) .py-xl-1 {
    padding-bottom: 0.25rem !important;
  }
  :where(#widgetEditorDialog) .pl-xl-1,
  :where(#widgetEditorDialog) .px-xl-1 {
    padding-left: 0.25rem !important;
  }
  :where(#widgetEditorDialog) .p-xl-2 {
    padding: 0.5rem !important;
  }
  :where(#widgetEditorDialog) .pt-xl-2,
  :where(#widgetEditorDialog) .py-xl-2 {
    padding-top: 0.5rem !important;
  }
  :where(#widgetEditorDialog) .pr-xl-2,
  :where(#widgetEditorDialog) .px-xl-2 {
    padding-right: 0.5rem !important;
  }
  :where(#widgetEditorDialog) .pb-xl-2,
  :where(#widgetEditorDialog) .py-xl-2 {
    padding-bottom: 0.5rem !important;
  }
  :where(#widgetEditorDialog) .pl-xl-2,
  :where(#widgetEditorDialog) .px-xl-2 {
    padding-left: 0.5rem !important;
  }
  :where(#widgetEditorDialog) .p-xl-3 {
    padding: 1rem !important;
  }
  :where(#widgetEditorDialog) .pt-xl-3,
  :where(#widgetEditorDialog) .py-xl-3 {
    padding-top: 1rem !important;
  }
  :where(#widgetEditorDialog) .pr-xl-3,
  :where(#widgetEditorDialog) .px-xl-3 {
    padding-right: 1rem !important;
  }
  :where(#widgetEditorDialog) .pb-xl-3,
  :where(#widgetEditorDialog) .py-xl-3 {
    padding-bottom: 1rem !important;
  }
  :where(#widgetEditorDialog) .pl-xl-3,
  :where(#widgetEditorDialog) .px-xl-3 {
    padding-left: 1rem !important;
  }
  :where(#widgetEditorDialog) .p-xl-4 {
    padding: 1.5rem !important;
  }
  :where(#widgetEditorDialog) .pt-xl-4,
  :where(#widgetEditorDialog) .py-xl-4 {
    padding-top: 1.5rem !important;
  }
  :where(#widgetEditorDialog) .pr-xl-4,
  :where(#widgetEditorDialog) .px-xl-4 {
    padding-right: 1.5rem !important;
  }
  :where(#widgetEditorDialog) .pb-xl-4,
  :where(#widgetEditorDialog) .py-xl-4 {
    padding-bottom: 1.5rem !important;
  }
  :where(#widgetEditorDialog) .pl-xl-4,
  :where(#widgetEditorDialog) .px-xl-4 {
    padding-left: 1.5rem !important;
  }
  :where(#widgetEditorDialog) .p-xl-5 {
    padding: 3rem !important;
  }
  :where(#widgetEditorDialog) .pt-xl-5,
  :where(#widgetEditorDialog) .py-xl-5 {
    padding-top: 3rem !important;
  }
  :where(#widgetEditorDialog) .pr-xl-5,
  :where(#widgetEditorDialog) .px-xl-5 {
    padding-right: 3rem !important;
  }
  :where(#widgetEditorDialog) .pb-xl-5,
  :where(#widgetEditorDialog) .py-xl-5 {
    padding-bottom: 3rem !important;
  }
  :where(#widgetEditorDialog) .pl-xl-5,
  :where(#widgetEditorDialog) .px-xl-5 {
    padding-left: 3rem !important;
  }
  :where(#widgetEditorDialog) .m-xl-n1 {
    margin: -0.25rem !important;
  }
  :where(#widgetEditorDialog) .mt-xl-n1,
  :where(#widgetEditorDialog) .my-xl-n1 {
    margin-top: -0.25rem !important;
  }
  :where(#widgetEditorDialog) .mr-xl-n1,
  :where(#widgetEditorDialog) .mx-xl-n1 {
    margin-right: -0.25rem !important;
  }
  :where(#widgetEditorDialog) .mb-xl-n1,
  :where(#widgetEditorDialog) .my-xl-n1 {
    margin-bottom: -0.25rem !important;
  }
  :where(#widgetEditorDialog) .ml-xl-n1,
  :where(#widgetEditorDialog) .mx-xl-n1 {
    margin-left: -0.25rem !important;
  }
  :where(#widgetEditorDialog) .m-xl-n2 {
    margin: -0.5rem !important;
  }
  :where(#widgetEditorDialog) .mt-xl-n2,
  :where(#widgetEditorDialog) .my-xl-n2 {
    margin-top: -0.5rem !important;
  }
  :where(#widgetEditorDialog) .mr-xl-n2,
  :where(#widgetEditorDialog) .mx-xl-n2 {
    margin-right: -0.5rem !important;
  }
  :where(#widgetEditorDialog) .mb-xl-n2,
  :where(#widgetEditorDialog) .my-xl-n2 {
    margin-bottom: -0.5rem !important;
  }
  :where(#widgetEditorDialog) .ml-xl-n2,
  :where(#widgetEditorDialog) .mx-xl-n2 {
    margin-left: -0.5rem !important;
  }
  :where(#widgetEditorDialog) .m-xl-n3 {
    margin: -1rem !important;
  }
  :where(#widgetEditorDialog) .mt-xl-n3,
  :where(#widgetEditorDialog) .my-xl-n3 {
    margin-top: -1rem !important;
  }
  :where(#widgetEditorDialog) .mr-xl-n3,
  :where(#widgetEditorDialog) .mx-xl-n3 {
    margin-right: -1rem !important;
  }
  :where(#widgetEditorDialog) .mb-xl-n3,
  :where(#widgetEditorDialog) .my-xl-n3 {
    margin-bottom: -1rem !important;
  }
  :where(#widgetEditorDialog) .ml-xl-n3,
  :where(#widgetEditorDialog) .mx-xl-n3 {
    margin-left: -1rem !important;
  }
  :where(#widgetEditorDialog) .m-xl-n4 {
    margin: -1.5rem !important;
  }
  :where(#widgetEditorDialog) .mt-xl-n4,
  :where(#widgetEditorDialog) .my-xl-n4 {
    margin-top: -1.5rem !important;
  }
  :where(#widgetEditorDialog) .mr-xl-n4,
  :where(#widgetEditorDialog) .mx-xl-n4 {
    margin-right: -1.5rem !important;
  }
  :where(#widgetEditorDialog) .mb-xl-n4,
  :where(#widgetEditorDialog) .my-xl-n4 {
    margin-bottom: -1.5rem !important;
  }
  :where(#widgetEditorDialog) .ml-xl-n4,
  :where(#widgetEditorDialog) .mx-xl-n4 {
    margin-left: -1.5rem !important;
  }
  :where(#widgetEditorDialog) .m-xl-n5 {
    margin: -3rem !important;
  }
  :where(#widgetEditorDialog) .mt-xl-n5,
  :where(#widgetEditorDialog) .my-xl-n5 {
    margin-top: -3rem !important;
  }
  :where(#widgetEditorDialog) .mr-xl-n5,
  :where(#widgetEditorDialog) .mx-xl-n5 {
    margin-right: -3rem !important;
  }
  :where(#widgetEditorDialog) .mb-xl-n5,
  :where(#widgetEditorDialog) .my-xl-n5 {
    margin-bottom: -3rem !important;
  }
  :where(#widgetEditorDialog) .ml-xl-n5,
  :where(#widgetEditorDialog) .mx-xl-n5 {
    margin-left: -3rem !important;
  }
  :where(#widgetEditorDialog) .m-xl-auto {
    margin: auto !important;
  }
  :where(#widgetEditorDialog) .mt-xl-auto,
  :where(#widgetEditorDialog) .my-xl-auto {
    margin-top: auto !important;
  }
  :where(#widgetEditorDialog) .mr-xl-auto,
  :where(#widgetEditorDialog) .mx-xl-auto {
    margin-right: auto !important;
  }
  :where(#widgetEditorDialog) .mb-xl-auto,
  :where(#widgetEditorDialog) .my-xl-auto {
    margin-bottom: auto !important;
  }
  :where(#widgetEditorDialog) .ml-xl-auto,
  :where(#widgetEditorDialog) .mx-xl-auto {
    margin-left: auto !important;
  }
}
:where(#widgetEditorDialog) .stretched-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  pointer-events: auto;
  content: "";
  background-color: rgba(0, 0, 0, 0);
}
:where(#widgetEditorDialog) .text-monospace {
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace !important;
}
:where(#widgetEditorDialog) .text-justify {
  text-align: justify !important;
}
:where(#widgetEditorDialog) .text-wrap {
  white-space: normal !important;
}
:where(#widgetEditorDialog) .text-nowrap {
  white-space: nowrap !important;
}
:where(#widgetEditorDialog) .text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
:where(#widgetEditorDialog) .text-left {
  text-align: left !important;
}
:where(#widgetEditorDialog) .text-right {
  text-align: right !important;
}
:where(#widgetEditorDialog) .text-center {
  text-align: center !important;
}
@media (min-width: 576px) {
  :where(#widgetEditorDialog) .text-sm-left {
    text-align: left !important;
  }
  :where(#widgetEditorDialog) .text-sm-right {
    text-align: right !important;
  }
  :where(#widgetEditorDialog) .text-sm-center {
    text-align: center !important;
  }
}
@media (min-width: 768px) {
  :where(#widgetEditorDialog) .text-md-left {
    text-align: left !important;
  }
  :where(#widgetEditorDialog) .text-md-right {
    text-align: right !important;
  }
  :where(#widgetEditorDialog) .text-md-center {
    text-align: center !important;
  }
}
@media (min-width: 992px) {
  :where(#widgetEditorDialog) .text-lg-left {
    text-align: left !important;
  }
  :where(#widgetEditorDialog) .text-lg-right {
    text-align: right !important;
  }
  :where(#widgetEditorDialog) .text-lg-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  :where(#widgetEditorDialog) .text-xl-left {
    text-align: left !important;
  }
  :where(#widgetEditorDialog) .text-xl-right {
    text-align: right !important;
  }
  :where(#widgetEditorDialog) .text-xl-center {
    text-align: center !important;
  }
}
:where(#widgetEditorDialog) .text-lowercase {
  text-transform: lowercase !important;
}
:where(#widgetEditorDialog) .text-uppercase {
  text-transform: uppercase !important;
}
:where(#widgetEditorDialog) .text-capitalize {
  text-transform: capitalize !important;
}
:where(#widgetEditorDialog) .font-weight-light {
  font-weight: 300 !important;
}
:where(#widgetEditorDialog) .font-weight-lighter {
  font-weight: lighter !important;
}
:where(#widgetEditorDialog) .font-weight-normal {
  font-weight: 400 !important;
}
:where(#widgetEditorDialog) .font-weight-bold {
  font-weight: 700 !important;
}
:where(#widgetEditorDialog) .font-weight-bolder {
  font-weight: bolder !important;
}
:where(#widgetEditorDialog) .font-italic {
  font-style: italic !important;
}
:where(#widgetEditorDialog) .text-white {
  color: #fff !important;
}
:where(#widgetEditorDialog) .text-primary {
  color: #007bff !important;
}
:where(#widgetEditorDialog) a.text-primary:hover, :where(#widgetEditorDialog) a.text-primary:focus {
  color: rgb(0%, 33.7647058824%, 70%) !important;
}
:where(#widgetEditorDialog) .text-secondary {
  color: #6c757d !important;
}
:where(#widgetEditorDialog) a.text-secondary:hover, :where(#widgetEditorDialog) a.text-secondary:focus {
  color: rgb(28.4473617773%, 30.8179752588%, 32.9251872423%) !important;
}
:where(#widgetEditorDialog) .text-success {
  color: #28a745 !important;
}
:where(#widgetEditorDialog) a.text-success:hover, :where(#widgetEditorDialog) a.text-success:focus {
  color: rgb(9.8891730605%, 41.2872975277%, 17.0588235294%) !important;
}
:where(#widgetEditorDialog) .text-info {
  color: #17a2b8 !important;
}
:where(#widgetEditorDialog) a.text-info:hover, :where(#widgetEditorDialog) a.text-info:focus {
  color: rgb(5.6862745098%, 40.0511508951%, 45.4901960784%) !important;
}
:where(#widgetEditorDialog) .text-warning {
  color: #ffc107 !important;
}
:where(#widgetEditorDialog) a.text-warning:hover, :where(#widgetEditorDialog) a.text-warning:focus {
  color: rgb(72.7450980392%, 54.5588235294%, 0%) !important;
}
:where(#widgetEditorDialog) .text-danger {
  color: #dc3545 !important;
}
:where(#widgetEditorDialog) a.text-danger:hover, :where(#widgetEditorDialog) a.text-danger:focus {
  color: rgb(65.6788284934%, 11.379995036%, 16.582278481%) !important;
}
:where(#widgetEditorDialog) .text-light {
  color: #f8f9fa !important;
}
:where(#widgetEditorDialog) a.text-light:hover, :where(#widgetEditorDialog) a.text-light:focus {
  color: rgb(79.7549019608%, 82.6470588235%, 85.5392156863%) !important;
}
:where(#widgetEditorDialog) .text-dark {
  color: #343a40 !important;
}
:where(#widgetEditorDialog) a.text-dark:hover, :where(#widgetEditorDialog) a.text-dark:focus {
  color: rgb(6.9438810007%, 7.7450980392%, 8.5463150778%) !important;
}
:where(#widgetEditorDialog) .text-body {
  color: #212529 !important;
}
:where(#widgetEditorDialog) .text-muted {
  color: #6c757d !important;
}
:where(#widgetEditorDialog) .text-black-50 {
  color: rgba(0, 0, 0, 0.5) !important;
}
:where(#widgetEditorDialog) .text-white-50 {
  color: rgba(255, 255, 255, 0.5) !important;
}
:where(#widgetEditorDialog) .text-hide {
  font: 0/0 a;
  color: transparent;
  text-shadow: none;
  background-color: transparent;
  border: 0;
}
:where(#widgetEditorDialog) .text-decoration-none {
  text-decoration: none !important;
}
:where(#widgetEditorDialog) .text-break {
  word-break: break-word !important;
  word-wrap: break-word !important;
}
:where(#widgetEditorDialog) .text-reset {
  color: inherit !important;
}
:where(#widgetEditorDialog) .visible {
  visibility: visible !important;
}
:where(#widgetEditorDialog) .invisible {
  visibility: hidden !important;
}
@media print {
  :where(#widgetEditorDialog) *,
  :where(#widgetEditorDialog) *::before,
  :where(#widgetEditorDialog) *::after {
    text-shadow: none !important;
    box-shadow: none !important;
  }
  :where(#widgetEditorDialog) a:not(.btn) {
    text-decoration: underline;
  }
  :where(#widgetEditorDialog) abbr[title]::after {
    content: " (" attr(title) ")";
  }
  :where(#widgetEditorDialog) pre {
    white-space: pre-wrap !important;
  }
  :where(#widgetEditorDialog) pre,
  :where(#widgetEditorDialog) blockquote {
    border: 1px solid #adb5bd;
    page-break-inside: avoid;
  }
  :where(#widgetEditorDialog) tr,
  :where(#widgetEditorDialog) img {
    page-break-inside: avoid;
  }
  :where(#widgetEditorDialog) p,
  :where(#widgetEditorDialog) h2,
  :where(#widgetEditorDialog) h3 {
    orphans: 3;
    widows: 3;
  }
  :where(#widgetEditorDialog) h2,
  :where(#widgetEditorDialog) h3 {
    page-break-after: avoid;
  }
  @page {
    :where(#widgetEditorDialog) {
      size: a3;
    }
  }
  :where(#widgetEditorDialog) body {
    min-width: 992px !important;
  }
  :where(#widgetEditorDialog) .container {
    min-width: 992px !important;
  }
  :where(#widgetEditorDialog) .navbar {
    display: none;
  }
  :where(#widgetEditorDialog) .badge {
    border: 1px solid #000;
  }
  :where(#widgetEditorDialog) .table {
    border-collapse: collapse !important;
  }
  :where(#widgetEditorDialog) .table td,
  :where(#widgetEditorDialog) .table th {
    background-color: #fff !important;
  }
  :where(#widgetEditorDialog) .table-bordered th,
  :where(#widgetEditorDialog) .table-bordered td {
    border: 1px solid #dee2e6 !important;
  }
  :where(#widgetEditorDialog) .table-dark {
    color: inherit;
  }
  :where(#widgetEditorDialog) .table-dark th,
  :where(#widgetEditorDialog) .table-dark td,
  :where(#widgetEditorDialog) .table-dark thead th,
  :where(#widgetEditorDialog) .table-dark tbody + tbody {
    border-color: #dee2e6;
  }
  :where(#widgetEditorDialog) .table .thead-dark th {
    color: inherit;
    border-color: #dee2e6;
  }
}

#widgetEditorDialog {
  overflow-x: hidden;
  overflow-y: auto;
  font-family: Roboto, sans-serif;
  font-size: 15px;
}

#widgetEditorDialog .flippy-front,
#widgetEditorDialog .flippy-front {
  height: auto;
  box-shadow: none;
  padding: 5px !important;
}

.no-left-margin {
  margin-left: 0px;
}

.no-right-margin {
  margin-right: 0px;
}

.no-left-padding {
  padding-left: 0px;
}

.no-right-padding {
  padding-right: 0px;
}

.widget-editor-form #propertyBox .card-body,
.widget-editor-form #previewBox .card-body {
  overflow-y: auto;
  overflow-x: hidden;
}

.widget-editor-form #chartPreview,
.widget-editor-form #valuePreview {
  width: 100%;
  height: 100%;
}

.widget-editor-form > div:first-child {
  padding: 3px;
}

.widget-editor-form .right-align {
  text-align: right;
}

.widget-editor-form .query-customization-button {
  width: 46px;
}

/* Begin - Error display tooltip color. */
.error-tooltip.bs-tooltip-bottom .arrow::before, :where(#widgetEditorDialog) .error-tooltip.bs-tooltip-auto[x-placement^=bottom] .arrow::before {
  border-bottom-color: red;
}

.error-tooltip.bs-tooltip-left .arrow::before, :where(#widgetEditorDialog) .error-tooltip.bs-tooltip-auto[x-placement^=left] .arrow::before {
  border-left-color: red;
}

.error-tooltip.bs-tooltip-right .arrow::before, :where(#widgetEditorDialog) .error-tooltip.bs-tooltip-auto[x-placement^=right] .arrow::before {
  border-right-color: red;
}

.error-tooltip.bs-tooltip-top .arrow::before, :where(#widgetEditorDialog) .error-tooltip.bs-tooltip-auto[x-placement^=top] .arrow::before {
  border-top-color: red;
}

.error-tooltip .tooltip-inner {
  background-color: red;
}

/* End - Error display tooltip color. */
/* Begin - styling react-bootstrap tabs. */
.tab-content {
  min-height: 330px;
  width: 100%;
}

.nav-tabs {
  width: 100%;
  border-bottom: 1px solid #dee2e6;
  margin-left: -7px;
}

/* End - styling react-bootstrap tabs. */
.create-widget-div {
  height: 9vh;
}

.disappear {
  display: none;
}

.widget-editor-form .flippy-back {
  box-shadow: none;
}

.drilldown-div {
  height: 100%;
  padding: 1em;
}

.drilldown-div .btn {
  margin-left: 0em;
}

.action-button-box {
  padding-left: 0px;
  padding-right: 0px;
  min-width: 210px;
}

.action-button-box > button {
  margin-left: 5px;
  margin-right: 5px;
}

#aggregateRefreshBtn,
#chartRefreshBtn,
#tableRefreshBtn,
#helpGuideIcon,
#fullScreenIcon {
  margin-left: auto;
  cursor: pointer;
}

.widget-action-btn {
  height: 35px;
}

.cke_dialog_ui_iframe {
  min-height: 500px !important;
}

.oxzion-widget-aggregate-drilldown {
  text-decoration: underline;
  color: blue;
  cursor: pointer;
}

.red {
  color: #ee4424;
  font-weight: bold;
}

.green {
  color: #a3c53a;
  font-weight: bold;
}

.yellow {
  color: #f3ba1d;
  font-weight: bold;
}

.react-editor-container {
  width: 100% !important;
}
.react-editor-container .k-animation-container {
  width: 100% !important;
}

.help-guide-window .k-window-titlebar {
  border-color: inherit;
  color: white;
  background-color: #275362;
}
.help-guide-window button[aria-label=minimize] {
  display: none;
}
.help-guide-window button[aria-label=maximize] {
  display: none;
}
.help-guide-window .doc-copy-icon {
  cursor: pointer;
  font-size: 15px;
  color: #275362;
}

.react-preview-container {
  height: 100%;
}

.react-preview-container > div:first-of-type {
  height: 100%;
}

.react-preview-container > div:first-of-type > div {
  height: 100%;
}`, "",{"version":3,"sources":["webpack://./../gui/src/components/widget/editor/widgetEditorApp.scss","webpack://./../gui/node_modules/bootstrap/scss/bootstrap.scss","webpack://./../gui/node_modules/bootstrap/scss/_root.scss","webpack://./../gui/node_modules/bootstrap/scss/_reboot.scss","webpack://./../gui/node_modules/bootstrap/scss/_variables.scss","webpack://./../gui/node_modules/bootstrap/scss/vendor/_rfs.scss","webpack://./../gui/node_modules/bootstrap/scss/mixins/_hover.scss","webpack://./../gui/node_modules/bootstrap/scss/_type.scss","webpack://./../gui/node_modules/bootstrap/scss/mixins/_lists.scss","webpack://./../gui/node_modules/bootstrap/scss/_images.scss","webpack://./../gui/node_modules/bootstrap/scss/mixins/_image.scss","webpack://./../gui/node_modules/bootstrap/scss/mixins/_border-radius.scss","webpack://./../gui/node_modules/bootstrap/scss/_code.scss","webpack://./../gui/node_modules/bootstrap/scss/_grid.scss","webpack://./../gui/node_modules/bootstrap/scss/mixins/_grid.scss","webpack://./../gui/node_modules/bootstrap/scss/mixins/_breakpoints.scss","webpack://./../gui/node_modules/bootstrap/scss/mixins/_grid-framework.scss","webpack://./../gui/node_modules/bootstrap/scss/_tables.scss","webpack://./../gui/node_modules/bootstrap/scss/mixins/_table-row.scss","webpack://./../gui/node_modules/bootstrap/scss/_forms.scss","webpack://./../gui/node_modules/bootstrap/scss/mixins/_transition.scss","webpack://./../gui/node_modules/bootstrap/scss/mixins/_forms.scss","webpack://./../gui/node_modules/bootstrap/scss/mixins/_gradients.scss","webpack://./../gui/node_modules/bootstrap/scss/_buttons.scss","webpack://./../gui/node_modules/bootstrap/scss/mixins/_buttons.scss","webpack://./../gui/node_modules/bootstrap/scss/_transitions.scss","webpack://./../gui/node_modules/bootstrap/scss/_dropdown.scss","webpack://./../gui/node_modules/bootstrap/scss/mixins/_caret.scss","webpack://./../gui/node_modules/bootstrap/scss/mixins/_nav-divider.scss","webpack://./../gui/node_modules/bootstrap/scss/_button-group.scss","webpack://./../gui/node_modules/bootstrap/scss/_input-group.scss","webpack://./../gui/node_modules/bootstrap/scss/_custom-forms.scss","webpack://./../gui/node_modules/bootstrap/scss/_nav.scss","webpack://./../gui/node_modules/bootstrap/scss/_navbar.scss","webpack://./../gui/node_modules/bootstrap/scss/_card.scss","webpack://./../gui/node_modules/bootstrap/scss/_breadcrumb.scss","webpack://./../gui/node_modules/bootstrap/scss/_pagination.scss","webpack://./../gui/node_modules/bootstrap/scss/mixins/_pagination.scss","webpack://./../gui/node_modules/bootstrap/scss/_badge.scss","webpack://./../gui/node_modules/bootstrap/scss/mixins/_badge.scss","webpack://./../gui/node_modules/bootstrap/scss/_jumbotron.scss","webpack://./../gui/node_modules/bootstrap/scss/_alert.scss","webpack://./../gui/node_modules/bootstrap/scss/mixins/_alert.scss","webpack://./../gui/node_modules/bootstrap/scss/_progress.scss","webpack://./../gui/node_modules/bootstrap/scss/_media.scss","webpack://./../gui/node_modules/bootstrap/scss/_list-group.scss","webpack://./../gui/node_modules/bootstrap/scss/mixins/_list-group.scss","webpack://./../gui/node_modules/bootstrap/scss/_close.scss","webpack://./../gui/node_modules/bootstrap/scss/_toasts.scss","webpack://./../gui/node_modules/bootstrap/scss/_modal.scss","webpack://./../gui/node_modules/bootstrap/scss/_tooltip.scss","webpack://./../gui/node_modules/bootstrap/scss/mixins/_reset-text.scss","webpack://./../gui/node_modules/bootstrap/scss/_popover.scss","webpack://./../gui/node_modules/bootstrap/scss/_carousel.scss","webpack://./../gui/node_modules/bootstrap/scss/mixins/_clearfix.scss","webpack://./../gui/node_modules/bootstrap/scss/_spinners.scss","webpack://./../gui/node_modules/bootstrap/scss/utilities/_align.scss","webpack://./../gui/node_modules/bootstrap/scss/mixins/_background-variant.scss","webpack://./../gui/node_modules/bootstrap/scss/utilities/_background.scss","webpack://./../gui/node_modules/bootstrap/scss/utilities/_borders.scss","webpack://./../gui/node_modules/bootstrap/scss/utilities/_display.scss","webpack://./../gui/node_modules/bootstrap/scss/utilities/_embed.scss","webpack://./../gui/node_modules/bootstrap/scss/utilities/_flex.scss","webpack://./../gui/node_modules/bootstrap/scss/utilities/_float.scss","webpack://./../gui/node_modules/bootstrap/scss/utilities/_interactions.scss","webpack://./../gui/node_modules/bootstrap/scss/utilities/_overflow.scss","webpack://./../gui/node_modules/bootstrap/scss/utilities/_position.scss","webpack://./../gui/node_modules/bootstrap/scss/utilities/_screenreaders.scss","webpack://./../gui/node_modules/bootstrap/scss/mixins/_screen-reader.scss","webpack://./../gui/node_modules/bootstrap/scss/utilities/_shadows.scss","webpack://./../gui/node_modules/bootstrap/scss/utilities/_sizing.scss","webpack://./../gui/node_modules/bootstrap/scss/utilities/_spacing.scss","webpack://./../gui/node_modules/bootstrap/scss/utilities/_stretched-link.scss","webpack://./../gui/node_modules/bootstrap/scss/utilities/_text.scss","webpack://./../gui/node_modules/bootstrap/scss/mixins/_text-truncate.scss","webpack://./../gui/node_modules/bootstrap/scss/mixins/_text-emphasis.scss","webpack://./../gui/node_modules/bootstrap/scss/mixins/_text-hide.scss","webpack://./../gui/node_modules/bootstrap/scss/utilities/_visibility.scss","webpack://./../gui/node_modules/bootstrap/scss/_print.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;ECAA;;;;;IAAA;ADQA;AERA;EAGI,eAAA;EAAA,iBAAA;EAAA,iBAAA;EAAA,eAAA;EAAA,cAAA;EAAA,iBAAA;EAAA,iBAAA;EAAA,gBAAA;EAAA,eAAA;EAAA,eAAA;EAAA,aAAA;EAAA,eAAA;EAAA,oBAAA;EAIA,kBAAA;EAAA,oBAAA;EAAA,kBAAA;EAAA,eAAA;EAAA,kBAAA;EAAA,iBAAA;EAAA,gBAAA;EAAA,eAAA;EAIA,kBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,uBAAA;EAKF,kOAAA;EACA,6GAAA;AFqBF;AGpBA;;;EAGE,sBAAA;AHsBF;AGnBA;EACE,uBAAA;EACA,iBAAA;EACA,8BAAA;EACA,6CAAA;AHqBF;AGfA;EACE,cAAA;AHiBF;AGPA;EACE,SAAA;EACA,qNCsO4B;ECjGxB,eAAA;EFnIJ,gBC+O4B;ED9O5B,gBCmP4B;EDlP5B,cCnCS;EDoCT,gBAAA;EACA,sBC9CS;AJuDX;AGGA;EACE,qBAAA;AHDF;AGUA;EACE,uBAAA;EACA,SAAA;EACA,iBAAA;AHRF;AGqBA;EACE,aAAA;EACA,qBCiN4B;AJpO9B;AG0BA;EACE,aAAA;EACA,mBCoF0B;AJ5G5B;AGmCA;;EAEE,0BAAA;EACA,iCAAA;EACA,YAAA;EACA,gBAAA;EACA,8BAAA;AHjCF;AGoCA;EACE,mBAAA;EACA,kBAAA;EACA,oBAAA;AHlCF;AGqCA;;;EAGE,aAAA;EACA,mBAAA;AHnCF;AGsCA;;;;EAIE,gBAAA;AHpCF;AGuCA;EACE,gBCkJ4B;AJvL9B;AGwCA;EACE,qBAAA;EACA,cAAA;AHtCF;AGyCA;EACE,gBAAA;AHvCF;AG0CA;;EAEE,mBCqI4B;AJ7K9B;AG2CA;EEII,cAAA;AL5CJ;AGiDA;;EAEE,kBAAA;EEPE,cAAA;EFSF,cAAA;EACA,wBAAA;AH/CF;AGkDA;EAAM,eAAA;AH/CN;AGgDA;EAAM,WAAA;AH7CN;AGoDA;EACE,cCXwC;EDYxC,qBCXwC;EDYxC,6BAAA;AHlDF;AM9HE;EHmLE,mCCdsC;EDetC,0BCdsC;AJpC1C;AG2DA;EACE,cAAA;EACA,qBAAA;AHzDF;AMtIE;EHkME,cAAA;EACA,qBAAA;AHzDJ;AGkEA;;;;EAIE,iGC0D4B;EClH1B,cAAA;ALPJ;AGmEA;EAEE,aAAA;EAEA,mBAAA;EAEA,cAAA;EAGA,6BAAA;AHtEF;AG8EA;EAEE,gBAAA;AH7EF;AGqFA;EACE,sBAAA;EACA,kBAAA;AHnFF;AGsFA;EAGE,gBAAA;EACA,sBAAA;AHtFF;AG8FA;EACE,yBAAA;AH5FF;AG+FA;EACE,oBC8E4B;ED7E5B,uBC6E4B;ED5E5B,cCtQS;EDuQT,gBAAA;EACA,oBAAA;AH7FF;AGoGA;EAEE,mBAAA;EACA,gCAAA;AHnGF;AG2GA;EAEE,qBAAA;EACA,qBC4JsC;AJtQxC;AGgHA;EAEE,gBAAA;AH/GF;AGuHA;EACE,UAAA;AHrHF;AGwHA;;;;;EAKE,SAAA;EACA,oBAAA;EEhKE,kBAAA;EFkKF,oBAAA;AHtHF;AGyHA;;EAEE,iBAAA;AHvHF;AG0HA;;EAEE,oBAAA;AHxHF;AG8HA;EACE,eAAA;AH5HF;AGkIA;EACE,iBAAA;AHhIF;AGuIA;;;;EAIE,0BAAA;AHrIF;AG8II;;;;EACE,eAAA;AHzIN;AG+IA;;;;EAIE,UAAA;EACA,kBAAA;AH7IF;AGgJA;;EAEE,sBAAA;EACA,UAAA;AH9IF;AGkJA;EACE,cAAA;EAEA,gBAAA;AHjJF;AGoJA;EAME,YAAA;EAEA,UAAA;EACA,SAAA;EACA,SAAA;AHxJF;AG6JA;EACE,cAAA;EACA,WAAA;EACA,eAAA;EACA,UAAA;EACA,qBAAA;EE9OI,iBAAA;EFgPJ,oBAAA;EACA,cAAA;EACA,mBAAA;AH3JF;AG8JA;EACE,wBAAA;AH5JF;AGgKA;;EAEE,YAAA;AH9JF;AGiKA;EAKE,oBAAA;EACA,wBAAA;AHnKF;AG0KA;EACE,wBAAA;AHxKF;AGgLA;EACE,aAAA;EACA,0BAAA;AH9KF;AGqLA;EACE,qBAAA;AHnLF;AGsLA;EACE,kBAAA;EACA,eAAA;AHpLF;AGuLA;EACE,aAAA;AHrLF;AG0LA;EACE,wBAAA;AHxLF;AOpSA;;EAEE,qBHsS4B;EGpS5B,gBHsS4B;EGrS5B,gBHsS4B;AJD9B;AOjSA;EFqKM,iBAAA;AL+HN;AOnSA;EFoKM,eAAA;ALkIN;AOrSA;EFmKM,kBAAA;ALqIN;AOvSA;EFkKM,iBAAA;ALwIN;AOzSA;EFiKM,kBAAA;AL2IN;AO3SA;EFgKM,eAAA;AL8IN;AO5SA;EF8JM,kBAAA;EE5JJ,gBHwS4B;AJM9B;AO1SA;EFwJM,eAAA;EEtJJ,gBH2R4B;EG1R5B,gBHkR4B;AJ0B9B;AO1SA;EFmJM,iBAAA;EEjJJ,gBHuR4B;EGtR5B,gBH6Q4B;AJ+B9B;AO1SA;EF8IM,iBAAA;EE5IJ,gBHmR4B;EGlR5B,gBHwQ4B;AJoC9B;AO1SA;EFyIM,iBAAA;EEvIJ,gBH+Q4B;EG9Q5B,gBHmQ4B;AJyC9B;AOpSA;EACE,gBHgFO;EG/EP,mBH+EO;EG9EP,SAAA;EACA,wCAAA;APsSF;AO9RA;;EFkGI,kBAAA;EE/FF,gBH2N4B;AJqE9B;AO7RA;;EAEE,cHmQ4B;EGlQ5B,yBH2Q4B;AJoB9B;AOvRA;EC/EE,eAAA;EACA,gBAAA;ARyWF;AOtRA;ECpFE,eAAA;EACA,gBAAA;AR6WF;AOvRA;EACE,qBAAA;APyRF;AOvRE;EACE,oBHqP0B;AJoC9B;AO/QA;EF2DI,cAAA;EEzDF,yBAAA;APiRF;AO7QA;EACE,mBHuBO;EC6CH,kBAAA;AL4MN;AO5QA;EACE,cAAA;EF+CE,kBAAA;EE7CF,cH1GS;AJwXX;AO5QE;EACE,aAAA;AP8QJ;ASjYA;ECIE,eAAA;EAGA,YAAA;AV8XF;AS/XA;EACE,gBLqgCkC;EKpgClC,sBLRS;EKST,yBAAA;EEEE,sBAAA;EDPF,eAAA;EAGA,YAAA;AVsYF;ASxXA;EAEE,qBAAA;ATyXF;AStXA;EACE,qBAAA;EACA,cAAA;ATwXF;ASrXA;EJ8HI,cAAA;EI5HF,cL3BS;AJkZX;AY9ZA;EPmKI,gBAAA;EOjKF,cRmCQ;EQlCR,qBAAA;AZgaF;AY7ZE;EACE,cAAA;AZ+ZJ;AY1ZA;EACE,sBAAA;EPsJE,gBAAA;EOpJF,WRTS;EQUT,yBRDS;EOEP,qBAAA;AX4ZJ;AYzZE;EACE,UAAA;EP8IA,eAAA;EO5IA,gBRyQ0B;AJkJ9B;AYrZA;EACE,cAAA;EPqIE,gBAAA;EOnIF,cRjBS;AJwaX;AYpZE;EPgIE,kBAAA;EO9HA,cAAA;EACA,kBAAA;AZsZJ;AYjZA;EACE,iBRikCkC;EQhkClC,kBAAA;AZmZF;Aa3bE;;;;;;ECDA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;AdocF;AejZI;EFzCE;IACE,gBT8Le;EJ+PrB;AACF;AetZI;EFzCE;IACE,gBT8Le;EJoQrB;AACF;Ae3ZI;EFzCE;IACE,gBT8Le;EJyQrB;AACF;AehaI;EFzCE;IACE,iBT8Le;EJ8QrB;AACF;AajbE;ECnCA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;AdudF;AajbE;EACE,eAAA;EACA,cAAA;AbmbJ;AajbI;;EAEE,gBAAA;EACA,eAAA;AbmbN;AgBzeE;;;;;;EACE,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;AhBgfJ;AgB1dM;EACE,aAAA;EACA,YAAA;EACA,eAAA;AhB4dR;AchcE;EACE,cAAA;EACA,eAAA;AdkcJ;AcpcE;EACE,aAAA;EACA,cAAA;AdscJ;AcxcE;EACE,wBAAA;EACA,yBAAA;Ad0cJ;Ac5cE;EACE,aAAA;EACA,cAAA;Ad8cJ;AchdE;EACE,aAAA;EACA,cAAA;AdkdJ;AcpdE;EACE,wBAAA;EACA,yBAAA;AdsdJ;AgBzeM;EFCJ,cAAA;EACA,WAAA;EACA,eAAA;Ad2eF;AgBxeU;EFbR,qBAAA;EAIA,sBAAA;AdqfF;AgB5eU;EFbR,sBAAA;EAIA,uBAAA;AdyfF;AgBhfU;EFbR,aAAA;EAIA,cAAA;Ad6fF;AgBpfU;EFbR,sBAAA;EAIA,uBAAA;AdigBF;AgBxfU;EFbR,sBAAA;EAIA,uBAAA;AdqgBF;AgB5fU;EFbR,aAAA;EAIA,cAAA;AdygBF;AgBhgBU;EFbR,sBAAA;EAIA,uBAAA;Ad6gBF;AgBpgBU;EFbR,sBAAA;EAIA,uBAAA;AdihBF;AgBxgBU;EFbR,aAAA;EAIA,cAAA;AdqhBF;AgB5gBU;EFbR,sBAAA;EAIA,uBAAA;AdyhBF;AgBhhBU;EFbR,sBAAA;EAIA,uBAAA;Ad6hBF;AgBphBU;EFbR,cAAA;EAIA,eAAA;AdiiBF;AgBlhBM;EAAwB,SAAA;AhBqhB9B;AgBnhBM;EAAuB,SAAA;AhBshB7B;AgBnhBQ;EAAwB,QADb;AhBuhBnB;AgBthBQ;EAAwB,QADb;AhB0hBnB;AgBzhBQ;EAAwB,QADb;AhB6hBnB;AgB5hBQ;EAAwB,QADb;AhBgiBnB;AgB/hBQ;EAAwB,QADb;AhBmiBnB;AgBliBQ;EAAwB,QADb;AhBsiBnB;AgBriBQ;EAAwB,QADb;AhByiBnB;AgBxiBQ;EAAwB,QADb;AhB4iBnB;AgB3iBQ;EAAwB,QADb;AhB+iBnB;AgB9iBQ;EAAwB,QADb;AhBkjBnB;AgBjjBQ;EAAwB,SADb;AhBqjBnB;AgBpjBQ;EAAwB,SADb;AhBwjBnB;AgBvjBQ;EAAwB,SADb;AhB2jBnB;AgBnjBY;EFhBV,wBAAA;AdskBF;AgBtjBY;EFhBV,yBAAA;AdykBF;AgBzjBY;EFhBV,gBAAA;Ad4kBF;AgB5jBY;EFhBV,yBAAA;Ad+kBF;AgB/jBY;EFhBV,yBAAA;AdklBF;AgBlkBY;EFhBV,gBAAA;AdqlBF;AgBrkBY;EFhBV,yBAAA;AdwlBF;AgBxkBY;EFhBV,yBAAA;Ad2lBF;AgB3kBY;EFhBV,gBAAA;Ad8lBF;AgB9kBY;EFhBV,yBAAA;AdimBF;AgBjlBY;EFhBV,yBAAA;AdomBF;Ae/lBI;EC3BE;IACE,aAAA;IACA,YAAA;IACA,eAAA;EhB6nBN;EcjmBA;IACE,cAAA;IACA,eAAA;EdmmBF;EcrmBA;IACE,aAAA;IACA,cAAA;EdumBF;EczmBA;IACE,wBAAA;IACA,yBAAA;Ed2mBF;Ec7mBA;IACE,aAAA;IACA,cAAA;Ed+mBF;EcjnBA;IACE,aAAA;IACA,cAAA;EdmnBF;EcrnBA;IACE,wBAAA;IACA,yBAAA;EdunBF;EgB1oBI;IFCJ,cAAA;IACA,WAAA;IACA,eAAA;Ed4oBA;EgBzoBQ;IFbR,qBAAA;IAIA,sBAAA;EdspBA;EgB7oBQ;IFbR,sBAAA;IAIA,uBAAA;Ed0pBA;EgBjpBQ;IFbR,aAAA;IAIA,cAAA;Ed8pBA;EgBrpBQ;IFbR,sBAAA;IAIA,uBAAA;EdkqBA;EgBzpBQ;IFbR,sBAAA;IAIA,uBAAA;EdsqBA;EgB7pBQ;IFbR,aAAA;IAIA,cAAA;Ed0qBA;EgBjqBQ;IFbR,sBAAA;IAIA,uBAAA;Ed8qBA;EgBrqBQ;IFbR,sBAAA;IAIA,uBAAA;EdkrBA;EgBzqBQ;IFbR,aAAA;IAIA,cAAA;EdsrBA;EgB7qBQ;IFbR,sBAAA;IAIA,uBAAA;Ed0rBA;EgBjrBQ;IFbR,sBAAA;IAIA,uBAAA;Ed8rBA;EgBrrBQ;IFbR,cAAA;IAIA,eAAA;EdksBA;EgBnrBI;IAAwB,SAAA;EhBsrB5B;EgBprBI;IAAuB,SAAA;EhBurB3B;EgBprBM;IAAwB,QADb;EhBwrBjB;EgBvrBM;IAAwB,QADb;EhB2rBjB;EgB1rBM;IAAwB,QADb;EhB8rBjB;EgB7rBM;IAAwB,QADb;EhBisBjB;EgBhsBM;IAAwB,QADb;EhBosBjB;EgBnsBM;IAAwB,QADb;EhBusBjB;EgBtsBM;IAAwB,QADb;EhB0sBjB;EgBzsBM;IAAwB,QADb;EhB6sBjB;EgB5sBM;IAAwB,QADb;EhBgtBjB;EgB/sBM;IAAwB,QADb;EhBmtBjB;EgBltBM;IAAwB,SADb;EhBstBjB;EgBrtBM;IAAwB,SADb;EhBytBjB;EgBxtBM;IAAwB,SADb;EhB4tBjB;EgBptBU;IFhBV,cAAA;EduuBA;EgBvtBU;IFhBV,wBAAA;Ed0uBA;EgB1tBU;IFhBV,yBAAA;Ed6uBA;EgB7tBU;IFhBV,gBAAA;EdgvBA;EgBhuBU;IFhBV,yBAAA;EdmvBA;EgBnuBU;IFhBV,yBAAA;EdsvBA;EgBtuBU;IFhBV,gBAAA;EdyvBA;EgBzuBU;IFhBV,yBAAA;Ed4vBA;EgB5uBU;IFhBV,yBAAA;Ed+vBA;EgB/uBU;IFhBV,gBAAA;EdkwBA;EgBlvBU;IFhBV,yBAAA;EdqwBA;EgBrvBU;IFhBV,yBAAA;EdwwBA;AACF;AepwBI;EC3BE;IACE,aAAA;IACA,YAAA;IACA,eAAA;EhBkyBN;EctwBA;IACE,cAAA;IACA,eAAA;EdwwBF;Ec1wBA;IACE,aAAA;IACA,cAAA;Ed4wBF;Ec9wBA;IACE,wBAAA;IACA,yBAAA;EdgxBF;EclxBA;IACE,aAAA;IACA,cAAA;EdoxBF;EctxBA;IACE,aAAA;IACA,cAAA;EdwxBF;Ec1xBA;IACE,wBAAA;IACA,yBAAA;Ed4xBF;EgB/yBI;IFCJ,cAAA;IACA,WAAA;IACA,eAAA;EdizBA;EgB9yBQ;IFbR,qBAAA;IAIA,sBAAA;Ed2zBA;EgBlzBQ;IFbR,sBAAA;IAIA,uBAAA;Ed+zBA;EgBtzBQ;IFbR,aAAA;IAIA,cAAA;Edm0BA;EgB1zBQ;IFbR,sBAAA;IAIA,uBAAA;Edu0BA;EgB9zBQ;IFbR,sBAAA;IAIA,uBAAA;Ed20BA;EgBl0BQ;IFbR,aAAA;IAIA,cAAA;Ed+0BA;EgBt0BQ;IFbR,sBAAA;IAIA,uBAAA;Edm1BA;EgB10BQ;IFbR,sBAAA;IAIA,uBAAA;Edu1BA;EgB90BQ;IFbR,aAAA;IAIA,cAAA;Ed21BA;EgBl1BQ;IFbR,sBAAA;IAIA,uBAAA;Ed+1BA;EgBt1BQ;IFbR,sBAAA;IAIA,uBAAA;Edm2BA;EgB11BQ;IFbR,cAAA;IAIA,eAAA;Edu2BA;EgBx1BI;IAAwB,SAAA;EhB21B5B;EgBz1BI;IAAuB,SAAA;EhB41B3B;EgBz1BM;IAAwB,QADb;EhB61BjB;EgB51BM;IAAwB,QADb;EhBg2BjB;EgB/1BM;IAAwB,QADb;EhBm2BjB;EgBl2BM;IAAwB,QADb;EhBs2BjB;EgBr2BM;IAAwB,QADb;EhBy2BjB;EgBx2BM;IAAwB,QADb;EhB42BjB;EgB32BM;IAAwB,QADb;EhB+2BjB;EgB92BM;IAAwB,QADb;EhBk3BjB;EgBj3BM;IAAwB,QADb;EhBq3BjB;EgBp3BM;IAAwB,QADb;EhBw3BjB;EgBv3BM;IAAwB,SADb;EhB23BjB;EgB13BM;IAAwB,SADb;EhB83BjB;EgB73BM;IAAwB,SADb;EhBi4BjB;EgBz3BU;IFhBV,cAAA;Ed44BA;EgB53BU;IFhBV,wBAAA;Ed+4BA;EgB/3BU;IFhBV,yBAAA;Edk5BA;EgBl4BU;IFhBV,gBAAA;Edq5BA;EgBr4BU;IFhBV,yBAAA;Edw5BA;EgBx4BU;IFhBV,yBAAA;Ed25BA;EgB34BU;IFhBV,gBAAA;Ed85BA;EgB94BU;IFhBV,yBAAA;Edi6BA;EgBj5BU;IFhBV,yBAAA;Edo6BA;EgBp5BU;IFhBV,gBAAA;Edu6BA;EgBv5BU;IFhBV,yBAAA;Ed06BA;EgB15BU;IFhBV,yBAAA;Ed66BA;AACF;Aez6BI;EC3BE;IACE,aAAA;IACA,YAAA;IACA,eAAA;EhBu8BN;Ec36BA;IACE,cAAA;IACA,eAAA;Ed66BF;Ec/6BA;IACE,aAAA;IACA,cAAA;Edi7BF;Ecn7BA;IACE,wBAAA;IACA,yBAAA;Edq7BF;Ecv7BA;IACE,aAAA;IACA,cAAA;Edy7BF;Ec37BA;IACE,aAAA;IACA,cAAA;Ed67BF;Ec/7BA;IACE,wBAAA;IACA,yBAAA;Edi8BF;EgBp9BI;IFCJ,cAAA;IACA,WAAA;IACA,eAAA;Eds9BA;EgBn9BQ;IFbR,qBAAA;IAIA,sBAAA;Edg+BA;EgBv9BQ;IFbR,sBAAA;IAIA,uBAAA;Edo+BA;EgB39BQ;IFbR,aAAA;IAIA,cAAA;Edw+BA;EgB/9BQ;IFbR,sBAAA;IAIA,uBAAA;Ed4+BA;EgBn+BQ;IFbR,sBAAA;IAIA,uBAAA;Edg/BA;EgBv+BQ;IFbR,aAAA;IAIA,cAAA;Edo/BA;EgB3+BQ;IFbR,sBAAA;IAIA,uBAAA;Edw/BA;EgB/+BQ;IFbR,sBAAA;IAIA,uBAAA;Ed4/BA;EgBn/BQ;IFbR,aAAA;IAIA,cAAA;EdggCA;EgBv/BQ;IFbR,sBAAA;IAIA,uBAAA;EdogCA;EgB3/BQ;IFbR,sBAAA;IAIA,uBAAA;EdwgCA;EgB//BQ;IFbR,cAAA;IAIA,eAAA;Ed4gCA;EgB7/BI;IAAwB,SAAA;EhBggC5B;EgB9/BI;IAAuB,SAAA;EhBigC3B;EgB9/BM;IAAwB,QADb;EhBkgCjB;EgBjgCM;IAAwB,QADb;EhBqgCjB;EgBpgCM;IAAwB,QADb;EhBwgCjB;EgBvgCM;IAAwB,QADb;EhB2gCjB;EgB1gCM;IAAwB,QADb;EhB8gCjB;EgB7gCM;IAAwB,QADb;EhBihCjB;EgBhhCM;IAAwB,QADb;EhBohCjB;EgBnhCM;IAAwB,QADb;EhBuhCjB;EgBthCM;IAAwB,QADb;EhB0hCjB;EgBzhCM;IAAwB,QADb;EhB6hCjB;EgB5hCM;IAAwB,SADb;EhBgiCjB;EgB/hCM;IAAwB,SADb;EhBmiCjB;EgBliCM;IAAwB,SADb;EhBsiCjB;EgB9hCU;IFhBV,cAAA;EdijCA;EgBjiCU;IFhBV,wBAAA;EdojCA;EgBpiCU;IFhBV,yBAAA;EdujCA;EgBviCU;IFhBV,gBAAA;Ed0jCA;EgB1iCU;IFhBV,yBAAA;Ed6jCA;EgB7iCU;IFhBV,yBAAA;EdgkCA;EgBhjCU;IFhBV,gBAAA;EdmkCA;EgBnjCU;IFhBV,yBAAA;EdskCA;EgBtjCU;IFhBV,yBAAA;EdykCA;EgBzjCU;IFhBV,gBAAA;Ed4kCA;EgB5jCU;IFhBV,yBAAA;Ed+kCA;EgB/jCU;IFhBV,yBAAA;EdklCA;AACF;Ae9kCI;EC3BE;IACE,aAAA;IACA,YAAA;IACA,eAAA;EhB4mCN;EchlCA;IACE,cAAA;IACA,eAAA;EdklCF;EcplCA;IACE,aAAA;IACA,cAAA;EdslCF;EcxlCA;IACE,wBAAA;IACA,yBAAA;Ed0lCF;Ec5lCA;IACE,aAAA;IACA,cAAA;Ed8lCF;EchmCA;IACE,aAAA;IACA,cAAA;EdkmCF;EcpmCA;IACE,wBAAA;IACA,yBAAA;EdsmCF;EgBznCI;IFCJ,cAAA;IACA,WAAA;IACA,eAAA;Ed2nCA;EgBxnCQ;IFbR,qBAAA;IAIA,sBAAA;EdqoCA;EgB5nCQ;IFbR,sBAAA;IAIA,uBAAA;EdyoCA;EgBhoCQ;IFbR,aAAA;IAIA,cAAA;Ed6oCA;EgBpoCQ;IFbR,sBAAA;IAIA,uBAAA;EdipCA;EgBxoCQ;IFbR,sBAAA;IAIA,uBAAA;EdqpCA;EgB5oCQ;IFbR,aAAA;IAIA,cAAA;EdypCA;EgBhpCQ;IFbR,sBAAA;IAIA,uBAAA;Ed6pCA;EgBppCQ;IFbR,sBAAA;IAIA,uBAAA;EdiqCA;EgBxpCQ;IFbR,aAAA;IAIA,cAAA;EdqqCA;EgB5pCQ;IFbR,sBAAA;IAIA,uBAAA;EdyqCA;EgBhqCQ;IFbR,sBAAA;IAIA,uBAAA;Ed6qCA;EgBpqCQ;IFbR,cAAA;IAIA,eAAA;EdirCA;EgBlqCI;IAAwB,SAAA;EhBqqC5B;EgBnqCI;IAAuB,SAAA;EhBsqC3B;EgBnqCM;IAAwB,QADb;EhBuqCjB;EgBtqCM;IAAwB,QADb;EhB0qCjB;EgBzqCM;IAAwB,QADb;EhB6qCjB;EgB5qCM;IAAwB,QADb;EhBgrCjB;EgB/qCM;IAAwB,QADb;EhBmrCjB;EgBlrCM;IAAwB,QADb;EhBsrCjB;EgBrrCM;IAAwB,QADb;EhByrCjB;EgBxrCM;IAAwB,QADb;EhB4rCjB;EgB3rCM;IAAwB,QADb;EhB+rCjB;EgB9rCM;IAAwB,QADb;EhBksCjB;EgBjsCM;IAAwB,SADb;EhBqsCjB;EgBpsCM;IAAwB,SADb;EhBwsCjB;EgBvsCM;IAAwB,SADb;EhB2sCjB;EgBnsCU;IFhBV,cAAA;EdstCA;EgBtsCU;IFhBV,wBAAA;EdytCA;EgBzsCU;IFhBV,yBAAA;Ed4tCA;EgB5sCU;IFhBV,gBAAA;Ed+tCA;EgB/sCU;IFhBV,yBAAA;EdkuCA;EgBltCU;IFhBV,yBAAA;EdquCA;EgBrtCU;IFhBV,gBAAA;EdwuCA;EgBxtCU;IFhBV,yBAAA;Ed2uCA;EgB3tCU;IFhBV,yBAAA;Ed8uCA;EgB9tCU;IFhBV,gBAAA;EdivCA;EgBjuCU;IFhBV,yBAAA;EdovCA;EgBpuCU;IFhBV,yBAAA;EduvCA;AACF;AiB3yCA;EACE,WAAA;EACA,mBbiIO;EahIP,cbSS;AJoyCX;AiB1yCE;;EAEE,gBbmV0B;EalV1B,mBAAA;EACA,6BAAA;AjB4yCJ;AiBzyCE;EACE,sBAAA;EACA,gCAAA;AjB2yCJ;AiBxyCE;EACE,6BAAA;AjB0yCJ;AiBhyCE;;EAEE,eb6T0B;AJq+B9B;AiBzxCA;EACE,yBAAA;AjB2xCF;AiBzxCE;;EAEE,yBAAA;AjB2xCJ;AiBvxCI;;EAEE,wBAAA;AjByxCN;AiBnxCE;;;;EAIE,SAAA;AjBqxCJ;AiB5wCE;EACE,qCbyR0B;AJq/B9B;AM70CE;EW2EI,cbvEK;EawEL,sCb8QwB;AJu/B9B;AkBv1CI;;;EAGE,gDD2F+B;AjB8vCrC;AkBr1CM;;;;EAIE,4CDmFyE;AjBowCjF;AM51CE;EYiBM,gDAJe;AlBk1CvB;AkB50CQ;;EAEE,gDARa;AlBs1CvB;AkBz2CI;;;EAGE,qED2F+B;AjBgxCrC;AkBv2CM;;;;EAIE,iEDmFyE;AjBsxCjF;AM92CE;EYiBM,oEAJe;AlBo2CvB;AkB91CQ;;EAEE,oEARa;AlBw2CvB;AkB33CI;;;EAGE,oED2F+B;AjBkyCrC;AkBz3CM;;;;EAIE,iEDmFyE;AjBwyCjF;AMh4CE;EYiBM,qEAJe;AlBs3CvB;AkBh3CQ;;EAEE,qEARa;AlB03CvB;AkB74CI;;;EAGE,qED2F+B;AjBozCrC;AkB34CM;;;;EAIE,iEDmFyE;AjB0zCjF;AMl5CE;EYiBM,qEAJe;AlBw4CvB;AkBl4CQ;;EAEE,qEARa;AlB44CvB;AkB/5CI;;;EAGE,0DD2F+B;AjBs0CrC;AkB75CM;;;;EAIE,uDDmFyE;AjB40CjF;AMp6CE;EYiBM,0DAJe;AlB05CvB;AkBp5CQ;;EAEE,0DARa;AlB85CvB;AkBj7CI;;;EAGE,qED2F+B;AjBw1CrC;AkB/6CM;;;;EAIE,gEDmFyE;AjB81CjF;AMt7CE;EYiBM,qEAJe;AlB46CvB;AkBt6CQ;;EAEE,qEARa;AlBg7CvB;AkBn8CI;;;EAGE,oED2F+B;AjB02CrC;AkBj8CM;;;;EAIE,iEDmFyE;AjBg3CjF;AMx8CE;EYiBM,qEAJe;AlB87CvB;AkBx7CQ;;EAEE,qEARa;AlBk8CvB;AkBr9CI;;;EAGE,oED2F+B;AjB43CrC;AkBn9CM;;;;EAIE,iEDmFyE;AjBk4CjF;AM19CE;EYiBM,oEAJe;AlBg9CvB;AkB18CQ;;EAEE,oEARa;AlBo9CvB;AkBv+CI;;;EAGE,sCd6VwB;AJ4oC9B;AMt+CE;EYiBM,sCAJe;AlB49CvB;AkBt9CQ;;EAEE,sCARa;AlBg+CvB;AiBx4CI;EACE,Wb3GK;Ea4GL,yBbpGK;EaqGL,iEbiQwB;AJyoC9B;AiBr4CI;EACE,cb5GK;Ea6GL,yBblHK;EamHL,qBblHK;AJy/CX;AiBl4CA;EACE,Wb3HS;Ea4HT,yBbpHS;AJw/CX;AiBl4CE;;;EAGE,iEb6O0B;AJupC9B;AiBj4CE;EACE,SAAA;AjBm4CJ;AiB/3CI;EACE,2CbiOwB;AJgqC9B;AMtgDE;EW4IM,WbjJG;EakJH,4Cb2NsB;AJkqC9B;Ae78CI;EEiGA;IAEI,cAAA;IACA,WAAA;IACA,gBAAA;IACA,iCAAA;EjB82CN;EiB32CM;IACE,SAAA;EjB62CR;AACF;Aex9CI;EEiGA;IAEI,cAAA;IACA,WAAA;IACA,gBAAA;IACA,iCAAA;EjBy3CN;EiBt3CM;IACE,SAAA;EjBw3CR;AACF;Aen+CI;EEiGA;IAEI,cAAA;IACA,WAAA;IACA,gBAAA;IACA,iCAAA;EjBo4CN;EiBj4CM;IACE,SAAA;EjBm4CR;AACF;Ae9+CI;EEiGA;IAEI,cAAA;IACA,WAAA;IACA,gBAAA;IACA,iCAAA;EjB+4CN;EiB54CM;IACE,SAAA;EjB84CR;AACF;AiBx5CI;EAEI,cAAA;EACA,WAAA;EACA,gBAAA;EACA,iCAAA;AjBy5CR;AiBt5CQ;EACE,SAAA;AjBw5CV;AmBrkDA;EACE,cAAA;EACA,WAAA;EACA,mCf2esC;Ee1etC,yBAAA;Ed0KI,eAAA;EcvKJ,gBfmR4B;EelR5B,gBfuR4B;EetR5B,cfDS;EeET,sBfTS;EeUT,4BAAA;EACA,yBAAA;ERAE,sBAAA;ESFE,wEDQJ;AnBkkDF;AoBtkDM;EDdN;ICeQ,gBAAA;EpBykDN;AACF;AmBpkDE;EACE,6BAAA;EACA,SAAA;AnBskDJ;AqBtlDE;EACE,cAAA;EACA,sBjBRO;EiBSP,4CjBsdoC;EiBrdpC,UAAA;EAKE,gDjBqXwB;AJ+tC9B;AmBtkDE;EACE,cfxBO;Ee0BP,UAAA;AnBukDJ;AmB/jDE;EAEE,yBfxCO;Ee0CP,UAAA;AnB+jDJ;AmBvjDE;;;;EACE,gBAAA;AnB4jDJ;AmBtjDE;EACE,kBAAA;EACA,0BAAA;AnBwjDJ;AmBrjDE;EAME,cf/DO;EegEP,sBfvEO;AJynDX;AmB7iDA;;EAEE,cAAA;EACA,WAAA;AnB+iDF;AmBriDA;EACE,iCAAA;EACA,oCAAA;EACA,gBAAA;EdiEE,kBAAA;Ec/DF,gBfgM4B;AJu2C9B;AmBpiDA;EACE,+BAAA;EACA,kCAAA;Ed0EI,kBAAA;EcxEJ,gBf6H4B;AJy6C9B;AmBniDA;EACE,gCAAA;EACA,mCAAA;EdmEI,mBAAA;EcjEJ,gBfuH4B;AJ86C9B;AmB5hDA;EACE,cAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EdoDI,eAAA;EclDJ,gBfmK4B;EelK5B,cfnHS;EeoHT,6BAAA;EACA,yBAAA;EACA,mBAAA;AnB8hDF;AmB5hDE;EAEE,gBAAA;EACA,eAAA;AnB6hDJ;AmBjhDA;EACE,kCf6VsC;Ee5VtC,uBAAA;Ed2BI,mBAAA;EczBJ,gBf+E4B;EOxN1B,qBAAA;AX6pDJ;AmBhhDA;EACE,gCfsVsC;EerVtC,oBAAA;EdmBI,kBAAA;EcjBJ,gBfsE4B;EOvN1B,qBAAA;AXoqDJ;AmB7gDE;EAEE,YAAA;AnB8gDJ;AmB1gDA;EACE,YAAA;AnB4gDF;AmBpgDA;EACE,mBf2UsC;AJ2rCxC;AmBngDA;EACE,cAAA;EACA,mBf4TsC;AJysCxC;AmB7/CA;EACE,aAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;AnB+/CF;AmB7/CE;;EAEE,kBAAA;EACA,iBAAA;AnB+/CJ;AmBt/CA;EACE,kBAAA;EACA,cAAA;EACA,qBfiSsC;AJutCxC;AmBr/CA;EACE,kBAAA;EACA,kBf6RsC;Ee5RtC,qBAAA;AnBu/CF;AmBp/CE;EAEE,cfzNO;AJ8sDX;AmBj/CA;EACE,gBAAA;AnBm/CF;AmBh/CA;EACE,oBAAA;EACA,mBAAA;EACA,eAAA;EACA,qBf8QsC;AJouCxC;AmB/+CE;EACE,gBAAA;EACA,aAAA;EACA,uBfyQoC;EexQpC,cAAA;AnBi/CJ;AqB9rDE;EACE,aAAA;EACA,WAAA;EACA,mBjB2coC;ECtVpC,kBAAA;EgBnHA,cFqNqC;AnB2+CzC;AqB7rDE;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;EhBwHE,mBAAA;EgBtHF,gBjBuO0B;EiBtO1B,WAAA;EACA,wCAAA;EV9CA,sBAAA;AX8uDJ;AqB3rDI;EAEE,SAAA;ArB4rDN;AqBvrDI;;;EAEE,cAAA;ArB0rDN;AqBxuDI;EAoDE,qBFkLmC;EE/KjC,+CAAA;EACA,yDAAA;EACA,4BAAA;EACA,2DAAA;EACA,gEAAA;ArBqrDR;AqBlrDM;EACE,qBFuKiC;EEtKjC,gDAAA;ArBorDR;AqBpvDI;EAyEI,8BAAA;EACA,wCAAA;ArB8qDR;AqBxvDI;EAmFI,oCjB6XgC;EiB5XhC,kFAAA;ArBwqDR;AqB5vDI;EA2FE,qBF2ImC;EExIjC,kDAAA;EACA,wNAAA;ArBkqDR;AqB/pDM;EACE,qBFmIiC;EElIjC,gDAAA;ArBiqDR;AqB1pDM;EACE,cF0HiC;AnBkiDzC;AqBzpDM;;;EAEE,cAAA;ArB4pDR;AqBrpDM;EACE,cF6GiC;AnB0iDzC;AqBrpDQ;EACE,qBF0G+B;AnB6iDzC;AqBlpDQ;EACE,iEAAA;EC5JN,qED6J2B;ArBopD/B;AqB/oDQ;EACE,gDAAA;ArBipDV;AqB9oDQ;EACE,qBFyF+B;AnBujDzC;AqBvoDM;EACE,qBF+EiC;AnB0jDzC;AqBroDQ;EACE,qBF0E+B;EEzE/B,gDAAA;ArBuoDV;AqBxxDE;EACE,aAAA;EACA,WAAA;EACA,mBjB2coC;ECtVpC,kBAAA;EgBnHA,cFqNqC;AnBqkDzC;AqBvxDE;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;EhBwHE,mBAAA;EgBtHF,gBjBuO0B;EiBtO1B,WAAA;EACA,wCAAA;EV9CA,sBAAA;AXw0DJ;AqBrxDI;EAEE,SAAA;ArBsxDN;AqBjxDI;;;EAEE,cAAA;ArBoxDN;AqBl0DI;EAoDE,qBFkLmC;EE/KjC,+CAAA;EACA,yDAAA;EACA,4BAAA;EACA,2DAAA;EACA,gEAAA;ArB+wDR;AqB5wDM;EACE,qBFuKiC;EEtKjC,gDAAA;ArB8wDR;AqB90DI;EAyEI,8BAAA;EACA,wCAAA;ArBwwDR;AqBl1DI;EAmFI,oCjB6XgC;EiB5XhC,kFAAA;ArBkwDR;AqBt1DI;EA2FE,qBF2ImC;EExIjC,kDAAA;EACA,wNAAA;ArB4vDR;AqBzvDM;EACE,qBFmIiC;EElIjC,gDAAA;ArB2vDR;AqBpvDM;EACE,cF0HiC;AnB4nDzC;AqBnvDM;;;EAEE,cAAA;ArBsvDR;AqB/uDM;EACE,cF6GiC;AnBooDzC;AqB/uDQ;EACE,qBF0G+B;AnBuoDzC;AqB5uDQ;EACE,iEAAA;EC5JN,qED6J2B;ArB8uD/B;AqBzuDQ;EACE,gDAAA;ArB2uDV;AqBxuDQ;EACE,qBFyF+B;AnBipDzC;AqBjuDM;EACE,qBF+EiC;AnBopDzC;AqB/tDQ;EACE,qBF0E+B;EEzE/B,gDAAA;ArBiuDV;AmB5oDA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AnB8oDF;AmBzoDE;EACE,WAAA;AnB2oDJ;Ae12DI;EIoOA;IACE,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,gBAAA;EnByoDJ;EmBroDE;IACE,aAAA;IACA,cAAA;IACA,mBAAA;IACA,mBAAA;IACA,gBAAA;EnBuoDJ;EmBnoDE;IACE,qBAAA;IACA,WAAA;IACA,sBAAA;EnBqoDJ;EmBjoDE;IACE,qBAAA;EnBmoDJ;EmBhoDE;;IAEE,WAAA;EnBkoDJ;EmB7nDE;IACE,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,WAAA;IACA,eAAA;EnB+nDJ;EmB7nDE;IACE,kBAAA;IACA,cAAA;IACA,aAAA;IACA,qBfgLkC;Ie/KlC,cAAA;EnB+nDJ;EmB5nDE;IACE,mBAAA;IACA,uBAAA;EnB8nDJ;EmB5nDE;IACE,gBAAA;EnB8nDJ;AACF;AuBh9DA;EACE,qBAAA;EAEA,gBnBuR4B;EmBtR5B,cnBMS;EmBLT,kBAAA;EAGA,sBAAA;EACA,iBAAA;EACA,6BAAA;EACA,6BAAA;ECuFA,yBAAA;EnB4EI,eAAA;EmB1EJ,gBpB2L4B;EOnR1B,sBAAA;ESFE,qIGGJ;AvBk9DF;AoBj9DM;EGdN;IHeQ,gBAAA;EpBo9DN;AACF;AM99DE;EiBUE,cnBNO;EmBOP,qBAAA;AvBu9DJ;AuBp9DE;EAEE,UAAA;EACA,gDnB8W0B;AJumD9B;AuBj9DE;EAEE,anBkZ0B;AJgkD9B;AuB98DE;EACE,eAAA;AvBg9DJ;AuBl8DA;;EAEE,oBAAA;AvBo8DF;AuB37DE;EC3DA,WAAA;EFAE,yBlBsEW;EoBpEb,qBpBoEa;AJq7Df;AMr/DE;EkBAE,WAAA;EFNA,mCED2D;EAS3D,0CATqG;AxBigEzG;AwBr/DE;EAEE,WAAA;EFbA,mCED2D;EAgB3D,0CAhBqG;EAqBnG,kDAAA;AxBk/DN;AwB7+DE;EAEE,WAAA;EACA,yBpB0CW;EoBzCX,qBpByCW;AJq8Df;AwBv+DE;EAGE,WAAA;EACA,8CAzC+I;EA6C/I,0CA7CyL;AxBihE7L;AwBl+DI;EAKI,kDAAA;AxBg+DR;AuBx9DE;EC3DA,WAAA;EFAE,yBlBsEW;EoBpEb,qBpBoEa;AJk9Df;AMlhEE;EkBAE,WAAA;EFNA,kEED2D;EAS3D,iEATqG;AxB8hEzG;AwBlhEE;EAEE,WAAA;EFbA,kEED2D;EAgB3D,iEAhBqG;EAqBnG,4DAAA;AxB+gEN;AwB1gEE;EAEE,WAAA;EACA,yBpB0CW;EoBzCX,qBpByCW;AJk+Df;AwBpgEE;EAGE,WAAA;EACA,qEAzC+I;EA6C/I,iEA7CyL;AxB8iE7L;AwB//DI;EAKI,4DAAA;AxB6/DR;AuBr/DE;EC3DA,WAAA;EFAE,yBlBsEW;EoBpEb,qBpBoEa;AJ++Df;AM/iEE;EkBAE,WAAA;EFNA,qEED2D;EAS3D,iEATqG;AxB2jEzG;AwB/iEE;EAEE,WAAA;EFbA,qEED2D;EAgB3D,iEAhBqG;EAqBnG,uEAAA;AxB4iEN;AwBviEE;EAEE,WAAA;EACA,yBpB0CW;EoBzCX,qBpByCW;AJ+/Df;AwBjiEE;EAGE,WAAA;EACA,qEAzC+I;EA6C/I,iEA7CyL;AxB2kE7L;AwB5hEI;EAKI,uEAAA;AxB0hER;AuBlhEE;EC3DA,WAAA;EFAE,yBlBsEW;EoBpEb,qBpBoEa;AJ4gEf;AM5kEE;EkBAE,WAAA;EFNA,oEED2D;EAS3D,gEATqG;AxBwlEzG;AwB5kEE;EAEE,WAAA;EFbA,oEED2D;EAgB3D,gEAhBqG;EAqBnG,uEAAA;AxBykEN;AwBpkEE;EAEE,WAAA;EACA,yBpB0CW;EoBzCX,qBpByCW;AJ4hEf;AwB9jEE;EAGE,WAAA;EACA,oEAzC+I;EA6C/I,gEA7CyL;AxBwmE7L;AwBzjEI;EAKI,uEAAA;AxBujER;AuB/iEE;EC3DA,cAAA;EFAE,yBlBsEW;EoBpEb,qBpBoEa;AJyiEf;AMzmEE;EkBAE,cAAA;EFNA,yDED2D;EAS3D,qDATqG;AxBqnEzG;AwBzmEE;EAEE,cAAA;EFbA,yDED2D;EAgB3D,qDAhBqG;EAqBnG,iFAAA;AxBsmEN;AwBjmEE;EAEE,cAAA;EACA,yBpB0CW;EoBzCX,qBpByCW;AJyjEf;AwB3lEE;EAGE,cAAA;EACA,yDAzC+I;EA6C/I,qDA7CyL;AxBqoE7L;AwBtlEI;EAKI,iFAAA;AxBolER;AuB5kEE;EC3DA,WAAA;EFAE,yBlBsEW;EoBpEb,qBpBoEa;AJskEf;AMtoEE;EkBAE,WAAA;EFNA,mEED2D;EAS3D,iEATqG;AxBkpEzG;AwBtoEE;EAEE,WAAA;EFbA,mEED2D;EAgB3D,iEAhBqG;EAqBnG,uEAAA;AxBmoEN;AwB9nEE;EAEE,WAAA;EACA,yBpB0CW;EoBzCX,qBpByCW;AJslEf;AwBxnEE;EAGE,WAAA;EACA,qEAzC+I;EA6C/I,gEA7CyL;AxBkqE7L;AwBnnEI;EAKI,uEAAA;AxBinER;AuBzmEE;EC3DA,cAAA;EFAE,yBlBsEW;EoBpEb,qBpBoEa;AJmmEf;AMnqEE;EkBAE,cAAA;EFNA,qEED2D;EAS3D,iEATqG;AxB+qEzG;AwBnqEE;EAEE,cAAA;EFbA,qEED2D;EAgB3D,iEAhBqG;EAqBnG,kFAAA;AxBgqEN;AwB3pEE;EAEE,cAAA;EACA,yBpB0CW;EoBzCX,qBpByCW;AJmnEf;AwBrpEE;EAGE,cAAA;EACA,qEAzC+I;EA6C/I,iEA7CyL;AxB+rE7L;AwBhpEI;EAKI,kFAAA;AxB8oER;AuBtoEE;EC3DA,WAAA;EFAE,yBlBsEW;EoBpEb,qBpBoEa;AJgoEf;AMhsEE;EkBAE,WAAA;EFNA,qEED2D;EAS3D,iEATqG;AxB4sEzG;AwBhsEE;EAEE,WAAA;EFbA,qEED2D;EAgB3D,iEAhBqG;EAqBnG,kFAAA;AxB6rEN;AwBxrEE;EAEE,WAAA;EACA,yBpB0CW;EoBzCX,qBpByCW;AJgpEf;AwBlrEE;EAGE,WAAA;EACA,qEAzC+I;EA6C/I,+DA7CyL;AxB4tE7L;AwB7qEI;EAKI,kFAAA;AxB2qER;AuB7pEE;ECPA,cpBYa;EoBXb,qBpBWa;AJ4pEf;AM5tEE;EkBwDE,WALgD;EAMhD,yBpBOW;EoBNX,qBpBMW;AJiqEf;AwBpqEE;EAEE,+CAAA;AxBqqEJ;AwBlqEE;EAEE,cpBJW;EoBKX,6BAAA;AxBmqEJ;AwBhqEE;EAGE,WAAA;EACA,yBpBZW;EoBaX,qBpBbW;AJ6qEf;AwB9pEI;EAKI,+CAAA;AxB4pER;AuBrrEE;ECPA,cpBYa;EoBXb,qBpBWa;AJorEf;AMpvEE;EkBwDE,WALgD;EAMhD,yBpBOW;EoBNX,qBpBMW;AJyrEf;AwB5rEE;EAEE,iDAAA;AxB6rEJ;AwB1rEE;EAEE,cpBJW;EoBKX,6BAAA;AxB2rEJ;AwBxrEE;EAGE,WAAA;EACA,yBpBZW;EoBaX,qBpBbW;AJqsEf;AwBtrEI;EAKI,iDAAA;AxBorER;AuB7sEE;ECPA,cpBYa;EoBXb,qBpBWa;AJ4sEf;AM5wEE;EkBwDE,WALgD;EAMhD,yBpBOW;EoBNX,qBpBMW;AJitEf;AwBptEE;EAEE,+CAAA;AxBqtEJ;AwBltEE;EAEE,cpBJW;EoBKX,6BAAA;AxBmtEJ;AwBhtEE;EAGE,WAAA;EACA,yBpBZW;EoBaX,qBpBbW;AJ6tEf;AwB9sEI;EAKI,+CAAA;AxB4sER;AuBruEE;ECPA,cpBYa;EoBXb,qBpBWa;AJouEf;AMpyEE;EkBwDE,WALgD;EAMhD,yBpBOW;EoBNX,qBpBMW;AJyuEf;AwB5uEE;EAEE,gDAAA;AxB6uEJ;AwB1uEE;EAEE,cpBJW;EoBKX,6BAAA;AxB2uEJ;AwBxuEE;EAGE,WAAA;EACA,yBpBZW;EoBaX,qBpBbW;AJqvEf;AwBtuEI;EAKI,gDAAA;AxBouER;AuB7vEE;ECPA,cpBYa;EoBXb,qBpBWa;AJ4vEf;AM5zEE;EkBwDE,cALgD;EAMhD,yBpBOW;EoBNX,qBpBMW;AJiwEf;AwBpwEE;EAEE,+CAAA;AxBqwEJ;AwBlwEE;EAEE,cpBJW;EoBKX,6BAAA;AxBmwEJ;AwBhwEE;EAGE,cAAA;EACA,yBpBZW;EoBaX,qBpBbW;AJ6wEf;AwB9vEI;EAKI,+CAAA;AxB4vER;AuBrxEE;ECPA,cpBYa;EoBXb,qBpBWa;AJoxEf;AMp1EE;EkBwDE,WALgD;EAMhD,yBpBOW;EoBNX,qBpBMW;AJyxEf;AwB5xEE;EAEE,+CAAA;AxB6xEJ;AwB1xEE;EAEE,cpBJW;EoBKX,6BAAA;AxB2xEJ;AwBxxEE;EAGE,WAAA;EACA,yBpBZW;EoBaX,qBpBbW;AJqyEf;AwBtxEI;EAKI,+CAAA;AxBoxER;AuB7yEE;ECPA,cpBYa;EoBXb,qBpBWa;AJ4yEf;AM52EE;EkBwDE,cALgD;EAMhD,yBpBOW;EoBNX,qBpBMW;AJizEf;AwBpzEE;EAEE,iDAAA;AxBqzEJ;AwBlzEE;EAEE,cpBJW;EoBKX,6BAAA;AxBmzEJ;AwBhzEE;EAGE,cAAA;EACA,yBpBZW;EoBaX,qBpBbW;AJ6zEf;AwB9yEI;EAKI,iDAAA;AxB4yER;AuBr0EE;ECPA,cpBYa;EoBXb,qBpBWa;AJo0Ef;AMp4EE;EkBwDE,WALgD;EAMhD,yBpBOW;EoBNX,qBpBMW;AJy0Ef;AwB50EE;EAEE,8CAAA;AxB60EJ;AwB10EE;EAEE,cpBJW;EoBKX,6BAAA;AxB20EJ;AwBx0EE;EAGE,WAAA;EACA,yBpBZW;EoBaX,qBpBbW;AJq1Ef;AwBt0EI;EAKI,8CAAA;AxBo0ER;AuBl1EA;EACE,gBnB6M4B;EmB5M5B,cnB2FwC;EmB1FxC,qBnB2FwC;AJyvE1C;AM75EE;EiB4EE,mCnByFsC;EmBxFtC,0BnByFsC;AJ2vE1C;AuBj1EE;EAEE,0BnBoFsC;AJ8vE1C;AuB/0EE;EAEE,cnBtFO;EmBuFP,oBAAA;AvBg1EJ;AuBr0EA;ECPE,oBAAA;EnB4EI,kBAAA;EmB1EJ,gBpB+H4B;EOvN1B,qBAAA;AXw6EJ;AuBv0EA;ECXE,uBAAA;EnB4EI,mBAAA;EmB1EJ,gBpBgI4B;EOxN1B,qBAAA;AX86EJ;AuBp0EA;EACE,cAAA;EACA,WAAA;AvBs0EF;AuBn0EE;EACE,kBnBwT0B;AJ6gE9B;AuB7zEE;;;EACE,WAAA;AvBi0EJ;AyB58EA;ELgBM,gCKfJ;AzB88EF;AoB37EM;EKpBN;ILqBQ,gBAAA;EpB87EN;AACF;AyBj9EE;EACE,UAAA;AzBm9EJ;AyB98EE;EACE,aAAA;AzBg9EJ;AyB58EA;EACE,kBAAA;EACA,SAAA;EACA,gBAAA;ELDI,6BKEJ;AzB88EF;AoB58EM;EKNN;ILOQ,gBAAA;EpB+8EN;AACF;AyBj9EE;EACE,QAAA;EACA,YAAA;ELNE,4BKOF;AzBm9EJ;AoBt9EM;EKAJ;ILCM,gBAAA;EpBy9EN;AACF;A0B9+EA;;;;EAIE,kBAAA;A1Bg/EF;A0B7+EA;EACE,mBAAA;A1B++EF;A2B39EI;EACE,qBAAA;EACA,oBvB+NwB;EuB9NxB,uBvB6NwB;EuB5NxB,WAAA;EAhCJ,uBAAA;EACA,qCAAA;EACA,gBAAA;EACA,oCAAA;A3B8/EF;A2Bz8EI;EACE,cAAA;A3B28EN;A0Br/EA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,atBypBkC;EsBxpBlC,aAAA;EACA,WAAA;EACA,gBtBiuBkC;EsBhuBlC,iBAAA;EACA,oBAAA;ErB2JI,eAAA;EqBzJJ,ctBXS;EsBYT,gBAAA;EACA,gBAAA;EACA,sBtBvBS;EsBwBT,4BAAA;EACA,qCAAA;EfdE,sBAAA;AXsgFJ;A0B/+EI;EACE,WAAA;EACA,OAAA;A1Bi/EN;A0B9+EI;EACE,QAAA;EACA,UAAA;A1Bg/EN;Aep+EI;EWnBA;IACE,WAAA;IACA,OAAA;E1B0/EJ;E0Bv/EE;IACE,QAAA;IACA,UAAA;E1By/EJ;AACF;Ae9+EI;EWnBA;IACE,WAAA;IACA,OAAA;E1BogFJ;E0BjgFE;IACE,QAAA;IACA,UAAA;E1BmgFJ;AACF;Aex/EI;EWnBA;IACE,WAAA;IACA,OAAA;E1B8gFJ;E0B3gFE;IACE,QAAA;IACA,UAAA;E1B6gFJ;AACF;AelgFI;EWnBA;IACE,WAAA;IACA,OAAA;E1BwhFJ;E0BrhFE;IACE,QAAA;IACA,UAAA;E1BuhFJ;AACF;A0BhhFE;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,uBtB+rBgC;AJm1DpC;A2BjjFI;EACE,qBAAA;EACA,oBvB+NwB;EuB9NxB,uBvB6NwB;EuB5NxB,WAAA;EAzBJ,aAAA;EACA,qCAAA;EACA,0BAAA;EACA,oCAAA;A3B6kFF;A2B/hFI;EACE,cAAA;A3BiiFN;A0BthFE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,qBtBirBgC;AJu2DpC;A2BrkFI;EACE,qBAAA;EACA,oBvB+NwB;EuB9NxB,uBvB6NwB;EuB5NxB,WAAA;EAlBJ,mCAAA;EACA,eAAA;EACA,sCAAA;EACA,wBAAA;A3B0lFF;A2BnjFI;EACE,cAAA;A3BqjFN;A0BhiFI;EACE,iBAAA;A1BkiFN;A0B5hFE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,sBtBgqBgC;AJ83DpC;A2B5lFI;EACE,qBAAA;EACA,oBvB+NwB;EuB9NxB,uBvB6NwB;EuB5NxB,WAAA;A3B8lFN;A2BnlFM;EACE,aAAA;A3BqlFR;A2BllFM;EACE,qBAAA;EACA,qBvB4MsB;EuB3MtB,uBvB0MsB;EuBzMtB,WAAA;EA9BN,mCAAA;EACA,yBAAA;EACA,sCAAA;A3BmnFF;A2BllFI;EACE,cAAA;A3BolFN;A0B9iFI;EACE,iBAAA;A1BgjFN;A0BxiFE;EAIE,WAAA;EACA,YAAA;A1BuiFJ;A0BliFA;EE9GE,SAAA;EACA,gBAAA;EACA,gBAAA;EACA,6BAAA;A5BmpFF;A0BjiFA;EACE,cAAA;EACA,WAAA;EACA,uBAAA;EACA,WAAA;EACA,gBtBiK4B;EsBhK5B,ctBhHS;EsBiHT,mBAAA;EAEA,mBAAA;EACA,6BAAA;EACA,SAAA;A1BkiFF;AMvpFE;EoBoIE,uDtBonBgC;EsBnnBhC,qBAAA;EJ/IA,yBlBGO;AJmqFX;A0BnhFE;EAEE,WtBpJO;EsBqJP,qBAAA;EJtJA,yBlBoP0B;AJu7E9B;A0BjhFE;EAEE,ctBtJO;EsBuJP,oBAAA;EACA,6BAAA;A1BkhFJ;A0B1gFA;EACE,cAAA;A1B4gFF;A0BxgFA;EACE,cAAA;EACA,sBtBimBkC;EsBhmBlC,gBAAA;ErBAI,mBAAA;EqBEJ,ctBzKS;EsB0KT,mBAAA;A1B0gFF;A0BtgFA;EACE,cAAA;EACA,uBAAA;EACA,ctB9KS;AJsrFX;A6BnsFA;;EAEE,kBAAA;EACA,oBAAA;EACA,sBAAA;A7BqsFF;A6BnsFE;;EACE,kBAAA;EACA,cAAA;A7BssFJ;AMrsFE;;EuBII,UAAA;A7BqsFN;A6BnsFI;;;;EAGE,UAAA;A7BssFN;A6BhsFA;EACE,aAAA;EACA,eAAA;EACA,2BAAA;A7BksFF;A6BhsFE;EACE,WAAA;A7BksFJ;A6B5rFE;;EAEE,iBAAA;A7B8rFJ;A6B1rFE;;ElBXE,0BAAA;EACA,6BAAA;AXysFJ;A6B1rFE;;ElBFE,yBAAA;EACA,4BAAA;AXgsFJ;A6B7qFA;EACE,wBAAA;EACA,uBAAA;A7B+qFF;A6B7qFE;EAGE,cAAA;A7B6qFJ;A6B1qFE;EACE,eAAA;A7B4qFJ;A6BxqFA;EACE,uBAAA;EACA,sBAAA;A7B0qFF;A6BvqFA;EACE,sBAAA;EACA,qBAAA;A7ByqFF;A6BrpFA;EACE,sBAAA;EACA,uBAAA;EACA,uBAAA;A7BupFF;A6BrpFE;;EAEE,WAAA;A7BupFJ;A6BppFE;;EAEE,gBAAA;A7BspFJ;A6BlpFE;;ElBrFE,6BAAA;EACA,4BAAA;AX2uFJ;A6BlpFE;;ElBxGE,yBAAA;EACA,0BAAA;AX8vFJ;A6BnoFE;;EAEE,gBAAA;A7BqoFJ;A6BnoFI;;;;EAEE,kBAAA;EACA,sBAAA;EACA,oBAAA;A7BuoFN;A8BhyFA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,oBAAA;EACA,WAAA;A9BkyFF;A8BhyFE;;;;EAIE,kBAAA;EACA,cAAA;EACA,SAAA;EACA,YAAA;EACA,gBAAA;A9BkyFJ;A8BhyFI;;;;;;;;;;;;EAGE,iBAAA;A9B2yFN;A8BtyFE;;;EAGE,UAAA;A9BwyFJ;A8BpyFE;EACE,UAAA;A9BsyFJ;A8BjyFI;;EnBIA,yBAAA;EACA,4BAAA;AXiyFJ;A8BjyFE;EACE,aAAA;EACA,mBAAA;A9BmyFJ;A8BjyFI;EnBnBA,0BAAA;EACA,6BAAA;AXuzFJ;A8BnyFI;EnBPA,yBAAA;EACA,4BAAA;AX6yFJ;A8BnyFI;;;;EnBzBA,0BAAA;EACA,6BAAA;AXk0FJ;A8BjyFI;;;;EnBlCA,0BAAA;EACA,6BAAA;AXy0FJ;A8BxxFA;;EAEE,aAAA;A9B0xFF;A8BrxFE;;EACE,kBAAA;EACA,UAAA;A9BwxFJ;A8BtxFI;;EACE,UAAA;A9ByxFN;A8BrxFE;;;;;;;;EAIE,iBAAA;A9B2xFJ;A8BvxFA;EAAuB,kBAAA;A9B0xFvB;A8BzxFA;EAAsB,iBAAA;A9B4xFtB;A8BpxFA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EzB2DI,eAAA;EyBzDJ,gB1BqK4B;E0BpK5B,gB1ByK4B;E0BxK5B,c1B/GS;E0BgHT,kBAAA;EACA,mBAAA;EACA,yB1BvHS;E0BwHT,yBAAA;EnB/GE,sBAAA;AXs4FJ;A8BnxFE;;EAEE,aAAA;A9BqxFJ;A8B3wFA;;EAEE,gC1BmWsC;AJ06ExC;A8B1wFA;;;;;;EAME,oBAAA;EzBwBI,kBAAA;EyBtBJ,gB1B2E4B;EOvN1B,qBAAA;AXy5FJ;A8BzwFA;;EAEE,kC1BiVsC;AJ07ExC;A8BxwFA;;;;;;EAME,uBAAA;EzBOI,mBAAA;EyBLJ,gB1B2D4B;EOxN1B,qBAAA;AXw6FJ;A8BvwFA;;EAEE,sBAAA;A9BywFF;A8B9vFA;;;;;;;;EnB9JI,0BAAA;EACA,6BAAA;AXs6FJ;A8B9vFA;;;;;;EnB3JI,yBAAA;EACA,4BAAA;AXi6FJ;A+Bz8FA;EACE,kBAAA;EACA,UAAA;EACA,cAAA;EACA,kBAAA;EACA,oBAAA;EACA,yBAAA;A/B28FF;A+Bx8FA;EACE,oBAAA;EACA,kB3ByfsC;AJi9ExC;A+Bv8FA;EACE,kBAAA;EACA,OAAA;EACA,WAAA;EACA,W3BqfsC;E2BpftC,eAAA;EACA,UAAA;A/By8FF;A+Bv8FE;EACE,W3BzBO;E2B0BP,qB3ByN0B;EkBpP1B,yBlBoP0B;AJivF9B;A+Br8FE;EAKI,gD3BgWwB;AJmmF9B;A+B/7FE;EACE,4C3BsboC;AJ2gFxC;A+B97FE;EACE,W3B7CO;E2B8CP,gD3Bkf4C;E2Bjf5C,4C3Bif4C;AJ+8EhD;A+Bz7FI;EACE,c3BjDK;AJ4+FX;A+Bz7FM;EACE,yB3BxDG;AJm/FX;A+Bj7FA;EACE,kBAAA;EACA,gBAAA;EAEA,mBAAA;A/Bk7FF;A+B96FE;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;EACA,W3BwboC;E2BvbpC,Y3BuboC;E2BtbpC,oBAAA;EACA,WAAA;EACA,sB3BrFO;E2BsFP,yBAAA;A/Bg7FJ;A+B36FE;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;EACA,W3ByaoC;E2BxapC,Y3BwaoC;E2BvapC,WAAA;EACA,iCAAA;A/B66FJ;A+Bn6FE;EpBlGE,sBAAA;AXwgGJ;A+Bj6FI;EACE,yDAAA;A/Bm6FN;A+B95FI;EACE,qB3B0HwB;EkBpP1B,yBlBoP0B;AJuyF9B;A+B75FI;EACE,yDAAA;A/B+5FN;A+B15FI;ETpIA,wClByhB4C;AJwgFhD;A+B15FI;ETvIA,wClByhB4C;AJ2gFhD;A+Bl5FE;EAEE,kB3B0Z4C;AJy/EhD;A+B/4FI;EACE,yDAAA;A/Bi5FN;A+B54FI;ET9JA,wClByhB4C;AJohFhD;A+Bp4FA;EACE,qBAAA;A/Bs4FF;A+Bn4FI;EACE,cAAA;EACA,c3BkY0C;E2BjY1C,mBAAA;EAEA,qB3BgY0C;AJogFhD;A+Bj4FI;EACE,wBAAA;EACA,0BAAA;EACA,uB3B2X0C;E2B1X1C,wB3B0X0C;E2BzX1C,yB3BpLK;E2BsLL,qB3BsX0C;EgBxiB1C,yIWmLA;A/Bk4FN;AoBjjGM;EWuKF;IXtKI,gBAAA;EpBojGN;AACF;A+Bl4FI;EACE,sB3BlMK;E2BmML,8BAAA;A/Bo4FN;A+B/3FI;ETzMA,wClByhB4C;AJkjFhD;A+Br3FA;EACE,qBAAA;EACA,WAAA;EACA,mC3BqRsC;E2BpRtC,0CAAA;E1B5CI,eAAA;E0B+CJ,gB3B6D4B;E2B5D5B,gB3BiE4B;E2BhE5B,c3BvNS;E2BwNT,sBAAA;EACA,gGAAA;EACA,yBAAA;EpBtNE,sBAAA;EoByNF,gBAAA;A/Bq3FF;A+Bn3FE;EACE,4C3BwPoC;E2BvPpC,UAAA;EAKE,gD3BmW8B;AJ8gFpC;A+B92FI;EAME,c3B/OK;E2BgPL,sB3BvPK;AJkmGX;A+Bv2FE;EAEE,YAAA;EACA,sB3B+H0B;E2B9H1B,sBAAA;A/Bw2FJ;A+Br2FE;EACE,c3B7PO;E2B8PP,yB3BlQO;AJymGX;A+Bn2FE;EACE,aAAA;A/Bq2FJ;A+Bj2FE;EACE,kBAAA;EACA,0BAAA;A/Bm2FJ;A+B/1FA;EACE,kC3B0NsC;E2BzNtC,oB3BiH4B;E2BhH5B,uB3BgH4B;E2B/G5B,oB3BgH4B;EC1NxB,mBAAA;AL48FN;A+B91FA;EACE,gC3BmNsC;E2BlNtC,mB3B8G4B;E2B7G5B,sB3B6G4B;E2B5G5B,kB3B6G4B;EC/NxB,kBAAA;ALm9FN;A+Bx1FA;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,mC3BiMsC;E2BhMtC,gBAAA;A/B01FF;A+Bv1FA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,mC3ByLsC;E2BxLtC,SAAA;EACA,gBAAA;EACA,UAAA;A/By1FF;A+Bv1FE;EACE,4C3BqKoC;E2BpKpC,gD3ByE0B;AJgxF9B;A+Br1FE;EAEE,yB3B/TO;AJqpGX;A+Bl1FI;EACE,iB3B2Ta;AJyhFnB;A+Bh1FE;EACE,0BAAA;A/Bk1FJ;A+B90FA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,UAAA;EACA,mC3BwJsC;E2BvJtC,yBAAA;EACA,gBAAA;EAEA,gB3BhE4B;E2BiE5B,gB3B5D4B;E2B6D5B,c3BpVS;E2BqVT,sB3B5VS;E2B6VT,yBAAA;EpBlVE,sBAAA;AXkqGJ;A+B50FE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,cAAA;EACA,6B3BiIoC;E2BhIpC,yBAAA;EACA,gB3B5E0B;E2B6E1B,c3BpWO;E2BqWP,iBAAA;ET7WA,yBlBGO;E2B4WP,oBAAA;EpBnWA,kCAAA;AXkrGJ;A+Bp0FA;EACE,WAAA;EACA,cAAA;EACA,UAAA;EACA,6BAAA;EACA,gBAAA;A/Bs0FF;A+Bp0FE;EACE,UAAA;A/Bs0FJ;A+Bl0FI;EAA0B,gE3BoOe;AJimF7C;A+Bp0FI;EAA0B,gE3BmOe;AJomF7C;A+Bt0FI;EAA0B,gE3BkOe;AJumF7C;A+Bt0FE;EACE,SAAA;A/Bw0FJ;A+Br0FE;EACE,W3BoNyC;E2BnNzC,Y3BmNyC;E2BlNzC,oBAAA;ETlZA,yBlBoP0B;E2BgK1B,S3BmNyC;EO3lBzC,mBAAA;ESFE,4GW6YF;A/Bs0FJ;AoB/sGM;EWiYJ;IXhYM,gBAAA;EpBktGN;AACF;A+Bn1FE;EASE,gBAAA;A/B60FJ;A+B30FI;ET1ZA,gDlB4mByC;AJ4nF7C;A+Bz0FE;EACE,W3B6LgC;E2B5LhC,c3B6LgC;E2B5LhC,kBAAA;EACA,e3B4LgC;E2B3LhC,yB3BhaO;E2BiaP,yBAAA;EpBzZA,mBAAA;AXquGJ;A+Bv0FE;EACE,W3ByLyC;E2BxLzC,Y3BwLyC;EkBpmBzC,yBlBoP0B;E2B0L1B,S3ByLyC;EO3lBzC,mBAAA;ESFE,4GWuaF;A/Bw0FJ;AoB3uGM;EW4ZJ;IX3ZM,gBAAA;EpB8uGN;AACF;A+Bp1FE;EAQE,gBAAA;A/B+0FJ;A+B70FI;ETpbA,gDlB4mByC;AJwpF7C;A+B30FE;EACE,W3BmKgC;E2BlKhC,c3BmKgC;E2BlKhC,kBAAA;EACA,e3BkKgC;E2BjKhC,yB3B1bO;E2B2bP,yBAAA;EpBnbA,mBAAA;AXiwGJ;A+Bz0FE;EACE,W3B+JyC;E2B9JzC,Y3B8JyC;E2B7JzC,aAAA;EACA,oB3BrE0B;E2BsE1B,mB3BtE0B;EkBnY1B,yBlBoP0B;E2BuN1B,S3B4JyC;EO3lBzC,mBAAA;ESFE,4GWocF;A/B00FJ;AoB1wGM;EWsbJ;IXrbM,gBAAA;EpB6wGN;AACF;A+Bz1FE;EAWE,gBAAA;A/Bi1FJ;A+B/0FI;ETjdA,gDlB4mByC;AJurF7C;A+B70FE;EACE,W3BsIgC;E2BrIhC,c3BsIgC;E2BrIhC,kBAAA;EACA,e3BqIgC;E2BpIhC,6BAAA;EACA,yBAAA;EACA,oBAAA;A/B+0FJ;A+B30FE;EACE,yB3B9dO;EOQP,mBAAA;AXoyGJ;A+B10FE;EACE,kBAAA;EACA,yB3BpeO;EOQP,mBAAA;AXyyGJ;A+Bx0FI;EACE,yB3BxeK;AJkzGX;A+Bv0FI;EACE,eAAA;A/By0FN;A+Bt0FI;EACE,yB3BhfK;AJwzGX;A+Br0FI;EACE,eAAA;A/Bu0FN;A+Bp0FI;EACE,yB3BxfK;AJ8zGX;A+Bj0FA;;;EXzfM,4GW4fJ;A/Bm0FF;AoB3zGM;EWqfN;;;IXpfQ,gBAAA;EpBg0GN;AACF;AgCj1GA;EACE,aAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AhCm1GF;AgCh1GA;EACE,cAAA;EACA,oBAAA;AhCk1GF;AMj1GE;E0BGE,qBAAA;AhCi1GJ;AgC70GE;EACE,c5BXO;E4BYP,oBAAA;EACA,eAAA;AhC+0GJ;AgCv0GA;EACE,gCAAA;AhCy0GF;AgCv0GE;EACE,mBAAA;EACA,6BAAA;EACA,6BAAA;ErBbA,+BAAA;EACA,gCAAA;AXu1GJ;AMn2GE;E0B6BI,kBAAA;EACA,qC5BipB8B;AJwrFpC;AgCt0GI;EACE,c5BrCK;E4BsCL,6BAAA;EACA,yBAAA;AhCw0GN;AgCp0GE;;EAEE,c5B5CO;E4B6CP,sB5BpDO;E4BqDP,kC5BsoBgC;AJgsFpC;AgCn0GE;EAEE,gBAAA;ErBtCA,yBAAA;EACA,0BAAA;AX22GJ;AgC1zGE;EACE,gBAAA;EACA,SAAA;ErB7DA,sBAAA;AX03GJ;AgCzzGE;;EAEE,W5B9EO;E4B+EP,yB5BoK0B;AJupG9B;AgCjzGE;;EAEE,cAAA;EACA,kBAAA;AhCmzGJ;AgC9yGE;;EAEE,aAAA;EACA,YAAA;EACA,kBAAA;AhCgzGJ;AgCtyGE;EACE,aAAA;AhCwyGJ;AgCtyGE;EACE,cAAA;AhCwyGJ;AiCj5GA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,oBAAA;AjCm5GF;AiC/4GE;;;;;;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;AjCs5GJ;AiCl4GA;EACE,qBAAA;EACA,sB7BkqBkC;E6BjqBlC,yB7BiqBkC;E6BhqBlC,kB7BgFO;EC6CH,kBAAA;E4B3HJ,oBAAA;EACA,mBAAA;AjCo4GF;AM96GE;E2B6CE,qBAAA;AjCo4GJ;AiC33GA;EACE,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AjC63GF;AiC33GE;EACE,gBAAA;EACA,eAAA;AjC63GJ;AiC13GE;EACE,gBAAA;EACA,WAAA;AjC43GJ;AiCn3GA;EACE,qBAAA;EACA,mB7BylBkC;E6BxlBlC,sB7BwlBkC;AJ6xFpC;AiCz2GA;EACE,gBAAA;EACA,YAAA;EAGA,mBAAA;AjCy2GF;AiCr2GA;EACE,wBAAA;E5B8DI,kBAAA;E4B5DJ,cAAA;EACA,6BAAA;EACA,6BAAA;EtBxGE,sBAAA;AXg9GJ;AMl9GE;E2B8GE,qBAAA;AjCu2GJ;AiCj2GA;EACE,qBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,mCAAA;AjCm2GF;AiCh2GA;EACE,gB7BglBkC;E6B/kBlC,gBAAA;AjCk2GF;Aex6GI;EkBkFI;;;;;;IACE,gBAAA;IACA,eAAA;EjC81GR;AACF;Aeh8GI;EkB6FA;IAoBI,qBAAA;IACA,2BAAA;EjCm1GN;EiCj1GM;IACE,mBAAA;EjCm1GR;EiCj1GQ;IACE,kBAAA;EjCm1GV;EiCh1GQ;IACE,qB7ByhBwB;I6BxhBxB,oB7BwhBwB;EJ0zFlC;EiC70GM;;;;;;IACE,iBAAA;EjCo1GR;EiCt0GM;IACE,iBAAA;EjCw0GR;EiCr0GM;IACE,wBAAA;IAGA,gBAAA;EjCq0GR;EiCl0GM;IACE,aAAA;EjCo0GR;AACF;Aer9GI;EkBkFI;;;;;;IACE,gBAAA;IACA,eAAA;EjC24GR;AACF;Ae7+GI;EkB6FA;IAoBI,qBAAA;IACA,2BAAA;EjCg4GN;EiC93GM;IACE,mBAAA;EjCg4GR;EiC93GQ;IACE,kBAAA;EjCg4GV;EiC73GQ;IACE,qB7ByhBwB;I6BxhBxB,oB7BwhBwB;EJu2FlC;EiC13GM;;;;;;IACE,iBAAA;EjCi4GR;EiCn3GM;IACE,iBAAA;EjCq3GR;EiCl3GM;IACE,wBAAA;IAGA,gBAAA;EjCk3GR;EiC/2GM;IACE,aAAA;EjCi3GR;AACF;AelgHI;EkBkFI;;;;;;IACE,gBAAA;IACA,eAAA;EjCw7GR;AACF;Ae1hHI;EkB6FA;IAoBI,qBAAA;IACA,2BAAA;EjC66GN;EiC36GM;IACE,mBAAA;EjC66GR;EiC36GQ;IACE,kBAAA;EjC66GV;EiC16GQ;IACE,qB7ByhBwB;I6BxhBxB,oB7BwhBwB;EJo5FlC;EiCv6GM;;;;;;IACE,iBAAA;EjC86GR;EiCh6GM;IACE,iBAAA;EjCk6GR;EiC/5GM;IACE,wBAAA;IAGA,gBAAA;EjC+5GR;EiC55GM;IACE,aAAA;EjC85GR;AACF;Ae/iHI;EkBkFI;;;;;;IACE,gBAAA;IACA,eAAA;EjCq+GR;AACF;AevkHI;EkB6FA;IAoBI,qBAAA;IACA,2BAAA;EjC09GN;EiCx9GM;IACE,mBAAA;EjC09GR;EiCx9GQ;IACE,kBAAA;EjC09GV;EiCv9GQ;IACE,qB7ByhBwB;I6BxhBxB,oB7BwhBwB;EJi8FlC;EiCp9GM;;;;;;IACE,iBAAA;EjC29GR;EiC78GM;IACE,iBAAA;EjC+8GR;EiC58GM;IACE,wBAAA;IAGA,gBAAA;EjC48GR;EiCz8GM;IACE,aAAA;EjC28GR;AACF;AiC1gHQ;;;;;;EACE,gBAAA;EACA,eAAA;AjCihHV;AiCrhHI;EAoBI,qBAAA;EACA,2BAAA;AjCogHR;AiClgHQ;EACE,mBAAA;AjCogHV;AiClgHU;EACE,kBAAA;AjCogHZ;AiCjgHU;EACE,qB7ByhBwB;E6BxhBxB,oB7BwhBwB;AJ2+FpC;AiC9/GQ;;;;;;EACE,iBAAA;AjCqgHV;AiCv/GQ;EACE,iBAAA;AjCy/GV;AiCt/GQ;EACE,wBAAA;EAGA,gBAAA;AjCs/GV;AiCn/GQ;EACE,aAAA;AjCq/GV;AiCv+GE;EACE,yB7BigBgC;AJw+FpC;AMjsHE;E2B2NI,yB7B8f8B;AJ2+FpC;AiCp+GI;EACE,yB7Bsf8B;AJg/FpC;AMvsHE;E2BoOM,yB7Bof4B;AJk/FpC;AiCn+GM;EACE,yB7Bkf4B;AJm/FpC;AiCj+GI;;;;EAIE,yB7Bye8B;AJ0/FpC;AiC/9GE;EACE,yB7BkegC;E6BjehC,gC7BsegC;AJ2/FpC;AiC99GE;EACE,yDAAA;AjCg+GJ;AiC79GE;EACE,yB7BydgC;AJsgGpC;AiC99GI;EACE,yB7Byd8B;AJugGpC;AMhuHE;E2BmQM,yB7Bsd4B;AJ0gGpC;AiCx9GE;EACE,W7BrRO;AJ+uHX;AMtuHE;E2B+QI,W7BxRK;AJkvHX;AiCr9GI;EACE,+B7B2b8B;AJ4hGpC;AM5uHE;E2BwRM,gC7Byb4B;AJ8hGpC;AiCp9GM;EACE,gC7Bub4B;AJ+hGpC;AiCl9GI;;;;EAIE,W7B7SK;AJiwHX;AiCh9GE;EACE,+B7BuagC;E6BtahC,sC7B2agC;AJuiGpC;AiC/8GE;EACE,yDAAA;AjCi9GJ;AiC98GE;EACE,+B7B8ZgC;AJkjGpC;AiC/8GI;EACE,W7B7TK;AJ8wHX;AMrwHE;E2BuTM,W7BhUG;AJixHX;AkCpxHA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EAEA,qBAAA;EACA,sB9BJS;E8BKT,2BAAA;EACA,sCAAA;EvBKE,sBAAA;AXixHJ;AkCnxHE;EACE,eAAA;EACA,cAAA;AlCqxHJ;AkClxHE;EACE,mBAAA;EACA,sBAAA;AlCoxHJ;AkClxHI;EACE,mBAAA;EvBCF,2CAAA;EACA,4CAAA;AXoxHJ;AkClxHI;EACE,sBAAA;EvBUF,+CAAA;EACA,8CAAA;AX2wHJ;AkC/wHE;;EAEE,aAAA;AlCixHJ;AkC7wHA;EAGE,cAAA;EAGA,eAAA;EACA,gB9BgxBkC;AJ2/FpC;AkCvwHA;EACE,sB9B0wBkC;AJ+/FpC;AkCtwHA;EACE,qBAAA;EACA,gBAAA;AlCwwHF;AkCrwHA;EACE,gBAAA;AlCuwHF;AM5zHE;E4B0DE,qBAAA;AlCqwHJ;AkClwHE;EACE,oB9ByvBgC;AJ2gGpC;AkC5vHA;EACE,wBAAA;EACA,gBAAA;EAEA,qC9BkvBkC;E8BjvBlC,6CAAA;AlC6vHF;AkC3vHE;EvBvEE,0DAAA;AXq0HJ;AkCzvHA;EACE,wBAAA;EAEA,qC9BuuBkC;E8BtuBlC,0CAAA;AlC0vHF;AkCxvHE;EvBlFE,0DAAA;AX60HJ;AkCjvHA;EACE,uBAAA;EACA,uBAAA;EACA,sBAAA;EACA,gBAAA;AlCmvHF;AkChvHA;EACE,uBAAA;EACA,sBAAA;AlCkvHF;AkC9uHA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,gB9B6sBkC;EO5zBhC,kCAAA;AXg2HJ;AkC7uHA;;;EAGE,cAAA;EACA,WAAA;AlC+uHF;AkC5uHA;;EvBjHI,2CAAA;EACA,4CAAA;AXi2HJ;AkC5uHA;;EvBxGI,+CAAA;EACA,8CAAA;AXw1HJ;AkCxuHE;EACE,mB9BqrBgC;AJqjGpC;Aez0HI;EmB6FJ;IAMI,aAAA;IACA,mBAAA;IACA,mBAAA;IACA,kBAAA;ElC0uHF;EkCxuHE;IAEE,YAAA;IACA,kB9ByqB8B;I8BxqB9B,gBAAA;IACA,iB9BuqB8B;EJkkGlC;AACF;AkC7tHE;EACE,mB9BypBgC;AJskGpC;Ae11HI;EmBuHJ;IAQI,aAAA;IACA,mBAAA;ElC+tHF;EkC5tHE;IAEE,YAAA;IACA,gBAAA;ElC6tHJ;EkC3tHI;IACE,cAAA;IACA,cAAA;ElC6tHN;EkCxtHM;IvBzKJ,0BAAA;IACA,6BAAA;EXo4HF;EkCztHQ;;IAGE,0BAAA;ElC0tHV;EkCxtHQ;;IAGE,6BAAA;ElCytHV;EkCrtHM;IvB1KJ,yBAAA;IACA,4BAAA;EXk4HF;EkCttHQ;;IAGE,yBAAA;ElCutHV;EkCrtHQ;;IAGE,4BAAA;ElCstHV;AACF;AkCzsHE;EACE,sB9B8kBgC;AJ6nGpC;Aen4HI;EmBsLJ;IAMI,e9B2lBgC;I8B1lBhC,mB9B2lBgC;I8B1lBhC,UAAA;IACA,SAAA;ElC2sHF;EkCzsHE;IACE,qBAAA;IACA,WAAA;ElC2sHJ;AACF;AkClsHA;EACE,qBAAA;AlCosHF;AkClsHE;EACE,gBAAA;AlCosHJ;AkClsHI;EACE,gBAAA;EvBvOF,6BAAA;EACA,4BAAA;AX46HJ;AkClsHI;EvBzPA,yBAAA;EACA,0BAAA;AX87HJ;AkClsHI;EvBtQA,gBAAA;EuBwQE,mBAAA;AlCosHN;AmC99HA;EACE,aAAA;EACA,eAAA;EACA,qBAAA;EACA,mB/BqiCkC;E+BniClC,gBAAA;EACA,yB/BES;EOSP,sBAAA;AXq9HJ;AmC19HE;EACE,oB/ByhCgC;AJm8FpC;AmC19HI;EACE,WAAA;EACA,qB/BqhC8B;E+BphC9B,c/BNK;E+BOL,YAAA;AnC49HN;AmCl9HE;EACE,0BAAA;AnCo9HJ;AmCj9HE;EACE,qBAAA;AnCm9HJ;AmCh9HE;EACE,c/B1BO;AJ4+HX;AoCz/HA;EACE,aAAA;E5BGA,eAAA;EACA,gBAAA;EGaE,sBAAA;AX6+HJ;AoCz/HA;EACE,kBAAA;EACA,cAAA;EACA,uBAAA;EACA,iBAAA;EACA,iBhCoxBkC;EgCnxBlC,chCmKwC;EgCjKxC,sBhCPS;EgCQT,yBAAA;ApC0/HF;AoCx/HE;EACE,UAAA;EACA,mChC8JsC;EgC7JtC,qBAAA;EACA,yBhCZO;EgCaP,qBhCZO;AJsgIX;AoCv/HE;EACE,UAAA;EACA,UhC4wBgC;EgC3wBhC,gDhC+W0B;AJ0oH9B;AoCn/HI;EACE,cAAA;EzBaF,+BAAA;EACA,kCAAA;AXy+HJ;AoCl/HI;EzBNA,gCAAA;EACA,mCAAA;AX2/HJ;AoCj/HE;EACE,UAAA;EACA,WhCxCO;EgCyCP,yBhC0M0B;EgCzM1B,qBhCyM0B;AJ0yH9B;AoCh/HE;EACE,chCxCO;EgCyCP,oBAAA;EAEA,YAAA;EACA,sBhClDO;EgCmDP,qBhChDO;AJiiIX;AqCxiIE;EACE,uBAAA;EhCgLE,kBAAA;EgC9KF,gBjCmO0B;AJu0H9B;AqCriIM;E1BqCF,8BAAA;EACA,iCAAA;AXmgIJ;AqCpiIM;E1BkBF,+BAAA;EACA,kCAAA;AXqhIJ;AqCrjIE;EACE,uBAAA;EhCgLE,mBAAA;EgC9KF,gBjCoO0B;AJm1H9B;AqCljIM;E1BqCF,8BAAA;EACA,iCAAA;AXghIJ;AqCjjIM;E1BkBF,+BAAA;EACA,kCAAA;AXkiIJ;AsChkIA;EACE,qBAAA;EACA,qBAAA;EjC6JE,cAAA;EiC3JF,gBlCwR4B;EkCvR5B,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;E3BKE,sBAAA;ESFE,qIkBDJ;AtCkkIF;AoB7jIM;EkBfN;IlBgBQ,gBAAA;EpBgkIN;AACF;AMtkIE;EgCGI,qBAAA;AtCskIN;;AsCjkIE;EACE,aAAA;AtCokIJ;AsC/jIA;EACE,kBAAA;EACA,SAAA;AtCikIF;AsC1jIA;EACE,oBlCi4BkC;EkCh4BlC,mBlCg4BkC;EOv5BhC,oBAAA;AXolIJ;AsCpjIE;ECjDA,WAAA;EACA,yBnC0Ea;AJ8hIf;AM1lIE;EiCVI,WAAA;EACA,8CAAA;AvCumIN;AuCpmII;EAEE,UAAA;EACA,+CAAA;AvCqmIN;;AsChkIE;ECjDA,WAAA;EACA,yBnC0Ea;AJ2iIf;AMvmIE;EiCVI,WAAA;EACA,qEAAA;AvConIN;AuCjnII;EAEE,UAAA;EACA,iDAAA;AvCknIN;;AsC7kIE;ECjDA,WAAA;EACA,yBnC0Ea;AJwjIf;AMpnIE;EiCVI,WAAA;EACA,qEAAA;AvCioIN;AuC9nII;EAEE,UAAA;EACA,+CAAA;AvC+nIN;;AsC1lIE;ECjDA,WAAA;EACA,yBnC0Ea;AJqkIf;AMjoIE;EiCVI,WAAA;EACA,oEAAA;AvC8oIN;AuC3oII;EAEE,UAAA;EACA,gDAAA;AvC4oIN;;AsCvmIE;ECjDA,cAAA;EACA,yBnC0Ea;AJklIf;AM9oIE;EiCVI,cAAA;EACA,yDAAA;AvC2pIN;AuCxpII;EAEE,UAAA;EACA,+CAAA;AvCypIN;;AsCpnIE;ECjDA,WAAA;EACA,yBnC0Ea;AJ+lIf;AM3pIE;EiCVI,WAAA;EACA,qEAAA;AvCwqIN;AuCrqII;EAEE,UAAA;EACA,+CAAA;AvCsqIN;;AsCjoIE;ECjDA,cAAA;EACA,yBnC0Ea;AJ4mIf;AMxqIE;EiCVI,cAAA;EACA,qEAAA;AvCqrIN;AuClrII;EAEE,UAAA;EACA,iDAAA;AvCmrIN;;AsC9oIE;ECjDA,WAAA;EACA,yBnC0Ea;AJynIf;AMrrIE;EiCVI,WAAA;EACA,qEAAA;AvCksIN;AuC/rII;EAEE,UAAA;EACA,8CAAA;AvCgsIN;;AwC7sIA;EACE,kBAAA;EACA,mBpCyzBkC;EoCvzBlC,yBpCKS;EOSP,qBAAA;AXksIJ;AexpII;EyB5DJ;IAQI,kBAAA;ExCgtIF;AACF;AwC7sIA;EACE,gBAAA;EACA,eAAA;E7BIE,gBAAA;AX4sIJ;AyC1tIA;EACE,kBAAA;EACA,wBAAA;EACA,mBrCy9BkC;EqCx9BlC,6BAAA;E9BUE,sBAAA;AXmtIJ;AyCxtIA;EAEE,cAAA;AzCytIF;AyCrtIA;EACE,gBrC6Q4B;AJ08H9B;AyC/sIA;EACE,mBAAA;AzCitIF;AyC9sIE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;EACA,wBAAA;EACA,cAAA;AzCgtIJ;AyCtsIE;EC/CA,mCDgDqH;EnB3CnH,gDmB2CuB;EC9CzB,4CD8CqE;AzC0sIvE;A0CtvIE;EACE,gDAAA;A1CwvIJ;A0CrvIE;EACE,mCAAA;A1CuvIJ;AyCjtIE;EC/CA,0DDgDqH;EnB3CnH,qEmB2CuB;EC9CzB,iED8CqE;AzCqtIvE;A0CjwIE;EACE,oEAAA;A1CmwIJ;A0ChwIE;EACE,0DAAA;A1CkwIJ;AyC5tIE;EC/CA,yDDgDqH;EnB3CnH,oEmB2CuB;EC9CzB,gED8CqE;AzCguIvE;A0C5wIE;EACE,qEAAA;A1C8wIJ;A0C3wIE;EACE,wDAAA;A1C6wIJ;AyCvuIE;EC/CA,yDDgDqH;EnB3CnH,oEmB2CuB;EC9CzB,iED8CqE;AzC2uIvE;A0CvxIE;EACE,qEAAA;A1CyxIJ;A0CtxIE;EACE,yDAAA;A1CwxIJ;AyClvIE;EC/CA,8CDgDqH;EnB3CnH,0DmB2CuB;EC9CzB,sDD8CqE;AzCsvIvE;A0ClyIE;EACE,0DAAA;A1CoyIJ;A0CjyIE;EACE,wDAAA;A1CmyIJ;AyC7vIE;EC/CA,yDDgDqH;EnB3CnH,qEmB2CuB;EC9CzB,iED8CqE;AzCiwIvE;A0C7yIE;EACE,qEAAA;A1C+yIJ;A0C5yIE;EACE,wDAAA;A1C8yIJ;AyCxwIE;EC/CA,0DDgDqH;EnB3CnH,qEmB2CuB;EC9CzB,gED8CqE;AzC4wIvE;A0CxzIE;EACE,qEAAA;A1C0zIJ;A0CvzIE;EACE,yDAAA;A1CyzIJ;AyCnxIE;EC/CA,0DDgDqH;EnB3CnH,qEmB2CuB;EC9CzB,gED8CqE;AzCuxIvE;A0Cn0IE;EACE,oEAAA;A1Cq0IJ;A0Cl0IE;EACE,uDAAA;A1Co0IJ;A2C50IE;EACE;IAAO,2BAAA;E3C+0IT;E2C90IE;IAAK,wBAAA;E3Ci1IP;AACF;A2C90IA;EACE,aAAA;EACA,YvCk+BkC;EuCj+BlC,gBAAA;EACA,cAAA;EtCwKI,kBAAA;EsCtKJ,yBvCLS;EOSP,sBAAA;AX60IJ;A2C50IA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,WvCjBS;EuCkBT,kBAAA;EACA,mBAAA;EACA,yBvCu9BkC;EgBl+B9B,2BuBYJ;A3C80IF;AoBt1IM;EuBDN;IvBEQ,gBAAA;EpBy1IN;AACF;A2Ch1IA;ErBYE,qMAAA;EqBVA,0BAAA;A3Ck1IF;A2C90IE;EACE,kDAAA;A3Cg1IJ;A2C70IM;EAJJ;IAKM,eAAA;E3Cg1IN;AACF;A4C33IA;EACE,aAAA;EACA,uBAAA;A5C63IF;A4C13IA;EACE,OAAA;A5C43IF;A6C93IA;EACE,aAAA;EACA,sBAAA;EAGA,eAAA;EACA,gBAAA;ElCQE,sBAAA;AXu3IJ;A6Cr3IA;EACE,WAAA;EACA,czCRS;EyCST,mBAAA;A7Cu3IF;AM93IE;EuCWE,UAAA;EACA,czCdO;EyCeP,qBAAA;EACA,yBzCtBO;AJ44IX;A6Cn3IE;EACE,czClBO;EyCmBP,yBzC1BO;AJ+4IX;A6C52IA;EACE,kBAAA;EACA,cAAA;EACA,wBAAA;EAGA,sBzC3CS;EyC4CT,sCAAA;A7C42IF;A6C12IE;ElC1BE,+BAAA;EACA,gCAAA;AXu4IJ;A6C12IE;ElChBE,mCAAA;EACA,kCAAA;AX63IJ;A6C12IE;EAEE,czClDO;EyCmDP,oBAAA;EACA,sBzC1DO;AJq6IX;A6Cv2IE;EACE,UAAA;EACA,WzChEO;EyCiEP,yBzCkL0B;EyCjL1B,qBzCiL0B;AJwrI9B;A6Ct2IE;EACE,mBAAA;A7Cw2IJ;A6Ct2II;EACE,gBAAA;EACA,qBzC2JwB;AJ6sI9B;A6C11II;EACE,mBAAA;A7C41IN;A6Cz1IQ;ElC1BJ,kCAAA;EAZA,0BAAA;AXm4IJ;A6Cx1IQ;ElC3CJ,gCAAA;EAYA,4BAAA;AX23IJ;A6Cv1IQ;EACE,aAAA;A7Cy1IV;A6Ct1IQ;EACE,qBzC0HoB;EyCzHpB,oBAAA;A7Cw1IV;A6Ct1IU;EACE,iBAAA;EACA,sBzCqHkB;AJmuI9B;Aen5II;E8BmCA;IACE,mBAAA;E7Cm3IJ;E6Ch3IM;IlC1BJ,kCAAA;IAZA,0BAAA;EX05IF;E6C/2IM;IlC3CJ,gCAAA;IAYA,4BAAA;EXk5IF;E6C92IM;IACE,aAAA;E7Cg3IR;E6C72IM;IACE,qBzC0HoB;IyCzHpB,oBAAA;E7C+2IR;E6C72IQ;IACE,iBAAA;IACA,sBzCqHkB;EJ0vI5B;AACF;Ae36II;E8BmCA;IACE,mBAAA;E7C24IJ;E6Cx4IM;IlC1BJ,kCAAA;IAZA,0BAAA;EXk7IF;E6Cv4IM;IlC3CJ,gCAAA;IAYA,4BAAA;EX06IF;E6Ct4IM;IACE,aAAA;E7Cw4IR;E6Cr4IM;IACE,qBzC0HoB;IyCzHpB,oBAAA;E7Cu4IR;E6Cr4IQ;IACE,iBAAA;IACA,sBzCqHkB;EJkxI5B;AACF;Aen8II;E8BmCA;IACE,mBAAA;E7Cm6IJ;E6Ch6IM;IlC1BJ,kCAAA;IAZA,0BAAA;EX08IF;E6C/5IM;IlC3CJ,gCAAA;IAYA,4BAAA;EXk8IF;E6C95IM;IACE,aAAA;E7Cg6IR;E6C75IM;IACE,qBzC0HoB;IyCzHpB,oBAAA;E7C+5IR;E6C75IQ;IACE,iBAAA;IACA,sBzCqHkB;EJ0yI5B;AACF;Ae39II;E8BmCA;IACE,mBAAA;E7C27IJ;E6Cx7IM;IlC1BJ,kCAAA;IAZA,0BAAA;EXk+IF;E6Cv7IM;IlC3CJ,gCAAA;IAYA,4BAAA;EX09IF;E6Ct7IM;IACE,aAAA;E7Cw7IR;E6Cr7IM;IACE,qBzC0HoB;IyCzHpB,oBAAA;E7Cu7IR;E6Cr7IQ;IACE,iBAAA;IACA,sBzCqHkB;EJk0I5B;AACF;A6C16IA;ElCnHI,gBAAA;AXgiJJ;A6C16IE;EACE,qBAAA;A7C46IJ;A6C16II;EACE,sBAAA;A7C46IN;A8CrjJE;EACE,mCDoJsE;ECnJtE,gDDmJuC;A7Co6I3C;AM5iJE;EwCPM,mCD+IkE;EC9IlE,gDAAA;A9CsjJR;A8CnjJM;EACE,W1CPG;E0CQH,8CDyIkE;ECxIlE,0CDwIkE;A7C66I1E;A8ClkJE;EACE,0DDoJsE;ECnJtE,qEDmJuC;A7Ci7I3C;AMzjJE;EwCPM,0DD+IkE;EC9IlE,oEAAA;A9CmkJR;A8ChkJM;EACE,W1CPG;E0CQH,qEDyIkE;ECxIlE,iEDwIkE;A7C07I1E;A8C/kJE;EACE,yDDoJsE;ECnJtE,oEDmJuC;A7C87I3C;AMtkJE;EwCPM,yDD+IkE;EC9IlE,qEAAA;A9CglJR;A8C7kJM;EACE,W1CPG;E0CQH,oEDyIkE;ECxIlE,gEDwIkE;A7Cu8I1E;A8C5lJE;EACE,yDDoJsE;ECnJtE,qEDmJuC;A7C28I3C;AMnlJE;EwCPM,yDD+IkE;EC9IlE,qEAAA;A9C6lJR;A8C1lJM;EACE,W1CPG;E0CQH,oEDyIkE;ECxIlE,gEDwIkE;A7Co9I1E;A8CzmJE;EACE,8CDoJsE;ECnJtE,0DDmJuC;A7Cw9I3C;AMhmJE;EwCPM,8CD+IkE;EC9IlE,0DAAA;A9C0mJR;A8CvmJM;EACE,W1CPG;E0CQH,yDDyIkE;ECxIlE,qDDwIkE;A7Ci+I1E;A8CtnJE;EACE,yDDoJsE;ECnJtE,qEDmJuC;A7Cq+I3C;AM7mJE;EwCPM,yDD+IkE;EC9IlE,qEAAA;A9CunJR;A8CpnJM;EACE,W1CPG;E0CQH,oEDyIkE;ECxIlE,gEDwIkE;A7C8+I1E;A8CnoJE;EACE,0DDoJsE;ECnJtE,oEDmJuC;A7Ck/I3C;AM1nJE;EwCPM,0DD+IkE;EC9IlE,qEAAA;A9CooJR;A8CjoJM;EACE,W1CPG;E0CQH,qEDyIkE;ECxIlE,iEDwIkE;A7C2/I1E;A8ChpJE;EACE,0DDoJsE;ECnJtE,oEDmJuC;A7C+/I3C;AMvoJE;EwCPM,0DD+IkE;EC9IlE,oEAAA;A9CipJR;A8C9oJM;EACE,W1CPG;E0CQH,qEDyIkE;ECxIlE,iEDwIkE;A7CwgJ1E;A+ChqJA;EACE,YAAA;E1CmLI,iBAAA;E0CjLJ,gB3C8R4B;E2C7R5B,cAAA;EACA,W3CYS;E2CXT,yB3CylCkC;E2CxlClC,YAAA;A/CkqJF;AM7pJE;EyCDE,W3CMO;E2CLP,qBAAA;A/CiqJJ;AM7pJE;EyCCI,aAAA;A/C+pJN;A+CppJA;EACE,UAAA;EACA,6BAAA;EACA,SAAA;A/CspJF;A+ChpJA;EACE,oBAAA;A/CkpJF;AgDxrJA;EAGE,iB5C24BkC;E4C14BlC,gB5C04BkC;EC1tB9B,mBAAA;E2C7KJ,2C5C44BkC;E4C34BlC,4BAAA;EACA,oCAAA;EACA,gD5C64BkC;E4C54BlC,UAAA;ErCOE,sBAAA;AXirJJ;AgDrrJE;EACE,sB5Cg4BgC;AJuzHpC;AgDprJE;EACE,UAAA;AhDsrJJ;AgDnrJE;EACE,cAAA;EACA,UAAA;AhDqrJJ;AgDlrJE;EACE,aAAA;AhDorJJ;AgDhrJA;EACE,aAAA;EACA,mBAAA;EACA,wBAAA;EACA,c5CvBS;E4CwBT,2C5Cq3BkC;E4Cp3BlC,4BAAA;EACA,4CAAA;ErCZE,2CAAA;EACA,4CAAA;AX+rJJ;AgDhrJA;EACE,gB5Cm2BkC;AJ+0HpC;AiDxtJA;EAEE,gBAAA;AjDytJF;AiDvtJE;EACE,kBAAA;EACA,gBAAA;AjDytJJ;AiDptJA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,a7C4pBkC;E6C3pBlC,aAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EAGA,UAAA;AjDotJF;AiD7sJA;EACE,kBAAA;EACA,WAAA;EACA,c7Ci5BkC;E6C/4BlC,oBAAA;AjD8sJF;AiD3sJE;E7B3BI,mC6B4BF;AjD6sJJ;AoBruJM;E6BuBJ;I7BtBM,gBAAA;EpBwuJN;AACF;AiDntJE;EAEE,8B7Cu6BgC;AJ6yHpC;AiDltJE;EACE,e7Cq6BgC;AJ+yHpC;AiDhtJE;EACE,sB7Ck6BgC;AJgzHpC;AiD9sJA;EACE,aAAA;EACA,6BAAA;AjDgtJF;AiD9sJE;EACE,8BAAA;EACA,gBAAA;AjDgtJJ;AiD7sJE;;EAEE,cAAA;AjD+sJJ;AiD5sJE;EACE,gBAAA;AjD8sJJ;AiD1sJA;EACE,aAAA;EACA,mBAAA;EACA,6BAAA;AjD4sJF;AiDzsJE;EACE,cAAA;EACA,0BAAA;EACA,mBAAA;EACA,WAAA;AjD2sJJ;AiDvsJE;EACE,sBAAA;EACA,uBAAA;EACA,YAAA;AjDysJJ;AiDvsJI;EACE,gBAAA;AjDysJN;AiDtsJI;EACE,aAAA;AjDwsJN;AiDlsJA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EAGA,oBAAA;EACA,sB7C3GS;E6C4GT,4BAAA;EACA,oCAAA;EtClGE,qBAAA;EsCsGF,UAAA;AjDgsJF;AiD5rJA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,a7CgjBkC;E6C/iBlC,YAAA;EACA,aAAA;EACA,sB7ClHS;AJgzJX;AiD3rJE;EAAS,UAAA;AjD8rJX;AiD7rJE;EAAS,Y7C+zByB;AJi4HpC;AiD3rJA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,kB7C6zBkC;E6C5zBlC,gCAAA;EtCtHE,0CAAA;EACA,2CAAA;AXozJJ;AiD5rJE;EACE,kB7CwzBgC;E6CtzBhC,8BAAA;AjD6rJJ;AiDxrJA;EACE,gBAAA;EACA,gB7CuI4B;AJmjJ9B;AiDrrJA;EACE,kBAAA;EAGA,cAAA;EACA,a7C0wBkC;AJ26HpC;AiDjrJA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,6BAAA;EtCzIE,8CAAA;EACA,6CAAA;AX6zJJ;AiD/qJE;EACE,eAAA;AjDirJJ;AiD5qJA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AjD8qJF;AerzJI;EkC6IF;IACE,gB7CuwBgC;I6CtwBhC,oBAAA;EjD2qJF;EiDxqJA;IACE,+BAAA;EjD0qJF;EiDxqJE;IACE,gCAAA;EjD0qJJ;EiDtqJA;IACE,+BAAA;EjDwqJF;EiDtqJE;IACE,4BAAA;IACA,mBAAA;EjDwqJJ;EiDhqJA;IAAY,gB7C+uBsB;EJo7HlC;AACF;Ae30JI;EkC2KF;;IAEE,gB7CuuBgC;EJ47HlC;AACF;Aej1JI;EkCkLF;IAAY,iB7CiuBsB;EJk8HlC;AACF;AkDj5JA;EACE,kBAAA;EACA,a9CgrBkC;E8C/qBlC,cAAA;EACA,S9C61BkC;E+Cj2BlC,qN/CoR4B;E+ClR5B,kBAAA;EACA,gB/C4R4B;E+C3R5B,gB/CgS4B;E+C/R5B,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;E9CqKI,mBAAA;E6CzKJ,qBAAA;EACA,UAAA;AlD65JF;AkD35JE;EAAS,Y9Ci1ByB;AJ6kIpC;AkD55JE;EACE,kBAAA;EACA,cAAA;EACA,a9Ci1BgC;E8Ch1BhC,c9Ci1BgC;AJ6kIpC;AkD55JI;EACE,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;AlD85JN;AkDz5JA;EACE,iBAAA;AlD25JF;AkDz5JE;EACE,SAAA;AlD25JJ;AkDz5JI;EACE,MAAA;EACA,6BAAA;EACA,sB9CvBK;AJk7JX;AkDt5JA;EACE,iBAAA;AlDw5JF;AkDt5JE;EACE,OAAA;EACA,a9CmzBgC;E8ClzBhC,c9CizBgC;AJumIpC;AkDt5JI;EACE,QAAA;EACA,oCAAA;EACA,wB9CvCK;AJ+7JX;AkDn5JA;EACE,iBAAA;AlDq5JF;AkDn5JE;EACE,MAAA;AlDq5JJ;AkDn5JI;EACE,SAAA;EACA,6BAAA;EACA,yB9CrDK;AJ08JX;AkDh5JA;EACE,iBAAA;AlDk5JF;AkDh5JE;EACE,QAAA;EACA,a9CqxBgC;E8CpxBhC,c9CmxBgC;AJ+nIpC;AkDh5JI;EACE,OAAA;EACA,oCAAA;EACA,uB9CrEK;AJu9JX;AkD73JA;EACE,gB9C+uBkC;E8C9uBlC,uBAAA;EACA,W9CvGS;E8CwGT,kBAAA;EACA,sB9C/FS;EOCP,sBAAA;AX89JJ;AoDh/JA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,ahD8qBkC;EgD7qBlC,cAAA;EACA,gBhD+2BkC;E+Cp3BlC,qN/CoR4B;E+ClR5B,kBAAA;EACA,gB/C4R4B;E+C3R5B,gB/CgS4B;E+C/R5B,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;E9CqKI,mBAAA;E+CxKJ,qBAAA;EACA,sBhDNS;EgDOT,4BAAA;EACA,oCAAA;EzCGE,qBAAA;AX0/JJ;AoDz/JE;EACE,kBAAA;EACA,cAAA;EACA,WhD+2BgC;EgD92BhC,chD+2BgC;EgD92BhC,gBAAA;ApD2/JJ;AoDz/JI;EAEE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;ApD0/JN;AoDr/JA;EACE,qBhDg2BkC;AJupIpC;AoDr/JE;EACE,2BAAA;ApDu/JJ;AoDr/JI;EACE,SAAA;EACA,6BAAA;EACA,qChD21B8B;AJ4pIpC;AoDp/JI;EACE,WhD0LwB;EgDzLxB,6BAAA;EACA,sBhD7CK;AJmiKX;AoDj/JA;EACE,mBhD40BkC;AJuqIpC;AoDj/JE;EACE,yBAAA;EACA,ahDw0BgC;EgDv0BhC,YhDs0BgC;EgDr0BhC,gBAAA;ApDm/JJ;AoDj/JI;EACE,OAAA;EACA,oCAAA;EACA,uChDo0B8B;AJ+qIpC;AoDh/JI;EACE,ShDmKwB;EgDlKxB,oCAAA;EACA,wBhDpEK;AJsjKX;AoD7+JA;EACE,kBhDqzBkC;AJ0rIpC;AoD7+JE;EACE,wBAAA;ApD++JJ;AoD7+JI;EACE,MAAA;EACA,oCAAA;EACA,wChDgzB8B;AJ+rIpC;AoD5+JI;EACE,QhD+IwB;EgD9IxB,oCAAA;EACA,yBhDxFK;AJskKX;AoDz+JE;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,cAAA;EACA,WhD4xBgC;EgD3xBhC,oBAAA;EACA,WAAA;EACA,2CAAA;ApD2+JJ;AoDv+JA;EACE,oBhDqxBkC;AJotIpC;AoDv+JE;EACE,0BAAA;EACA,ahDixBgC;EgDhxBhC,YhD+wBgC;EgD9wBhC,gBAAA;ApDy+JJ;AoDv+JI;EACE,QAAA;EACA,oCAAA;EACA,sChD6wB8B;AJ4tIpC;AoDt+JI;EACE,UhD4GwB;EgD3GxB,oCAAA;EACA,uBhD3HK;AJmmKX;AoDl9JA;EACE,uBAAA;EACA,gBAAA;E/C0BI,eAAA;E+CvBJ,oChD+tBkC;EgD9tBlC,2CAAA;EzCnIE,0CAAA;EACA,2CAAA;AXulKJ;AoDl9JE;EACE,aAAA;ApDo9JJ;AoDh9JA;EACE,uBAAA;EACA,chDxJS;AJ0mKX;AqD7mKA;EACE,kBAAA;ArD+mKF;AqD5mKA;EACE,mBAAA;ArD8mKF;AqD3mKA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;ArD6mKF;AsDpoKE;EACE,cAAA;EACA,WAAA;EACA,WAAA;AtDsoKJ;AqD9mKA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,2BAAA;EjClBI,sCiCmBJ;ArDgnKF;AoB/nKM;EiCQN;IjCPQ,gBAAA;EpBkoKN;AACF;AqDlnKA;;;EAGE,cAAA;ArDonKF;AqDjnKA;;EAEE,2BAAA;ArDmnKF;AqDhnKA;;EAEE,4BAAA;ArDknKF;AqDzmKE;EACE,UAAA;EACA,4BAAA;EACA,eAAA;ArD2mKJ;AqDxmKE;;;EAGE,UAAA;EACA,UAAA;ArD0mKJ;AqDvmKE;;EAEE,UAAA;EACA,UAAA;EjC5DE,2BiC6DF;ArDymKJ;AoBlqKM;EiCqDJ;;IjCpDM,gBAAA;EpBsqKN;AACF;AqDtmKA;;EAEE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UjDs9BmC;EiDr9BnC,UAAA;EACA,WjD3FS;EiD4FT,kBAAA;EACA,gBAAA;EACA,SAAA;EACA,YjDi9BmC;EgBviC/B,8BiCuFJ;ArDumKF;AoB1rKM;EiCkEN;;IjCjEQ,gBAAA;EpB8rKN;AACF;AMpsKE;;;E+C2FE,WjDpGO;EiDqGP,qBAAA;EACA,UAAA;EACA,YjD08BiC;AJoqIrC;AqD3mKA;EACE,OAAA;ArD6mKF;AqDxmKA;EACE,QAAA;ArD0mKF;AqDnmKA;;EAEE,qBAAA;EACA,WjDm8BmC;EiDl8BnC,YjDk8BmC;EiDj8BnC,mCAAA;ArDqmKF;AqDnmKA;EACE,yDAAA;ArDqmKF;AqDnmKA;EACE,yDAAA;ArDqmKF;AqD5lKA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;EAEA,iBjDy5BmC;EiDx5BnC,gBjDw5BmC;EiDv5BnC,gBAAA;ArD6lKF;AqD3lKE;EACE,uBAAA;EACA,cAAA;EACA,WjDu5BiC;EiDt5BjC,WjDu5BiC;EiDt5BjC,iBjDw5BiC;EiDv5BjC,gBjDu5BiC;EiDt5BjC,mBAAA;EACA,eAAA;EACA,sBjDnKO;EiDoKP,4BAAA;EAEA,kCAAA;EACA,qCAAA;EACA,YAAA;EjC/JE,6BiCgKF;ArD4lKJ;AoBxvKM;EiC6IJ;IjC5IM,gBAAA;EpB2vKN;AACF;AqD9lKE;EACE,UAAA;ArDgmKJ;AqDvlKA;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;EACA,iBAAA;EACA,oBAAA;EACA,WjD9LS;EiD+LT,kBAAA;ArDylKF;AuD3xKA;EACE;IAAK,yBAAA;EvD8xKL;AACF;AuD5xKA;EACE,qBAAA;EACA,WnDskCwB;EmDrkCxB,YnDqkCwB;EmDpkCxB,wBnDskCwB;EmDrkCxB,iCAAA;EACA,+BAAA;EAEA,kBAAA;EACA,+CAAA;AvD6xKF;AuD1xKA;EACE,WnDgkCwB;EmD/jCxB,YnD+jCwB;EmD9jCxB,mBnDgkCwB;AJ4tI1B;AuDrxKA;EACE;IACE,mBAAA;EvDuxKF;EuDrxKA;IACE,UAAA;IACA,eAAA;EvDuxKF;AACF;AuDpxKA;EACE,qBAAA;EACA,WnDsiCwB;EmDriCxB,YnDqiCwB;EmDpiCxB,wBnDsiCwB;EmDriCxB,8BAAA;EAEA,kBAAA;EACA,UAAA;EACA,6CAAA;AvDqxKF;AuDlxKA;EACE,WnDgiCwB;EmD/hCxB,YnD+hCwB;AJqvI1B;AuDhxKE;EACE;;IAEE,wBAAA;EvDkxKJ;AACF;AwD90KA;EAAqB,mCAAA;AxDi1KrB;AwDh1KA;EAAqB,8BAAA;AxDm1KrB;AwDl1KA;EAAqB,iCAAA;AxDq1KrB;AwDp1KA;EAAqB,iCAAA;AxDu1KrB;AwDt1KA;EAAqB,sCAAA;AxDy1KrB;AwDx1KA;EAAqB,mCAAA;AxD21KrB;AyD71KE;EACE,oCAAA;AzD+1KJ;AMr1KE;;;EmDLI,yDAAA;AzD+1KN;AyDr2KE;EACE,oCAAA;AzDu2KJ;AM71KE;;;EmDLI,gFAAA;AzDu2KN;AyD72KE;EACE,oCAAA;AzD+2KJ;AMr2KE;;;EmDLI,gFAAA;AzD+2KN;AyDr3KE;EACE,oCAAA;AzDu3KJ;AM72KE;;;EmDLI,+EAAA;AzDu3KN;AyD73KE;EACE,oCAAA;AzD+3KJ;AMr3KE;;;EmDLI,oEAAA;AzD+3KN;AyDr4KE;EACE,oCAAA;AzDu4KJ;AM73KE;;;EmDLI,gFAAA;AzDu4KN;AyD74KE;EACE,oCAAA;AzD+4KJ;AMr4KE;;;EmDLI,gFAAA;AzD+4KN;AyDr5KE;EACE,oCAAA;AzDu5KJ;AM74KE;;;EmDLI,gFAAA;AzDu5KN;A0Dt5KA;EACE,iCAAA;A1Dw5KF;A0Dr5KA;EACE,wCAAA;A1Du5KF;A2Dl6KA;EAAkB,oCAAA;A3Dq6KlB;A2Dp6KA;EAAkB,wCAAA;A3Du6KlB;A2Dt6KA;EAAkB,0CAAA;A3Dy6KlB;A2Dx6KA;EAAkB,2CAAA;A3D26KlB;A2D16KA;EAAkB,yCAAA;A3D66KlB;A2D36KA;EAAmB,oBAAA;A3D86KnB;A2D76KA;EAAmB,wBAAA;A3Dg7KnB;A2D/6KA;EAAmB,0BAAA;A3Dk7KnB;A2Dj7KA;EAAmB,2BAAA;A3Do7KnB;A2Dn7KA;EAAmB,yBAAA;A3Ds7KnB;A2Dn7KE;EACE,gCAAA;A3Dq7KJ;A2Dt7KE;EACE,gCAAA;A3Dw7KJ;A2Dz7KE;EACE,gCAAA;A3D27KJ;A2D57KE;EACE,gCAAA;A3D87KJ;A2D/7KE;EACE,gCAAA;A3Di8KJ;A2Dl8KE;EACE,gCAAA;A3Do8KJ;A2Dr8KE;EACE,gCAAA;A3Du8KJ;A2Dx8KE;EACE,gCAAA;A3D08KJ;A2Dt8KA;EACE,6BAAA;A3Dw8KF;A2Dj8KA;EACE,gCAAA;A3Dm8KF;A2Dh8KA;EACE,iCAAA;A3Dk8KF;A2D/7KA;EACE,0CAAA;EACA,2CAAA;A3Di8KF;A2D97KA;EACE,2CAAA;EACA,8CAAA;A3Dg8KF;A2D77KA;EACE,8CAAA;EACA,6CAAA;A3D+7KF;A2D57KA;EACE,0CAAA;EACA,6CAAA;A3D87KF;A2D37KA;EACE,gCAAA;A3D67KF;A2D17KA;EACE,6BAAA;A3D47KF;A2Dz7KA;EACE,+BAAA;A3D27KF;A2Dx7KA;EACE,2BAAA;A3D07KF;AsDlgLE;EACE,cAAA;EACA,WAAA;EACA,WAAA;AtDogLJ;A4D7/KM;EAAwB,wBAAA;A5DggL9B;A4DhgLM;EAAwB,0BAAA;A5DmgL9B;A4DngLM;EAAwB,gCAAA;A5DsgL9B;A4DtgLM;EAAwB,yBAAA;A5DygL9B;A4DzgLM;EAAwB,yBAAA;A5D4gL9B;A4D5gLM;EAAwB,6BAAA;A5D+gL9B;A4D/gLM;EAAwB,8BAAA;A5DkhL9B;A4DlhLM;EAAwB,wBAAA;A5DqhL9B;A4DrhLM;EAAwB,+BAAA;A5DwhL9B;Aev+KI;E6CjDE;IAAwB,wBAAA;E5D4hL5B;E4D5hLI;IAAwB,0BAAA;E5D+hL5B;E4D/hLI;IAAwB,gCAAA;E5DkiL5B;E4DliLI;IAAwB,yBAAA;E5DqiL5B;E4DriLI;IAAwB,yBAAA;E5DwiL5B;E4DxiLI;IAAwB,6BAAA;E5D2iL5B;E4D3iLI;IAAwB,8BAAA;E5D8iL5B;E4D9iLI;IAAwB,wBAAA;E5DijL5B;E4DjjLI;IAAwB,+BAAA;E5DojL5B;AACF;AepgLI;E6CjDE;IAAwB,wBAAA;E5DyjL5B;E4DzjLI;IAAwB,0BAAA;E5D4jL5B;E4D5jLI;IAAwB,gCAAA;E5D+jL5B;E4D/jLI;IAAwB,yBAAA;E5DkkL5B;E4DlkLI;IAAwB,yBAAA;E5DqkL5B;E4DrkLI;IAAwB,6BAAA;E5DwkL5B;E4DxkLI;IAAwB,8BAAA;E5D2kL5B;E4D3kLI;IAAwB,wBAAA;E5D8kL5B;E4D9kLI;IAAwB,+BAAA;E5DilL5B;AACF;AejiLI;E6CjDE;IAAwB,wBAAA;E5DslL5B;E4DtlLI;IAAwB,0BAAA;E5DylL5B;E4DzlLI;IAAwB,gCAAA;E5D4lL5B;E4D5lLI;IAAwB,yBAAA;E5D+lL5B;E4D/lLI;IAAwB,yBAAA;E5DkmL5B;E4DlmLI;IAAwB,6BAAA;E5DqmL5B;E4DrmLI;IAAwB,8BAAA;E5DwmL5B;E4DxmLI;IAAwB,wBAAA;E5D2mL5B;E4D3mLI;IAAwB,+BAAA;E5D8mL5B;AACF;Ae9jLI;E6CjDE;IAAwB,wBAAA;E5DmnL5B;E4DnnLI;IAAwB,0BAAA;E5DsnL5B;E4DtnLI;IAAwB,gCAAA;E5DynL5B;E4DznLI;IAAwB,yBAAA;E5D4nL5B;E4D5nLI;IAAwB,yBAAA;E5D+nL5B;E4D/nLI;IAAwB,6BAAA;E5DkoL5B;E4DloLI;IAAwB,8BAAA;E5DqoL5B;E4DroLI;IAAwB,wBAAA;E5DwoL5B;E4DxoLI;IAAwB,+BAAA;E5D2oL5B;AACF;A4DloLA;EAEI;IAAqB,wBAAA;E5DooLvB;E4DpoLE;IAAqB,0BAAA;E5DuoLvB;E4DvoLE;IAAqB,gCAAA;E5D0oLvB;E4D1oLE;IAAqB,yBAAA;E5D6oLvB;E4D7oLE;IAAqB,yBAAA;E5DgpLvB;E4DhpLE;IAAqB,6BAAA;E5DmpLvB;E4DnpLE;IAAqB,8BAAA;E5DspLvB;E4DtpLE;IAAqB,wBAAA;E5DypLvB;E4DzpLE;IAAqB,+BAAA;E5D4pLvB;AACF;A6DlrLA;EACE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,UAAA;EACA,gBAAA;A7DorLF;A6DlrLE;EACE,cAAA;EACA,WAAA;A7DorLJ;A6DjrLE;;;;;EAKE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;A7DmrLJ;A6D1qLI;EACE,yBAAA;A7D4qLN;A6D7qLI;EACE,mBAAA;A7D+qLN;A6DhrLI;EACE,gBAAA;A7DkrLN;A6DnrLI;EACE,iBAAA;A7DqrLN;A8D9sLI;EAAgC,8BAAA;A9DitLpC;A8DhtLI;EAAgC,iCAAA;A9DmtLpC;A8DltLI;EAAgC,sCAAA;A9DqtLpC;A8DptLI;EAAgC,yCAAA;A9DutLpC;A8DrtLI;EAA8B,0BAAA;A9DwtLlC;A8DvtLI;EAA8B,4BAAA;A9D0tLlC;A8DztLI;EAA8B,kCAAA;A9D4tLlC;A8D3tLI;EAA8B,yBAAA;A9D8tLlC;A8D7tLI;EAA8B,uBAAA;A9DguLlC;A8D/tLI;EAA8B,uBAAA;A9DkuLlC;A8DjuLI;EAA8B,yBAAA;A9DouLlC;A8DnuLI;EAA8B,yBAAA;A9DsuLlC;A8DpuLI;EAAoC,sCAAA;A9DuuLxC;A8DtuLI;EAAoC,oCAAA;A9DyuLxC;A8DxuLI;EAAoC,kCAAA;A9D2uLxC;A8D1uLI;EAAoC,yCAAA;A9D6uLxC;A8D5uLI;EAAoC,wCAAA;A9D+uLxC;A8D7uLI;EAAiC,kCAAA;A9DgvLrC;A8D/uLI;EAAiC,gCAAA;A9DkvLrC;A8DjvLI;EAAiC,8BAAA;A9DovLrC;A8DnvLI;EAAiC,gCAAA;A9DsvLrC;A8DrvLI;EAAiC,+BAAA;A9DwvLrC;A8DtvLI;EAAkC,oCAAA;A9DyvLtC;A8DxvLI;EAAkC,kCAAA;A9D2vLtC;A8D1vLI;EAAkC,gCAAA;A9D6vLtC;A8D5vLI;EAAkC,uCAAA;A9D+vLtC;A8D9vLI;EAAkC,sCAAA;A9DiwLtC;A8DhwLI;EAAkC,iCAAA;A9DmwLtC;A8DjwLI;EAAgC,2BAAA;A9DowLpC;A8DnwLI;EAAgC,iCAAA;A9DswLpC;A8DrwLI;EAAgC,+BAAA;A9DwwLpC;A8DvwLI;EAAgC,6BAAA;A9D0wLpC;A8DzwLI;EAAgC,+BAAA;A9D4wLpC;A8D3wLI;EAAgC,8BAAA;A9D8wLpC;AelwLI;E+ClDA;IAAgC,8BAAA;E9DwzLlC;E8DvzLE;IAAgC,iCAAA;E9D0zLlC;E8DzzLE;IAAgC,sCAAA;E9D4zLlC;E8D3zLE;IAAgC,yCAAA;E9D8zLlC;E8D5zLE;IAA8B,0BAAA;E9D+zLhC;E8D9zLE;IAA8B,4BAAA;E9Di0LhC;E8Dh0LE;IAA8B,kCAAA;E9Dm0LhC;E8Dl0LE;IAA8B,yBAAA;E9Dq0LhC;E8Dp0LE;IAA8B,uBAAA;E9Du0LhC;E8Dt0LE;IAA8B,uBAAA;E9Dy0LhC;E8Dx0LE;IAA8B,yBAAA;E9D20LhC;E8D10LE;IAA8B,yBAAA;E9D60LhC;E8D30LE;IAAoC,sCAAA;E9D80LtC;E8D70LE;IAAoC,oCAAA;E9Dg1LtC;E8D/0LE;IAAoC,kCAAA;E9Dk1LtC;E8Dj1LE;IAAoC,yCAAA;E9Do1LtC;E8Dn1LE;IAAoC,wCAAA;E9Ds1LtC;E8Dp1LE;IAAiC,kCAAA;E9Du1LnC;E8Dt1LE;IAAiC,gCAAA;E9Dy1LnC;E8Dx1LE;IAAiC,8BAAA;E9D21LnC;E8D11LE;IAAiC,gCAAA;E9D61LnC;E8D51LE;IAAiC,+BAAA;E9D+1LnC;E8D71LE;IAAkC,oCAAA;E9Dg2LpC;E8D/1LE;IAAkC,kCAAA;E9Dk2LpC;E8Dj2LE;IAAkC,gCAAA;E9Do2LpC;E8Dn2LE;IAAkC,uCAAA;E9Ds2LpC;E8Dr2LE;IAAkC,sCAAA;E9Dw2LpC;E8Dv2LE;IAAkC,iCAAA;E9D02LpC;E8Dx2LE;IAAgC,2BAAA;E9D22LlC;E8D12LE;IAAgC,iCAAA;E9D62LlC;E8D52LE;IAAgC,+BAAA;E9D+2LlC;E8D92LE;IAAgC,6BAAA;E9Di3LlC;E8Dh3LE;IAAgC,+BAAA;E9Dm3LlC;E8Dl3LE;IAAgC,8BAAA;E9Dq3LlC;AACF;Ae12LI;E+ClDA;IAAgC,8BAAA;E9Dg6LlC;E8D/5LE;IAAgC,iCAAA;E9Dk6LlC;E8Dj6LE;IAAgC,sCAAA;E9Do6LlC;E8Dn6LE;IAAgC,yCAAA;E9Ds6LlC;E8Dp6LE;IAA8B,0BAAA;E9Du6LhC;E8Dt6LE;IAA8B,4BAAA;E9Dy6LhC;E8Dx6LE;IAA8B,kCAAA;E9D26LhC;E8D16LE;IAA8B,yBAAA;E9D66LhC;E8D56LE;IAA8B,uBAAA;E9D+6LhC;E8D96LE;IAA8B,uBAAA;E9Di7LhC;E8Dh7LE;IAA8B,yBAAA;E9Dm7LhC;E8Dl7LE;IAA8B,yBAAA;E9Dq7LhC;E8Dn7LE;IAAoC,sCAAA;E9Ds7LtC;E8Dr7LE;IAAoC,oCAAA;E9Dw7LtC;E8Dv7LE;IAAoC,kCAAA;E9D07LtC;E8Dz7LE;IAAoC,yCAAA;E9D47LtC;E8D37LE;IAAoC,wCAAA;E9D87LtC;E8D57LE;IAAiC,kCAAA;E9D+7LnC;E8D97LE;IAAiC,gCAAA;E9Di8LnC;E8Dh8LE;IAAiC,8BAAA;E9Dm8LnC;E8Dl8LE;IAAiC,gCAAA;E9Dq8LnC;E8Dp8LE;IAAiC,+BAAA;E9Du8LnC;E8Dr8LE;IAAkC,oCAAA;E9Dw8LpC;E8Dv8LE;IAAkC,kCAAA;E9D08LpC;E8Dz8LE;IAAkC,gCAAA;E9D48LpC;E8D38LE;IAAkC,uCAAA;E9D88LpC;E8D78LE;IAAkC,sCAAA;E9Dg9LpC;E8D/8LE;IAAkC,iCAAA;E9Dk9LpC;E8Dh9LE;IAAgC,2BAAA;E9Dm9LlC;E8Dl9LE;IAAgC,iCAAA;E9Dq9LlC;E8Dp9LE;IAAgC,+BAAA;E9Du9LlC;E8Dt9LE;IAAgC,6BAAA;E9Dy9LlC;E8Dx9LE;IAAgC,+BAAA;E9D29LlC;E8D19LE;IAAgC,8BAAA;E9D69LlC;AACF;Ael9LI;E+ClDA;IAAgC,8BAAA;E9DwgMlC;E8DvgME;IAAgC,iCAAA;E9D0gMlC;E8DzgME;IAAgC,sCAAA;E9D4gMlC;E8D3gME;IAAgC,yCAAA;E9D8gMlC;E8D5gME;IAA8B,0BAAA;E9D+gMhC;E8D9gME;IAA8B,4BAAA;E9DihMhC;E8DhhME;IAA8B,kCAAA;E9DmhMhC;E8DlhME;IAA8B,yBAAA;E9DqhMhC;E8DphME;IAA8B,uBAAA;E9DuhMhC;E8DthME;IAA8B,uBAAA;E9DyhMhC;E8DxhME;IAA8B,yBAAA;E9D2hMhC;E8D1hME;IAA8B,yBAAA;E9D6hMhC;E8D3hME;IAAoC,sCAAA;E9D8hMtC;E8D7hME;IAAoC,oCAAA;E9DgiMtC;E8D/hME;IAAoC,kCAAA;E9DkiMtC;E8DjiME;IAAoC,yCAAA;E9DoiMtC;E8DniME;IAAoC,wCAAA;E9DsiMtC;E8DpiME;IAAiC,kCAAA;E9DuiMnC;E8DtiME;IAAiC,gCAAA;E9DyiMnC;E8DxiME;IAAiC,8BAAA;E9D2iMnC;E8D1iME;IAAiC,gCAAA;E9D6iMnC;E8D5iME;IAAiC,+BAAA;E9D+iMnC;E8D7iME;IAAkC,oCAAA;E9DgjMpC;E8D/iME;IAAkC,kCAAA;E9DkjMpC;E8DjjME;IAAkC,gCAAA;E9DojMpC;E8DnjME;IAAkC,uCAAA;E9DsjMpC;E8DrjME;IAAkC,sCAAA;E9DwjMpC;E8DvjME;IAAkC,iCAAA;E9D0jMpC;E8DxjME;IAAgC,2BAAA;E9D2jMlC;E8D1jME;IAAgC,iCAAA;E9D6jMlC;E8D5jME;IAAgC,+BAAA;E9D+jMlC;E8D9jME;IAAgC,6BAAA;E9DikMlC;E8DhkME;IAAgC,+BAAA;E9DmkMlC;E8DlkME;IAAgC,8BAAA;E9DqkMlC;AACF;Ae1jMI;E+ClDA;IAAgC,8BAAA;E9DgnMlC;E8D/mME;IAAgC,iCAAA;E9DknMlC;E8DjnME;IAAgC,sCAAA;E9DonMlC;E8DnnME;IAAgC,yCAAA;E9DsnMlC;E8DpnME;IAA8B,0BAAA;E9DunMhC;E8DtnME;IAA8B,4BAAA;E9DynMhC;E8DxnME;IAA8B,kCAAA;E9D2nMhC;E8D1nME;IAA8B,yBAAA;E9D6nMhC;E8D5nME;IAA8B,uBAAA;E9D+nMhC;E8D9nME;IAA8B,uBAAA;E9DioMhC;E8DhoME;IAA8B,yBAAA;E9DmoMhC;E8DloME;IAA8B,yBAAA;E9DqoMhC;E8DnoME;IAAoC,sCAAA;E9DsoMtC;E8DroME;IAAoC,oCAAA;E9DwoMtC;E8DvoME;IAAoC,kCAAA;E9D0oMtC;E8DzoME;IAAoC,yCAAA;E9D4oMtC;E8D3oME;IAAoC,wCAAA;E9D8oMtC;E8D5oME;IAAiC,kCAAA;E9D+oMnC;E8D9oME;IAAiC,gCAAA;E9DipMnC;E8DhpME;IAAiC,8BAAA;E9DmpMnC;E8DlpME;IAAiC,gCAAA;E9DqpMnC;E8DppME;IAAiC,+BAAA;E9DupMnC;E8DrpME;IAAkC,oCAAA;E9DwpMpC;E8DvpME;IAAkC,kCAAA;E9D0pMpC;E8DzpME;IAAkC,gCAAA;E9D4pMpC;E8D3pME;IAAkC,uCAAA;E9D8pMpC;E8D7pME;IAAkC,sCAAA;E9DgqMpC;E8D/pME;IAAkC,iCAAA;E9DkqMpC;E8DhqME;IAAgC,2BAAA;E9DmqMlC;E8DlqME;IAAgC,iCAAA;E9DqqMlC;E8DpqME;IAAgC,+BAAA;E9DuqMlC;E8DtqME;IAAgC,6BAAA;E9DyqMlC;E8DxqME;IAAgC,+BAAA;E9D2qMlC;E8D1qME;IAAgC,8BAAA;E9D6qMlC;AACF;A+DxtMI;EAAwB,sBAAA;A/D2tM5B;A+D1tMI;EAAwB,uBAAA;A/D6tM5B;A+D5tMI;EAAwB,sBAAA;A/D+tM5B;Ae3qMI;EgDtDA;IAAwB,sBAAA;E/DquM1B;E+DpuME;IAAwB,uBAAA;E/DuuM1B;E+DtuME;IAAwB,sBAAA;E/DyuM1B;AACF;AetrMI;EgDtDA;IAAwB,sBAAA;E/DgvM1B;E+D/uME;IAAwB,uBAAA;E/DkvM1B;E+DjvME;IAAwB,sBAAA;E/DovM1B;AACF;AejsMI;EgDtDA;IAAwB,sBAAA;E/D2vM1B;E+D1vME;IAAwB,uBAAA;E/D6vM1B;E+D5vME;IAAwB,sBAAA;E/D+vM1B;AACF;Ae5sMI;EgDtDA;IAAwB,sBAAA;E/DswM1B;E+DrwME;IAAwB,uBAAA;E/DwwM1B;E+DvwME;IAAwB,sBAAA;E/D0wM1B;AACF;AgEhxME;EAAyB,2BAAA;AhEmxM3B;AgEnxME;EAAyB,4BAAA;AhEsxM3B;AgEtxME;EAAyB,4BAAA;AhEyxM3B;AiEzxME;EAAsB,yBAAA;AjE4xMxB;AiE5xME;EAAsB,2BAAA;AjE+xMxB;AkE9xME;EAAyB,2BAAA;AlEiyM3B;AkEjyME;EAAyB,6BAAA;AlEoyM3B;AkEpyME;EAAyB,6BAAA;AlEuyM3B;AkEvyME;EAAyB,0BAAA;AlE0yM3B;AkE1yME;EAAyB,2BAAA;AlE6yM3B;AkExyMA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,a9DiqBkC;AJyoLpC;AkEvyMA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,a9DypBkC;AJgpLpC;AkEryME;EADF;IAEI,gBAAA;IACA,MAAA;IACA,a9DipBgC;EJupLlC;AACF;AmEl0MA;ECEE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;ApEm0MF;AoEzzME;EAEE,gBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,UAAA;EACA,mBAAA;ApE0zMJ;AqEv1MA;EAAa,8DAAA;ArE01Mb;AqEz1MA;EAAU,wDAAA;ArE41MV;AqE31MA;EAAa,uDAAA;ArE81Mb;AqE71MA;EAAe,2BAAA;ArEg2Mf;AsE/1MI;EAAuB,qBAAA;AtEk2M3B;AsEl2MI;EAAuB,qBAAA;AtEq2M3B;AsEr2MI;EAAuB,qBAAA;AtEw2M3B;AsEx2MI;EAAuB,sBAAA;AtE22M3B;AsE32MI;EAAuB,sBAAA;AtE82M3B;AsE92MI;EAAuB,sBAAA;AtEi3M3B;AsEj3MI;EAAuB,sBAAA;AtEo3M3B;AsEp3MI;EAAuB,sBAAA;AtEu3M3B;AsEv3MI;EAAuB,uBAAA;AtE03M3B;AsE13MI;EAAuB,uBAAA;AtE63M3B;AsEz3MA;EAAU,0BAAA;AtE43MV;AsE33MA;EAAU,2BAAA;AtE83MV;AsE13MA;EAAc,2BAAA;AtE63Md;AsE53MA;EAAc,4BAAA;AtE+3Md;AsE73MA;EAAU,uBAAA;AtEg4MV;AsE/3MA;EAAU,wBAAA;AtEk4MV;AuE34MQ;EAAgC,oBAAA;AvE84MxC;AuE74MQ;;EAEE,wBAAA;AvE+4MV;AuE74MQ;;EAEE,0BAAA;AvE+4MV;AuE74MQ;;EAEE,2BAAA;AvE+4MV;AuE74MQ;;EAEE,yBAAA;AvE+4MV;AuE95MQ;EAAgC,0BAAA;AvEi6MxC;AuEh6MQ;;EAEE,8BAAA;AvEk6MV;AuEh6MQ;;EAEE,gCAAA;AvEk6MV;AuEh6MQ;;EAEE,iCAAA;AvEk6MV;AuEh6MQ;;EAEE,+BAAA;AvEk6MV;AuEj7MQ;EAAgC,yBAAA;AvEo7MxC;AuEn7MQ;;EAEE,6BAAA;AvEq7MV;AuEn7MQ;;EAEE,+BAAA;AvEq7MV;AuEn7MQ;;EAEE,gCAAA;AvEq7MV;AuEn7MQ;;EAEE,8BAAA;AvEq7MV;AuEp8MQ;EAAgC,uBAAA;AvEu8MxC;AuEt8MQ;;EAEE,2BAAA;AvEw8MV;AuEt8MQ;;EAEE,6BAAA;AvEw8MV;AuEt8MQ;;EAEE,8BAAA;AvEw8MV;AuEt8MQ;;EAEE,4BAAA;AvEw8MV;AuEv9MQ;EAAgC,yBAAA;AvE09MxC;AuEz9MQ;;EAEE,6BAAA;AvE29MV;AuEz9MQ;;EAEE,+BAAA;AvE29MV;AuEz9MQ;;EAEE,gCAAA;AvE29MV;AuEz9MQ;;EAEE,8BAAA;AvE29MV;AuE1+MQ;EAAgC,uBAAA;AvE6+MxC;AuE5+MQ;;EAEE,2BAAA;AvE8+MV;AuE5+MQ;;EAEE,6BAAA;AvE8+MV;AuE5+MQ;;EAEE,8BAAA;AvE8+MV;AuE5+MQ;;EAEE,4BAAA;AvE8+MV;AuE7/MQ;EAAgC,qBAAA;AvEggNxC;AuE//MQ;;EAEE,yBAAA;AvEigNV;AuE//MQ;;EAEE,2BAAA;AvEigNV;AuE//MQ;;EAEE,4BAAA;AvEigNV;AuE//MQ;;EAEE,0BAAA;AvEigNV;AuEhhNQ;EAAgC,2BAAA;AvEmhNxC;AuElhNQ;;EAEE,+BAAA;AvEohNV;AuElhNQ;;EAEE,iCAAA;AvEohNV;AuElhNQ;;EAEE,kCAAA;AvEohNV;AuElhNQ;;EAEE,gCAAA;AvEohNV;AuEniNQ;EAAgC,0BAAA;AvEsiNxC;AuEriNQ;;EAEE,8BAAA;AvEuiNV;AuEriNQ;;EAEE,gCAAA;AvEuiNV;AuEriNQ;;EAEE,iCAAA;AvEuiNV;AuEriNQ;;EAEE,+BAAA;AvEuiNV;AuEtjNQ;EAAgC,wBAAA;AvEyjNxC;AuExjNQ;;EAEE,4BAAA;AvE0jNV;AuExjNQ;;EAEE,8BAAA;AvE0jNV;AuExjNQ;;EAEE,+BAAA;AvE0jNV;AuExjNQ;;EAEE,6BAAA;AvE0jNV;AuEzkNQ;EAAgC,0BAAA;AvE4kNxC;AuE3kNQ;;EAEE,8BAAA;AvE6kNV;AuE3kNQ;;EAEE,gCAAA;AvE6kNV;AuE3kNQ;;EAEE,iCAAA;AvE6kNV;AuE3kNQ;;EAEE,+BAAA;AvE6kNV;AuE5lNQ;EAAgC,wBAAA;AvE+lNxC;AuE9lNQ;;EAEE,4BAAA;AvEgmNV;AuE9lNQ;;EAEE,8BAAA;AvEgmNV;AuE9lNQ;;EAEE,+BAAA;AvEgmNV;AuE9lNQ;;EAEE,6BAAA;AvEgmNV;AuExlNQ;EAAwB,2BAAA;AvE2lNhC;AuE1lNQ;;EAEE,+BAAA;AvE4lNV;AuE1lNQ;;EAEE,iCAAA;AvE4lNV;AuE1lNQ;;EAEE,kCAAA;AvE4lNV;AuE1lNQ;;EAEE,gCAAA;AvE4lNV;AuE3mNQ;EAAwB,0BAAA;AvE8mNhC;AuE7mNQ;;EAEE,8BAAA;AvE+mNV;AuE7mNQ;;EAEE,gCAAA;AvE+mNV;AuE7mNQ;;EAEE,iCAAA;AvE+mNV;AuE7mNQ;;EAEE,+BAAA;AvE+mNV;AuE9nNQ;EAAwB,wBAAA;AvEioNhC;AuEhoNQ;;EAEE,4BAAA;AvEkoNV;AuEhoNQ;;EAEE,8BAAA;AvEkoNV;AuEhoNQ;;EAEE,+BAAA;AvEkoNV;AuEhoNQ;;EAEE,6BAAA;AvEkoNV;AuEjpNQ;EAAwB,0BAAA;AvEopNhC;AuEnpNQ;;EAEE,8BAAA;AvEqpNV;AuEnpNQ;;EAEE,gCAAA;AvEqpNV;AuEnpNQ;;EAEE,iCAAA;AvEqpNV;AuEnpNQ;;EAEE,+BAAA;AvEqpNV;AuEpqNQ;EAAwB,wBAAA;AvEuqNhC;AuEtqNQ;;EAEE,4BAAA;AvEwqNV;AuEtqNQ;;EAEE,8BAAA;AvEwqNV;AuEtqNQ;;EAEE,+BAAA;AvEwqNV;AuEtqNQ;;EAEE,6BAAA;AvEwqNV;AuElqNI;EAAmB,uBAAA;AvEqqNvB;AuEpqNI;;EAEE,2BAAA;AvEsqNN;AuEpqNI;;EAEE,6BAAA;AvEsqNN;AuEpqNI;;EAEE,8BAAA;AvEsqNN;AuEpqNI;;EAEE,4BAAA;AvEsqNN;Ae/qNI;EwDlDI;IAAgC,oBAAA;EvEquNtC;EuEpuNM;;IAEE,wBAAA;EvEsuNR;EuEpuNM;;IAEE,0BAAA;EvEsuNR;EuEpuNM;;IAEE,2BAAA;EvEsuNR;EuEpuNM;;IAEE,yBAAA;EvEsuNR;EuErvNM;IAAgC,0BAAA;EvEwvNtC;EuEvvNM;;IAEE,8BAAA;EvEyvNR;EuEvvNM;;IAEE,gCAAA;EvEyvNR;EuEvvNM;;IAEE,iCAAA;EvEyvNR;EuEvvNM;;IAEE,+BAAA;EvEyvNR;EuExwNM;IAAgC,yBAAA;EvE2wNtC;EuE1wNM;;IAEE,6BAAA;EvE4wNR;EuE1wNM;;IAEE,+BAAA;EvE4wNR;EuE1wNM;;IAEE,gCAAA;EvE4wNR;EuE1wNM;;IAEE,8BAAA;EvE4wNR;EuE3xNM;IAAgC,uBAAA;EvE8xNtC;EuE7xNM;;IAEE,2BAAA;EvE+xNR;EuE7xNM;;IAEE,6BAAA;EvE+xNR;EuE7xNM;;IAEE,8BAAA;EvE+xNR;EuE7xNM;;IAEE,4BAAA;EvE+xNR;EuE9yNM;IAAgC,yBAAA;EvEizNtC;EuEhzNM;;IAEE,6BAAA;EvEkzNR;EuEhzNM;;IAEE,+BAAA;EvEkzNR;EuEhzNM;;IAEE,gCAAA;EvEkzNR;EuEhzNM;;IAEE,8BAAA;EvEkzNR;EuEj0NM;IAAgC,uBAAA;EvEo0NtC;EuEn0NM;;IAEE,2BAAA;EvEq0NR;EuEn0NM;;IAEE,6BAAA;EvEq0NR;EuEn0NM;;IAEE,8BAAA;EvEq0NR;EuEn0NM;;IAEE,4BAAA;EvEq0NR;EuEp1NM;IAAgC,qBAAA;EvEu1NtC;EuEt1NM;;IAEE,yBAAA;EvEw1NR;EuEt1NM;;IAEE,2BAAA;EvEw1NR;EuEt1NM;;IAEE,4BAAA;EvEw1NR;EuEt1NM;;IAEE,0BAAA;EvEw1NR;EuEv2NM;IAAgC,2BAAA;EvE02NtC;EuEz2NM;;IAEE,+BAAA;EvE22NR;EuEz2NM;;IAEE,iCAAA;EvE22NR;EuEz2NM;;IAEE,kCAAA;EvE22NR;EuEz2NM;;IAEE,gCAAA;EvE22NR;EuE13NM;IAAgC,0BAAA;EvE63NtC;EuE53NM;;IAEE,8BAAA;EvE83NR;EuE53NM;;IAEE,gCAAA;EvE83NR;EuE53NM;;IAEE,iCAAA;EvE83NR;EuE53NM;;IAEE,+BAAA;EvE83NR;EuE74NM;IAAgC,wBAAA;EvEg5NtC;EuE/4NM;;IAEE,4BAAA;EvEi5NR;EuE/4NM;;IAEE,8BAAA;EvEi5NR;EuE/4NM;;IAEE,+BAAA;EvEi5NR;EuE/4NM;;IAEE,6BAAA;EvEi5NR;EuEh6NM;IAAgC,0BAAA;EvEm6NtC;EuEl6NM;;IAEE,8BAAA;EvEo6NR;EuEl6NM;;IAEE,gCAAA;EvEo6NR;EuEl6NM;;IAEE,iCAAA;EvEo6NR;EuEl6NM;;IAEE,+BAAA;EvEo6NR;EuEn7NM;IAAgC,wBAAA;EvEs7NtC;EuEr7NM;;IAEE,4BAAA;EvEu7NR;EuEr7NM;;IAEE,8BAAA;EvEu7NR;EuEr7NM;;IAEE,+BAAA;EvEu7NR;EuEr7NM;;IAEE,6BAAA;EvEu7NR;EuE/6NM;IAAwB,2BAAA;EvEk7N9B;EuEj7NM;;IAEE,+BAAA;EvEm7NR;EuEj7NM;;IAEE,iCAAA;EvEm7NR;EuEj7NM;;IAEE,kCAAA;EvEm7NR;EuEj7NM;;IAEE,gCAAA;EvEm7NR;EuEl8NM;IAAwB,0BAAA;EvEq8N9B;EuEp8NM;;IAEE,8BAAA;EvEs8NR;EuEp8NM;;IAEE,gCAAA;EvEs8NR;EuEp8NM;;IAEE,iCAAA;EvEs8NR;EuEp8NM;;IAEE,+BAAA;EvEs8NR;EuEr9NM;IAAwB,wBAAA;EvEw9N9B;EuEv9NM;;IAEE,4BAAA;EvEy9NR;EuEv9NM;;IAEE,8BAAA;EvEy9NR;EuEv9NM;;IAEE,+BAAA;EvEy9NR;EuEv9NM;;IAEE,6BAAA;EvEy9NR;EuEx+NM;IAAwB,0BAAA;EvE2+N9B;EuE1+NM;;IAEE,8BAAA;EvE4+NR;EuE1+NM;;IAEE,gCAAA;EvE4+NR;EuE1+NM;;IAEE,iCAAA;EvE4+NR;EuE1+NM;;IAEE,+BAAA;EvE4+NR;EuE3/NM;IAAwB,wBAAA;EvE8/N9B;EuE7/NM;;IAEE,4BAAA;EvE+/NR;EuE7/NM;;IAEE,8BAAA;EvE+/NR;EuE7/NM;;IAEE,+BAAA;EvE+/NR;EuE7/NM;;IAEE,6BAAA;EvE+/NR;EuEz/NE;IAAmB,uBAAA;EvE4/NrB;EuE3/NE;;IAEE,2BAAA;EvE6/NJ;EuE3/NE;;IAEE,6BAAA;EvE6/NJ;EuE3/NE;;IAEE,8BAAA;EvE6/NJ;EuE3/NE;;IAEE,4BAAA;EvE6/NJ;AACF;AevgOI;EwDlDI;IAAgC,oBAAA;EvE6jOtC;EuE5jOM;;IAEE,wBAAA;EvE8jOR;EuE5jOM;;IAEE,0BAAA;EvE8jOR;EuE5jOM;;IAEE,2BAAA;EvE8jOR;EuE5jOM;;IAEE,yBAAA;EvE8jOR;EuE7kOM;IAAgC,0BAAA;EvEglOtC;EuE/kOM;;IAEE,8BAAA;EvEilOR;EuE/kOM;;IAEE,gCAAA;EvEilOR;EuE/kOM;;IAEE,iCAAA;EvEilOR;EuE/kOM;;IAEE,+BAAA;EvEilOR;EuEhmOM;IAAgC,yBAAA;EvEmmOtC;EuElmOM;;IAEE,6BAAA;EvEomOR;EuElmOM;;IAEE,+BAAA;EvEomOR;EuElmOM;;IAEE,gCAAA;EvEomOR;EuElmOM;;IAEE,8BAAA;EvEomOR;EuEnnOM;IAAgC,uBAAA;EvEsnOtC;EuErnOM;;IAEE,2BAAA;EvEunOR;EuErnOM;;IAEE,6BAAA;EvEunOR;EuErnOM;;IAEE,8BAAA;EvEunOR;EuErnOM;;IAEE,4BAAA;EvEunOR;EuEtoOM;IAAgC,yBAAA;EvEyoOtC;EuExoOM;;IAEE,6BAAA;EvE0oOR;EuExoOM;;IAEE,+BAAA;EvE0oOR;EuExoOM;;IAEE,gCAAA;EvE0oOR;EuExoOM;;IAEE,8BAAA;EvE0oOR;EuEzpOM;IAAgC,uBAAA;EvE4pOtC;EuE3pOM;;IAEE,2BAAA;EvE6pOR;EuE3pOM;;IAEE,6BAAA;EvE6pOR;EuE3pOM;;IAEE,8BAAA;EvE6pOR;EuE3pOM;;IAEE,4BAAA;EvE6pOR;EuE5qOM;IAAgC,qBAAA;EvE+qOtC;EuE9qOM;;IAEE,yBAAA;EvEgrOR;EuE9qOM;;IAEE,2BAAA;EvEgrOR;EuE9qOM;;IAEE,4BAAA;EvEgrOR;EuE9qOM;;IAEE,0BAAA;EvEgrOR;EuE/rOM;IAAgC,2BAAA;EvEksOtC;EuEjsOM;;IAEE,+BAAA;EvEmsOR;EuEjsOM;;IAEE,iCAAA;EvEmsOR;EuEjsOM;;IAEE,kCAAA;EvEmsOR;EuEjsOM;;IAEE,gCAAA;EvEmsOR;EuEltOM;IAAgC,0BAAA;EvEqtOtC;EuEptOM;;IAEE,8BAAA;EvEstOR;EuEptOM;;IAEE,gCAAA;EvEstOR;EuEptOM;;IAEE,iCAAA;EvEstOR;EuEptOM;;IAEE,+BAAA;EvEstOR;EuEruOM;IAAgC,wBAAA;EvEwuOtC;EuEvuOM;;IAEE,4BAAA;EvEyuOR;EuEvuOM;;IAEE,8BAAA;EvEyuOR;EuEvuOM;;IAEE,+BAAA;EvEyuOR;EuEvuOM;;IAEE,6BAAA;EvEyuOR;EuExvOM;IAAgC,0BAAA;EvE2vOtC;EuE1vOM;;IAEE,8BAAA;EvE4vOR;EuE1vOM;;IAEE,gCAAA;EvE4vOR;EuE1vOM;;IAEE,iCAAA;EvE4vOR;EuE1vOM;;IAEE,+BAAA;EvE4vOR;EuE3wOM;IAAgC,wBAAA;EvE8wOtC;EuE7wOM;;IAEE,4BAAA;EvE+wOR;EuE7wOM;;IAEE,8BAAA;EvE+wOR;EuE7wOM;;IAEE,+BAAA;EvE+wOR;EuE7wOM;;IAEE,6BAAA;EvE+wOR;EuEvwOM;IAAwB,2BAAA;EvE0wO9B;EuEzwOM;;IAEE,+BAAA;EvE2wOR;EuEzwOM;;IAEE,iCAAA;EvE2wOR;EuEzwOM;;IAEE,kCAAA;EvE2wOR;EuEzwOM;;IAEE,gCAAA;EvE2wOR;EuE1xOM;IAAwB,0BAAA;EvE6xO9B;EuE5xOM;;IAEE,8BAAA;EvE8xOR;EuE5xOM;;IAEE,gCAAA;EvE8xOR;EuE5xOM;;IAEE,iCAAA;EvE8xOR;EuE5xOM;;IAEE,+BAAA;EvE8xOR;EuE7yOM;IAAwB,wBAAA;EvEgzO9B;EuE/yOM;;IAEE,4BAAA;EvEizOR;EuE/yOM;;IAEE,8BAAA;EvEizOR;EuE/yOM;;IAEE,+BAAA;EvEizOR;EuE/yOM;;IAEE,6BAAA;EvEizOR;EuEh0OM;IAAwB,0BAAA;EvEm0O9B;EuEl0OM;;IAEE,8BAAA;EvEo0OR;EuEl0OM;;IAEE,gCAAA;EvEo0OR;EuEl0OM;;IAEE,iCAAA;EvEo0OR;EuEl0OM;;IAEE,+BAAA;EvEo0OR;EuEn1OM;IAAwB,wBAAA;EvEs1O9B;EuEr1OM;;IAEE,4BAAA;EvEu1OR;EuEr1OM;;IAEE,8BAAA;EvEu1OR;EuEr1OM;;IAEE,+BAAA;EvEu1OR;EuEr1OM;;IAEE,6BAAA;EvEu1OR;EuEj1OE;IAAmB,uBAAA;EvEo1OrB;EuEn1OE;;IAEE,2BAAA;EvEq1OJ;EuEn1OE;;IAEE,6BAAA;EvEq1OJ;EuEn1OE;;IAEE,8BAAA;EvEq1OJ;EuEn1OE;;IAEE,4BAAA;EvEq1OJ;AACF;Ae/1OI;EwDlDI;IAAgC,oBAAA;EvEq5OtC;EuEp5OM;;IAEE,wBAAA;EvEs5OR;EuEp5OM;;IAEE,0BAAA;EvEs5OR;EuEp5OM;;IAEE,2BAAA;EvEs5OR;EuEp5OM;;IAEE,yBAAA;EvEs5OR;EuEr6OM;IAAgC,0BAAA;EvEw6OtC;EuEv6OM;;IAEE,8BAAA;EvEy6OR;EuEv6OM;;IAEE,gCAAA;EvEy6OR;EuEv6OM;;IAEE,iCAAA;EvEy6OR;EuEv6OM;;IAEE,+BAAA;EvEy6OR;EuEx7OM;IAAgC,yBAAA;EvE27OtC;EuE17OM;;IAEE,6BAAA;EvE47OR;EuE17OM;;IAEE,+BAAA;EvE47OR;EuE17OM;;IAEE,gCAAA;EvE47OR;EuE17OM;;IAEE,8BAAA;EvE47OR;EuE38OM;IAAgC,uBAAA;EvE88OtC;EuE78OM;;IAEE,2BAAA;EvE+8OR;EuE78OM;;IAEE,6BAAA;EvE+8OR;EuE78OM;;IAEE,8BAAA;EvE+8OR;EuE78OM;;IAEE,4BAAA;EvE+8OR;EuE99OM;IAAgC,yBAAA;EvEi+OtC;EuEh+OM;;IAEE,6BAAA;EvEk+OR;EuEh+OM;;IAEE,+BAAA;EvEk+OR;EuEh+OM;;IAEE,gCAAA;EvEk+OR;EuEh+OM;;IAEE,8BAAA;EvEk+OR;EuEj/OM;IAAgC,uBAAA;EvEo/OtC;EuEn/OM;;IAEE,2BAAA;EvEq/OR;EuEn/OM;;IAEE,6BAAA;EvEq/OR;EuEn/OM;;IAEE,8BAAA;EvEq/OR;EuEn/OM;;IAEE,4BAAA;EvEq/OR;EuEpgPM;IAAgC,qBAAA;EvEugPtC;EuEtgPM;;IAEE,yBAAA;EvEwgPR;EuEtgPM;;IAEE,2BAAA;EvEwgPR;EuEtgPM;;IAEE,4BAAA;EvEwgPR;EuEtgPM;;IAEE,0BAAA;EvEwgPR;EuEvhPM;IAAgC,2BAAA;EvE0hPtC;EuEzhPM;;IAEE,+BAAA;EvE2hPR;EuEzhPM;;IAEE,iCAAA;EvE2hPR;EuEzhPM;;IAEE,kCAAA;EvE2hPR;EuEzhPM;;IAEE,gCAAA;EvE2hPR;EuE1iPM;IAAgC,0BAAA;EvE6iPtC;EuE5iPM;;IAEE,8BAAA;EvE8iPR;EuE5iPM;;IAEE,gCAAA;EvE8iPR;EuE5iPM;;IAEE,iCAAA;EvE8iPR;EuE5iPM;;IAEE,+BAAA;EvE8iPR;EuE7jPM;IAAgC,wBAAA;EvEgkPtC;EuE/jPM;;IAEE,4BAAA;EvEikPR;EuE/jPM;;IAEE,8BAAA;EvEikPR;EuE/jPM;;IAEE,+BAAA;EvEikPR;EuE/jPM;;IAEE,6BAAA;EvEikPR;EuEhlPM;IAAgC,0BAAA;EvEmlPtC;EuEllPM;;IAEE,8BAAA;EvEolPR;EuEllPM;;IAEE,gCAAA;EvEolPR;EuEllPM;;IAEE,iCAAA;EvEolPR;EuEllPM;;IAEE,+BAAA;EvEolPR;EuEnmPM;IAAgC,wBAAA;EvEsmPtC;EuErmPM;;IAEE,4BAAA;EvEumPR;EuErmPM;;IAEE,8BAAA;EvEumPR;EuErmPM;;IAEE,+BAAA;EvEumPR;EuErmPM;;IAEE,6BAAA;EvEumPR;EuE/lPM;IAAwB,2BAAA;EvEkmP9B;EuEjmPM;;IAEE,+BAAA;EvEmmPR;EuEjmPM;;IAEE,iCAAA;EvEmmPR;EuEjmPM;;IAEE,kCAAA;EvEmmPR;EuEjmPM;;IAEE,gCAAA;EvEmmPR;EuElnPM;IAAwB,0BAAA;EvEqnP9B;EuEpnPM;;IAEE,8BAAA;EvEsnPR;EuEpnPM;;IAEE,gCAAA;EvEsnPR;EuEpnPM;;IAEE,iCAAA;EvEsnPR;EuEpnPM;;IAEE,+BAAA;EvEsnPR;EuEroPM;IAAwB,wBAAA;EvEwoP9B;EuEvoPM;;IAEE,4BAAA;EvEyoPR;EuEvoPM;;IAEE,8BAAA;EvEyoPR;EuEvoPM;;IAEE,+BAAA;EvEyoPR;EuEvoPM;;IAEE,6BAAA;EvEyoPR;EuExpPM;IAAwB,0BAAA;EvE2pP9B;EuE1pPM;;IAEE,8BAAA;EvE4pPR;EuE1pPM;;IAEE,gCAAA;EvE4pPR;EuE1pPM;;IAEE,iCAAA;EvE4pPR;EuE1pPM;;IAEE,+BAAA;EvE4pPR;EuE3qPM;IAAwB,wBAAA;EvE8qP9B;EuE7qPM;;IAEE,4BAAA;EvE+qPR;EuE7qPM;;IAEE,8BAAA;EvE+qPR;EuE7qPM;;IAEE,+BAAA;EvE+qPR;EuE7qPM;;IAEE,6BAAA;EvE+qPR;EuEzqPE;IAAmB,uBAAA;EvE4qPrB;EuE3qPE;;IAEE,2BAAA;EvE6qPJ;EuE3qPE;;IAEE,6BAAA;EvE6qPJ;EuE3qPE;;IAEE,8BAAA;EvE6qPJ;EuE3qPE;;IAEE,4BAAA;EvE6qPJ;AACF;AevrPI;EwDlDI;IAAgC,oBAAA;EvE6uPtC;EuE5uPM;;IAEE,wBAAA;EvE8uPR;EuE5uPM;;IAEE,0BAAA;EvE8uPR;EuE5uPM;;IAEE,2BAAA;EvE8uPR;EuE5uPM;;IAEE,yBAAA;EvE8uPR;EuE7vPM;IAAgC,0BAAA;EvEgwPtC;EuE/vPM;;IAEE,8BAAA;EvEiwPR;EuE/vPM;;IAEE,gCAAA;EvEiwPR;EuE/vPM;;IAEE,iCAAA;EvEiwPR;EuE/vPM;;IAEE,+BAAA;EvEiwPR;EuEhxPM;IAAgC,yBAAA;EvEmxPtC;EuElxPM;;IAEE,6BAAA;EvEoxPR;EuElxPM;;IAEE,+BAAA;EvEoxPR;EuElxPM;;IAEE,gCAAA;EvEoxPR;EuElxPM;;IAEE,8BAAA;EvEoxPR;EuEnyPM;IAAgC,uBAAA;EvEsyPtC;EuEryPM;;IAEE,2BAAA;EvEuyPR;EuEryPM;;IAEE,6BAAA;EvEuyPR;EuEryPM;;IAEE,8BAAA;EvEuyPR;EuEryPM;;IAEE,4BAAA;EvEuyPR;EuEtzPM;IAAgC,yBAAA;EvEyzPtC;EuExzPM;;IAEE,6BAAA;EvE0zPR;EuExzPM;;IAEE,+BAAA;EvE0zPR;EuExzPM;;IAEE,gCAAA;EvE0zPR;EuExzPM;;IAEE,8BAAA;EvE0zPR;EuEz0PM;IAAgC,uBAAA;EvE40PtC;EuE30PM;;IAEE,2BAAA;EvE60PR;EuE30PM;;IAEE,6BAAA;EvE60PR;EuE30PM;;IAEE,8BAAA;EvE60PR;EuE30PM;;IAEE,4BAAA;EvE60PR;EuE51PM;IAAgC,qBAAA;EvE+1PtC;EuE91PM;;IAEE,yBAAA;EvEg2PR;EuE91PM;;IAEE,2BAAA;EvEg2PR;EuE91PM;;IAEE,4BAAA;EvEg2PR;EuE91PM;;IAEE,0BAAA;EvEg2PR;EuE/2PM;IAAgC,2BAAA;EvEk3PtC;EuEj3PM;;IAEE,+BAAA;EvEm3PR;EuEj3PM;;IAEE,iCAAA;EvEm3PR;EuEj3PM;;IAEE,kCAAA;EvEm3PR;EuEj3PM;;IAEE,gCAAA;EvEm3PR;EuEl4PM;IAAgC,0BAAA;EvEq4PtC;EuEp4PM;;IAEE,8BAAA;EvEs4PR;EuEp4PM;;IAEE,gCAAA;EvEs4PR;EuEp4PM;;IAEE,iCAAA;EvEs4PR;EuEp4PM;;IAEE,+BAAA;EvEs4PR;EuEr5PM;IAAgC,wBAAA;EvEw5PtC;EuEv5PM;;IAEE,4BAAA;EvEy5PR;EuEv5PM;;IAEE,8BAAA;EvEy5PR;EuEv5PM;;IAEE,+BAAA;EvEy5PR;EuEv5PM;;IAEE,6BAAA;EvEy5PR;EuEx6PM;IAAgC,0BAAA;EvE26PtC;EuE16PM;;IAEE,8BAAA;EvE46PR;EuE16PM;;IAEE,gCAAA;EvE46PR;EuE16PM;;IAEE,iCAAA;EvE46PR;EuE16PM;;IAEE,+BAAA;EvE46PR;EuE37PM;IAAgC,wBAAA;EvE87PtC;EuE77PM;;IAEE,4BAAA;EvE+7PR;EuE77PM;;IAEE,8BAAA;EvE+7PR;EuE77PM;;IAEE,+BAAA;EvE+7PR;EuE77PM;;IAEE,6BAAA;EvE+7PR;EuEv7PM;IAAwB,2BAAA;EvE07P9B;EuEz7PM;;IAEE,+BAAA;EvE27PR;EuEz7PM;;IAEE,iCAAA;EvE27PR;EuEz7PM;;IAEE,kCAAA;EvE27PR;EuEz7PM;;IAEE,gCAAA;EvE27PR;EuE18PM;IAAwB,0BAAA;EvE68P9B;EuE58PM;;IAEE,8BAAA;EvE88PR;EuE58PM;;IAEE,gCAAA;EvE88PR;EuE58PM;;IAEE,iCAAA;EvE88PR;EuE58PM;;IAEE,+BAAA;EvE88PR;EuE79PM;IAAwB,wBAAA;EvEg+P9B;EuE/9PM;;IAEE,4BAAA;EvEi+PR;EuE/9PM;;IAEE,8BAAA;EvEi+PR;EuE/9PM;;IAEE,+BAAA;EvEi+PR;EuE/9PM;;IAEE,6BAAA;EvEi+PR;EuEh/PM;IAAwB,0BAAA;EvEm/P9B;EuEl/PM;;IAEE,8BAAA;EvEo/PR;EuEl/PM;;IAEE,gCAAA;EvEo/PR;EuEl/PM;;IAEE,iCAAA;EvEo/PR;EuEl/PM;;IAEE,+BAAA;EvEo/PR;EuEngQM;IAAwB,wBAAA;EvEsgQ9B;EuErgQM;;IAEE,4BAAA;EvEugQR;EuErgQM;;IAEE,8BAAA;EvEugQR;EuErgQM;;IAEE,+BAAA;EvEugQR;EuErgQM;;IAEE,6BAAA;EvEugQR;EuEjgQE;IAAmB,uBAAA;EvEogQrB;EuEngQE;;IAEE,2BAAA;EvEqgQJ;EuEngQE;;IAEE,6BAAA;EvEqgQJ;EuEngQE;;IAEE,8BAAA;EvEqgQJ;EuEngQE;;IAEE,4BAAA;EvEqgQJ;AACF;AwEtkQE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EAEA,oBAAA;EACA,WAAA;EAEA,kCAAA;AxEskQJ;AyEhlQA;EAAkB,4GAAA;AzEmlQlB;AyE/kQA;EAAiB,8BAAA;AzEklQjB;AyEjlQA;EAAiB,8BAAA;AzEolQjB;AyEnlQA;EAAiB,8BAAA;AzEslQjB;AyErlQA;ECTE,gBAAA;EACA,uBAAA;EACA,mBAAA;A1EimQF;AyEllQI;EAAwB,2BAAA;AzEqlQ5B;AyEplQI;EAAwB,4BAAA;AzEulQ5B;AyEtlQI;EAAwB,6BAAA;AzEylQ5B;AepjQI;E0DvCA;IAAwB,2BAAA;EzE+lQ1B;EyE9lQE;IAAwB,4BAAA;EzEimQ1B;EyEhmQE;IAAwB,6BAAA;EzEmmQ1B;AACF;Ae/jQI;E0DvCA;IAAwB,2BAAA;EzE0mQ1B;EyEzmQE;IAAwB,4BAAA;EzE4mQ1B;EyE3mQE;IAAwB,6BAAA;EzE8mQ1B;AACF;Ae1kQI;E0DvCA;IAAwB,2BAAA;EzEqnQ1B;EyEpnQE;IAAwB,4BAAA;EzEunQ1B;EyEtnQE;IAAwB,6BAAA;EzEynQ1B;AACF;AerlQI;E0DvCA;IAAwB,2BAAA;EzEgoQ1B;EyE/nQE;IAAwB,4BAAA;EzEkoQ1B;EyEjoQE;IAAwB,6BAAA;EzEooQ1B;AACF;AyE/nQA;EAAmB,oCAAA;AzEkoQnB;AyEjoQA;EAAmB,oCAAA;AzEooQnB;AyEnoQA;EAAmB,qCAAA;AzEsoQnB;AyEloQA;EAAuB,2BAAA;AzEqoQvB;AyEpoQA;EAAuB,+BAAA;AzEuoQvB;AyEtoQA;EAAuB,2BAAA;AzEyoQvB;AyExoQA;EAAuB,2BAAA;AzE2oQvB;AyE1oQA;EAAuB,8BAAA;AzE6oQvB;AyE5oQA;EAAuB,6BAAA;AzE+oQvB;AyE3oQA;EAAc,sBAAA;AzE8oQd;A2ErrQE;EACE,yBAAA;A3EurQJ;AM7qQE;EqELM,8CAAA;A3EqrQR;A2E3rQE;EACE,yBAAA;A3E6rQJ;AMnrQE;EqELM,qEAAA;A3E2rQR;A2EjsQE;EACE,yBAAA;A3EmsQJ;AMzrQE;EqELM,oEAAA;A3EisQR;A2EvsQE;EACE,yBAAA;A3EysQJ;AM/rQE;EqELM,oEAAA;A3EusQR;A2E7sQE;EACE,yBAAA;A3E+sQJ;AMrsQE;EqELM,yDAAA;A3E6sQR;A2EntQE;EACE,yBAAA;A3EqtQJ;AM3sQE;EqELM,mEAAA;A3EmtQR;A2EztQE;EACE,yBAAA;A3E2tQJ;AMjtQE;EqELM,qEAAA;A3EytQR;A2E/tQE;EACE,yBAAA;A3EiuQJ;AMvtQE;EqELM,kEAAA;A3E+tQR;AyExrQA;EAAa,yBAAA;AzE2rQb;AyE1rQA;EAAc,yBAAA;AzE6rQd;AyE3rQA;EAAiB,oCAAA;AzE8rQjB;AyE7rQA;EAAiB,0CAAA;AzEgsQjB;AyE5rQA;EGvDE,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,6BAAA;EACA,SAAA;A5EsvQF;AyE/rQA;EAAwB,gCAAA;AzEksQxB;AyEhsQA;EACE,iCAAA;EACA,gCAAA;AzEksQF;AyE7rQA;EAAc,yBAAA;AzEgsQd;A6EjwQA;EACE,8BAAA;A7EmwQF;A6EhwQA;EACE,6BAAA;A7EkwQF;A8ElwQE;EACE;;;IAKE,4BAAA;IAEA,2BAAA;E9EiwQJ;E8E7vQI;IACE,0BAAA;E9E+vQN;E8EtvQE;IACE,6BAAA;E9EwvQJ;E8E1uQE;IACE,gCAAA;E9E4uQJ;E8E1uQE;;IAEE,yBAAA;IACA,wBAAA;E9E4uQJ;E8EzuQE;;IAEE,wBAAA;E9E2uQJ;E8ExuQE;;;IAGE,UAAA;IACA,SAAA;E9E0uQJ;E8EvuQE;;IAEE,uBAAA;E9EyuQJ;E8EjuQE;I9E/EJ;M8EgFM,Q1E2iC8B;IJyrOhC;EACF;E8EnuQE;IACE,2BAAA;E9EquQJ;E8EnuQE;IACE,2BAAA;E9EquQJ;E8EjuQE;IACE,aAAA;E9EmuQJ;E8EjuQE;IACE,sBAAA;E9EmuQJ;E8EhuQE;IACE,oCAAA;E9EkuQJ;E8EhuQI;;IAEE,iCAAA;E9EkuQN;E8E7tQI;;IAEE,oCAAA;E9E+tQN;E8E3tQE;IACE,cAAA;E9E6tQJ;E8E3tQI;;;;IAIE,qB1E9GG;EJ20QT;E8EztQE;IACE,cAAA;IACA,qB1EpHK;EJ+0QT;AACF;;AAt1QA;EACE,kBAAA;EACA,gBAAA;EACA,+BAAA;EACA,eAAA;AAy1QF;;AAt1QA;;EAEE,YAAA;EACA,gBAAA;EACA,uBAAA;AAy1QF;;AAt1QA;EACE,gBAAA;AAy1QF;;AAt1QA;EACE,iBAAA;AAy1QF;;AAt1QA;EACE,iBAAA;AAy1QF;;AAt1QA;EACE,kBAAA;AAy1QF;;AAt1QA;;EAEE,gBAAA;EACA,kBAAA;AAy1QF;;AAt1QA;;EAEE,WAAA;EACA,YAAA;AAy1QF;;AAt1QA;EACE,YAAA;AAy1QF;;AAt1QA;EACE,iBAAA;AAy1QF;;AAt1QA;EACE,WAAA;AAy1QF;;AAt1QA,yCAAA;AACA;EACE,wBAAA;AAy1QF;;AAt1QA;EACE,sBAAA;AAy1QF;;AAt1QA;EACE,uBAAA;AAy1QF;;AAt1QA;EACE,qBAAA;AAy1QF;;AAt1QA;EACE,qBAAA;AAy1QF;;AAt1QA,uCAAA;AAEA,0CAAA;AACA;EACE,iBAAA;EACA,WAAA;AAw1QF;;AAr1QA;EACE,WAAA;EACA,gCAAA;EACA,iBAAA;AAw1QF;;AAr1QA,wCAAA;AACA;EACE,WAAA;AAw1QF;;AAr1QA;EACE,aAAA;AAw1QF;;AAr1QA;EACE,gBAAA;AAw1QF;;AAr1QA;EACE,YAAA;EACA,YAAA;AAw1QF;;AAr1QA;EACE,gBAAA;AAw1QF;;AAr1QA;EACE,iBAAA;EACA,kBAAA;EACA,gBAAA;AAw1QF;;AAr1QA;EACE,gBAAA;EACA,iBAAA;AAw1QF;;AAr1QA;;;;;EAKE,iBAAA;EACA,eAAA;AAw1QF;;AAr1QA;EACE,YAAA;AAw1QF;;AAr1QA;EACE,4BAAA;AAw1QF;;AA/0QA;EACE,0BAAA;EACA,WAAA;EACA,eAAA;AAk1QF;;AA/0QA;EACE,cAAA;EACA,iBAAA;AAk1QF;;AA/0QA;EACE,cAAA;EACA,iBAAA;AAk1QF;;AA/0QA;EACE,cAAA;EACA,iBAAA;AAk1QF;;AA/0QA;EACE,sBAAA;AAk1QF;AAh1QE;EACE,sBAAA;AAk1QJ;;AA70QE;EACE,qBAAA;EACA,YAAA;EACA,yBAAA;AAg1QJ;AA70QE;EACE,aAAA;AA+0QJ;AA50QE;EACE,aAAA;AA80QJ;AA30QE;EACE,eAAA;EACA,eAAA;EACA,cAAA;AA60QJ;;AAz0QA;EACE,YAAA;AA40QF;;AAz0QA;EACE,YAAA;AA40QF;;AAz0QA;EACE,YAAA;AA40QF","sourcesContent":[":where(#widgetEditorDialog) {\n  @import \"~bootstrap/scss/bootstrap\";\n}\n\n#widgetEditorDialog {\n  overflow-x: hidden;\n  overflow-y: auto;\n  font-family: Roboto, sans-serif;\n  font-size: 15px;\n}\n\n#widgetEditorDialog .flippy-front,\n#widgetEditorDialog .flippy-front {\n  height: auto;\n  box-shadow: none;\n  padding: 5px !important;\n}\n\n.no-left-margin {\n  margin-left: 0px;\n}\n\n.no-right-margin {\n  margin-right: 0px;\n}\n\n.no-left-padding {\n  padding-left: 0px;\n}\n\n.no-right-padding {\n  padding-right: 0px;\n}\n\n.widget-editor-form #propertyBox .card-body,\n.widget-editor-form #previewBox .card-body {\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n.widget-editor-form #chartPreview,\n.widget-editor-form #valuePreview {\n  width: 100%;\n  height: 100%;\n}\n\n.widget-editor-form>div:first-child {\n  padding: 3px;\n}\n\n.widget-editor-form .right-align {\n  text-align: right;\n}\n\n.widget-editor-form .query-customization-button {\n  width: 46px;\n}\n\n/* Begin - Error display tooltip color. */\n.error-tooltip.bs-tooltip-bottom .arrow::before {\n  border-bottom-color: red;\n}\n\n.error-tooltip.bs-tooltip-left .arrow::before {\n  border-left-color: red;\n}\n\n.error-tooltip.bs-tooltip-right .arrow::before {\n  border-right-color: red;\n}\n\n.error-tooltip.bs-tooltip-top .arrow::before {\n  border-top-color: red;\n}\n\n.error-tooltip .tooltip-inner {\n  background-color: red;\n}\n\n/* End - Error display tooltip color. */\n\n/* Begin - styling react-bootstrap tabs. */\n.tab-content {\n  min-height: 330px;\n  width: 100%;\n}\n\n.nav-tabs {\n  width: 100%;\n  border-bottom: 1px solid #dee2e6;\n  margin-left: -7px;\n}\n\n/* End - styling react-bootstrap tabs. */\n.create-widget-div {\n  height: 9vh;\n}\n\n.disappear {\n  display: none;\n}\n\n.widget-editor-form .flippy-back {\n  box-shadow: none;\n}\n\n.drilldown-div {\n  height: 100%;\n  padding: 1em;\n}\n\n.drilldown-div .btn {\n  margin-left: 0em;\n}\n\n.action-button-box {\n  padding-left: 0px;\n  padding-right: 0px;\n  min-width: 210px;\n}\n\n.action-button-box>button {\n  margin-left: 5px;\n  margin-right: 5px;\n}\n\n#aggregateRefreshBtn,\n#chartRefreshBtn,\n#tableRefreshBtn,\n#helpGuideIcon,\n#fullScreenIcon {\n  margin-left: auto;\n  cursor: pointer;\n}\n\n.widget-action-btn {\n  height: 35px;\n}\n\n.cke_dialog_ui_iframe {\n  min-height: 500px !important;\n}\n\n// .card-header {\n//   padding: 5px;\n//   display: flex;\n//   align-items: center;\n// }\n\n.oxzion-widget-aggregate-drilldown {\n  text-decoration: underline;\n  color: blue;\n  cursor: pointer;\n}\n\n.red {\n  color: #ee4424;\n  font-weight: bold;\n}\n\n.green {\n  color: #a3c53a;\n  font-weight: bold;\n}\n\n.yellow {\n  color: #f3ba1d;\n  font-weight: bold;\n}\n\n.react-editor-container {\n  width: 100% !important;\n\n  .k-animation-container {\n    width: 100% !important;\n  }\n}\n\n.help-guide-window {\n  .k-window-titlebar {\n    border-color: inherit;\n    color: white;\n    background-color: #275362;\n  }\n\n  button[aria-label=\"minimize\"] {\n    display: none;\n  }\n\n  button[aria-label=\"maximize\"] {\n    display: none;\n  }\n\n  .doc-copy-icon {\n    cursor: pointer;\n    font-size: 15px;\n    color: #275362; \n  }\n}\n\n.react-preview-container{\n  height: 100%;\n}\n\n.react-preview-container > div:first-of-type {\n  height: 100%;\n}\n\n.react-preview-container > div:first-of-type > div {\n  height: 100%;\n}","/*!\n * Bootstrap v4.6.2 (https://getbootstrap.com/)\n * Copyright 2011-2022 The Bootstrap Authors\n * Copyright 2011-2022 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n */\n\n@import \"functions\";\n@import \"variables\";\n@import \"mixins\";\n@import \"root\";\n@import \"reboot\";\n@import \"type\";\n@import \"images\";\n@import \"code\";\n@import \"grid\";\n@import \"tables\";\n@import \"forms\";\n@import \"buttons\";\n@import \"transitions\";\n@import \"dropdown\";\n@import \"button-group\";\n@import \"input-group\";\n@import \"custom-forms\";\n@import \"nav\";\n@import \"navbar\";\n@import \"card\";\n@import \"breadcrumb\";\n@import \"pagination\";\n@import \"badge\";\n@import \"jumbotron\";\n@import \"alert\";\n@import \"progress\";\n@import \"media\";\n@import \"list-group\";\n@import \"close\";\n@import \"toasts\";\n@import \"modal\";\n@import \"tooltip\";\n@import \"popover\";\n@import \"carousel\";\n@import \"spinners\";\n@import \"utilities\";\n@import \"print\";\n",":root {\n  // Custom variable values only support SassScript inside `#{}`.\n  @each $color, $value in $colors {\n    --#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors {\n    --#{$color}: #{$value};\n  }\n\n  @each $bp, $value in $grid-breakpoints {\n    --breakpoint-#{$bp}: #{$value};\n  }\n\n  // Use `inspect` for lists so that quoted items keep the quotes.\n  // See https://github.com/sass/sass/issues/2383#issuecomment-336349172\n  --font-family-sans-serif: #{inspect($font-family-sans-serif)};\n  --font-family-monospace: #{inspect($font-family-monospace)};\n}\n","// stylelint-disable declaration-no-important, selector-no-qualifying-type, property-no-vendor-prefix\n\n// Reboot\n//\n// Normalization of HTML elements, manually forked from Normalize.css to remove\n// styles targeting irrelevant browsers while applying new styles.\n//\n// Normalize is licensed MIT. https://github.com/necolas/normalize.css\n\n\n// Document\n//\n// 1. Change from `box-sizing: content-box` so that `width` is not affected by `padding` or `border`.\n// 2. Change the default font family in all browsers.\n// 3. Correct the line height in all browsers.\n// 4. Prevent adjustments of font size after orientation changes in IE on Windows Phone and in iOS.\n// 5. Change the default tap highlight to be completely transparent in iOS.\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box; // 1\n}\n\nhtml {\n  font-family: sans-serif; // 2\n  line-height: 1.15; // 3\n  -webkit-text-size-adjust: 100%; // 4\n  -webkit-tap-highlight-color: rgba($black, 0); // 5\n}\n\n// Shim for \"new\" HTML5 structural elements to display correctly (IE10, older browsers)\n// TODO: remove in v5\n// stylelint-disable-next-line selector-list-comma-newline-after\narticle, aside, figcaption, figure, footer, header, hgroup, main, nav, section {\n  display: block;\n}\n\n// Body\n//\n// 1. Remove the margin in all browsers.\n// 2. As a best practice, apply a default `background-color`.\n// 3. Set an explicit initial text-align value so that we can later use\n//    the `inherit` value on things like `<th>` elements.\n\nbody {\n  margin: 0; // 1\n  font-family: $font-family-base;\n  @include font-size($font-size-base);\n  font-weight: $font-weight-base;\n  line-height: $line-height-base;\n  color: $body-color;\n  text-align: left; // 3\n  background-color: $body-bg; // 2\n}\n\n// Future-proof rule: in browsers that support :focus-visible, suppress the focus outline\n// on elements that programmatically receive focus but wouldn't normally show a visible\n// focus outline. In general, this would mean that the outline is only applied if the\n// interaction that led to the element receiving programmatic focus was a keyboard interaction,\n// or the browser has somehow determined that the user is primarily a keyboard user and/or\n// wants focus outlines to always be presented.\n//\n// See https://developer.mozilla.org/en-US/docs/Web/CSS/:focus-visible\n// and https://developer.paciellogroup.com/blog/2018/03/focus-visible-and-backwards-compatibility/\n[tabindex=\"-1\"]:focus:not(:focus-visible) {\n  outline: 0 !important;\n}\n\n\n// Content grouping\n//\n// 1. Add the correct box sizing in Firefox.\n// 2. Show the overflow in Edge and IE.\n\nhr {\n  box-sizing: content-box; // 1\n  height: 0; // 1\n  overflow: visible; // 2\n}\n\n\n//\n// Typography\n//\n\n// Remove top margins from headings\n//\n// By default, `<h1>`-`<h6>` all receive top and bottom margins. We nuke the top\n// margin for easier control within type scales as it avoids margin collapsing.\n// stylelint-disable-next-line selector-list-comma-newline-after\nh1, h2, h3, h4, h5, h6 {\n  margin-top: 0;\n  margin-bottom: $headings-margin-bottom;\n}\n\n// Reset margins on paragraphs\n//\n// Similarly, the top margin on `<p>`s get reset. However, we also reset the\n// bottom margin to use `rem` units instead of `em`.\np {\n  margin-top: 0;\n  margin-bottom: $paragraph-margin-bottom;\n}\n\n// Abbreviations\n//\n// 1. Duplicate behavior to the data-* attribute for our tooltip plugin\n// 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n// 3. Add explicit cursor to indicate changed behavior.\n// 4. Remove the bottom border in Firefox 39-.\n// 5. Prevent the text-decoration to be skipped.\n\nabbr[title],\nabbr[data-original-title] { // 1\n  text-decoration: underline; // 2\n  text-decoration: underline dotted; // 2\n  cursor: help; // 3\n  border-bottom: 0; // 4\n  text-decoration-skip-ink: none; // 5\n}\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: $dt-font-weight;\n}\n\ndd {\n  margin-bottom: .5rem;\n  margin-left: 0; // Undo browser default\n}\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\nb,\nstrong {\n  font-weight: $font-weight-bolder; // Add the correct font weight in Chrome, Edge, and Safari\n}\n\nsmall {\n  @include font-size(80%); // Add the correct font size in all browsers\n}\n\n//\n// Prevent `sub` and `sup` elements from affecting the line height in\n// all browsers.\n//\n\nsub,\nsup {\n  position: relative;\n  @include font-size(75%);\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub { bottom: -.25em; }\nsup { top: -.5em; }\n\n\n//\n// Links\n//\n\na {\n  color: $link-color;\n  text-decoration: $link-decoration;\n  background-color: transparent; // Remove the gray background on active links in IE 10.\n\n  @include hover() {\n    color: $link-hover-color;\n    text-decoration: $link-hover-decoration;\n  }\n}\n\n// And undo these styles for placeholder links/named anchors (without href).\n// It would be more straightforward to just use a[href] in previous block, but that\n// causes specificity issues in many other styles that are too complex to fix.\n// See https://github.com/twbs/bootstrap/issues/19402\n\na:not([href]):not([class]) {\n  color: inherit;\n  text-decoration: none;\n\n  @include hover() {\n    color: inherit;\n    text-decoration: none;\n  }\n}\n\n\n//\n// Code\n//\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: $font-family-monospace;\n  @include font-size(1em); // Correct the odd `em` font sizing in all browsers.\n}\n\npre {\n  // Remove browser default top margin\n  margin-top: 0;\n  // Reset browser default of `1em` to use `rem`s\n  margin-bottom: 1rem;\n  // Don't allow content to break outside\n  overflow: auto;\n  // Disable auto-hiding scrollbar in IE & legacy Edge to avoid overlap,\n  // making it impossible to interact with the content\n  -ms-overflow-style: scrollbar;\n}\n\n\n//\n// Figures\n//\n\nfigure {\n  // Apply a consistent margin strategy (matches our type styles).\n  margin: 0 0 1rem;\n}\n\n\n//\n// Images and content\n//\n\nimg {\n  vertical-align: middle;\n  border-style: none; // Remove the border on images inside links in IE 10-.\n}\n\nsvg {\n  // Workaround for the SVG overflow bug in IE10/11 is still required.\n  // See https://github.com/twbs/bootstrap/issues/26878\n  overflow: hidden;\n  vertical-align: middle;\n}\n\n\n//\n// Tables\n//\n\ntable {\n  border-collapse: collapse; // Prevent double borders\n}\n\ncaption {\n  padding-top: $table-cell-padding;\n  padding-bottom: $table-cell-padding;\n  color: $table-caption-color;\n  text-align: left;\n  caption-side: bottom;\n}\n\n// 1. Removes font-weight bold by inheriting\n// 2. Matches default `<td>` alignment by inheriting `text-align`.\n// 3. Fix alignment for Safari\n\nth {\n  font-weight: $table-th-font-weight; // 1\n  text-align: inherit; // 2\n  text-align: -webkit-match-parent; // 3\n}\n\n\n//\n// Forms\n//\n\nlabel {\n  // Allow labels to use `margin` for spacing.\n  display: inline-block;\n  margin-bottom: $label-margin-bottom;\n}\n\n// Remove the default `border-radius` that macOS Chrome adds.\n//\n// Details at https://github.com/twbs/bootstrap/issues/24093\nbutton {\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 0;\n}\n\n// Explicitly remove focus outline in Chromium when it shouldn't be\n// visible (e.g. as result of mouse click or touch tap). It already\n// should be doing this automatically, but seems to currently be\n// confused and applies its very visible two-tone outline anyway.\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0; // Remove the margin in Firefox and Safari\n  font-family: inherit;\n  @include font-size(inherit);\n  line-height: inherit;\n}\n\nbutton,\ninput {\n  overflow: visible; // Show the overflow in Edge\n}\n\nbutton,\nselect {\n  text-transform: none; // Remove the inheritance of text transform in Firefox\n}\n\n// Set the cursor for non-`<button>` buttons\n//\n// Details at https://github.com/twbs/bootstrap/pull/30562\n[role=\"button\"] {\n  cursor: pointer;\n}\n\n// Remove the inheritance of word-wrap in Safari.\n//\n// Details at https://github.com/twbs/bootstrap/issues/24990\nselect {\n  word-wrap: normal;\n}\n\n\n// 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n//    controls in Android 4.\n// 2. Correct the inability to style clickable types in iOS and Safari.\nbutton,\n[type=\"button\"], // 1\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; // 2\n}\n\n// Opinionated: add \"hand\" cursor to non-disabled button elements.\n@if $enable-pointer-cursor-for-buttons {\n  button,\n  [type=\"button\"],\n  [type=\"reset\"],\n  [type=\"submit\"] {\n    &:not(:disabled) {\n      cursor: pointer;\n    }\n  }\n}\n\n// Remove inner border and padding from Firefox, but don't restore the outline like Normalize.\nbutton::-moz-focus-inner,\n[type=\"button\"]::-moz-focus-inner,\n[type=\"reset\"]::-moz-focus-inner,\n[type=\"submit\"]::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\ninput[type=\"radio\"],\ninput[type=\"checkbox\"] {\n  box-sizing: border-box; // 1. Add the correct box sizing in IE 10-\n  padding: 0; // 2. Remove the padding in IE 10-\n}\n\n\ntextarea {\n  overflow: auto; // Remove the default vertical scrollbar in IE.\n  // Textareas should really only resize vertically so they don't break their (horizontal) containers.\n  resize: vertical;\n}\n\nfieldset {\n  // Browsers set a default `min-width: min-content;` on fieldsets,\n  // unlike e.g. `<div>`s, which have `min-width: 0;` by default.\n  // So we reset that to ensure fieldsets behave more like a standard block element.\n  // See https://github.com/twbs/bootstrap/issues/12359\n  // and https://html.spec.whatwg.org/multipage/#the-fieldset-and-legend-elements\n  min-width: 0;\n  // Reset the default outline behavior of fieldsets so they don't affect page layout.\n  padding: 0;\n  margin: 0;\n  border: 0;\n}\n\n// 1. Correct the text wrapping in Edge and IE.\n// 2. Correct the color inheritance from `fieldset` elements in IE.\nlegend {\n  display: block;\n  width: 100%;\n  max-width: 100%; // 1\n  padding: 0;\n  margin-bottom: .5rem;\n  @include font-size(1.5rem);\n  line-height: inherit;\n  color: inherit; // 2\n  white-space: normal; // 1\n}\n\nprogress {\n  vertical-align: baseline; // Add the correct vertical alignment in Chrome, Firefox, and Opera.\n}\n\n// Correct the cursor style of increment and decrement buttons in Chrome.\n[type=\"number\"]::-webkit-inner-spin-button,\n[type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}\n\n[type=\"search\"] {\n  // This overrides the extra rounded corners on search inputs in iOS so that our\n  // `.form-control` class can properly style them. Note that this cannot simply\n  // be added to `.form-control` as it's not specific enough. For details, see\n  // https://github.com/twbs/bootstrap/issues/11586.\n  outline-offset: -2px; // 2. Correct the outline style in Safari.\n  -webkit-appearance: none;\n}\n\n//\n// Remove the inner padding in Chrome and Safari on macOS.\n//\n\n[type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n//\n// 1. Correct the inability to style clickable types in iOS and Safari.\n// 2. Change font properties to `inherit` in Safari.\n//\n\n::-webkit-file-upload-button {\n  font: inherit; // 2\n  -webkit-appearance: button; // 1\n}\n\n//\n// Correct element displays\n//\n\noutput {\n  display: inline-block;\n}\n\nsummary {\n  display: list-item; // Add the correct display in all browsers\n  cursor: pointer;\n}\n\ntemplate {\n  display: none; // Add the correct display in IE\n}\n\n// Always hide an element with the `hidden` HTML attribute (from PureCSS).\n// Needed for proper display in IE 10-.\n[hidden] {\n  display: none !important;\n}\n","// Variables\n//\n// Variables should follow the `$component-state-property-size` formula for\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\n\n// Color system\n\n$white:    #fff !default;\n$gray-100: #f8f9fa !default;\n$gray-200: #e9ecef !default;\n$gray-300: #dee2e6 !default;\n$gray-400: #ced4da !default;\n$gray-500: #adb5bd !default;\n$gray-600: #6c757d !default;\n$gray-700: #495057 !default;\n$gray-800: #343a40 !default;\n$gray-900: #212529 !default;\n$black:    #000 !default;\n\n$grays: () !default;\n$grays: map-merge(\n  (\n    \"100\": $gray-100,\n    \"200\": $gray-200,\n    \"300\": $gray-300,\n    \"400\": $gray-400,\n    \"500\": $gray-500,\n    \"600\": $gray-600,\n    \"700\": $gray-700,\n    \"800\": $gray-800,\n    \"900\": $gray-900\n  ),\n  $grays\n);\n\n$blue:    #007bff !default;\n$indigo:  #6610f2 !default;\n$purple:  #6f42c1 !default;\n$pink:    #e83e8c !default;\n$red:     #dc3545 !default;\n$orange:  #fd7e14 !default;\n$yellow:  #ffc107 !default;\n$green:   #28a745 !default;\n$teal:    #20c997 !default;\n$cyan:    #17a2b8 !default;\n\n$colors: () !default;\n$colors: map-merge(\n  (\n    \"blue\":       $blue,\n    \"indigo\":     $indigo,\n    \"purple\":     $purple,\n    \"pink\":       $pink,\n    \"red\":        $red,\n    \"orange\":     $orange,\n    \"yellow\":     $yellow,\n    \"green\":      $green,\n    \"teal\":       $teal,\n    \"cyan\":       $cyan,\n    \"white\":      $white,\n    \"gray\":       $gray-600,\n    \"gray-dark\":  $gray-800\n  ),\n  $colors\n);\n\n$primary:       $blue !default;\n$secondary:     $gray-600 !default;\n$success:       $green !default;\n$info:          $cyan !default;\n$warning:       $yellow !default;\n$danger:        $red !default;\n$light:         $gray-100 !default;\n$dark:          $gray-800 !default;\n\n$theme-colors: () !default;\n$theme-colors: map-merge(\n  (\n    \"primary\":    $primary,\n    \"secondary\":  $secondary,\n    \"success\":    $success,\n    \"info\":       $info,\n    \"warning\":    $warning,\n    \"danger\":     $danger,\n    \"light\":      $light,\n    \"dark\":       $dark\n  ),\n  $theme-colors\n);\n\n// Set a specific jump point for requesting color jumps\n$theme-color-interval:      8% !default;\n\n// The yiq lightness value that determines when the lightness of color changes from \"dark\" to \"light\". Acceptable values are between 0 and 255.\n$yiq-contrasted-threshold:  150 !default;\n\n// Customize the light and dark text colors for use in our YIQ color contrast function.\n$yiq-text-dark:             $gray-900 !default;\n$yiq-text-light:            $white !default;\n\n// Characters which are escaped by the escape-svg function\n$escaped-characters: (\n  (\"<\", \"%3c\"),\n  (\">\", \"%3e\"),\n  (\"#\", \"%23\"),\n  (\"(\", \"%28\"),\n  (\")\", \"%29\"),\n) !default;\n\n\n// Options\n//\n// Quickly modify global styling by enabling or disabling optional features.\n\n$enable-caret:                                true !default;\n$enable-rounded:                              true !default;\n$enable-shadows:                              false !default;\n$enable-gradients:                            false !default;\n$enable-transitions:                          true !default;\n$enable-prefers-reduced-motion-media-query:   true !default;\n$enable-hover-media-query:                    false !default; // Deprecated, no longer affects any compiled CSS\n$enable-grid-classes:                         true !default;\n$enable-pointer-cursor-for-buttons:           true !default;\n$enable-print-styles:                         true !default;\n$enable-responsive-font-sizes:                false !default;\n$enable-validation-icons:                     true !default;\n$enable-deprecation-messages:                 true !default;\n\n\n// Spacing\n//\n// Control the default styling of most Bootstrap elements by modifying these\n// variables. Mostly focused on spacing.\n// You can add more entries to the $spacers map, should you need more variation.\n\n$spacer: 1rem !default;\n$spacers: () !default;\n$spacers: map-merge(\n  (\n    0: 0,\n    1: ($spacer * .25),\n    2: ($spacer * .5),\n    3: $spacer,\n    4: ($spacer * 1.5),\n    5: ($spacer * 3)\n  ),\n  $spacers\n);\n\n// This variable affects the `.h-*` and `.w-*` classes.\n$sizes: () !default;\n$sizes: map-merge(\n  (\n    25: 25%,\n    50: 50%,\n    75: 75%,\n    100: 100%,\n    auto: auto\n  ),\n  $sizes\n);\n\n\n// Body\n//\n// Settings for the `<body>` element.\n\n$body-bg:                   $white !default;\n$body-color:                $gray-900 !default;\n\n\n// Links\n//\n// Style anchor elements.\n\n$link-color:                              theme-color(\"primary\") !default;\n$link-decoration:                         none !default;\n$link-hover-color:                        darken($link-color, 15%) !default;\n$link-hover-decoration:                   underline !default;\n// Darken percentage for links with `.text-*` class (e.g. `.text-success`)\n$emphasized-link-hover-darken-percentage: 15% !default;\n\n// Paragraphs\n//\n// Style p element.\n\n$paragraph-margin-bottom:   1rem !default;\n\n\n// Grid breakpoints\n//\n// Define the minimum dimensions at which your layout will change,\n// adapting to different screen sizes, for use in media queries.\n\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px\n) !default;\n\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\n@include _assert-starts-at-zero($grid-breakpoints, \"$grid-breakpoints\");\n\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px\n) !default;\n\n@include _assert-ascending($container-max-widths, \"$container-max-widths\");\n\n\n// Grid columns\n//\n// Set the number of columns and specify the width of the gutters.\n\n$grid-columns:                12 !default;\n$grid-gutter-width:           30px !default;\n$grid-row-columns:            6 !default;\n\n\n// Components\n//\n// Define common padding and border radius sizes and more.\n\n$line-height-lg:              1.5 !default;\n$line-height-sm:              1.5 !default;\n\n$border-width:                1px !default;\n$border-color:                $gray-300 !default;\n\n$border-radius:               .25rem !default;\n$border-radius-lg:            .3rem !default;\n$border-radius-sm:            .2rem !default;\n\n$rounded-pill:                50rem !default;\n\n$box-shadow-sm:               0 .125rem .25rem rgba($black, .075) !default;\n$box-shadow:                  0 .5rem 1rem rgba($black, .15) !default;\n$box-shadow-lg:               0 1rem 3rem rgba($black, .175) !default;\n\n$component-active-color:      $white !default;\n$component-active-bg:         theme-color(\"primary\") !default;\n\n$caret-width:                 .3em !default;\n$caret-vertical-align:        $caret-width * .85 !default;\n$caret-spacing:               $caret-width * .85 !default;\n\n$transition-base:             all .2s ease-in-out !default;\n$transition-fade:             opacity .15s linear !default;\n$transition-collapse:         height .35s ease !default;\n$transition-collapse-width:   width .35s ease !default;\n\n$embed-responsive-aspect-ratios: () !default;\n$embed-responsive-aspect-ratios: join(\n  (\n    (21 9),\n    (16 9),\n    (4 3),\n    (1 1),\n  ),\n  $embed-responsive-aspect-ratios\n);\n\n// Typography\n//\n// Font, line-height, and color for body text, headings, and more.\n\n// stylelint-disable value-keyword-case\n$font-family-sans-serif:      -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\" !default;\n$font-family-monospace:       SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !default;\n$font-family-base:            $font-family-sans-serif !default;\n// stylelint-enable value-keyword-case\n\n$font-size-base:              1rem !default; // Assumes the browser default, typically `16px`\n$font-size-lg:                $font-size-base * 1.25 !default;\n$font-size-sm:                $font-size-base * .875 !default;\n\n$font-weight-lighter:         lighter !default;\n$font-weight-light:           300 !default;\n$font-weight-normal:          400 !default;\n$font-weight-bold:            700 !default;\n$font-weight-bolder:          bolder !default;\n\n$font-weight-base:            $font-weight-normal !default;\n$line-height-base:            1.5 !default;\n\n$h1-font-size:                $font-size-base * 2.5 !default;\n$h2-font-size:                $font-size-base * 2 !default;\n$h3-font-size:                $font-size-base * 1.75 !default;\n$h4-font-size:                $font-size-base * 1.5 !default;\n$h5-font-size:                $font-size-base * 1.25 !default;\n$h6-font-size:                $font-size-base !default;\n\n$headings-margin-bottom:      $spacer * .5 !default;\n$headings-font-family:        null !default;\n$headings-font-weight:        500 !default;\n$headings-line-height:        1.2 !default;\n$headings-color:              null !default;\n\n$display1-size:               6rem !default;\n$display2-size:               5.5rem !default;\n$display3-size:               4.5rem !default;\n$display4-size:               3.5rem !default;\n\n$display1-weight:             300 !default;\n$display2-weight:             300 !default;\n$display3-weight:             300 !default;\n$display4-weight:             300 !default;\n$display-line-height:         $headings-line-height !default;\n\n$lead-font-size:              $font-size-base * 1.25 !default;\n$lead-font-weight:            300 !default;\n\n$small-font-size:             .875em !default;\n\n$text-muted:                  $gray-600 !default;\n\n$blockquote-small-color:      $gray-600 !default;\n$blockquote-small-font-size:  $small-font-size !default;\n$blockquote-font-size:        $font-size-base * 1.25 !default;\n\n$hr-border-color:             rgba($black, .1) !default;\n$hr-border-width:             $border-width !default;\n\n$mark-padding:                .2em !default;\n\n$dt-font-weight:              $font-weight-bold !default;\n\n$kbd-box-shadow:              inset 0 -.1rem 0 rgba($black, .25) !default;\n$nested-kbd-font-weight:      $font-weight-bold !default;\n\n$list-inline-padding:         .5rem !default;\n\n$mark-bg:                     #fcf8e3 !default;\n\n$hr-margin-y:                 $spacer !default;\n\n\n// Tables\n//\n// Customizes the `.table` component with basic values, each used across all table variations.\n\n$table-cell-padding:          .75rem !default;\n$table-cell-padding-sm:       .3rem !default;\n\n$table-color:                 $body-color !default;\n$table-bg:                    null !default;\n$table-accent-bg:             rgba($black, .05) !default;\n$table-hover-color:           $table-color !default;\n$table-hover-bg:              rgba($black, .075) !default;\n$table-active-bg:             $table-hover-bg !default;\n\n$table-border-width:          $border-width !default;\n$table-border-color:          $border-color !default;\n\n$table-head-bg:               $gray-200 !default;\n$table-head-color:            $gray-700 !default;\n$table-th-font-weight:        null !default;\n\n$table-dark-color:            $white !default;\n$table-dark-bg:               $gray-800 !default;\n$table-dark-accent-bg:        rgba($white, .05) !default;\n$table-dark-hover-color:      $table-dark-color !default;\n$table-dark-hover-bg:         rgba($white, .075) !default;\n$table-dark-border-color:     lighten($table-dark-bg, 7.5%) !default;\n\n$table-striped-order:         odd !default;\n\n$table-caption-color:         $text-muted !default;\n\n$table-bg-level:              -9 !default;\n$table-border-level:          -6 !default;\n\n\n// Buttons + Forms\n//\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\n\n$input-btn-padding-y:         .375rem !default;\n$input-btn-padding-x:         .75rem !default;\n$input-btn-font-family:       null !default;\n$input-btn-font-size:         $font-size-base !default;\n$input-btn-line-height:       $line-height-base !default;\n\n$input-btn-focus-width:       .2rem !default;\n$input-btn-focus-color:       rgba($component-active-bg, .25) !default;\n$input-btn-focus-box-shadow:  0 0 0 $input-btn-focus-width $input-btn-focus-color !default;\n\n$input-btn-padding-y-sm:      .25rem !default;\n$input-btn-padding-x-sm:      .5rem !default;\n$input-btn-font-size-sm:      $font-size-sm !default;\n$input-btn-line-height-sm:    $line-height-sm !default;\n\n$input-btn-padding-y-lg:      .5rem !default;\n$input-btn-padding-x-lg:      1rem !default;\n$input-btn-font-size-lg:      $font-size-lg !default;\n$input-btn-line-height-lg:    $line-height-lg !default;\n\n$input-btn-border-width:      $border-width !default;\n\n\n// Buttons\n//\n// For each of Bootstrap's buttons, define text, background, and border color.\n\n$btn-padding-y:               $input-btn-padding-y !default;\n$btn-padding-x:               $input-btn-padding-x !default;\n$btn-font-family:             $input-btn-font-family !default;\n$btn-font-size:               $input-btn-font-size !default;\n$btn-line-height:             $input-btn-line-height !default;\n$btn-white-space:             null !default; // Set to `nowrap` to prevent text wrapping\n\n$btn-padding-y-sm:            $input-btn-padding-y-sm !default;\n$btn-padding-x-sm:            $input-btn-padding-x-sm !default;\n$btn-font-size-sm:            $input-btn-font-size-sm !default;\n$btn-line-height-sm:          $input-btn-line-height-sm !default;\n\n$btn-padding-y-lg:            $input-btn-padding-y-lg !default;\n$btn-padding-x-lg:            $input-btn-padding-x-lg !default;\n$btn-font-size-lg:            $input-btn-font-size-lg !default;\n$btn-line-height-lg:          $input-btn-line-height-lg !default;\n\n$btn-border-width:            $input-btn-border-width !default;\n\n$btn-font-weight:             $font-weight-normal !default;\n$btn-box-shadow:              inset 0 1px 0 rgba($white, .15), 0 1px 1px rgba($black, .075) !default;\n$btn-focus-width:             $input-btn-focus-width !default;\n$btn-focus-box-shadow:        $input-btn-focus-box-shadow !default;\n$btn-disabled-opacity:        .65 !default;\n$btn-active-box-shadow:       inset 0 3px 5px rgba($black, .125) !default;\n\n$btn-link-disabled-color:     $gray-600 !default;\n\n$btn-block-spacing-y:         .5rem !default;\n\n// Allows for customizing button radius independently from global border radius\n$btn-border-radius:           $border-radius !default;\n$btn-border-radius-lg:        $border-radius-lg !default;\n$btn-border-radius-sm:        $border-radius-sm !default;\n\n$btn-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n\n// Forms\n\n$label-margin-bottom:                   .5rem !default;\n\n$input-padding-y:                       $input-btn-padding-y !default;\n$input-padding-x:                       $input-btn-padding-x !default;\n$input-font-family:                     $input-btn-font-family !default;\n$input-font-size:                       $input-btn-font-size !default;\n$input-font-weight:                     $font-weight-base !default;\n$input-line-height:                     $input-btn-line-height !default;\n\n$input-padding-y-sm:                    $input-btn-padding-y-sm !default;\n$input-padding-x-sm:                    $input-btn-padding-x-sm !default;\n$input-font-size-sm:                    $input-btn-font-size-sm !default;\n$input-line-height-sm:                  $input-btn-line-height-sm !default;\n\n$input-padding-y-lg:                    $input-btn-padding-y-lg !default;\n$input-padding-x-lg:                    $input-btn-padding-x-lg !default;\n$input-font-size-lg:                    $input-btn-font-size-lg !default;\n$input-line-height-lg:                  $input-btn-line-height-lg !default;\n\n$input-bg:                              $white !default;\n$input-disabled-bg:                     $gray-200 !default;\n\n$input-color:                           $gray-700 !default;\n$input-border-color:                    $gray-400 !default;\n$input-border-width:                    $input-btn-border-width !default;\n$input-box-shadow:                      inset 0 1px 1px rgba($black, .075) !default;\n\n$input-border-radius:                   $border-radius !default;\n$input-border-radius-lg:                $border-radius-lg !default;\n$input-border-radius-sm:                $border-radius-sm !default;\n\n$input-focus-bg:                        $input-bg !default;\n$input-focus-border-color:              lighten($component-active-bg, 25%) !default;\n$input-focus-color:                     $input-color !default;\n$input-focus-width:                     $input-btn-focus-width !default;\n$input-focus-box-shadow:                $input-btn-focus-box-shadow !default;\n\n$input-placeholder-color:               $gray-600 !default;\n$input-plaintext-color:                 $body-color !default;\n\n$input-height-border:                   $input-border-width * 2 !default;\n\n$input-height-inner:                    add($input-line-height * 1em, $input-padding-y * 2) !default;\n$input-height-inner-half:               add($input-line-height * .5em, $input-padding-y) !default;\n$input-height-inner-quarter:            add($input-line-height * .25em, $input-padding-y * .5) !default;\n\n$input-height:                          add($input-line-height * 1em, add($input-padding-y * 2, $input-height-border, false)) !default;\n$input-height-sm:                       add($input-line-height-sm * 1em, add($input-padding-y-sm * 2, $input-height-border, false)) !default;\n$input-height-lg:                       add($input-line-height-lg * 1em, add($input-padding-y-lg * 2, $input-height-border, false)) !default;\n\n$input-transition:                      border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$form-text-margin-top:                  .25rem !default;\n\n$form-check-input-gutter:               1.25rem !default;\n$form-check-input-margin-y:             .3rem !default;\n$form-check-input-margin-x:             .25rem !default;\n\n$form-check-inline-margin-x:            .75rem !default;\n$form-check-inline-input-margin-x:      .3125rem !default;\n\n$form-grid-gutter-width:                10px !default;\n$form-group-margin-bottom:              1rem !default;\n\n$input-group-addon-color:               $input-color !default;\n$input-group-addon-bg:                  $gray-200 !default;\n$input-group-addon-border-color:        $input-border-color !default;\n\n$custom-forms-transition:               background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$custom-control-gutter:                 .5rem !default;\n$custom-control-spacer-x:               1rem !default;\n$custom-control-cursor:                 null !default;\n\n$custom-control-indicator-size:         1rem !default;\n$custom-control-indicator-bg:           $input-bg !default;\n\n$custom-control-indicator-bg-size:      50% 50% !default;\n$custom-control-indicator-box-shadow:   $input-box-shadow !default;\n$custom-control-indicator-border-color: $gray-500 !default;\n$custom-control-indicator-border-width: $input-border-width !default;\n\n$custom-control-label-color:            null !default;\n\n$custom-control-indicator-disabled-bg:          $input-disabled-bg !default;\n$custom-control-label-disabled-color:           $gray-600 !default;\n\n$custom-control-indicator-checked-color:        $component-active-color !default;\n$custom-control-indicator-checked-bg:           $component-active-bg !default;\n$custom-control-indicator-checked-disabled-bg:  rgba(theme-color(\"primary\"), .5) !default;\n$custom-control-indicator-checked-box-shadow:   null !default;\n$custom-control-indicator-checked-border-color: $custom-control-indicator-checked-bg !default;\n\n$custom-control-indicator-focus-box-shadow:     $input-focus-box-shadow !default;\n$custom-control-indicator-focus-border-color:   $input-focus-border-color !default;\n\n$custom-control-indicator-active-color:         $component-active-color !default;\n$custom-control-indicator-active-bg:            lighten($component-active-bg, 35%) !default;\n$custom-control-indicator-active-box-shadow:    null !default;\n$custom-control-indicator-active-border-color:  $custom-control-indicator-active-bg !default;\n\n$custom-checkbox-indicator-border-radius:       $border-radius !default;\n$custom-checkbox-indicator-icon-checked:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'><path fill='#{$custom-control-indicator-checked-color}' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z'/></svg>\") !default;\n\n$custom-checkbox-indicator-indeterminate-bg:           $component-active-bg !default;\n$custom-checkbox-indicator-indeterminate-color:        $custom-control-indicator-checked-color !default;\n$custom-checkbox-indicator-icon-indeterminate:         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='4' height='4' viewBox='0 0 4 4'><path stroke='#{$custom-checkbox-indicator-indeterminate-color}' d='M0 2h4'/></svg>\") !default;\n$custom-checkbox-indicator-indeterminate-box-shadow:   null !default;\n$custom-checkbox-indicator-indeterminate-border-color: $custom-checkbox-indicator-indeterminate-bg !default;\n\n$custom-radio-indicator-border-radius:          50% !default;\n$custom-radio-indicator-icon-checked:           url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='-4 -4 8 8'><circle r='3' fill='#{$custom-control-indicator-checked-color}'/></svg>\") !default;\n\n$custom-switch-width:                           $custom-control-indicator-size * 1.75 !default;\n$custom-switch-indicator-border-radius:         $custom-control-indicator-size * .5 !default;\n$custom-switch-indicator-size:                  subtract($custom-control-indicator-size, $custom-control-indicator-border-width * 4) !default;\n\n$custom-select-padding-y:           $input-padding-y !default;\n$custom-select-padding-x:           $input-padding-x !default;\n$custom-select-font-family:         $input-font-family !default;\n$custom-select-font-size:           $input-font-size !default;\n$custom-select-height:              $input-height !default;\n$custom-select-indicator-padding:   1rem !default; // Extra padding to account for the presence of the background-image based indicator\n$custom-select-font-weight:         $input-font-weight !default;\n$custom-select-line-height:         $input-line-height !default;\n$custom-select-color:               $input-color !default;\n$custom-select-disabled-color:      $gray-600 !default;\n$custom-select-bg:                  $input-bg !default;\n$custom-select-disabled-bg:         $gray-200 !default;\n$custom-select-bg-size:             8px 10px !default; // In pixels because image dimensions\n$custom-select-indicator-color:     $gray-800 !default;\n$custom-select-indicator:           url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'><path fill='#{$custom-select-indicator-color}' d='M2 0L0 2h4zm0 5L0 3h4z'/></svg>\") !default;\n$custom-select-background:          escape-svg($custom-select-indicator) right $custom-select-padding-x center / $custom-select-bg-size no-repeat !default; // Used so we can have multiple background elements (e.g., arrow and feedback icon)\n\n$custom-select-feedback-icon-padding-right: add(1em * .75, (2 * $custom-select-padding-y * .75) + $custom-select-padding-x + $custom-select-indicator-padding) !default;\n$custom-select-feedback-icon-position:      center right ($custom-select-padding-x + $custom-select-indicator-padding) !default;\n$custom-select-feedback-icon-size:          $input-height-inner-half $input-height-inner-half !default;\n\n$custom-select-border-width:        $input-border-width !default;\n$custom-select-border-color:        $input-border-color !default;\n$custom-select-border-radius:       $border-radius !default;\n$custom-select-box-shadow:          inset 0 1px 2px rgba($black, .075) !default;\n\n$custom-select-focus-border-color:  $input-focus-border-color !default;\n$custom-select-focus-width:         $input-focus-width !default;\n$custom-select-focus-box-shadow:    0 0 0 $custom-select-focus-width $input-btn-focus-color !default;\n\n$custom-select-padding-y-sm:        $input-padding-y-sm !default;\n$custom-select-padding-x-sm:        $input-padding-x-sm !default;\n$custom-select-font-size-sm:        $input-font-size-sm !default;\n$custom-select-height-sm:           $input-height-sm !default;\n\n$custom-select-padding-y-lg:        $input-padding-y-lg !default;\n$custom-select-padding-x-lg:        $input-padding-x-lg !default;\n$custom-select-font-size-lg:        $input-font-size-lg !default;\n$custom-select-height-lg:           $input-height-lg !default;\n\n$custom-range-track-width:          100% !default;\n$custom-range-track-height:         .5rem !default;\n$custom-range-track-cursor:         pointer !default;\n$custom-range-track-bg:             $gray-300 !default;\n$custom-range-track-border-radius:  1rem !default;\n$custom-range-track-box-shadow:     inset 0 .25rem .25rem rgba($black, .1) !default;\n\n$custom-range-thumb-width:                   1rem !default;\n$custom-range-thumb-height:                  $custom-range-thumb-width !default;\n$custom-range-thumb-bg:                      $component-active-bg !default;\n$custom-range-thumb-border:                  0 !default;\n$custom-range-thumb-border-radius:           1rem !default;\n$custom-range-thumb-box-shadow:              0 .1rem .25rem rgba($black, .1) !default;\n$custom-range-thumb-focus-box-shadow:        0 0 0 1px $body-bg, $input-focus-box-shadow !default;\n$custom-range-thumb-focus-box-shadow-width:  $input-focus-width !default; // For focus box shadow issue in IE/Edge\n$custom-range-thumb-active-bg:               lighten($component-active-bg, 35%) !default;\n$custom-range-thumb-disabled-bg:             $gray-500 !default;\n\n$custom-file-height:                $input-height !default;\n$custom-file-height-inner:          $input-height-inner !default;\n$custom-file-focus-border-color:    $input-focus-border-color !default;\n$custom-file-focus-box-shadow:      $input-focus-box-shadow !default;\n$custom-file-disabled-bg:           $input-disabled-bg !default;\n\n$custom-file-padding-y:             $input-padding-y !default;\n$custom-file-padding-x:             $input-padding-x !default;\n$custom-file-line-height:           $input-line-height !default;\n$custom-file-font-family:           $input-font-family !default;\n$custom-file-font-weight:           $input-font-weight !default;\n$custom-file-color:                 $input-color !default;\n$custom-file-bg:                    $input-bg !default;\n$custom-file-border-width:          $input-border-width !default;\n$custom-file-border-color:          $input-border-color !default;\n$custom-file-border-radius:         $input-border-radius !default;\n$custom-file-box-shadow:            $input-box-shadow !default;\n$custom-file-button-color:          $custom-file-color !default;\n$custom-file-button-bg:             $input-group-addon-bg !default;\n$custom-file-text: (\n  en: \"Browse\"\n) !default;\n\n\n// Form validation\n\n$form-feedback-margin-top:          $form-text-margin-top !default;\n$form-feedback-font-size:           $small-font-size !default;\n$form-feedback-valid-color:         theme-color(\"success\") !default;\n$form-feedback-invalid-color:       theme-color(\"danger\") !default;\n\n$form-feedback-icon-valid-color:    $form-feedback-valid-color !default;\n$form-feedback-icon-valid:          url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'><path fill='#{$form-feedback-icon-valid-color}' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/></svg>\") !default;\n$form-feedback-icon-invalid-color:  $form-feedback-invalid-color !default;\n$form-feedback-icon-invalid:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='#{$form-feedback-icon-invalid-color}' viewBox='0 0 12 12'><circle cx='6' cy='6' r='4.5'/><path stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/><circle cx='6' cy='8.2' r='.6' fill='#{$form-feedback-icon-invalid-color}' stroke='none'/></svg>\") !default;\n\n$form-validation-states: () !default;\n$form-validation-states: map-merge(\n  (\n    \"valid\": (\n      \"color\": $form-feedback-valid-color,\n      \"icon\": $form-feedback-icon-valid\n    ),\n    \"invalid\": (\n      \"color\": $form-feedback-invalid-color,\n      \"icon\": $form-feedback-icon-invalid\n    ),\n  ),\n  $form-validation-states\n);\n\n// Z-index master list\n//\n// Warning: Avoid customizing these values. They're used for a bird's eye view\n// of components dependent on the z-axis and are designed to all work together.\n\n$zindex-dropdown:                   1000 !default;\n$zindex-sticky:                     1020 !default;\n$zindex-fixed:                      1030 !default;\n$zindex-modal-backdrop:             1040 !default;\n$zindex-modal:                      1050 !default;\n$zindex-popover:                    1060 !default;\n$zindex-tooltip:                    1070 !default;\n\n\n// Navs\n\n$nav-link-padding-y:                .5rem !default;\n$nav-link-padding-x:                1rem !default;\n$nav-link-disabled-color:           $gray-600 !default;\n\n$nav-tabs-border-color:             $gray-300 !default;\n$nav-tabs-border-width:             $border-width !default;\n$nav-tabs-border-radius:            $border-radius !default;\n$nav-tabs-link-hover-border-color:  $gray-200 $gray-200 $nav-tabs-border-color !default;\n$nav-tabs-link-active-color:        $gray-700 !default;\n$nav-tabs-link-active-bg:           $body-bg !default;\n$nav-tabs-link-active-border-color: $gray-300 $gray-300 $nav-tabs-link-active-bg !default;\n\n$nav-pills-border-radius:           $border-radius !default;\n$nav-pills-link-active-color:       $component-active-color !default;\n$nav-pills-link-active-bg:          $component-active-bg !default;\n\n$nav-divider-color:                 $gray-200 !default;\n$nav-divider-margin-y:              $spacer * .5 !default;\n\n\n// Navbar\n\n$navbar-padding-y:                  $spacer * .5 !default;\n$navbar-padding-x:                  $spacer !default;\n\n$navbar-nav-link-padding-x:         .5rem !default;\n\n$navbar-brand-font-size:            $font-size-lg !default;\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\n$nav-link-height:                   $font-size-base * $line-height-base + $nav-link-padding-y * 2 !default;\n$navbar-brand-height:               $navbar-brand-font-size * $line-height-base !default;\n$navbar-brand-padding-y:            ($nav-link-height - $navbar-brand-height) * .5 !default;\n\n$navbar-toggler-padding-y:          .25rem !default;\n$navbar-toggler-padding-x:          .75rem !default;\n$navbar-toggler-font-size:          $font-size-lg !default;\n$navbar-toggler-border-radius:      $btn-border-radius !default;\n\n$navbar-nav-scroll-max-height:      75vh !default;\n\n$navbar-dark-color:                 rgba($white, .5) !default;\n$navbar-dark-hover-color:           rgba($white, .75) !default;\n$navbar-dark-active-color:          $white !default;\n$navbar-dark-disabled-color:        rgba($white, .25) !default;\n$navbar-dark-toggler-icon-bg:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'><path stroke='#{$navbar-dark-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-dark-toggler-border-color:  rgba($white, .1) !default;\n\n$navbar-light-color:                rgba($black, .5) !default;\n$navbar-light-hover-color:          rgba($black, .7) !default;\n$navbar-light-active-color:         rgba($black, .9) !default;\n$navbar-light-disabled-color:       rgba($black, .3) !default;\n$navbar-light-toggler-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'><path stroke='#{$navbar-light-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-light-toggler-border-color: rgba($black, .1) !default;\n\n$navbar-light-brand-color:                $navbar-light-active-color !default;\n$navbar-light-brand-hover-color:          $navbar-light-active-color !default;\n$navbar-dark-brand-color:                 $navbar-dark-active-color !default;\n$navbar-dark-brand-hover-color:           $navbar-dark-active-color !default;\n\n\n// Dropdowns\n//\n// Dropdown menu container and contents.\n\n$dropdown-min-width:                10rem !default;\n$dropdown-padding-x:                0 !default;\n$dropdown-padding-y:                .5rem !default;\n$dropdown-spacer:                   .125rem !default;\n$dropdown-font-size:                $font-size-base !default;\n$dropdown-color:                    $body-color !default;\n$dropdown-bg:                       $white !default;\n$dropdown-border-color:             rgba($black, .15) !default;\n$dropdown-border-radius:            $border-radius !default;\n$dropdown-border-width:             $border-width !default;\n$dropdown-inner-border-radius:      subtract($dropdown-border-radius, $dropdown-border-width) !default;\n$dropdown-divider-bg:               $gray-200 !default;\n$dropdown-divider-margin-y:         $nav-divider-margin-y !default;\n$dropdown-box-shadow:               0 .5rem 1rem rgba($black, .175) !default;\n\n$dropdown-link-color:               $gray-900 !default;\n$dropdown-link-hover-color:         darken($gray-900, 5%) !default;\n$dropdown-link-hover-bg:            $gray-200 !default;\n\n$dropdown-link-active-color:        $component-active-color !default;\n$dropdown-link-active-bg:           $component-active-bg !default;\n\n$dropdown-link-disabled-color:      $gray-500 !default;\n\n$dropdown-item-padding-y:           .25rem !default;\n$dropdown-item-padding-x:           1.5rem !default;\n\n$dropdown-header-color:             $gray-600 !default;\n$dropdown-header-padding:           $dropdown-padding-y $dropdown-item-padding-x !default;\n\n\n// Pagination\n\n$pagination-padding-y:              .5rem !default;\n$pagination-padding-x:              .75rem !default;\n$pagination-padding-y-sm:           .25rem !default;\n$pagination-padding-x-sm:           .5rem !default;\n$pagination-padding-y-lg:           .75rem !default;\n$pagination-padding-x-lg:           1.5rem !default;\n$pagination-line-height:            1.25 !default;\n\n$pagination-color:                  $link-color !default;\n$pagination-bg:                     $white !default;\n$pagination-border-width:           $border-width !default;\n$pagination-border-color:           $gray-300 !default;\n\n$pagination-focus-box-shadow:       $input-btn-focus-box-shadow !default;\n$pagination-focus-outline:          0 !default;\n\n$pagination-hover-color:            $link-hover-color !default;\n$pagination-hover-bg:               $gray-200 !default;\n$pagination-hover-border-color:     $gray-300 !default;\n\n$pagination-active-color:           $component-active-color !default;\n$pagination-active-bg:              $component-active-bg !default;\n$pagination-active-border-color:    $pagination-active-bg !default;\n\n$pagination-disabled-color:         $gray-600 !default;\n$pagination-disabled-bg:            $white !default;\n$pagination-disabled-border-color:  $gray-300 !default;\n\n$pagination-border-radius-sm:       $border-radius-sm !default;\n$pagination-border-radius-lg:       $border-radius-lg !default;\n\n\n// Jumbotron\n\n$jumbotron-padding:                 2rem !default;\n$jumbotron-color:                   null !default;\n$jumbotron-bg:                      $gray-200 !default;\n\n\n// Cards\n\n$card-spacer-y:                     .75rem !default;\n$card-spacer-x:                     1.25rem !default;\n$card-border-width:                 $border-width !default;\n$card-border-radius:                $border-radius !default;\n$card-border-color:                 rgba($black, .125) !default;\n$card-inner-border-radius:          subtract($card-border-radius, $card-border-width) !default;\n$card-cap-bg:                       rgba($black, .03) !default;\n$card-cap-color:                    null !default;\n$card-height:                       null !default;\n$card-color:                        null !default;\n$card-bg:                           $white !default;\n\n$card-img-overlay-padding:          1.25rem !default;\n\n$card-group-margin:                 $grid-gutter-width * .5 !default;\n$card-deck-margin:                  $card-group-margin !default;\n\n$card-columns-count:                3 !default;\n$card-columns-gap:                  1.25rem !default;\n$card-columns-margin:               $card-spacer-y !default;\n\n\n// Tooltips\n\n$tooltip-font-size:                 $font-size-sm !default;\n$tooltip-max-width:                 200px !default;\n$tooltip-color:                     $white !default;\n$tooltip-bg:                        $black !default;\n$tooltip-border-radius:             $border-radius !default;\n$tooltip-opacity:                   .9 !default;\n$tooltip-padding-y:                 .25rem !default;\n$tooltip-padding-x:                 .5rem !default;\n$tooltip-margin:                    0 !default;\n\n$tooltip-arrow-width:               .8rem !default;\n$tooltip-arrow-height:              .4rem !default;\n$tooltip-arrow-color:               $tooltip-bg !default;\n\n// Form tooltips must come after regular tooltips\n$form-feedback-tooltip-padding-y:     $tooltip-padding-y !default;\n$form-feedback-tooltip-padding-x:     $tooltip-padding-x !default;\n$form-feedback-tooltip-font-size:     $tooltip-font-size !default;\n$form-feedback-tooltip-line-height:   $line-height-base !default;\n$form-feedback-tooltip-opacity:       $tooltip-opacity !default;\n$form-feedback-tooltip-border-radius: $tooltip-border-radius !default;\n\n\n// Popovers\n\n$popover-font-size:                 $font-size-sm !default;\n$popover-bg:                        $white !default;\n$popover-max-width:                 276px !default;\n$popover-border-width:              $border-width !default;\n$popover-border-color:              rgba($black, .2) !default;\n$popover-border-radius:             $border-radius-lg !default;\n$popover-inner-border-radius:       subtract($popover-border-radius, $popover-border-width) !default;\n$popover-box-shadow:                0 .25rem .5rem rgba($black, .2) !default;\n\n$popover-header-bg:                 darken($popover-bg, 3%) !default;\n$popover-header-color:              $headings-color !default;\n$popover-header-padding-y:          .5rem !default;\n$popover-header-padding-x:          .75rem !default;\n\n$popover-body-color:                $body-color !default;\n$popover-body-padding-y:            $popover-header-padding-y !default;\n$popover-body-padding-x:            $popover-header-padding-x !default;\n\n$popover-arrow-width:               1rem !default;\n$popover-arrow-height:              .5rem !default;\n$popover-arrow-color:               $popover-bg !default;\n\n$popover-arrow-outer-color:         fade-in($popover-border-color, .05) !default;\n\n\n// Toasts\n\n$toast-max-width:                   350px !default;\n$toast-padding-x:                   .75rem !default;\n$toast-padding-y:                   .25rem !default;\n$toast-font-size:                   .875rem !default;\n$toast-color:                       null !default;\n$toast-background-color:            rgba($white, .85) !default;\n$toast-border-width:                1px !default;\n$toast-border-color:                rgba(0, 0, 0, .1) !default;\n$toast-border-radius:               .25rem !default;\n$toast-box-shadow:                  0 .25rem .75rem rgba($black, .1) !default;\n\n$toast-header-color:                $gray-600 !default;\n$toast-header-background-color:     rgba($white, .85) !default;\n$toast-header-border-color:         rgba(0, 0, 0, .05) !default;\n\n\n// Badges\n\n$badge-font-size:                   75% !default;\n$badge-font-weight:                 $font-weight-bold !default;\n$badge-padding-y:                   .25em !default;\n$badge-padding-x:                   .4em !default;\n$badge-border-radius:               $border-radius !default;\n\n$badge-transition:                  $btn-transition !default;\n$badge-focus-width:                 $input-btn-focus-width !default;\n\n$badge-pill-padding-x:              .6em !default;\n// Use a higher than normal value to ensure completely rounded edges when\n// customizing padding or font-size on labels.\n$badge-pill-border-radius:          10rem !default;\n\n\n// Modals\n\n// Padding applied to the modal body\n$modal-inner-padding:               1rem !default;\n\n// Margin between elements in footer, must be lower than or equal to 2 * $modal-inner-padding\n$modal-footer-margin-between:       .5rem !default;\n\n$modal-dialog-margin:               .5rem !default;\n$modal-dialog-margin-y-sm-up:       1.75rem !default;\n\n$modal-title-line-height:           $line-height-base !default;\n\n$modal-content-color:               null !default;\n$modal-content-bg:                  $white !default;\n$modal-content-border-color:        rgba($black, .2) !default;\n$modal-content-border-width:        $border-width !default;\n$modal-content-border-radius:       $border-radius-lg !default;\n$modal-content-inner-border-radius: subtract($modal-content-border-radius, $modal-content-border-width) !default;\n$modal-content-box-shadow-xs:       0 .25rem .5rem rgba($black, .5) !default;\n$modal-content-box-shadow-sm-up:    0 .5rem 1rem rgba($black, .5) !default;\n\n$modal-backdrop-bg:                 $black !default;\n$modal-backdrop-opacity:            .5 !default;\n$modal-header-border-color:         $border-color !default;\n$modal-footer-border-color:         $modal-header-border-color !default;\n$modal-header-border-width:         $modal-content-border-width !default;\n$modal-footer-border-width:         $modal-header-border-width !default;\n$modal-header-padding-y:            1rem !default;\n$modal-header-padding-x:            1rem !default;\n$modal-header-padding:              $modal-header-padding-y $modal-header-padding-x !default; // Keep this for backwards compatibility\n\n$modal-xl:                          1140px !default;\n$modal-lg:                          800px !default;\n$modal-md:                          500px !default;\n$modal-sm:                          300px !default;\n\n$modal-fade-transform:              translate(0, -50px) !default;\n$modal-show-transform:              none !default;\n$modal-transition:                  transform .3s ease-out !default;\n$modal-scale-transform:             scale(1.02) !default;\n\n\n// Alerts\n//\n// Define alert colors, border radius, and padding.\n\n$alert-padding-y:                   .75rem !default;\n$alert-padding-x:                   1.25rem !default;\n$alert-margin-bottom:               1rem !default;\n$alert-border-radius:               $border-radius !default;\n$alert-link-font-weight:            $font-weight-bold !default;\n$alert-border-width:                $border-width !default;\n\n$alert-bg-level:                    -10 !default;\n$alert-border-level:                -9 !default;\n$alert-color-level:                 6 !default;\n\n\n// Progress bars\n\n$progress-height:                   1rem !default;\n$progress-font-size:                $font-size-base * .75 !default;\n$progress-bg:                       $gray-200 !default;\n$progress-border-radius:            $border-radius !default;\n$progress-box-shadow:               inset 0 .1rem .1rem rgba($black, .1) !default;\n$progress-bar-color:                $white !default;\n$progress-bar-bg:                   theme-color(\"primary\") !default;\n$progress-bar-animation-timing:     1s linear infinite !default;\n$progress-bar-transition:           width .6s ease !default;\n\n\n// List group\n\n$list-group-color:                  null !default;\n$list-group-bg:                     $white !default;\n$list-group-border-color:           rgba($black, .125) !default;\n$list-group-border-width:           $border-width !default;\n$list-group-border-radius:          $border-radius !default;\n\n$list-group-item-padding-y:         .75rem !default;\n$list-group-item-padding-x:         1.25rem !default;\n\n$list-group-hover-bg:               $gray-100 !default;\n$list-group-active-color:           $component-active-color !default;\n$list-group-active-bg:              $component-active-bg !default;\n$list-group-active-border-color:    $list-group-active-bg !default;\n\n$list-group-disabled-color:         $gray-600 !default;\n$list-group-disabled-bg:            $list-group-bg !default;\n\n$list-group-action-color:           $gray-700 !default;\n$list-group-action-hover-color:     $list-group-action-color !default;\n\n$list-group-action-active-color:    $body-color !default;\n$list-group-action-active-bg:       $gray-200 !default;\n\n\n// Image thumbnails\n\n$thumbnail-padding:                 .25rem !default;\n$thumbnail-bg:                      $body-bg !default;\n$thumbnail-border-width:            $border-width !default;\n$thumbnail-border-color:            $gray-300 !default;\n$thumbnail-border-radius:           $border-radius !default;\n$thumbnail-box-shadow:              0 1px 2px rgba($black, .075) !default;\n\n\n// Figures\n\n$figure-caption-font-size:          90% !default;\n$figure-caption-color:              $gray-600 !default;\n\n\n// Breadcrumbs\n\n$breadcrumb-font-size:              null !default;\n\n$breadcrumb-padding-y:              .75rem !default;\n$breadcrumb-padding-x:              1rem !default;\n$breadcrumb-item-padding:           .5rem !default;\n\n$breadcrumb-margin-bottom:          1rem !default;\n\n$breadcrumb-bg:                     $gray-200 !default;\n$breadcrumb-divider-color:          $gray-600 !default;\n$breadcrumb-active-color:           $gray-600 !default;\n$breadcrumb-divider:                quote(\"/\") !default;\n\n$breadcrumb-border-radius:          $border-radius !default;\n\n\n// Carousel\n\n$carousel-control-color:             $white !default;\n$carousel-control-width:             15% !default;\n$carousel-control-opacity:           .5 !default;\n$carousel-control-hover-opacity:     .9 !default;\n$carousel-control-transition:        opacity .15s ease !default;\n\n$carousel-indicator-width:           30px !default;\n$carousel-indicator-height:          3px !default;\n$carousel-indicator-hit-area-height: 10px !default;\n$carousel-indicator-spacer:          3px !default;\n$carousel-indicator-active-bg:       $white !default;\n$carousel-indicator-transition:      opacity .6s ease !default;\n\n$carousel-caption-width:             70% !default;\n$carousel-caption-color:             $white !default;\n\n$carousel-control-icon-width:        20px !default;\n\n$carousel-control-prev-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' fill='#{$carousel-control-color}' width='8' height='8' viewBox='0 0 8 8'><path d='M5.25 0l-4 4 4 4 1.5-1.5L4.25 4l2.5-2.5L5.25 0z'/></svg>\") !default;\n$carousel-control-next-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' fill='#{$carousel-control-color}' width='8' height='8' viewBox='0 0 8 8'><path d='M2.75 0l-1.5 1.5L3.75 4l-2.5 2.5L2.75 8l4-4-4-4z'/></svg>\") !default;\n\n$carousel-transition-duration:       .6s !default;\n$carousel-transition:                transform $carousel-transition-duration ease-in-out !default; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\n\n\n// Spinners\n\n$spinner-width:           2rem !default;\n$spinner-height:          $spinner-width !default;\n$spinner-vertical-align:  -.125em !default;\n$spinner-border-width:    .25em !default;\n\n$spinner-width-sm:        1rem !default;\n$spinner-height-sm:       $spinner-width-sm !default;\n$spinner-border-width-sm: .2em !default;\n\n\n// Close\n\n$close-font-size:                   $font-size-base * 1.5 !default;\n$close-font-weight:                 $font-weight-bold !default;\n$close-color:                       $black !default;\n$close-text-shadow:                 0 1px 0 $white !default;\n\n\n// Code\n\n$code-font-size:                    87.5% !default;\n$code-color:                        $pink !default;\n\n$kbd-padding-y:                     .2rem !default;\n$kbd-padding-x:                     .4rem !default;\n$kbd-font-size:                     $code-font-size !default;\n$kbd-color:                         $white !default;\n$kbd-bg:                            $gray-900 !default;\n\n$pre-color:                         $gray-900 !default;\n$pre-scrollable-max-height:         340px !default;\n\n\n// Utilities\n\n$displays: none, inline, inline-block, block, table, table-row, table-cell, flex, inline-flex !default;\n$overflows: auto, hidden !default;\n$positions: static, relative, absolute, fixed, sticky !default;\n$user-selects: all, auto, none !default;\n\n\n// Printing\n\n$print-page-size:                   a3 !default;\n$print-body-min-width:              map-get($grid-breakpoints, \"lg\") !default;\n","// stylelint-disable property-blacklist, scss/dollar-variable-default\n\n// SCSS RFS mixin\n//\n// Automated responsive font sizes\n//\n// Licensed under MIT (https://github.com/twbs/rfs/blob/v8.x/LICENSE)\n\n// Configuration\n\n// Base font size\n$rfs-base-font-size: 1.25rem !default;\n$rfs-font-size-unit: rem !default;\n\n@if $rfs-font-size-unit != rem and $rfs-font-size-unit != px {\n  @error \"`#{$rfs-font-size-unit}` is not a valid unit for $rfs-font-size-unit. Use `px` or `rem`.\";\n}\n\n// Breakpoint at where font-size starts decreasing if screen width is smaller\n$rfs-breakpoint: 1200px !default;\n$rfs-breakpoint-unit: px !default;\n\n@if $rfs-breakpoint-unit != px and $rfs-breakpoint-unit != em and $rfs-breakpoint-unit != rem {\n  @error \"`#{$rfs-breakpoint-unit}` is not a valid unit for $rfs-breakpoint-unit. Use `px`, `em` or `rem`.\";\n}\n\n// Resize font size based on screen height and width\n$rfs-two-dimensional: false !default;\n\n// Factor of decrease\n$rfs-factor: 10 !default;\n\n@if type-of($rfs-factor) != \"number\" or $rfs-factor <= 1 {\n  @error \"`#{$rfs-factor}` is not a valid  $rfs-factor, it must be greater than 1.\";\n}\n\n// Generate enable or disable classes. Possibilities: false, \"enable\" or \"disable\"\n$rfs-class: false !default;\n\n// 1 rem = $rfs-rem-value px\n$rfs-rem-value: 16 !default;\n\n// Safari iframe resize bug: https://github.com/twbs/rfs/issues/14\n$rfs-safari-iframe-resize-bug-fix: false !default;\n\n// Disable RFS by setting $enable-responsive-font-sizes to false\n$enable-responsive-font-sizes: true !default;\n\n// Cache $rfs-base-font-size unit\n$rfs-base-font-size-unit: unit($rfs-base-font-size);\n\n@function divide($dividend, $divisor, $precision: 10) {\n  $sign: if($dividend > 0 and $divisor > 0 or $dividend < 0 and $divisor < 0, 1, -1);\n  $dividend: abs($dividend);\n  $divisor: abs($divisor);\n  @if $dividend == 0 {\n    @return 0;\n  }\n  @if $divisor == 0 {\n    @error \"Cannot divide by 0\";\n  }\n  $remainder: $dividend;\n  $result: 0;\n  $factor: 10;\n  @while ($remainder > 0 and $precision >= 0) {\n    $quotient: 0;\n    @while ($remainder >= $divisor) {\n      $remainder: $remainder - $divisor;\n      $quotient: $quotient + 1;\n    }\n    $result: $result * 10 + $quotient;\n    $factor: $factor * .1;\n    $remainder: $remainder * 10;\n    $precision: $precision - 1;\n    @if ($precision < 0 and $remainder >= $divisor * 5) {\n      $result: $result + 1;\n    }\n  }\n  $result: $result * $factor * $sign;\n  $dividend-unit: unit($dividend);\n  $divisor-unit: unit($divisor);\n  $unit-map: (\n    \"px\": 1px,\n    \"rem\": 1rem,\n    \"em\": 1em,\n    \"%\": 1%\n  );\n  @if ($dividend-unit != $divisor-unit and map-has-key($unit-map, $dividend-unit)) {\n    $result: $result * map-get($unit-map, $dividend-unit);\n  }\n  @return $result;\n}\n\n// Remove px-unit from $rfs-base-font-size for calculations\n@if $rfs-base-font-size-unit == \"px\" {\n  $rfs-base-font-size: divide($rfs-base-font-size, $rfs-base-font-size * 0 + 1);\n}\n@else if $rfs-base-font-size-unit == \"rem\" {\n  $rfs-base-font-size: divide($rfs-base-font-size, divide($rfs-base-font-size * 0 + 1, $rfs-rem-value));\n}\n\n// Cache $rfs-breakpoint unit to prevent multiple calls\n$rfs-breakpoint-unit-cache: unit($rfs-breakpoint);\n\n// Remove unit from $rfs-breakpoint for calculations\n@if $rfs-breakpoint-unit-cache == \"px\" {\n  $rfs-breakpoint: divide($rfs-breakpoint, $rfs-breakpoint * 0 + 1);\n}\n@else if $rfs-breakpoint-unit-cache == \"rem\" or $rfs-breakpoint-unit-cache == \"em\" {\n  $rfs-breakpoint: divide($rfs-breakpoint, divide($rfs-breakpoint * 0 + 1, $rfs-rem-value));\n}\n\n// Internal mixin that adds disable classes to the selector if needed.\n@mixin _rfs-disable-class {\n  @if $rfs-class == \"disable\" {\n    // Adding an extra class increases specificity, which prevents the media query to override the font size\n    &,\n    .disable-responsive-font-size &,\n    &.disable-responsive-font-size {\n      @content;\n    }\n  }\n  @else {\n    @content;\n  }\n}\n\n// Internal mixin that adds enable classes to the selector if needed.\n@mixin _rfs-enable-class {\n  @if $rfs-class == \"enable\" {\n    .enable-responsive-font-size &,\n    &.enable-responsive-font-size {\n      @content;\n    }\n  }\n  @else {\n    @content;\n  }\n}\n\n// Internal mixin used to determine which media query needs to be used\n@mixin _rfs-media-query($mq-value) {\n  @if $rfs-two-dimensional {\n    @media (max-width: #{$mq-value}), (max-height: #{$mq-value}) {\n      @content;\n    }\n  }\n  @else {\n    @media (max-width: #{$mq-value}) {\n      @content;\n    }\n  }\n}\n\n// Responsive font size mixin\n@mixin rfs($fs, $important: false) {\n  // Cache $fs unit\n  $fs-unit: if(type-of($fs) == \"number\", unit($fs), false);\n\n  // Add !important suffix if needed\n  $rfs-suffix: if($important, \" !important\", \"\");\n\n  // If $fs isn't a number (like inherit) or $fs has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n  @if not $fs-unit or $fs-unit != \"\" and $fs-unit != \"px\" and $fs-unit != \"rem\" or $fs == 0 {\n    font-size: #{$fs}#{$rfs-suffix};\n  }\n  @else {\n    // Remove unit from $fs for calculations\n    @if $fs-unit == \"px\" {\n      $fs: divide($fs, $fs * 0 + 1);\n    }\n    @else if $fs-unit == \"rem\" {\n      $fs: divide($fs, divide($fs * 0 + 1, $rfs-rem-value));\n    }\n\n    // Set default font size\n    $rfs-static: if($rfs-font-size-unit == rem, #{divide($fs, $rfs-rem-value)}rem, #{$fs}px);\n\n    // Only add the media query if the font size is bigger than the minimum font size\n    @if $fs <= $rfs-base-font-size or not $enable-responsive-font-sizes {\n      font-size: #{$rfs-static}#{$rfs-suffix};\n    }\n    @else {\n      // Calculate the minimum font size for $fs\n      $fs-min: $rfs-base-font-size + divide($fs - $rfs-base-font-size, $rfs-factor);\n\n      // Calculate difference between $fs and the minimum font size\n      $fs-diff: $fs - $fs-min;\n\n      // Base font-size formatting\n      $min-width: if($rfs-font-size-unit == rem, #{divide($fs-min, $rfs-rem-value)}rem, #{$fs-min}px);\n\n      // Use `vmin` if two-dimensional is enabled\n      $variable-unit: if($rfs-two-dimensional, vmin, vw);\n\n      // Calculate the variable width between 0 and $rfs-breakpoint\n      $variable-width: #{divide($fs-diff * 100, $rfs-breakpoint)}#{$variable-unit};\n\n      // Set the calculated font-size\n      $rfs-fluid: calc(#{$min-width} + #{$variable-width}) #{$rfs-suffix};\n\n      // Breakpoint formatting\n      $mq-value: if($rfs-breakpoint-unit == px, #{$rfs-breakpoint}px, #{divide($rfs-breakpoint, $rfs-rem-value)}#{$rfs-breakpoint-unit});\n\n      @include _rfs-disable-class {\n        font-size: #{$rfs-static}#{$rfs-suffix};\n      }\n\n      @include _rfs-media-query($mq-value) {\n        @include _rfs-enable-class {\n          font-size: $rfs-fluid;\n        }\n\n        // Include safari iframe resize fix if needed\n        min-width: if($rfs-safari-iframe-resize-bug-fix, (0 * 1vw), null);\n      }\n    }\n  }\n}\n\n// The font-size & responsive-font-size mixins use RFS to rescale the font size\n@mixin font-size($fs, $important: false) {\n  @include rfs($fs, $important);\n}\n\n@mixin responsive-font-size($fs, $important: false) {\n  @include rfs($fs, $important);\n}\n","// Hover mixin and `$enable-hover-media-query` are deprecated.\n//\n// Originally added during our alphas and maintained during betas, this mixin was\n// designed to prevent `:hover` stickiness on iOS-an issue where hover styles\n// would persist after initial touch.\n//\n// For backward compatibility, we've kept these mixins and updated them to\n// always return their regular pseudo-classes instead of a shimmed media query.\n//\n// Issue: https://github.com/twbs/bootstrap/issues/25195\n\n@mixin hover() {\n  &:hover { @content; }\n}\n\n@mixin hover-focus() {\n  &:hover,\n  &:focus {\n    @content;\n  }\n}\n\n@mixin plain-hover-focus() {\n  &,\n  &:hover,\n  &:focus {\n    @content;\n  }\n}\n\n@mixin hover-focus-active() {\n  &:hover,\n  &:focus,\n  &:active {\n    @content;\n  }\n}\n","// stylelint-disable selector-list-comma-newline-after\n\n//\n// Headings\n//\n\nh1, h2, h3, h4, h5, h6,\n.h1, .h2, .h3, .h4, .h5, .h6 {\n  margin-bottom: $headings-margin-bottom;\n  font-family: $headings-font-family;\n  font-weight: $headings-font-weight;\n  line-height: $headings-line-height;\n  color: $headings-color;\n}\n\nh1, .h1 { @include font-size($h1-font-size); }\nh2, .h2 { @include font-size($h2-font-size); }\nh3, .h3 { @include font-size($h3-font-size); }\nh4, .h4 { @include font-size($h4-font-size); }\nh5, .h5 { @include font-size($h5-font-size); }\nh6, .h6 { @include font-size($h6-font-size); }\n\n.lead {\n  @include font-size($lead-font-size);\n  font-weight: $lead-font-weight;\n}\n\n// Type display classes\n.display-1 {\n  @include font-size($display1-size);\n  font-weight: $display1-weight;\n  line-height: $display-line-height;\n}\n.display-2 {\n  @include font-size($display2-size);\n  font-weight: $display2-weight;\n  line-height: $display-line-height;\n}\n.display-3 {\n  @include font-size($display3-size);\n  font-weight: $display3-weight;\n  line-height: $display-line-height;\n}\n.display-4 {\n  @include font-size($display4-size);\n  font-weight: $display4-weight;\n  line-height: $display-line-height;\n}\n\n\n//\n// Horizontal rules\n//\n\nhr {\n  margin-top: $hr-margin-y;\n  margin-bottom: $hr-margin-y;\n  border: 0;\n  border-top: $hr-border-width solid $hr-border-color;\n}\n\n\n//\n// Emphasis\n//\n\nsmall,\n.small {\n  @include font-size($small-font-size);\n  font-weight: $font-weight-normal;\n}\n\nmark,\n.mark {\n  padding: $mark-padding;\n  background-color: $mark-bg;\n}\n\n\n//\n// Lists\n//\n\n.list-unstyled {\n  @include list-unstyled();\n}\n\n// Inline turns list items into inline-block\n.list-inline {\n  @include list-unstyled();\n}\n.list-inline-item {\n  display: inline-block;\n\n  &:not(:last-child) {\n    margin-right: $list-inline-padding;\n  }\n}\n\n\n//\n// Misc\n//\n\n// Builds on `abbr`\n.initialism {\n  @include font-size(90%);\n  text-transform: uppercase;\n}\n\n// Blockquotes\n.blockquote {\n  margin-bottom: $spacer;\n  @include font-size($blockquote-font-size);\n}\n\n.blockquote-footer {\n  display: block;\n  @include font-size($blockquote-small-font-size);\n  color: $blockquote-small-color;\n\n  &::before {\n    content: \"\\2014\\00A0\"; // em dash, nbsp\n  }\n}\n","// Lists\n\n// Unstyled keeps list items block level, just removes default browser padding and list-style\n@mixin list-unstyled() {\n  padding-left: 0;\n  list-style: none;\n}\n","// Responsive images (ensure images don't scale beyond their parents)\n//\n// This is purposefully opt-in via an explicit class rather than being the default for all `<img>`s.\n// We previously tried the \"images are responsive by default\" approach in Bootstrap v2,\n// and abandoned it in Bootstrap v3 because it breaks lots of third-party widgets (including Google Maps)\n// which weren't expecting the images within themselves to be involuntarily resized.\n// See also https://github.com/twbs/bootstrap/issues/18178\n.img-fluid {\n  @include img-fluid();\n}\n\n\n// Image thumbnails\n.img-thumbnail {\n  padding: $thumbnail-padding;\n  background-color: $thumbnail-bg;\n  border: $thumbnail-border-width solid $thumbnail-border-color;\n  @include border-radius($thumbnail-border-radius);\n  @include box-shadow($thumbnail-box-shadow);\n\n  // Keep them at most 100% wide\n  @include img-fluid();\n}\n\n//\n// Figures\n//\n\n.figure {\n  // Ensures the caption's text aligns with the image.\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: $spacer * .5;\n  line-height: 1;\n}\n\n.figure-caption {\n  @include font-size($figure-caption-font-size);\n  color: $figure-caption-color;\n}\n","// Image Mixins\n// - Responsive image\n// - Retina image\n\n\n// Responsive image\n//\n// Keep images from scaling beyond the width of their parents.\n\n@mixin img-fluid() {\n  // Part 1: Set a maximum relative to the parent\n  max-width: 100%;\n  // Part 2: Override the height to auto, otherwise images will be stretched\n  // when setting a width and height attribute on the img element.\n  height: auto;\n}\n\n\n// Retina image\n//\n// Short retina mixin for setting background-image and -size.\n\n@mixin img-retina($file-1x, $file-2x, $width-1x, $height-1x) {\n  background-image: url($file-1x);\n\n  // Autoprefixer takes care of adding -webkit-min-device-pixel-ratio and -o-min-device-pixel-ratio,\n  // but doesn't convert dppx=>dpi.\n  // There's no such thing as unprefixed min-device-pixel-ratio since it's nonstandard.\n  // Compatibility info: https://caniuse.com/css-media-resolution\n  @media only screen and (min-resolution: 192dpi), // IE9-11 don't support dppx\n    only screen and (min-resolution: 2dppx) { // Standardized\n    background-image: url($file-2x);\n    background-size: $width-1x $height-1x;\n  }\n  @include deprecate(\"`img-retina()`\", \"v4.3.0\", \"v5\");\n}\n","// stylelint-disable property-disallowed-list\n// Single side border-radius\n\n// Helper function to replace negative values with 0\n@function valid-radius($radius) {\n  $return: ();\n  @each $value in $radius {\n    @if type-of($value) == number {\n      $return: append($return, max($value, 0));\n    } @else {\n      $return: append($return, $value);\n    }\n  }\n  @return $return;\n}\n\n@mixin border-radius($radius: $border-radius, $fallback-border-radius: false) {\n  @if $enable-rounded {\n    border-radius: valid-radius($radius);\n  }\n  @else if $fallback-border-radius != false {\n    border-radius: $fallback-border-radius;\n  }\n}\n\n@mixin border-top-radius($radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-right-radius($radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-radius($radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-left-radius($radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-left-radius($radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-right-radius($radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-right-radius($radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-left-radius($radius) {\n  @if $enable-rounded {\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n","// Inline code\ncode {\n  @include font-size($code-font-size);\n  color: $code-color;\n  word-wrap: break-word;\n\n  // Streamline the style when inside anchors to avoid broken underline and more\n  a > & {\n    color: inherit;\n  }\n}\n\n// User input typically entered via keyboard\nkbd {\n  padding: $kbd-padding-y $kbd-padding-x;\n  @include font-size($kbd-font-size);\n  color: $kbd-color;\n  background-color: $kbd-bg;\n  @include border-radius($border-radius-sm);\n  @include box-shadow($kbd-box-shadow);\n\n  kbd {\n    padding: 0;\n    @include font-size(100%);\n    font-weight: $nested-kbd-font-weight;\n    @include box-shadow(none);\n  }\n}\n\n// Blocks of code\npre {\n  display: block;\n  @include font-size($code-font-size);\n  color: $pre-color;\n\n  // Account for some code outputs that place code tags in pre tags\n  code {\n    @include font-size(inherit);\n    color: inherit;\n    word-break: normal;\n  }\n}\n\n// Enable scrollable blocks of code\n.pre-scrollable {\n  max-height: $pre-scrollable-max-height;\n  overflow-y: scroll;\n}\n","// Container widths\n//\n// Set the container width, and override it for fixed navbars in media queries.\n\n@if $enable-grid-classes {\n  // Single container class with breakpoint max-widths\n  .container,\n  // 100% wide container at all breakpoints\n  .container-fluid {\n    @include make-container();\n  }\n\n  // Responsive containers that are 100% wide until a breakpoint\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    .container-#{$breakpoint} {\n      @extend .container-fluid;\n    }\n\n    @include media-breakpoint-up($breakpoint, $grid-breakpoints) {\n      %responsive-container-#{$breakpoint} {\n        max-width: $container-max-width;\n      }\n\n      // Extend each breakpoint which is smaller or equal to the current breakpoint\n      $extend-breakpoint: true;\n\n      @each $name, $width in $grid-breakpoints {\n        @if ($extend-breakpoint) {\n          .container#{breakpoint-infix($name, $grid-breakpoints)} {\n            @extend %responsive-container-#{$breakpoint};\n          }\n\n          // Once the current breakpoint is reached, stop extending\n          @if ($breakpoint == $name) {\n            $extend-breakpoint: false;\n          }\n        }\n      }\n    }\n  }\n}\n\n\n// Row\n//\n// Rows contain your columns.\n\n@if $enable-grid-classes {\n  .row {\n    @include make-row();\n  }\n\n  // Remove the negative margin from default .row, then the horizontal padding\n  // from all immediate children columns (to prevent runaway style inheritance).\n  .no-gutters {\n    margin-right: 0;\n    margin-left: 0;\n\n    > .col,\n    > [class*=\"col-\"] {\n      padding-right: 0;\n      padding-left: 0;\n    }\n  }\n}\n\n// Columns\n//\n// Common styles for small and large grid columns\n\n@if $enable-grid-classes {\n  @include make-grid-columns();\n}\n","/// Grid system\n//\n// Generate semantic grid columns with these mixins.\n\n@mixin make-container($gutter: $grid-gutter-width) {\n  width: 100%;\n  padding-right: $gutter * .5;\n  padding-left: $gutter * .5;\n  margin-right: auto;\n  margin-left: auto;\n}\n\n@mixin make-row($gutter: $grid-gutter-width) {\n  display: flex;\n  flex-wrap: wrap;\n  margin-right: -$gutter * .5;\n  margin-left: -$gutter * .5;\n}\n\n// For each breakpoint, define the maximum width of the container in a media query\n@mixin make-container-max-widths($max-widths: $container-max-widths, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint, $container-max-width in $max-widths {\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      max-width: $container-max-width;\n    }\n  }\n  @include deprecate(\"The `make-container-max-widths` mixin\", \"v4.5.2\", \"v5\");\n}\n\n@mixin make-col-ready($gutter: $grid-gutter-width) {\n  position: relative;\n  // Prevent columns from becoming too narrow when at smaller grid tiers by\n  // always setting `width: 100%;`. This works because we use `flex` values\n  // later on to override this initial width.\n  width: 100%;\n  padding-right: $gutter * .5;\n  padding-left: $gutter * .5;\n}\n\n@mixin make-col($size, $columns: $grid-columns) {\n  flex: 0 0 percentage(divide($size, $columns));\n  // Add a `max-width` to ensure content within each column does not blow out\n  // the width of the column. Applies to IE10+ and Firefox. Chrome and Safari\n  // do not appear to require this.\n  max-width: percentage(divide($size, $columns));\n}\n\n@mixin make-col-auto() {\n  flex: 0 0 auto;\n  width: auto;\n  max-width: 100%; // Reset earlier grid tiers\n}\n\n@mixin make-col-offset($size, $columns: $grid-columns) {\n  $num: divide($size, $columns);\n  margin-left: if($num == 0, 0, percentage($num));\n}\n\n// Row columns\n//\n// Specify on a parent element(e.g., .row) to force immediate children into NN\n// numberof columns. Supports wrapping to new lines, but does not do a Masonry\n// style grid.\n@mixin row-cols($count) {\n  > * {\n    flex: 0 0 divide(100%, $count);\n    max-width: divide(100%, $count);\n  }\n}\n","// Breakpoint viewport sizes and media queries.\n//\n// Breakpoints are defined as a map of (name: minimum width), order from small to large:\n//\n//    (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px)\n//\n// The map defined in the `$grid-breakpoints` global variable is used as the `$breakpoints` argument by default.\n\n// Name of the next breakpoint, or null for the last breakpoint.\n//\n//    >> breakpoint-next(sm)\n//    md\n//    >> breakpoint-next(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    md\n//    >> breakpoint-next(sm, $breakpoint-names: (xs sm md lg xl))\n//    md\n@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map-keys($breakpoints)) {\n  $n: index($breakpoint-names, $name);\n  @return if($n != null and $n < length($breakpoint-names), nth($breakpoint-names, $n + 1), null);\n}\n\n// Minimum breakpoint width. Null for the smallest (first) breakpoint.\n//\n//    >> breakpoint-min(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    576px\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\n  $min: map-get($breakpoints, $name);\n  @return if($min != 0, $min, null);\n}\n\n// Maximum breakpoint width. Null for the largest (last) breakpoint.\n// The maximum value is calculated as the minimum of the next one less 0.02px\n// to work around the limitations of `min-` and `max-` prefixes and viewports with fractional widths.\n// See https://www.w3.org/TR/mediaqueries-4/#mq-min-max\n// Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.\n// See https://bugs.webkit.org/show_bug.cgi?id=178261\n//\n//    >> breakpoint-max(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    767.98px\n@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\n  $next: breakpoint-next($name, $breakpoints);\n  @return if($next, breakpoint-min($next, $breakpoints) - .02, null);\n}\n\n// Returns a blank string if smallest breakpoint, otherwise returns the name with a dash in front.\n// Useful for making responsive utilities.\n//\n//    >> breakpoint-infix(xs, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    \"\"  (Returns a blank string)\n//    >> breakpoint-infix(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    \"-sm\"\n@function breakpoint-infix($name, $breakpoints: $grid-breakpoints) {\n  @return if(breakpoint-min($name, $breakpoints) == null, \"\", \"-#{$name}\");\n}\n\n// Media of at least the minimum breakpoint width. No query for the smallest breakpoint.\n// Makes the @content apply to the given breakpoint and wider.\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  @if $min {\n    @media (min-width: $min) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media of at most the maximum breakpoint width. No query for the largest breakpoint.\n// Makes the @content apply to the given breakpoint and narrower.\n@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\n  $max: breakpoint-max($name, $breakpoints);\n  @if $max {\n    @media (max-width: $max) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media that spans multiple breakpoint widths.\n// Makes the @content apply between the min and max breakpoints\n@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($lower, $breakpoints);\n  $max: breakpoint-max($upper, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($lower, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($upper, $breakpoints) {\n      @content;\n    }\n  }\n}\n\n// Media between the breakpoint's minimum and maximum widths.\n// No minimum for the smallest breakpoint, and no maximum for the largest one.\n// Makes the @content apply only to the given breakpoint, not viewports any wider or narrower.\n@mixin media-breakpoint-only($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  $max: breakpoint-max($name, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($name, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($name, $breakpoints) {\n      @content;\n    }\n  }\n}\n","// Framework grid generation\n//\n// Used only by Bootstrap to generate the correct number of grid classes given\n// any value of `$grid-columns`.\n\n@mixin make-grid-columns($columns: $grid-columns, $gutter: $grid-gutter-width, $breakpoints: $grid-breakpoints) {\n  // Common properties for all breakpoints\n  %grid-column {\n    position: relative;\n    width: 100%;\n    padding-right: $gutter * .5;\n    padding-left: $gutter * .5;\n  }\n\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @if $columns > 0 {\n      // Allow columns to stretch full width below their breakpoints\n      @for $i from 1 through $columns {\n        .col#{$infix}-#{$i} {\n          @extend %grid-column;\n        }\n      }\n    }\n\n    .col#{$infix},\n    .col#{$infix}-auto {\n      @extend %grid-column;\n    }\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      // Provide basic `.col-{bp}` classes for equal-width flexbox columns\n      .col#{$infix} {\n        flex-basis: 0;\n        flex-grow: 1;\n        max-width: 100%;\n      }\n\n      @if $grid-row-columns > 0 {\n        @for $i from 1 through $grid-row-columns {\n          .row-cols#{$infix}-#{$i} {\n            @include row-cols($i);\n          }\n        }\n      }\n\n      .col#{$infix}-auto {\n        @include make-col-auto();\n      }\n\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .col#{$infix}-#{$i} {\n            @include make-col($i, $columns);\n          }\n        }\n      }\n\n      .order#{$infix}-first { order: -1; }\n\n      .order#{$infix}-last { order: $columns + 1; }\n\n      @for $i from 0 through $columns {\n        .order#{$infix}-#{$i} { order: $i; }\n      }\n\n      @if $columns > 0 {\n        // `$columns - 1` because offsetting by the width of an entire row isn't possible\n        @for $i from 0 through ($columns - 1) {\n          @if not ($infix == \"\" and $i == 0) { // Avoid emitting useless .offset-0\n            .offset#{$infix}-#{$i} {\n              @include make-col-offset($i, $columns);\n            }\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Basic Bootstrap table\n//\n\n.table {\n  width: 100%;\n  margin-bottom: $spacer;\n  color: $table-color;\n  background-color: $table-bg; // Reset for nesting within parents with `background-color`.\n\n  th,\n  td {\n    padding: $table-cell-padding;\n    vertical-align: top;\n    border-top: $table-border-width solid $table-border-color;\n  }\n\n  thead th {\n    vertical-align: bottom;\n    border-bottom: (2 * $table-border-width) solid $table-border-color;\n  }\n\n  tbody + tbody {\n    border-top: (2 * $table-border-width) solid $table-border-color;\n  }\n}\n\n\n//\n// Condensed table w/ half padding\n//\n\n.table-sm {\n  th,\n  td {\n    padding: $table-cell-padding-sm;\n  }\n}\n\n\n// Border versions\n//\n// Add or remove borders all around the table and between all the columns.\n\n.table-bordered {\n  border: $table-border-width solid $table-border-color;\n\n  th,\n  td {\n    border: $table-border-width solid $table-border-color;\n  }\n\n  thead {\n    th,\n    td {\n      border-bottom-width: 2 * $table-border-width;\n    }\n  }\n}\n\n.table-borderless {\n  th,\n  td,\n  thead th,\n  tbody + tbody {\n    border: 0;\n  }\n}\n\n// Zebra-striping\n//\n// Default zebra-stripe styles (alternating gray and transparent backgrounds)\n\n.table-striped {\n  tbody tr:nth-of-type(#{$table-striped-order}) {\n    background-color: $table-accent-bg;\n  }\n}\n\n\n// Hover effect\n//\n// Placed here since it has to come after the potential zebra striping\n\n.table-hover {\n  tbody tr {\n    @include hover() {\n      color: $table-hover-color;\n      background-color: $table-hover-bg;\n    }\n  }\n}\n\n\n// Table backgrounds\n//\n// Exact selectors below required to override `.table-striped` and prevent\n// inheritance to nested tables.\n\n@each $color, $value in $theme-colors {\n  @include table-row-variant($color, theme-color-level($color, $table-bg-level), theme-color-level($color, $table-border-level));\n}\n\n@include table-row-variant(active, $table-active-bg);\n\n\n// Dark styles\n//\n// Same table markup, but inverted color scheme: dark background and light text.\n\n// stylelint-disable-next-line no-duplicate-selectors\n.table {\n  .thead-dark {\n    th {\n      color: $table-dark-color;\n      background-color: $table-dark-bg;\n      border-color: $table-dark-border-color;\n    }\n  }\n\n  .thead-light {\n    th {\n      color: $table-head-color;\n      background-color: $table-head-bg;\n      border-color: $table-border-color;\n    }\n  }\n}\n\n.table-dark {\n  color: $table-dark-color;\n  background-color: $table-dark-bg;\n\n  th,\n  td,\n  thead th {\n    border-color: $table-dark-border-color;\n  }\n\n  &.table-bordered {\n    border: 0;\n  }\n\n  &.table-striped {\n    tbody tr:nth-of-type(#{$table-striped-order}) {\n      background-color: $table-dark-accent-bg;\n    }\n  }\n\n  &.table-hover {\n    tbody tr {\n      @include hover() {\n        color: $table-dark-hover-color;\n        background-color: $table-dark-hover-bg;\n      }\n    }\n  }\n}\n\n\n// Responsive tables\n//\n// Generate series of `.table-responsive-*` classes for configuring the screen\n// size of where your table will overflow.\n\n.table-responsive {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\n    $infix: breakpoint-infix($next, $grid-breakpoints);\n\n    &#{$infix} {\n      @include media-breakpoint-down($breakpoint) {\n        display: block;\n        width: 100%;\n        overflow-x: auto;\n        -webkit-overflow-scrolling: touch;\n\n        // Prevent double border on horizontal scroll due to use of `display: block;`\n        > .table-bordered {\n          border: 0;\n        }\n      }\n    }\n  }\n}\n","// Tables\n\n@mixin table-row-variant($state, $background, $border: null) {\n  // Exact selectors below required to override `.table-striped` and prevent\n  // inheritance to nested tables.\n  .table-#{$state} {\n    &,\n    > th,\n    > td {\n      background-color: $background;\n    }\n\n    @if $border != null {\n      th,\n      td,\n      thead th,\n      tbody + tbody {\n        border-color: $border;\n      }\n    }\n  }\n\n  // Hover states for `.table-hover`\n  // Note: this is not available for cells or rows within `thead` or `tfoot`.\n  .table-hover {\n    $hover-background: darken($background, 5%);\n\n    .table-#{$state} {\n      @include hover() {\n        background-color: $hover-background;\n\n        > td,\n        > th {\n          background-color: $hover-background;\n        }\n      }\n    }\n  }\n}\n","// stylelint-disable selector-no-qualifying-type\n\n//\n// Textual form controls\n//\n\n.form-control {\n  display: block;\n  width: 100%;\n  height: $input-height;\n  padding: $input-padding-y $input-padding-x;\n  font-family: $input-font-family;\n  @include font-size($input-font-size);\n  font-weight: $input-font-weight;\n  line-height: $input-line-height;\n  color: $input-color;\n  background-color: $input-bg;\n  background-clip: padding-box;\n  border: $input-border-width solid $input-border-color;\n\n  // Note: This has no effect on <select>s in some browsers, due to the limited stylability of `<select>`s in CSS.\n  @include border-radius($input-border-radius, 0);\n\n  @include box-shadow($input-box-shadow);\n  @include transition($input-transition);\n\n  // Unstyle the caret on `<select>`s in IE10+.\n  &::-ms-expand {\n    background-color: transparent;\n    border: 0;\n  }\n\n  // Customize the `:focus` state to imitate native WebKit styles.\n  @include form-control-focus($ignore-warning: true);\n\n  // Placeholder\n  &::placeholder {\n    color: $input-placeholder-color;\n    // Override Firefox's unusual default opacity; see https://github.com/twbs/bootstrap/pull/11526.\n    opacity: 1;\n  }\n\n  // Disabled and read-only inputs\n  //\n  // HTML5 says that controls under a fieldset > legend:first-child won't be\n  // disabled if the fieldset is disabled. Due to implementation difficulty, we\n  // don't honor that edge case; we style them as disabled anyway.\n  &:disabled,\n  &[readonly] {\n    background-color: $input-disabled-bg;\n    // iOS fix for unreadable disabled content; see https://github.com/twbs/bootstrap/issues/11655.\n    opacity: 1;\n  }\n}\n\ninput[type=\"date\"],\ninput[type=\"time\"],\ninput[type=\"datetime-local\"],\ninput[type=\"month\"] {\n  &.form-control {\n    appearance: none; // Fix appearance for date inputs in Safari\n  }\n}\n\nselect.form-control {\n  // Remove select outline from select box in FF\n  &:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 $input-color;\n  }\n\n  &:focus::-ms-value {\n    // Suppress the nested default white text on blue background highlight given to\n    // the selected option text when the (still closed) <select> receives focus\n    // in IE and (under certain conditions) Edge, as it looks bad and cannot be made to\n    // match the appearance of the native widget.\n    // See https://github.com/twbs/bootstrap/issues/19398.\n    color: $input-color;\n    background-color: $input-bg;\n  }\n}\n\n// Make file inputs better match text inputs by forcing them to new lines.\n.form-control-file,\n.form-control-range {\n  display: block;\n  width: 100%;\n}\n\n\n//\n// Labels\n//\n\n// For use with horizontal and inline forms, when you need the label (or legend)\n// text to align with the form controls.\n.col-form-label {\n  padding-top: add($input-padding-y, $input-border-width);\n  padding-bottom: add($input-padding-y, $input-border-width);\n  margin-bottom: 0; // Override the `<label>/<legend>` default\n  @include font-size(inherit); // Override the `<legend>` default\n  line-height: $input-line-height;\n}\n\n.col-form-label-lg {\n  padding-top: add($input-padding-y-lg, $input-border-width);\n  padding-bottom: add($input-padding-y-lg, $input-border-width);\n  @include font-size($input-font-size-lg);\n  line-height: $input-line-height-lg;\n}\n\n.col-form-label-sm {\n  padding-top: add($input-padding-y-sm, $input-border-width);\n  padding-bottom: add($input-padding-y-sm, $input-border-width);\n  @include font-size($input-font-size-sm);\n  line-height: $input-line-height-sm;\n}\n\n\n// Readonly controls as plain text\n//\n// Apply class to a readonly input to make it appear like regular plain\n// text (without any border, background color, focus indicator)\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y 0;\n  margin-bottom: 0; // match inputs if this class comes on inputs with default margins\n  @include font-size($input-font-size);\n  line-height: $input-line-height;\n  color: $input-plaintext-color;\n  background-color: transparent;\n  border: solid transparent;\n  border-width: $input-border-width 0;\n\n  &.form-control-sm,\n  &.form-control-lg {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n\n// Form control sizing\n//\n// Build on `.form-control` with modifier classes to decrease or increase the\n// height and font-size of form controls.\n//\n// Repeated in `_input_group.scss` to avoid Sass extend issues.\n\n.form-control-sm {\n  height: $input-height-sm;\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  line-height: $input-line-height-sm;\n  @include border-radius($input-border-radius-sm);\n}\n\n.form-control-lg {\n  height: $input-height-lg;\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  line-height: $input-line-height-lg;\n  @include border-radius($input-border-radius-lg);\n}\n\n// stylelint-disable-next-line no-duplicate-selectors\nselect.form-control {\n  &[size],\n  &[multiple] {\n    height: auto;\n  }\n}\n\ntextarea.form-control {\n  height: auto;\n}\n\n// Form groups\n//\n// Designed to help with the organization and spacing of vertical forms. For\n// horizontal forms, use the predefined grid classes.\n\n.form-group {\n  margin-bottom: $form-group-margin-bottom;\n}\n\n.form-text {\n  display: block;\n  margin-top: $form-text-margin-top;\n}\n\n\n// Form grid\n//\n// Special replacement for our grid system's `.row` for tighter form layouts.\n\n.form-row {\n  display: flex;\n  flex-wrap: wrap;\n  margin-right: -$form-grid-gutter-width * .5;\n  margin-left: -$form-grid-gutter-width * .5;\n\n  > .col,\n  > [class*=\"col-\"] {\n    padding-right: $form-grid-gutter-width * .5;\n    padding-left: $form-grid-gutter-width * .5;\n  }\n}\n\n\n// Checkboxes and radios\n//\n// Indent the labels to position radios/checkboxes as hanging controls.\n\n.form-check {\n  position: relative;\n  display: block;\n  padding-left: $form-check-input-gutter;\n}\n\n.form-check-input {\n  position: absolute;\n  margin-top: $form-check-input-margin-y;\n  margin-left: -$form-check-input-gutter;\n\n  // Use [disabled] and :disabled for workaround https://github.com/twbs/bootstrap/issues/28247\n  &[disabled] ~ .form-check-label,\n  &:disabled ~ .form-check-label {\n    color: $text-muted;\n  }\n}\n\n.form-check-label {\n  margin-bottom: 0; // Override default `<label>` bottom margin\n}\n\n.form-check-inline {\n  display: inline-flex;\n  align-items: center;\n  padding-left: 0; // Override base .form-check\n  margin-right: $form-check-inline-margin-x;\n\n  // Undo .form-check-input defaults and add some `margin-right`.\n  .form-check-input {\n    position: static;\n    margin-top: 0;\n    margin-right: $form-check-inline-input-margin-x;\n    margin-left: 0;\n  }\n}\n\n\n// Form validation\n//\n// Provide feedback to users when form field values are valid or invalid. Works\n// primarily for client-side validation via scoped `:invalid` and `:valid`\n// pseudo-classes but also includes `.is-invalid` and `.is-valid` classes for\n// server side validation.\n\n@each $state, $data in $form-validation-states {\n  @include form-validation-state($state, map-get($data, color), map-get($data, icon));\n}\n\n// Inline forms\n//\n// Make forms appear inline(-block) by adding the `.form-inline` class. Inline\n// forms begin stacked on extra small (mobile) devices and then go inline when\n// viewports reach <768px.\n//\n// Requires wrapping inputs and labels with `.form-group` for proper display of\n// default HTML form controls and our custom form controls (e.g., input groups).\n\n.form-inline {\n  display: flex;\n  flex-flow: row wrap;\n  align-items: center; // Prevent shorter elements from growing to same height as others (e.g., small buttons growing to normal sized button height)\n\n  // Because we use flex, the initial sizing of checkboxes is collapsed and\n  // doesn't occupy the full-width (which is what we want for xs grid tier),\n  // so we force that here.\n  .form-check {\n    width: 100%;\n  }\n\n  // Kick in the inline\n  @include media-breakpoint-up(sm) {\n    label {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      margin-bottom: 0;\n    }\n\n    // Inline-block all the things for \"inline\"\n    .form-group {\n      display: flex;\n      flex: 0 0 auto;\n      flex-flow: row wrap;\n      align-items: center;\n      margin-bottom: 0;\n    }\n\n    // Allow folks to *not* use `.form-group`\n    .form-control {\n      display: inline-block;\n      width: auto; // Prevent labels from stacking above inputs in `.form-group`\n      vertical-align: middle;\n    }\n\n    // Make static controls behave like regular ones\n    .form-control-plaintext {\n      display: inline-block;\n    }\n\n    .input-group,\n    .custom-select {\n      width: auto;\n    }\n\n    // Remove default margin on radios/checkboxes that were used for stacking, and\n    // then undo the floating of radios and checkboxes to match.\n    .form-check {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      width: auto;\n      padding-left: 0;\n    }\n    .form-check-input {\n      position: relative;\n      flex-shrink: 0;\n      margin-top: 0;\n      margin-right: $form-check-input-margin-x;\n      margin-left: 0;\n    }\n\n    .custom-control {\n      align-items: center;\n      justify-content: center;\n    }\n    .custom-control-label {\n      margin-bottom: 0;\n    }\n  }\n}\n","// stylelint-disable property-disallowed-list\n@mixin transition($transition...) {\n  @if length($transition) == 0 {\n    $transition: $transition-base;\n  }\n\n  @if length($transition) > 1 {\n    @each $value in $transition {\n      @if $value == null or $value == none {\n        @warn \"The keyword 'none' or 'null' must be used as a single argument.\";\n      }\n    }\n  }\n\n  @if $enable-transitions {\n    @if nth($transition, 1) != null {\n      transition: $transition;\n    }\n\n    @if $enable-prefers-reduced-motion-media-query and nth($transition, 1) != null and nth($transition, 1) != none {\n      @media (prefers-reduced-motion: reduce) {\n        transition: none;\n      }\n    }\n  }\n}\n","// Form control focus state\n//\n// Generate a customized focus state and for any input with the specified color,\n// which defaults to the `$input-focus-border-color` variable.\n//\n// We highly encourage you to not customize the default value, but instead use\n// this to tweak colors on an as-needed basis. This aesthetic change is based on\n// WebKit's default styles, but applicable to a wider range of browsers. Its\n// usability and accessibility should be taken into account with any change.\n//\n// Example usage: change the default blue border and shadow to white for better\n// contrast against a dark gray background.\n@mixin form-control-focus($ignore-warning: false) {\n  &:focus {\n    color: $input-focus-color;\n    background-color: $input-focus-bg;\n    border-color: $input-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($input-box-shadow, $input-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $input-focus-box-shadow;\n    }\n  }\n  @include deprecate(\"The `form-control-focus()` mixin\", \"v4.4.0\", \"v5\", $ignore-warning);\n}\n\n// This mixin uses an `if()` technique to be compatible with Dart Sass\n// See https://github.com/sass/sass/issues/1873#issuecomment-152293725 for more details\n@mixin form-validation-state-selector($state) {\n  @if ($state == \"valid\" or $state == \"invalid\") {\n    .was-validated #{if(&, \"&\", \"\")}:#{$state},\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  } @else {\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  }\n}\n\n@mixin form-validation-state($state, $color, $icon) {\n  .#{$state}-feedback {\n    display: none;\n    width: 100%;\n    margin-top: $form-feedback-margin-top;\n    @include font-size($form-feedback-font-size);\n    color: $color;\n  }\n\n  .#{$state}-tooltip {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    z-index: 5;\n    display: none;\n    max-width: 100%; // Contain to parent when possible\n    padding: $form-feedback-tooltip-padding-y $form-feedback-tooltip-padding-x;\n    margin-top: .1rem;\n    @include font-size($form-feedback-tooltip-font-size);\n    line-height: $form-feedback-tooltip-line-height;\n    color: color-yiq($color);\n    background-color: rgba($color, $form-feedback-tooltip-opacity);\n    @include border-radius($form-feedback-tooltip-border-radius);\n\n    // See https://github.com/twbs/bootstrap/pull/31557\n    // Align tooltip to form elements\n    .form-row > .col > &,\n    .form-row > [class*=\"col-\"] > & {\n      left: $form-grid-gutter-width * .5;\n    }\n  }\n\n  @include form-validation-state-selector($state) {\n    ~ .#{$state}-feedback,\n    ~ .#{$state}-tooltip {\n      display: block;\n    }\n  }\n\n  .form-control {\n    @include form-validation-state-selector($state) {\n      border-color: $color;\n\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner !important; // stylelint-disable-line declaration-no-important\n        background-image: escape-svg($icon);\n        background-repeat: no-repeat;\n        background-position: right $input-height-inner-quarter center;\n        background-size: $input-height-inner-half $input-height-inner-half;\n      }\n\n      &:focus {\n        border-color: $color;\n        box-shadow: 0 0 0 $input-focus-width rgba($color, .25);\n      }\n    }\n  }\n\n  // stylelint-disable-next-line selector-no-qualifying-type\n  select.form-control {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        padding-right: $input-padding-x * 4 !important; // stylelint-disable-line declaration-no-important\n        background-position: right $input-padding-x * 2 center;\n      }\n    }\n  }\n\n  // stylelint-disable-next-line selector-no-qualifying-type\n  textarea.form-control {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-position: top $input-height-inner-quarter right $input-height-inner-quarter;\n      }\n    }\n  }\n\n  .custom-select {\n    @include form-validation-state-selector($state) {\n      border-color: $color;\n\n      @if $enable-validation-icons {\n        padding-right: $custom-select-feedback-icon-padding-right !important; // stylelint-disable-line declaration-no-important\n        background: $custom-select-background, $custom-select-bg escape-svg($icon) $custom-select-feedback-icon-position / $custom-select-feedback-icon-size no-repeat;\n      }\n\n      &:focus {\n        border-color: $color;\n        box-shadow: 0 0 0 $input-focus-width rgba($color, .25);\n      }\n    }\n  }\n\n  .form-check-input {\n    @include form-validation-state-selector($state) {\n      ~ .form-check-label {\n        color: $color;\n      }\n\n      ~ .#{$state}-feedback,\n      ~ .#{$state}-tooltip {\n        display: block;\n      }\n    }\n  }\n\n  .custom-control-input {\n    @include form-validation-state-selector($state) {\n      ~ .custom-control-label {\n        color: $color;\n\n        &::before {\n          border-color: $color;\n        }\n      }\n\n      &:checked {\n        ~ .custom-control-label::before {\n          border-color: lighten($color, 10%);\n          @include gradient-bg(lighten($color, 10%));\n        }\n      }\n\n      &:focus {\n        ~ .custom-control-label::before {\n          box-shadow: 0 0 0 $input-focus-width rgba($color, .25);\n        }\n\n        &:not(:checked) ~ .custom-control-label::before {\n          border-color: $color;\n        }\n      }\n    }\n  }\n\n  // custom file\n  .custom-file-input {\n    @include form-validation-state-selector($state) {\n      ~ .custom-file-label {\n        border-color: $color;\n      }\n\n      &:focus {\n        ~ .custom-file-label {\n          border-color: $color;\n          box-shadow: 0 0 0 $input-focus-width rgba($color, .25);\n        }\n      }\n    }\n  }\n}\n","// Gradients\n\n@mixin gradient-bg($color) {\n  @if $enable-gradients {\n    background: $color linear-gradient(180deg, mix($body-bg, $color, 15%), $color) repeat-x;\n  } @else {\n    background-color: $color;\n  }\n}\n\n// Horizontal gradient, from left to right\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-x($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\n  background-image: linear-gradient(to right, $start-color $start-percent, $end-color $end-percent);\n  background-repeat: repeat-x;\n}\n\n// Vertical gradient, from top to bottom\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-y($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\n  background-image: linear-gradient(to bottom, $start-color $start-percent, $end-color $end-percent);\n  background-repeat: repeat-x;\n}\n\n@mixin gradient-directional($start-color: $gray-700, $end-color: $gray-800, $deg: 45deg) {\n  background-image: linear-gradient($deg, $start-color, $end-color);\n  background-repeat: repeat-x;\n}\n@mixin gradient-x-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient(to right, $start-color, $mid-color $color-stop, $end-color);\n  background-repeat: no-repeat;\n}\n@mixin gradient-y-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient($start-color, $mid-color $color-stop, $end-color);\n  background-repeat: no-repeat;\n}\n@mixin gradient-radial($inner-color: $gray-700, $outer-color: $gray-800) {\n  background-image: radial-gradient(circle, $inner-color, $outer-color);\n  background-repeat: no-repeat;\n}\n@mixin gradient-striped($color: rgba($white, .15), $angle: 45deg) {\n  background-image: linear-gradient($angle, $color 25%, transparent 25%, transparent 50%, $color 50%, $color 75%, transparent 75%, transparent);\n}\n","// stylelint-disable selector-no-qualifying-type\n\n//\n// Base styles\n//\n\n.btn {\n  display: inline-block;\n  font-family: $btn-font-family;\n  font-weight: $btn-font-weight;\n  color: $body-color;\n  text-align: center;\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: $btn-white-space;\n  vertical-align: middle;\n  user-select: none;\n  background-color: transparent;\n  border: $btn-border-width solid transparent;\n  @include button-size($btn-padding-y, $btn-padding-x, $btn-font-size, $btn-line-height, $btn-border-radius);\n  @include transition($btn-transition);\n\n  @include hover() {\n    color: $body-color;\n    text-decoration: none;\n  }\n\n  &:focus,\n  &.focus {\n    outline: 0;\n    box-shadow: $btn-focus-box-shadow;\n  }\n\n  // Disabled comes first so active can properly restyle\n  &.disabled,\n  &:disabled {\n    opacity: $btn-disabled-opacity;\n    @include box-shadow(none);\n  }\n\n  &:not(:disabled):not(.disabled) {\n    cursor: if($enable-pointer-cursor-for-buttons, pointer, null);\n\n    &:active,\n    &.active {\n      @include box-shadow($btn-active-box-shadow);\n\n      &:focus {\n        @include box-shadow($btn-focus-box-shadow, $btn-active-box-shadow);\n      }\n    }\n  }\n}\n\n// Future-proof disabling of clicks on `<a>` elements\na.btn.disabled,\nfieldset:disabled a.btn {\n  pointer-events: none;\n}\n\n\n//\n// Alternate buttons\n//\n\n@each $color, $value in $theme-colors {\n  .btn-#{$color} {\n    @include button-variant($value, $value);\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .btn-outline-#{$color} {\n    @include button-outline-variant($value);\n  }\n}\n\n\n//\n// Link buttons\n//\n\n// Make a button look and behave like a link\n.btn-link {\n  font-weight: $font-weight-normal;\n  color: $link-color;\n  text-decoration: $link-decoration;\n\n  @include hover() {\n    color: $link-hover-color;\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:focus,\n  &.focus {\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:disabled,\n  &.disabled {\n    color: $btn-link-disabled-color;\n    pointer-events: none;\n  }\n\n  // No need for an active state here\n}\n\n\n//\n// Button Sizes\n//\n\n.btn-lg {\n  @include button-size($btn-padding-y-lg, $btn-padding-x-lg, $btn-font-size-lg, $btn-line-height-lg, $btn-border-radius-lg);\n}\n\n.btn-sm {\n  @include button-size($btn-padding-y-sm, $btn-padding-x-sm, $btn-font-size-sm, $btn-line-height-sm, $btn-border-radius-sm);\n}\n\n\n//\n// Block button\n//\n\n.btn-block {\n  display: block;\n  width: 100%;\n\n  // Vertically space out multiple block buttons\n  + .btn-block {\n    margin-top: $btn-block-spacing-y;\n  }\n}\n\n// Specificity overrides\ninput[type=\"submit\"],\ninput[type=\"reset\"],\ninput[type=\"button\"] {\n  &.btn-block {\n    width: 100%;\n  }\n}\n","// Button variants\n//\n// Easily pump out default styles, as well as :hover, :focus, :active,\n// and disabled options for all buttons\n\n@mixin button-variant($background, $border, $hover-background: darken($background, 7.5%), $hover-border: darken($border, 10%), $active-background: darken($background, 10%), $active-border: darken($border, 12.5%)) {\n  color: color-yiq($background);\n  @include gradient-bg($background);\n  border-color: $border;\n  @include box-shadow($btn-box-shadow);\n\n  @include hover() {\n    color: color-yiq($hover-background);\n    @include gradient-bg($hover-background);\n    border-color: $hover-border;\n  }\n\n  &:focus,\n  &.focus {\n    color: color-yiq($hover-background);\n    @include gradient-bg($hover-background);\n    border-color: $hover-border;\n    @if $enable-shadows {\n      @include box-shadow($btn-box-shadow, 0 0 0 $btn-focus-width rgba(mix(color-yiq($background), $border, 15%), .5));\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: 0 0 0 $btn-focus-width rgba(mix(color-yiq($background), $border, 15%), .5);\n    }\n  }\n\n  // Disabled comes first so active can properly restyle\n  &.disabled,\n  &:disabled {\n    color: color-yiq($background);\n    background-color: $background;\n    border-color: $border;\n    // Remove CSS gradients if they're enabled\n    @if $enable-gradients {\n      background-image: none;\n    }\n  }\n\n  &:not(:disabled):not(.disabled):active,\n  &:not(:disabled):not(.disabled).active,\n  .show > &.dropdown-toggle {\n    color: color-yiq($active-background);\n    background-color: $active-background;\n    @if $enable-gradients {\n      background-image: none; // Remove the gradient for the pressed/active state\n    }\n    border-color: $active-border;\n\n    &:focus {\n      @if $enable-shadows and $btn-active-box-shadow != none {\n        @include box-shadow($btn-active-box-shadow, 0 0 0 $btn-focus-width rgba(mix(color-yiq($background), $border, 15%), .5));\n      } @else {\n        // Avoid using mixin so we can pass custom focus shadow properly\n        box-shadow: 0 0 0 $btn-focus-width rgba(mix(color-yiq($background), $border, 15%), .5);\n      }\n    }\n  }\n}\n\n@mixin button-outline-variant($color, $color-hover: color-yiq($color), $active-background: $color, $active-border: $color) {\n  color: $color;\n  border-color: $color;\n\n  @include hover() {\n    color: $color-hover;\n    background-color: $active-background;\n    border-color: $active-border;\n  }\n\n  &:focus,\n  &.focus {\n    box-shadow: 0 0 0 $btn-focus-width rgba($color, .5);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: $color;\n    background-color: transparent;\n  }\n\n  &:not(:disabled):not(.disabled):active,\n  &:not(:disabled):not(.disabled).active,\n  .show > &.dropdown-toggle {\n    color: color-yiq($active-background);\n    background-color: $active-background;\n    border-color: $active-border;\n\n    &:focus {\n      @if $enable-shadows and $btn-active-box-shadow != none {\n        @include box-shadow($btn-active-box-shadow, 0 0 0 $btn-focus-width rgba($color, .5));\n      } @else {\n        // Avoid using mixin so we can pass custom focus shadow properly\n        box-shadow: 0 0 0 $btn-focus-width rgba($color, .5);\n      }\n    }\n  }\n}\n\n// Button sizes\n@mixin button-size($padding-y, $padding-x, $font-size, $line-height, $border-radius) {\n  padding: $padding-y $padding-x;\n  @include font-size($font-size);\n  line-height: $line-height;\n  // Manually declare to provide an override to the browser default\n  @include border-radius($border-radius, 0);\n}\n",".fade {\n  @include transition($transition-fade);\n\n  &:not(.show) {\n    opacity: 0;\n  }\n}\n\n.collapse {\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.collapsing {\n  position: relative;\n  height: 0;\n  overflow: hidden;\n  @include transition($transition-collapse);\n\n  &.width {\n    width: 0;\n    height: auto;\n    @include transition($transition-collapse-width);\n  }\n}\n","// The dropdown wrapper (`<div>`)\n.dropup,\n.dropright,\n.dropdown,\n.dropleft {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n\n  // Generate the caret automatically\n  @include caret();\n}\n\n// The dropdown menu\n.dropdown-menu {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  z-index: $zindex-dropdown;\n  display: none; // none by default, but block on \"open\" of the menu\n  float: left;\n  min-width: $dropdown-min-width;\n  padding: $dropdown-padding-y $dropdown-padding-x;\n  margin: $dropdown-spacer 0 0; // override default ul\n  @include font-size($dropdown-font-size);\n  color: $dropdown-color;\n  text-align: left; // Ensures proper alignment if parent has it changed (e.g., modal footer)\n  list-style: none;\n  background-color: $dropdown-bg;\n  background-clip: padding-box;\n  border: $dropdown-border-width solid $dropdown-border-color;\n  @include border-radius($dropdown-border-radius);\n  @include box-shadow($dropdown-box-shadow);\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .dropdown-menu#{$infix}-left {\n      right: auto;\n      left: 0;\n    }\n\n    .dropdown-menu#{$infix}-right {\n      right: 0;\n      left: auto;\n    }\n  }\n}\n\n// Allow for dropdowns to go bottom up (aka, dropup-menu)\n// Just add .dropup after the standard .dropdown class and you're set.\n.dropup {\n  .dropdown-menu {\n    top: auto;\n    bottom: 100%;\n    margin-top: 0;\n    margin-bottom: $dropdown-spacer;\n  }\n\n  .dropdown-toggle {\n    @include caret(up);\n  }\n}\n\n.dropright {\n  .dropdown-menu {\n    top: 0;\n    right: auto;\n    left: 100%;\n    margin-top: 0;\n    margin-left: $dropdown-spacer;\n  }\n\n  .dropdown-toggle {\n    @include caret(right);\n    &::after {\n      vertical-align: 0;\n    }\n  }\n}\n\n.dropleft {\n  .dropdown-menu {\n    top: 0;\n    right: 100%;\n    left: auto;\n    margin-top: 0;\n    margin-right: $dropdown-spacer;\n  }\n\n  .dropdown-toggle {\n    @include caret(left);\n    &::before {\n      vertical-align: 0;\n    }\n  }\n}\n\n// When Popper is enabled, reset the basic dropdown position\n// stylelint-disable-next-line no-duplicate-selectors\n.dropdown-menu {\n  &[x-placement^=\"top\"],\n  &[x-placement^=\"right\"],\n  &[x-placement^=\"bottom\"],\n  &[x-placement^=\"left\"] {\n    right: auto;\n    bottom: auto;\n  }\n}\n\n// Dividers (basically an `<hr>`) within the dropdown\n.dropdown-divider {\n  @include nav-divider($dropdown-divider-bg, $dropdown-divider-margin-y, true);\n}\n\n// Links, buttons, and more within the dropdown menu\n//\n// `<button>`-specific styles are denoted with `// For <button>s`\n.dropdown-item {\n  display: block;\n  width: 100%; // For `<button>`s\n  padding: $dropdown-item-padding-y $dropdown-item-padding-x;\n  clear: both;\n  font-weight: $font-weight-normal;\n  color: $dropdown-link-color;\n  text-align: inherit; // For `<button>`s\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap; // prevent links from randomly breaking onto new lines\n  background-color: transparent; // For `<button>`s\n  border: 0; // For `<button>`s\n\n  // Prevent dropdown overflow if there's no padding\n  // See https://github.com/twbs/bootstrap/pull/27703\n  @if $dropdown-padding-y == 0 {\n    &:first-child {\n      @include border-top-radius($dropdown-inner-border-radius);\n    }\n\n    &:last-child {\n      @include border-bottom-radius($dropdown-inner-border-radius);\n    }\n  }\n\n  @include hover-focus() {\n    color: $dropdown-link-hover-color;\n    text-decoration: none;\n    @include gradient-bg($dropdown-link-hover-bg);\n  }\n\n  &.active,\n  &:active {\n    color: $dropdown-link-active-color;\n    text-decoration: none;\n    @include gradient-bg($dropdown-link-active-bg);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: $dropdown-link-disabled-color;\n    pointer-events: none;\n    background-color: transparent;\n    // Remove CSS gradients if they're enabled\n    @if $enable-gradients {\n      background-image: none;\n    }\n  }\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n// Dropdown section headers\n.dropdown-header {\n  display: block;\n  padding: $dropdown-header-padding;\n  margin-bottom: 0; // for use with heading elements\n  @include font-size($font-size-sm);\n  color: $dropdown-header-color;\n  white-space: nowrap; // as with > li > a\n}\n\n// Dropdown text\n.dropdown-item-text {\n  display: block;\n  padding: $dropdown-item-padding-y $dropdown-item-padding-x;\n  color: $dropdown-link-color;\n}\n","@mixin caret-down() {\n  border-top: $caret-width solid;\n  border-right: $caret-width solid transparent;\n  border-bottom: 0;\n  border-left: $caret-width solid transparent;\n}\n\n@mixin caret-up() {\n  border-top: 0;\n  border-right: $caret-width solid transparent;\n  border-bottom: $caret-width solid;\n  border-left: $caret-width solid transparent;\n}\n\n@mixin caret-right() {\n  border-top: $caret-width solid transparent;\n  border-right: 0;\n  border-bottom: $caret-width solid transparent;\n  border-left: $caret-width solid;\n}\n\n@mixin caret-left() {\n  border-top: $caret-width solid transparent;\n  border-right: $caret-width solid;\n  border-bottom: $caret-width solid transparent;\n}\n\n@mixin caret($direction: down) {\n  @if $enable-caret {\n    &::after {\n      display: inline-block;\n      margin-left: $caret-spacing;\n      vertical-align: $caret-vertical-align;\n      content: \"\";\n      @if $direction == down {\n        @include caret-down();\n      } @else if $direction == up {\n        @include caret-up();\n      } @else if $direction == right {\n        @include caret-right();\n      }\n    }\n\n    @if $direction == left {\n      &::after {\n        display: none;\n      }\n\n      &::before {\n        display: inline-block;\n        margin-right: $caret-spacing;\n        vertical-align: $caret-vertical-align;\n        content: \"\";\n        @include caret-left();\n      }\n    }\n\n    &:empty::after {\n      margin-left: 0;\n    }\n  }\n}\n","// Horizontal dividers\n//\n// Dividers (basically an hr) within dropdowns and nav lists\n\n@mixin nav-divider($color: $nav-divider-color, $margin-y: $nav-divider-margin-y, $ignore-warning: false) {\n  height: 0;\n  margin: $margin-y 0;\n  overflow: hidden;\n  border-top: 1px solid $color;\n  @include deprecate(\"The `nav-divider()` mixin\", \"v4.4.0\", \"v5\", $ignore-warning);\n}\n","// stylelint-disable selector-no-qualifying-type\n\n// Make the div behave like a button\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle; // match .btn alignment given font-size hack above\n\n  > .btn {\n    position: relative;\n    flex: 1 1 auto;\n\n    // Bring the hover, focused, and \"active\" buttons to the front to overlay\n    // the borders properly\n    @include hover() {\n      z-index: 1;\n    }\n    &:focus,\n    &:active,\n    &.active {\n      z-index: 1;\n    }\n  }\n}\n\n// Optional: Group multiple button groups together for a toolbar\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n\n  .input-group {\n    width: auto;\n  }\n}\n\n.btn-group {\n  // Prevent double borders when buttons are next to each other\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-left: -$btn-border-width;\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-right-radius(0);\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) > .btn {\n    @include border-left-radius(0);\n  }\n}\n\n// Sizing\n//\n// Remix the default button sizing classes into new ones for easier manipulation.\n\n.btn-group-sm > .btn { @extend .btn-sm; }\n.btn-group-lg > .btn { @extend .btn-lg; }\n\n\n//\n// Split button dropdowns\n//\n\n.dropdown-toggle-split {\n  padding-right: $btn-padding-x * .75;\n  padding-left: $btn-padding-x * .75;\n\n  &::after,\n  .dropup &::after,\n  .dropright &::after {\n    margin-left: 0;\n  }\n\n  .dropleft &::before {\n    margin-right: 0;\n  }\n}\n\n.btn-sm + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-sm * .75;\n  padding-left: $btn-padding-x-sm * .75;\n}\n\n.btn-lg + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-lg * .75;\n  padding-left: $btn-padding-x-lg * .75;\n}\n\n\n// The clickable button for toggling the menu\n// Set the same inset shadow as the :active state\n.btn-group.show .dropdown-toggle {\n  @include box-shadow($btn-active-box-shadow);\n\n  // Show no shadow for `.btn-link` since it has no other button styles.\n  &.btn-link {\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Vertical button groups\n//\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n\n  > .btn,\n  > .btn-group {\n    width: 100%;\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-top: -$btn-border-width;\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-bottom-radius(0);\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) > .btn {\n    @include border-top-radius(0);\n  }\n}\n\n\n// Checkbox and radio options\n//\n// In order to support the browser's form validation feedback, powered by the\n// `required` attribute, we have to \"hide\" the inputs via `clip`. We cannot use\n// `display: none;` or `visibility: hidden;` as that also hides the popover.\n// Simply visually hiding the inputs via `opacity` would leave them clickable in\n// certain cases which is prevented by using `clip` and `pointer-events`.\n// This way, we ensure a DOM element is visible to position the popover from.\n//\n// See https://github.com/twbs/bootstrap/pull/12794 and\n// https://github.com/twbs/bootstrap/pull/14559 for more information.\n\n.btn-group-toggle {\n  > .btn,\n  > .btn-group > .btn {\n    margin-bottom: 0; // Override default `<label>` value\n\n    input[type=\"radio\"],\n    input[type=\"checkbox\"] {\n      position: absolute;\n      clip: rect(0, 0, 0, 0);\n      pointer-events: none;\n    }\n  }\n}\n","// stylelint-disable selector-no-qualifying-type\n\n//\n// Base styles\n//\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // For form validation feedback\n  align-items: stretch;\n  width: 100%;\n\n  > .form-control,\n  > .form-control-plaintext,\n  > .custom-select,\n  > .custom-file {\n    position: relative; // For focus state's z-index\n    flex: 1 1 auto;\n    width: 1%;\n    min-width: 0; // https://stackoverflow.com/questions/36247140/why-dont-flex-items-shrink-past-content-size\n    margin-bottom: 0;\n\n    + .form-control,\n    + .custom-select,\n    + .custom-file {\n      margin-left: -$input-border-width;\n    }\n  }\n\n  // Bring the \"active\" form control to the top of surrounding elements\n  > .form-control:focus,\n  > .custom-select:focus,\n  > .custom-file .custom-file-input:focus ~ .custom-file-label {\n    z-index: 3;\n  }\n\n  // Bring the custom file input above the label\n  > .custom-file .custom-file-input:focus {\n    z-index: 4;\n  }\n\n  > .form-control,\n  > .custom-select {\n    &:not(:first-child) { @include border-left-radius(0); }\n  }\n\n  // Custom file inputs have more complex markup, thus requiring different\n  // border-radius overrides.\n  > .custom-file {\n    display: flex;\n    align-items: center;\n\n    &:not(:last-child) .custom-file-label,\n    &:not(:last-child) .custom-file-label::after { @include border-right-radius(0); }\n    &:not(:first-child) .custom-file-label { @include border-left-radius(0); }\n  }\n\n  &:not(.has-validation) {\n    > .form-control:not(:last-child),\n    > .custom-select:not(:last-child),\n    > .custom-file:not(:last-child) .custom-file-label,\n    > .custom-file:not(:last-child) .custom-file-label::after {\n      @include border-right-radius(0);\n    }\n  }\n\n  &.has-validation {\n    > .form-control:nth-last-child(n + 3),\n    > .custom-select:nth-last-child(n + 3),\n    > .custom-file:nth-last-child(n + 3) .custom-file-label,\n    > .custom-file:nth-last-child(n + 3) .custom-file-label::after {\n      @include border-right-radius(0);\n    }\n  }\n}\n\n\n// Prepend and append\n//\n// While it requires one extra layer of HTML for each, dedicated prepend and\n// append elements allow us to 1) be less clever, 2) simplify our selectors, and\n// 3) support HTML5 form validation.\n\n.input-group-prepend,\n.input-group-append {\n  display: flex;\n\n  // Ensure buttons are always above inputs for more visually pleasing borders.\n  // This isn't needed for `.input-group-text` since it shares the same border-color\n  // as our inputs.\n  .btn {\n    position: relative;\n    z-index: 2;\n\n    &:focus {\n      z-index: 3;\n    }\n  }\n\n  .btn + .btn,\n  .btn + .input-group-text,\n  .input-group-text + .input-group-text,\n  .input-group-text + .btn {\n    margin-left: -$input-border-width;\n  }\n}\n\n.input-group-prepend { margin-right: -$input-border-width; }\n.input-group-append { margin-left: -$input-border-width; }\n\n\n// Textual addons\n//\n// Serves as a catch-all element for any text or radio/checkbox input you wish\n// to prepend or append to an input.\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: $input-padding-y $input-padding-x;\n  margin-bottom: 0; // Allow use of <label> elements by overriding our default margin-bottom\n  @include font-size($input-font-size); // Match inputs\n  font-weight: $font-weight-normal;\n  line-height: $input-line-height;\n  color: $input-group-addon-color;\n  text-align: center;\n  white-space: nowrap;\n  background-color: $input-group-addon-bg;\n  border: $input-border-width solid $input-group-addon-border-color;\n  @include border-radius($input-border-radius);\n\n  // Nuke default margins from checkboxes and radios to vertically center within.\n  input[type=\"radio\"],\n  input[type=\"checkbox\"] {\n    margin-top: 0;\n  }\n}\n\n\n// Sizing\n//\n// Remix the default form control sizing classes into new ones for easier\n// manipulation.\n\n.input-group-lg > .form-control:not(textarea),\n.input-group-lg > .custom-select {\n  height: $input-height-lg;\n}\n\n.input-group-lg > .form-control,\n.input-group-lg > .custom-select,\n.input-group-lg > .input-group-prepend > .input-group-text,\n.input-group-lg > .input-group-append > .input-group-text,\n.input-group-lg > .input-group-prepend > .btn,\n.input-group-lg > .input-group-append > .btn {\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  line-height: $input-line-height-lg;\n  @include border-radius($input-border-radius-lg);\n}\n\n.input-group-sm > .form-control:not(textarea),\n.input-group-sm > .custom-select {\n  height: $input-height-sm;\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .custom-select,\n.input-group-sm > .input-group-prepend > .input-group-text,\n.input-group-sm > .input-group-append > .input-group-text,\n.input-group-sm > .input-group-prepend > .btn,\n.input-group-sm > .input-group-append > .btn {\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  line-height: $input-line-height-sm;\n  @include border-radius($input-border-radius-sm);\n}\n\n.input-group-lg > .custom-select,\n.input-group-sm > .custom-select {\n  padding-right: $custom-select-padding-x + $custom-select-indicator-padding;\n}\n\n\n// Prepend and append rounded corners\n//\n// These rulesets must come after the sizing ones to properly override sm and lg\n// border-radius values when extending. They're more specific than we'd like\n// with the `.input-group >` part, but without it, we cannot override the sizing.\n\n\n.input-group > .input-group-prepend > .btn,\n.input-group > .input-group-prepend > .input-group-text,\n.input-group:not(.has-validation) > .input-group-append:not(:last-child) > .btn,\n.input-group:not(.has-validation) > .input-group-append:not(:last-child) > .input-group-text,\n.input-group.has-validation > .input-group-append:nth-last-child(n + 3) > .btn,\n.input-group.has-validation > .input-group-append:nth-last-child(n + 3) > .input-group-text,\n.input-group > .input-group-append:last-child > .btn:not(:last-child):not(.dropdown-toggle),\n.input-group > .input-group-append:last-child > .input-group-text:not(:last-child) {\n  @include border-right-radius(0);\n}\n\n.input-group > .input-group-append > .btn,\n.input-group > .input-group-append > .input-group-text,\n.input-group > .input-group-prepend:not(:first-child) > .btn,\n.input-group > .input-group-prepend:not(:first-child) > .input-group-text,\n.input-group > .input-group-prepend:first-child > .btn:not(:first-child),\n.input-group > .input-group-prepend:first-child > .input-group-text:not(:first-child) {\n  @include border-left-radius(0);\n}\n","// Embedded icons from Open Iconic.\n// Released under MIT and copyright 2014 Waybury.\n// https://useiconic.com/open\n\n\n// Checkboxes and radios\n//\n// Base class takes care of all the key behavioral aspects.\n\n.custom-control {\n  position: relative;\n  z-index: 1;\n  display: block;\n  min-height: $font-size-base * $line-height-base;\n  padding-left: $custom-control-gutter + $custom-control-indicator-size;\n  print-color-adjust: exact; // Keep themed appearance for print\n}\n\n.custom-control-inline {\n  display: inline-flex;\n  margin-right: $custom-control-spacer-x;\n}\n\n.custom-control-input {\n  position: absolute;\n  left: 0;\n  z-index: -1; // Put the input behind the label so it doesn't overlay text\n  width: $custom-control-indicator-size;\n  height: ($font-size-base * $line-height-base + $custom-control-indicator-size) * .5;\n  opacity: 0;\n\n  &:checked ~ .custom-control-label::before {\n    color: $custom-control-indicator-checked-color;\n    border-color: $custom-control-indicator-checked-border-color;\n    @include gradient-bg($custom-control-indicator-checked-bg);\n    @include box-shadow($custom-control-indicator-checked-box-shadow);\n  }\n\n  &:focus ~ .custom-control-label::before {\n    // the mixin is not used here to make sure there is feedback\n    @if $enable-shadows {\n      box-shadow: $input-box-shadow, $custom-control-indicator-focus-box-shadow;\n    } @else {\n      box-shadow: $custom-control-indicator-focus-box-shadow;\n    }\n  }\n\n  &:focus:not(:checked) ~ .custom-control-label::before {\n    border-color: $custom-control-indicator-focus-border-color;\n  }\n\n  &:not(:disabled):active ~ .custom-control-label::before {\n    color: $custom-control-indicator-active-color;\n    background-color: $custom-control-indicator-active-bg;\n    border-color: $custom-control-indicator-active-border-color;\n    @include box-shadow($custom-control-indicator-active-box-shadow);\n  }\n\n  // Use [disabled] and :disabled to work around https://github.com/twbs/bootstrap/issues/28247\n  &[disabled],\n  &:disabled {\n    ~ .custom-control-label {\n      color: $custom-control-label-disabled-color;\n\n      &::before {\n        background-color: $custom-control-indicator-disabled-bg;\n      }\n    }\n  }\n}\n\n// Custom control indicators\n//\n// Build the custom controls out of pseudo-elements.\n\n.custom-control-label {\n  position: relative;\n  margin-bottom: 0;\n  color: $custom-control-label-color;\n  vertical-align: top;\n  cursor: $custom-control-cursor;\n\n  // Background-color and (when enabled) gradient\n  &::before {\n    position: absolute;\n    top: ($font-size-base * $line-height-base - $custom-control-indicator-size) * .5;\n    left: -($custom-control-gutter + $custom-control-indicator-size);\n    display: block;\n    width: $custom-control-indicator-size;\n    height: $custom-control-indicator-size;\n    pointer-events: none;\n    content: \"\";\n    background-color: $custom-control-indicator-bg;\n    border: $custom-control-indicator-border-width solid $custom-control-indicator-border-color;\n    @include box-shadow($custom-control-indicator-box-shadow);\n  }\n\n  // Foreground (icon)\n  &::after {\n    position: absolute;\n    top: ($font-size-base * $line-height-base - $custom-control-indicator-size) * .5;\n    left: -($custom-control-gutter + $custom-control-indicator-size);\n    display: block;\n    width: $custom-control-indicator-size;\n    height: $custom-control-indicator-size;\n    content: \"\";\n    background: 50% / #{$custom-control-indicator-bg-size} no-repeat;\n  }\n}\n\n\n// Checkboxes\n//\n// Tweak just a few things for checkboxes.\n\n.custom-checkbox {\n  .custom-control-label::before {\n    @include border-radius($custom-checkbox-indicator-border-radius);\n  }\n\n  .custom-control-input:checked ~ .custom-control-label {\n    &::after {\n      background-image: escape-svg($custom-checkbox-indicator-icon-checked);\n    }\n  }\n\n  .custom-control-input:indeterminate ~ .custom-control-label {\n    &::before {\n      border-color: $custom-checkbox-indicator-indeterminate-border-color;\n      @include gradient-bg($custom-checkbox-indicator-indeterminate-bg);\n      @include box-shadow($custom-checkbox-indicator-indeterminate-box-shadow);\n    }\n    &::after {\n      background-image: escape-svg($custom-checkbox-indicator-icon-indeterminate);\n    }\n  }\n\n  .custom-control-input:disabled {\n    &:checked ~ .custom-control-label::before {\n      @include gradient-bg($custom-control-indicator-checked-disabled-bg);\n    }\n    &:indeterminate ~ .custom-control-label::before {\n      @include gradient-bg($custom-control-indicator-checked-disabled-bg);\n    }\n  }\n}\n\n// Radios\n//\n// Tweak just a few things for radios.\n\n.custom-radio {\n  .custom-control-label::before {\n    // stylelint-disable-next-line property-disallowed-list\n    border-radius: $custom-radio-indicator-border-radius;\n  }\n\n  .custom-control-input:checked ~ .custom-control-label {\n    &::after {\n      background-image: escape-svg($custom-radio-indicator-icon-checked);\n    }\n  }\n\n  .custom-control-input:disabled {\n    &:checked ~ .custom-control-label::before {\n      @include gradient-bg($custom-control-indicator-checked-disabled-bg);\n    }\n  }\n}\n\n\n// switches\n//\n// Tweak a few things for switches\n\n.custom-switch {\n  padding-left: $custom-switch-width + $custom-control-gutter;\n\n  .custom-control-label {\n    &::before {\n      left: -($custom-switch-width + $custom-control-gutter);\n      width: $custom-switch-width;\n      pointer-events: all;\n      // stylelint-disable-next-line property-disallowed-list\n      border-radius: $custom-switch-indicator-border-radius;\n    }\n\n    &::after {\n      top: add(($font-size-base * $line-height-base - $custom-control-indicator-size) * .5, $custom-control-indicator-border-width * 2);\n      left: add(-($custom-switch-width + $custom-control-gutter), $custom-control-indicator-border-width * 2);\n      width: $custom-switch-indicator-size;\n      height: $custom-switch-indicator-size;\n      background-color: $custom-control-indicator-border-color;\n      // stylelint-disable-next-line property-disallowed-list\n      border-radius: $custom-switch-indicator-border-radius;\n      @include transition(transform .15s ease-in-out, $custom-forms-transition);\n    }\n  }\n\n  .custom-control-input:checked ~ .custom-control-label {\n    &::after {\n      background-color: $custom-control-indicator-bg;\n      transform: translateX($custom-switch-width - $custom-control-indicator-size);\n    }\n  }\n\n  .custom-control-input:disabled {\n    &:checked ~ .custom-control-label::before {\n      @include gradient-bg($custom-control-indicator-checked-disabled-bg);\n    }\n  }\n}\n\n\n// Select\n//\n// Replaces the browser default select with a custom one, mostly pulled from\n// https://primer.github.io/.\n//\n\n.custom-select {\n  display: inline-block;\n  width: 100%;\n  height: $custom-select-height;\n  padding: $custom-select-padding-y ($custom-select-padding-x + $custom-select-indicator-padding) $custom-select-padding-y $custom-select-padding-x;\n  font-family: $custom-select-font-family;\n  @include font-size($custom-select-font-size);\n  font-weight: $custom-select-font-weight;\n  line-height: $custom-select-line-height;\n  color: $custom-select-color;\n  vertical-align: middle;\n  background: $custom-select-bg $custom-select-background;\n  border: $custom-select-border-width solid $custom-select-border-color;\n  @include border-radius($custom-select-border-radius, 0);\n  @include box-shadow($custom-select-box-shadow);\n  appearance: none;\n\n  &:focus {\n    border-color: $custom-select-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($custom-select-box-shadow, $custom-select-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $custom-select-focus-box-shadow;\n    }\n\n    &::-ms-value {\n      // For visual consistency with other platforms/browsers,\n      // suppress the default white text on blue background highlight given to\n      // the selected option text when the (still closed) <select> receives focus\n      // in IE and (under certain conditions) Edge.\n      // See https://github.com/twbs/bootstrap/issues/19398.\n      color: $input-color;\n      background-color: $input-bg;\n    }\n  }\n\n  &[multiple],\n  &[size]:not([size=\"1\"]) {\n    height: auto;\n    padding-right: $custom-select-padding-x;\n    background-image: none;\n  }\n\n  &:disabled {\n    color: $custom-select-disabled-color;\n    background-color: $custom-select-disabled-bg;\n  }\n\n  // Hides the default caret in IE11\n  &::-ms-expand {\n    display: none;\n  }\n\n  // Remove outline from select box in FF\n  &:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 $custom-select-color;\n  }\n}\n\n.custom-select-sm {\n  height: $custom-select-height-sm;\n  padding-top: $custom-select-padding-y-sm;\n  padding-bottom: $custom-select-padding-y-sm;\n  padding-left: $custom-select-padding-x-sm;\n  @include font-size($custom-select-font-size-sm);\n}\n\n.custom-select-lg {\n  height: $custom-select-height-lg;\n  padding-top: $custom-select-padding-y-lg;\n  padding-bottom: $custom-select-padding-y-lg;\n  padding-left: $custom-select-padding-x-lg;\n  @include font-size($custom-select-font-size-lg);\n}\n\n\n// File\n//\n// Custom file input.\n\n.custom-file {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n  height: $custom-file-height;\n  margin-bottom: 0;\n}\n\n.custom-file-input {\n  position: relative;\n  z-index: 2;\n  width: 100%;\n  height: $custom-file-height;\n  margin: 0;\n  overflow: hidden;\n  opacity: 0;\n\n  &:focus ~ .custom-file-label {\n    border-color: $custom-file-focus-border-color;\n    box-shadow: $custom-file-focus-box-shadow;\n  }\n\n  // Use [disabled] and :disabled to work around https://github.com/twbs/bootstrap/issues/28247\n  &[disabled] ~ .custom-file-label,\n  &:disabled ~ .custom-file-label {\n    background-color: $custom-file-disabled-bg;\n  }\n\n  @each $lang, $value in $custom-file-text {\n    &:lang(#{$lang}) ~ .custom-file-label::after {\n      content: $value;\n    }\n  }\n\n  ~ .custom-file-label[data-browse]::after {\n    content: attr(data-browse);\n  }\n}\n\n.custom-file-label {\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 1;\n  height: $custom-file-height;\n  padding: $custom-file-padding-y $custom-file-padding-x;\n  overflow: hidden;\n  font-family: $custom-file-font-family;\n  font-weight: $custom-file-font-weight;\n  line-height: $custom-file-line-height;\n  color: $custom-file-color;\n  background-color: $custom-file-bg;\n  border: $custom-file-border-width solid $custom-file-border-color;\n  @include border-radius($custom-file-border-radius);\n  @include box-shadow($custom-file-box-shadow);\n\n  &::after {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 3;\n    display: block;\n    height: $custom-file-height-inner;\n    padding: $custom-file-padding-y $custom-file-padding-x;\n    line-height: $custom-file-line-height;\n    color: $custom-file-button-color;\n    content: \"Browse\";\n    @include gradient-bg($custom-file-button-bg);\n    border-left: inherit;\n    @include border-radius(0 $custom-file-border-radius $custom-file-border-radius 0);\n  }\n}\n\n// Range\n//\n// Style range inputs the same across browsers. Vendor-specific rules for pseudo\n// elements cannot be mixed. As such, there are no shared styles for focus or\n// active states on prefixed selectors.\n\n.custom-range {\n  width: 100%;\n  height: add($custom-range-thumb-height, $custom-range-thumb-focus-box-shadow-width * 2);\n  padding: 0; // Need to reset padding\n  background-color: transparent;\n  appearance: none;\n\n  &:focus {\n    outline: 0;\n\n    // Pseudo-elements must be split across multiple rulesets to have an effect.\n    // No box-shadow() mixin for focus accessibility.\n    &::-webkit-slider-thumb { box-shadow: $custom-range-thumb-focus-box-shadow; }\n    &::-moz-range-thumb     { box-shadow: $custom-range-thumb-focus-box-shadow; }\n    &::-ms-thumb            { box-shadow: $custom-range-thumb-focus-box-shadow; }\n  }\n\n  &::-moz-focus-outer {\n    border: 0;\n  }\n\n  &::-webkit-slider-thumb {\n    width: $custom-range-thumb-width;\n    height: $custom-range-thumb-height;\n    margin-top: ($custom-range-track-height - $custom-range-thumb-height) * .5; // Webkit specific\n    @include gradient-bg($custom-range-thumb-bg);\n    border: $custom-range-thumb-border;\n    @include border-radius($custom-range-thumb-border-radius);\n    @include box-shadow($custom-range-thumb-box-shadow);\n    @include transition($custom-forms-transition);\n    appearance: none;\n\n    &:active {\n      @include gradient-bg($custom-range-thumb-active-bg);\n    }\n  }\n\n  &::-webkit-slider-runnable-track {\n    width: $custom-range-track-width;\n    height: $custom-range-track-height;\n    color: transparent; // Why?\n    cursor: $custom-range-track-cursor;\n    background-color: $custom-range-track-bg;\n    border-color: transparent;\n    @include border-radius($custom-range-track-border-radius);\n    @include box-shadow($custom-range-track-box-shadow);\n  }\n\n  &::-moz-range-thumb {\n    width: $custom-range-thumb-width;\n    height: $custom-range-thumb-height;\n    @include gradient-bg($custom-range-thumb-bg);\n    border: $custom-range-thumb-border;\n    @include border-radius($custom-range-thumb-border-radius);\n    @include box-shadow($custom-range-thumb-box-shadow);\n    @include transition($custom-forms-transition);\n    appearance: none;\n\n    &:active {\n      @include gradient-bg($custom-range-thumb-active-bg);\n    }\n  }\n\n  &::-moz-range-track {\n    width: $custom-range-track-width;\n    height: $custom-range-track-height;\n    color: transparent;\n    cursor: $custom-range-track-cursor;\n    background-color: $custom-range-track-bg;\n    border-color: transparent; // Firefox specific?\n    @include border-radius($custom-range-track-border-radius);\n    @include box-shadow($custom-range-track-box-shadow);\n  }\n\n  &::-ms-thumb {\n    width: $custom-range-thumb-width;\n    height: $custom-range-thumb-height;\n    margin-top: 0; // Edge specific\n    margin-right: $custom-range-thumb-focus-box-shadow-width; // Workaround that overflowed box-shadow is hidden.\n    margin-left: $custom-range-thumb-focus-box-shadow-width;  // Workaround that overflowed box-shadow is hidden.\n    @include gradient-bg($custom-range-thumb-bg);\n    border: $custom-range-thumb-border;\n    @include border-radius($custom-range-thumb-border-radius);\n    @include box-shadow($custom-range-thumb-box-shadow);\n    @include transition($custom-forms-transition);\n    appearance: none;\n\n    &:active {\n      @include gradient-bg($custom-range-thumb-active-bg);\n    }\n  }\n\n  &::-ms-track {\n    width: $custom-range-track-width;\n    height: $custom-range-track-height;\n    color: transparent;\n    cursor: $custom-range-track-cursor;\n    background-color: transparent;\n    border-color: transparent;\n    border-width: $custom-range-thumb-height * .5;\n    @include box-shadow($custom-range-track-box-shadow);\n  }\n\n  &::-ms-fill-lower {\n    background-color: $custom-range-track-bg;\n    @include border-radius($custom-range-track-border-radius);\n  }\n\n  &::-ms-fill-upper {\n    margin-right: 15px; // arbitrary?\n    background-color: $custom-range-track-bg;\n    @include border-radius($custom-range-track-border-radius);\n  }\n\n  &:disabled {\n    &::-webkit-slider-thumb {\n      background-color: $custom-range-thumb-disabled-bg;\n    }\n\n    &::-webkit-slider-runnable-track {\n      cursor: default;\n    }\n\n    &::-moz-range-thumb {\n      background-color: $custom-range-thumb-disabled-bg;\n    }\n\n    &::-moz-range-track {\n      cursor: default;\n    }\n\n    &::-ms-thumb {\n      background-color: $custom-range-thumb-disabled-bg;\n    }\n  }\n}\n\n.custom-control-label::before,\n.custom-file-label,\n.custom-select {\n  @include transition($custom-forms-transition);\n}\n","// Base class\n//\n// Kickstart any navigation component with a set of style resets. Works with\n// `<nav>`s, `<ul>`s or `<ol>`s.\n\n.nav {\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: $nav-link-padding-y $nav-link-padding-x;\n  text-decoration: if($link-decoration == none, null, none);\n\n  @include hover-focus() {\n    text-decoration: none;\n  }\n\n  // Disabled state lightens text\n  &.disabled {\n    color: $nav-link-disabled-color;\n    pointer-events: none;\n    cursor: default;\n  }\n}\n\n//\n// Tabs\n//\n\n.nav-tabs {\n  border-bottom: $nav-tabs-border-width solid $nav-tabs-border-color;\n\n  .nav-link {\n    margin-bottom: -$nav-tabs-border-width;\n    background-color: transparent;\n    border: $nav-tabs-border-width solid transparent;\n    @include border-top-radius($nav-tabs-border-radius);\n\n    @include hover-focus() {\n      // Prevents active .nav-link tab overlapping focus outline of previous/next .nav-link\n      isolation: isolate;\n      border-color: $nav-tabs-link-hover-border-color;\n    }\n\n    &.disabled {\n      color: $nav-link-disabled-color;\n      background-color: transparent;\n      border-color: transparent;\n    }\n  }\n\n  .nav-link.active,\n  .nav-item.show .nav-link {\n    color: $nav-tabs-link-active-color;\n    background-color: $nav-tabs-link-active-bg;\n    border-color: $nav-tabs-link-active-border-color;\n  }\n\n  .dropdown-menu {\n    // Make dropdown border overlap tab border\n    margin-top: -$nav-tabs-border-width;\n    // Remove the top rounded corners here since there is a hard edge above the menu\n    @include border-top-radius(0);\n  }\n}\n\n\n//\n// Pills\n//\n\n.nav-pills {\n  .nav-link {\n    background: none;\n    border: 0;\n    @include border-radius($nav-pills-border-radius);\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    color: $nav-pills-link-active-color;\n    background-color: $nav-pills-link-active-bg;\n  }\n}\n\n\n//\n// Justified variants\n//\n\n.nav-fill {\n  > .nav-link,\n  .nav-item {\n    flex: 1 1 auto;\n    text-align: center;\n  }\n}\n\n.nav-justified {\n  > .nav-link,\n  .nav-item {\n    flex-basis: 0;\n    flex-grow: 1;\n    text-align: center;\n  }\n}\n\n\n// Tabbable tabs\n//\n// Hide tabbable panes to start, show them when `.active`\n\n.tab-content {\n  > .tab-pane {\n    display: none;\n  }\n  > .active {\n    display: block;\n  }\n}\n","// Contents\n//\n// Navbar\n// Navbar brand\n// Navbar nav\n// Navbar text\n// Navbar divider\n// Responsive navbar\n// Navbar position\n// Navbar themes\n\n\n// Navbar\n//\n// Provide a static navbar from which we expand to create full-width, fixed, and\n// other navbar variations.\n\n.navbar {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\n  align-items: center;\n  justify-content: space-between; // space out brand from logo\n  padding: $navbar-padding-y $navbar-padding-x;\n\n  // Because flex properties aren't inherited, we need to redeclare these first\n  // few properties so that content nested within behave properly.\n  %container-flex-properties {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  .container,\n  .container-fluid {\n    @extend %container-flex-properties;\n  }\n\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    > .container#{breakpoint-infix($breakpoint, $container-max-widths)} {\n      @extend %container-flex-properties;\n    }\n  }\n}\n\n\n// Navbar brand\n//\n// Used for brand, project, or site names.\n\n.navbar-brand {\n  display: inline-block;\n  padding-top: $navbar-brand-padding-y;\n  padding-bottom: $navbar-brand-padding-y;\n  margin-right: $navbar-padding-x;\n  @include font-size($navbar-brand-font-size);\n  line-height: inherit;\n  white-space: nowrap;\n\n  @include hover-focus() {\n    text-decoration: none;\n  }\n}\n\n\n// Navbar nav\n//\n// Custom navbar navigation (doesn't require `.nav`, but does make use of `.nav-link`).\n\n.navbar-nav {\n  display: flex;\n  flex-direction: column; // cannot use `inherit` to get the `.navbar`s value\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n\n  .nav-link {\n    padding-right: 0;\n    padding-left: 0;\n  }\n\n  .dropdown-menu {\n    position: static;\n    float: none;\n  }\n}\n\n\n// Navbar text\n//\n//\n\n.navbar-text {\n  display: inline-block;\n  padding-top: $nav-link-padding-y;\n  padding-bottom: $nav-link-padding-y;\n}\n\n\n// Responsive navbar\n//\n// Custom styles for responsive collapsing and toggling of navbar contents.\n// Powered by the collapse Bootstrap JavaScript plugin.\n\n// When collapsed, prevent the toggleable navbar contents from appearing in\n// the default flexbox row orientation. Requires the use of `flex-wrap: wrap`\n// on the `.navbar` parent.\n.navbar-collapse {\n  flex-basis: 100%;\n  flex-grow: 1;\n  // For always expanded or extra full navbars, ensure content aligns itself\n  // properly vertically. Can be easily overridden with flex utilities.\n  align-items: center;\n}\n\n// Button for toggling the navbar when in its collapsed state\n.navbar-toggler {\n  padding: $navbar-toggler-padding-y $navbar-toggler-padding-x;\n  @include font-size($navbar-toggler-font-size);\n  line-height: 1;\n  background-color: transparent; // remove default button style\n  border: $border-width solid transparent; // remove default button style\n  @include border-radius($navbar-toggler-border-radius);\n\n  @include hover-focus() {\n    text-decoration: none;\n  }\n}\n\n// Keep as a separate element so folks can easily override it with another icon\n// or image file as needed.\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  content: \"\";\n  background: 50% / 100% 100% no-repeat;\n}\n\n.navbar-nav-scroll {\n  max-height: $navbar-nav-scroll-max-height;\n  overflow-y: auto;\n}\n\n// Generate series of `.navbar-expand-*` responsive classes for configuring\n// where your navbar collapses.\n.navbar-expand {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\n    $infix: breakpoint-infix($next, $grid-breakpoints);\n\n    &#{$infix} {\n      @include media-breakpoint-down($breakpoint) {\n        %container-navbar-expand-#{$breakpoint} {\n          padding-right: 0;\n          padding-left: 0;\n        }\n\n        > .container,\n        > .container-fluid {\n          @extend %container-navbar-expand-#{$breakpoint};\n        }\n\n        @each $size, $container-max-width in $container-max-widths {\n          > .container#{breakpoint-infix($size, $container-max-widths)} {\n            @extend %container-navbar-expand-#{$breakpoint};\n          }\n        }\n      }\n\n      @include media-breakpoint-up($next) {\n        flex-flow: row nowrap;\n        justify-content: flex-start;\n\n        .navbar-nav {\n          flex-direction: row;\n\n          .dropdown-menu {\n            position: absolute;\n          }\n\n          .nav-link {\n            padding-right: $navbar-nav-link-padding-x;\n            padding-left: $navbar-nav-link-padding-x;\n          }\n        }\n\n        // For nesting containers, have to redeclare for alignment purposes\n        %container-nesting-#{$breakpoint} {\n          flex-wrap: nowrap;\n        }\n\n        > .container,\n        > .container-fluid {\n          @extend %container-nesting-#{$breakpoint};\n        }\n\n        @each $size, $container-max-width in $container-max-widths {\n          > .container#{breakpoint-infix($size, $container-max-widths)} {\n            @extend %container-nesting-#{$breakpoint};\n          }\n        }\n\n        .navbar-nav-scroll {\n          overflow: visible;\n        }\n\n        .navbar-collapse {\n          display: flex !important; // stylelint-disable-line declaration-no-important\n\n          // Changes flex-bases to auto because of an IE10 bug\n          flex-basis: auto;\n        }\n\n        .navbar-toggler {\n          display: none;\n        }\n      }\n    }\n  }\n}\n\n\n// Navbar themes\n//\n// Styles for switching between navbars with light or dark background.\n\n// Dark links against a light background\n.navbar-light {\n  .navbar-brand {\n    color: $navbar-light-brand-color;\n\n    @include hover-focus() {\n      color: $navbar-light-brand-hover-color;\n    }\n  }\n\n  .navbar-nav {\n    .nav-link {\n      color: $navbar-light-color;\n\n      @include hover-focus() {\n        color: $navbar-light-hover-color;\n      }\n\n      &.disabled {\n        color: $navbar-light-disabled-color;\n      }\n    }\n\n    .show > .nav-link,\n    .active > .nav-link,\n    .nav-link.show,\n    .nav-link.active {\n      color: $navbar-light-active-color;\n    }\n  }\n\n  .navbar-toggler {\n    color: $navbar-light-color;\n    border-color: $navbar-light-toggler-border-color;\n  }\n\n  .navbar-toggler-icon {\n    background-image: escape-svg($navbar-light-toggler-icon-bg);\n  }\n\n  .navbar-text {\n    color: $navbar-light-color;\n    a {\n      color: $navbar-light-active-color;\n\n      @include hover-focus() {\n        color: $navbar-light-active-color;\n      }\n    }\n  }\n}\n\n// White links against a dark background\n.navbar-dark {\n  .navbar-brand {\n    color: $navbar-dark-brand-color;\n\n    @include hover-focus() {\n      color: $navbar-dark-brand-hover-color;\n    }\n  }\n\n  .navbar-nav {\n    .nav-link {\n      color: $navbar-dark-color;\n\n      @include hover-focus() {\n        color: $navbar-dark-hover-color;\n      }\n\n      &.disabled {\n        color: $navbar-dark-disabled-color;\n      }\n    }\n\n    .show > .nav-link,\n    .active > .nav-link,\n    .nav-link.show,\n    .nav-link.active {\n      color: $navbar-dark-active-color;\n    }\n  }\n\n  .navbar-toggler {\n    color: $navbar-dark-color;\n    border-color: $navbar-dark-toggler-border-color;\n  }\n\n  .navbar-toggler-icon {\n    background-image: escape-svg($navbar-dark-toggler-icon-bg);\n  }\n\n  .navbar-text {\n    color: $navbar-dark-color;\n    a {\n      color: $navbar-dark-active-color;\n\n      @include hover-focus() {\n        color: $navbar-dark-active-color;\n      }\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.card {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0; // See https://github.com/twbs/bootstrap/pull/22740#issuecomment-305868106\n  height: $card-height;\n  word-wrap: break-word;\n  background-color: $card-bg;\n  background-clip: border-box;\n  border: $card-border-width solid $card-border-color;\n  @include border-radius($card-border-radius);\n\n  > hr {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  > .list-group {\n    border-top: inherit;\n    border-bottom: inherit;\n\n    &:first-child {\n      border-top-width: 0;\n      @include border-top-radius($card-inner-border-radius);\n    }\n\n    &:last-child  {\n      border-bottom-width: 0;\n      @include border-bottom-radius($card-inner-border-radius);\n    }\n  }\n\n  // Due to specificity of the above selector (`.card > .list-group`), we must\n  // use a child selector here to prevent double borders.\n  > .card-header + .list-group,\n  > .list-group + .card-footer {\n    border-top: 0;\n  }\n}\n\n.card-body {\n  // Enable `flex-grow: 1` for decks and groups so that card blocks take up\n  // as much space as possible, ensuring footers are aligned to the bottom.\n  flex: 1 1 auto;\n  // Workaround for the image size bug in IE\n  // See: https://github.com/twbs/bootstrap/pull/28855\n  min-height: 1px;\n  padding: $card-spacer-x;\n  color: $card-color;\n}\n\n.card-title {\n  margin-bottom: $card-spacer-y;\n}\n\n.card-subtitle {\n  margin-top: -$card-spacer-y * .5;\n  margin-bottom: 0;\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link {\n  @include hover() {\n    text-decoration: none;\n  }\n\n  + .card-link {\n    margin-left: $card-spacer-x;\n  }\n}\n\n//\n// Optional textual caps\n//\n\n.card-header {\n  padding: $card-spacer-y $card-spacer-x;\n  margin-bottom: 0; // Removes the default margin-bottom of <hN>\n  color: $card-cap-color;\n  background-color: $card-cap-bg;\n  border-bottom: $card-border-width solid $card-border-color;\n\n  &:first-child {\n    @include border-radius($card-inner-border-radius $card-inner-border-radius 0 0);\n  }\n}\n\n.card-footer {\n  padding: $card-spacer-y $card-spacer-x;\n  color: $card-cap-color;\n  background-color: $card-cap-bg;\n  border-top: $card-border-width solid $card-border-color;\n\n  &:last-child {\n    @include border-radius(0 0 $card-inner-border-radius $card-inner-border-radius);\n  }\n}\n\n\n//\n// Header navs\n//\n\n.card-header-tabs {\n  margin-right: -$card-spacer-x * .5;\n  margin-bottom: -$card-spacer-y;\n  margin-left: -$card-spacer-x * .5;\n  border-bottom: 0;\n}\n\n.card-header-pills {\n  margin-right: -$card-spacer-x * .5;\n  margin-left: -$card-spacer-x * .5;\n}\n\n// Card image\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: $card-img-overlay-padding;\n  @include border-radius($card-inner-border-radius);\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  flex-shrink: 0; // For IE: https://github.com/twbs/bootstrap/issues/29396\n  width: 100%; // Required because we use flexbox and this inherently applies align-self: stretch\n}\n\n.card-img,\n.card-img-top {\n  @include border-top-radius($card-inner-border-radius);\n}\n\n.card-img,\n.card-img-bottom {\n  @include border-bottom-radius($card-inner-border-radius);\n}\n\n\n// Card deck\n\n.card-deck {\n  .card {\n    margin-bottom: $card-deck-margin;\n  }\n\n  @include media-breakpoint-up(sm) {\n    display: flex;\n    flex-flow: row wrap;\n    margin-right: -$card-deck-margin;\n    margin-left: -$card-deck-margin;\n\n    .card {\n      // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      flex: 1 0 0%;\n      margin-right: $card-deck-margin;\n      margin-bottom: 0; // Override the default\n      margin-left: $card-deck-margin;\n    }\n  }\n}\n\n\n//\n// Card groups\n//\n\n.card-group {\n  // The child selector allows nested `.card` within `.card-group`\n  // to display properly.\n  > .card {\n    margin-bottom: $card-group-margin;\n  }\n\n  @include media-breakpoint-up(sm) {\n    display: flex;\n    flex-flow: row wrap;\n    // The child selector allows nested `.card` within `.card-group`\n    // to display properly.\n    > .card {\n      // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      flex: 1 0 0%;\n      margin-bottom: 0;\n\n      + .card {\n        margin-left: 0;\n        border-left: 0;\n      }\n\n      // Handle rounded corners\n      @if $enable-rounded {\n        &:not(:last-child) {\n          @include border-right-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-right-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-right-radius: 0;\n          }\n        }\n\n        &:not(:first-child) {\n          @include border-left-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-left-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-left-radius: 0;\n          }\n        }\n      }\n    }\n  }\n}\n\n\n//\n// Columns\n//\n\n.card-columns {\n  .card {\n    margin-bottom: $card-columns-margin;\n  }\n\n  @include media-breakpoint-up(sm) {\n    column-count: $card-columns-count;\n    column-gap: $card-columns-gap;\n    orphans: 1;\n    widows: 1;\n\n    .card {\n      display: inline-block; // Don't let them vertically span multiple columns\n      width: 100%; // Don't let their width change\n    }\n  }\n}\n\n\n//\n// Accordion\n//\n\n.accordion {\n  overflow-anchor: none;\n\n  > .card {\n    overflow: hidden;\n\n    &:not(:last-of-type) {\n      border-bottom: 0;\n      @include border-bottom-radius(0);\n    }\n\n    &:not(:first-of-type) {\n      @include border-top-radius(0);\n    }\n\n    > .card-header {\n      @include border-radius(0);\n      margin-bottom: -$card-border-width;\n    }\n  }\n}\n",".breadcrumb {\n  display: flex;\n  flex-wrap: wrap;\n  padding: $breadcrumb-padding-y $breadcrumb-padding-x;\n  margin-bottom: $breadcrumb-margin-bottom;\n  @include font-size($breadcrumb-font-size);\n  list-style: none;\n  background-color: $breadcrumb-bg;\n  @include border-radius($breadcrumb-border-radius);\n}\n\n.breadcrumb-item {\n  // The separator between breadcrumbs (by default, a forward-slash: \"/\")\n  + .breadcrumb-item {\n    padding-left: $breadcrumb-item-padding;\n\n    &::before {\n      float: left; // Suppress inline spacings and underlining of the separator\n      padding-right: $breadcrumb-item-padding;\n      color: $breadcrumb-divider-color;\n      content: escape-svg($breadcrumb-divider);\n    }\n  }\n\n  // IE9-11 hack to properly handle hyperlink underlines for breadcrumbs built\n  // without `<ul>`s. The `::before` pseudo-element generates an element\n  // *within* the .breadcrumb-item and thereby inherits the `text-decoration`.\n  //\n  // To trick IE into suppressing the underline, we give the pseudo-element an\n  // underline and then immediately remove it.\n  + .breadcrumb-item:hover::before {\n    text-decoration: underline;\n  }\n  // stylelint-disable-next-line no-duplicate-selectors\n  + .breadcrumb-item:hover::before {\n    text-decoration: none;\n  }\n\n  &.active {\n    color: $breadcrumb-active-color;\n  }\n}\n",".pagination {\n  display: flex;\n  @include list-unstyled();\n  @include border-radius();\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: $pagination-padding-y $pagination-padding-x;\n  margin-left: -$pagination-border-width;\n  line-height: $pagination-line-height;\n  color: $pagination-color;\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: $pagination-bg;\n  border: $pagination-border-width solid $pagination-border-color;\n\n  &:hover {\n    z-index: 2;\n    color: $pagination-hover-color;\n    text-decoration: none;\n    background-color: $pagination-hover-bg;\n    border-color: $pagination-hover-border-color;\n  }\n\n  &:focus {\n    z-index: 3;\n    outline: $pagination-focus-outline;\n    box-shadow: $pagination-focus-box-shadow;\n  }\n}\n\n.page-item {\n  &:first-child {\n    .page-link {\n      margin-left: 0;\n      @include border-left-radius($border-radius);\n    }\n  }\n  &:last-child {\n    .page-link {\n      @include border-right-radius($border-radius);\n    }\n  }\n\n  &.active .page-link {\n    z-index: 3;\n    color: $pagination-active-color;\n    background-color: $pagination-active-bg;\n    border-color: $pagination-active-border-color;\n  }\n\n  &.disabled .page-link {\n    color: $pagination-disabled-color;\n    pointer-events: none;\n    // Opinionated: remove the \"hand\" cursor set previously for .page-link\n    cursor: auto;\n    background-color: $pagination-disabled-bg;\n    border-color: $pagination-disabled-border-color;\n  }\n}\n\n\n//\n// Sizing\n//\n\n.pagination-lg {\n  @include pagination-size($pagination-padding-y-lg, $pagination-padding-x-lg, $font-size-lg, $line-height-lg, $pagination-border-radius-lg);\n}\n\n.pagination-sm {\n  @include pagination-size($pagination-padding-y-sm, $pagination-padding-x-sm, $font-size-sm, $line-height-sm, $pagination-border-radius-sm);\n}\n","// Pagination\n\n@mixin pagination-size($padding-y, $padding-x, $font-size, $line-height, $border-radius) {\n  .page-link {\n    padding: $padding-y $padding-x;\n    @include font-size($font-size);\n    line-height: $line-height;\n  }\n\n  .page-item {\n    &:first-child {\n      .page-link {\n        @include border-left-radius($border-radius);\n      }\n    }\n    &:last-child {\n      .page-link {\n        @include border-right-radius($border-radius);\n      }\n    }\n  }\n}\n","// Base class\n//\n// Requires one of the contextual, color modifier classes for `color` and\n// `background-color`.\n\n.badge {\n  display: inline-block;\n  padding: $badge-padding-y $badge-padding-x;\n  @include font-size($badge-font-size);\n  font-weight: $badge-font-weight;\n  line-height: 1;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  @include border-radius($badge-border-radius);\n  @include transition($badge-transition);\n\n  @at-root a#{&} {\n    @include hover-focus() {\n      text-decoration: none;\n    }\n  }\n\n  // Empty badges collapse automatically\n  &:empty {\n    display: none;\n  }\n}\n\n// Quick fix for badges in buttons\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n\n// Pill badges\n//\n// Make them extra rounded with a modifier to replace v3's badges.\n\n.badge-pill {\n  padding-right: $badge-pill-padding-x;\n  padding-left: $badge-pill-padding-x;\n  @include border-radius($badge-pill-border-radius);\n}\n\n// Colors\n//\n// Contextual variations (linked badges get darker on :hover).\n\n@each $color, $value in $theme-colors {\n  .badge-#{$color} {\n    @include badge-variant($value);\n  }\n}\n","@mixin badge-variant($bg) {\n  color: color-yiq($bg);\n  background-color: $bg;\n\n  @at-root a#{&} {\n    @include hover-focus() {\n      color: color-yiq($bg);\n      background-color: darken($bg, 10%);\n    }\n\n    &:focus,\n    &.focus {\n      outline: 0;\n      box-shadow: 0 0 0 $badge-focus-width rgba($bg, .5);\n    }\n  }\n}\n",".jumbotron {\n  padding: $jumbotron-padding ($jumbotron-padding * .5);\n  margin-bottom: $jumbotron-padding;\n  color: $jumbotron-color;\n  background-color: $jumbotron-bg;\n  @include border-radius($border-radius-lg);\n\n  @include media-breakpoint-up(sm) {\n    padding: ($jumbotron-padding * 2) $jumbotron-padding;\n  }\n}\n\n.jumbotron-fluid {\n  padding-right: 0;\n  padding-left: 0;\n  @include border-radius(0);\n}\n","//\n// Base styles\n//\n\n.alert {\n  position: relative;\n  padding: $alert-padding-y $alert-padding-x;\n  margin-bottom: $alert-margin-bottom;\n  border: $alert-border-width solid transparent;\n  @include border-radius($alert-border-radius);\n}\n\n// Headings for larger alerts\n.alert-heading {\n  // Specified to prevent conflicts of changing $headings-color\n  color: inherit;\n}\n\n// Provide class for links that match alerts\n.alert-link {\n  font-weight: $alert-link-font-weight;\n}\n\n\n// Dismissible alerts\n//\n// Expand the right padding and account for the close button's positioning.\n\n.alert-dismissible {\n  padding-right: $close-font-size + $alert-padding-x * 2;\n\n  // Adjust close link position\n  .close {\n    position: absolute;\n    top: 0;\n    right: 0;\n    z-index: 2;\n    padding: $alert-padding-y $alert-padding-x;\n    color: inherit;\n  }\n}\n\n\n// Alternate styles\n//\n// Generate contextual modifier classes for colorizing the alert.\n\n@each $color, $value in $theme-colors {\n  .alert-#{$color} {\n    @include alert-variant(theme-color-level($color, $alert-bg-level), theme-color-level($color, $alert-border-level), theme-color-level($color, $alert-color-level));\n  }\n}\n","@mixin alert-variant($background, $border, $color) {\n  color: $color;\n  @include gradient-bg($background);\n  border-color: $border;\n\n  hr {\n    border-top-color: darken($border, 5%);\n  }\n\n  .alert-link {\n    color: darken($color, 10%);\n  }\n}\n","// Disable animation if transitions are disabled\n@if $enable-transitions {\n  @keyframes progress-bar-stripes {\n    from { background-position: $progress-height 0; }\n    to { background-position: 0 0; }\n  }\n}\n\n.progress {\n  display: flex;\n  height: $progress-height;\n  overflow: hidden; // force rounded corners by cropping it\n  line-height: 0;\n  @include font-size($progress-font-size);\n  background-color: $progress-bg;\n  @include border-radius($progress-border-radius);\n  @include box-shadow($progress-box-shadow);\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: $progress-bar-color;\n  text-align: center;\n  white-space: nowrap;\n  background-color: $progress-bar-bg;\n  @include transition($progress-bar-transition);\n}\n\n.progress-bar-striped {\n  @include gradient-striped();\n  background-size: $progress-height $progress-height;\n}\n\n@if $enable-transitions {\n  .progress-bar-animated {\n    animation: $progress-bar-animation-timing progress-bar-stripes;\n\n    @if $enable-prefers-reduced-motion-media-query {\n      @media (prefers-reduced-motion: reduce) {\n        animation: none;\n      }\n    }\n  }\n}\n",".media {\n  display: flex;\n  align-items: flex-start;\n}\n\n.media-body {\n  flex: 1;\n}\n","// Base class\n//\n// Easily usable on <ul>, <ol>, or <div>.\n\n.list-group {\n  display: flex;\n  flex-direction: column;\n\n  // No need to set list-style: none; since .list-group-item is block level\n  padding-left: 0; // reset padding because ul and ol\n  margin-bottom: 0;\n  @include border-radius($list-group-border-radius);\n}\n\n\n// Interactive list items\n//\n// Use anchor or button elements instead of `li`s or `div`s to create interactive\n// list items. Includes an extra `.active` modifier class for selected items.\n\n.list-group-item-action {\n  width: 100%; // For `<button>`s (anchors become 100% by default though)\n  color: $list-group-action-color;\n  text-align: inherit; // For `<button>`s (anchors inherit)\n\n  // Hover state\n  @include hover-focus() {\n    z-index: 1; // Place hover/focus items above their siblings for proper border styling\n    color: $list-group-action-hover-color;\n    text-decoration: none;\n    background-color: $list-group-hover-bg;\n  }\n\n  &:active {\n    color: $list-group-action-active-color;\n    background-color: $list-group-action-active-bg;\n  }\n}\n\n\n// Individual list items\n//\n// Use on `li`s or `div`s within the `.list-group` parent.\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: $list-group-item-padding-y $list-group-item-padding-x;\n  color: $list-group-color;\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: $list-group-bg;\n  border: $list-group-border-width solid $list-group-border-color;\n\n  &:first-child {\n    @include border-top-radius(inherit);\n  }\n\n  &:last-child {\n    @include border-bottom-radius(inherit);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: $list-group-disabled-color;\n    pointer-events: none;\n    background-color: $list-group-disabled-bg;\n  }\n\n  // Include both here for `<a>`s and `<button>`s\n  &.active {\n    z-index: 2; // Place active items above their siblings for proper border styling\n    color: $list-group-active-color;\n    background-color: $list-group-active-bg;\n    border-color: $list-group-active-border-color;\n  }\n\n  & + & {\n    border-top-width: 0;\n\n    &.active {\n      margin-top: -$list-group-border-width;\n      border-top-width: $list-group-border-width;\n    }\n  }\n}\n\n\n// Horizontal\n//\n// Change the layout of list group items from vertical (default) to horizontal.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .list-group-horizontal#{$infix} {\n      flex-direction: row;\n\n      > .list-group-item {\n        &:first-child {\n          @include border-bottom-left-radius($list-group-border-radius);\n          @include border-top-right-radius(0);\n        }\n\n        &:last-child {\n          @include border-top-right-radius($list-group-border-radius);\n          @include border-bottom-left-radius(0);\n        }\n\n        &.active {\n          margin-top: 0;\n        }\n\n        + .list-group-item {\n          border-top-width: $list-group-border-width;\n          border-left-width: 0;\n\n          &.active {\n            margin-left: -$list-group-border-width;\n            border-left-width: $list-group-border-width;\n          }\n        }\n      }\n    }\n  }\n}\n\n\n// Flush list items\n//\n// Remove borders and border-radius to keep list group items edge-to-edge. Most\n// useful within other components (e.g., cards).\n\n.list-group-flush {\n  @include border-radius(0);\n\n  > .list-group-item {\n    border-width: 0 0 $list-group-border-width;\n\n    &:last-child {\n      border-bottom-width: 0;\n    }\n  }\n}\n\n\n// Contextual variants\n//\n// Add modifier classes to change text and background color on individual items.\n// Organizationally, this must come after the `:hover` states.\n\n@each $color, $value in $theme-colors {\n  @include list-group-item-variant($color, theme-color-level($color, -9), theme-color-level($color, 6));\n}\n","// List Groups\n\n@mixin list-group-item-variant($state, $background, $color) {\n  .list-group-item-#{$state} {\n    color: $color;\n    background-color: $background;\n\n    &.list-group-item-action {\n      @include hover-focus() {\n        color: $color;\n        background-color: darken($background, 5%);\n      }\n\n      &.active {\n        color: $white;\n        background-color: $color;\n        border-color: $color;\n      }\n    }\n  }\n}\n",".close {\n  float: right;\n  @include font-size($close-font-size);\n  font-weight: $close-font-weight;\n  line-height: 1;\n  color: $close-color;\n  text-shadow: $close-text-shadow;\n  opacity: .5;\n\n  // Override <a>'s hover style\n  @include hover() {\n    color: $close-color;\n    text-decoration: none;\n  }\n\n  &:not(:disabled):not(.disabled) {\n    @include hover-focus() {\n      opacity: .75;\n    }\n  }\n}\n\n// Additional properties for button version\n// iOS requires the button element instead of an anchor tag.\n// If you want the anchor version, it requires `href=\"#\"`.\n// See https://developer.mozilla.org/en-US/docs/Web/Events/click#Safari_Mobile\n\n// stylelint-disable-next-line selector-no-qualifying-type\nbutton.close {\n  padding: 0;\n  background-color: transparent;\n  border: 0;\n}\n\n// Future-proof disabling of clicks on `<a>` elements\n\n// stylelint-disable-next-line selector-no-qualifying-type\na.close.disabled {\n  pointer-events: none;\n}\n",".toast {\n  // Prevents from shrinking in IE11, when in a flex container\n  // See https://github.com/twbs/bootstrap/issues/28341\n  flex-basis: $toast-max-width;\n  max-width: $toast-max-width;\n  @include font-size($toast-font-size);\n  color: $toast-color;\n  background-color: $toast-background-color;\n  background-clip: padding-box;\n  border: $toast-border-width solid $toast-border-color;\n  box-shadow: $toast-box-shadow;\n  opacity: 0;\n  @include border-radius($toast-border-radius);\n\n  &:not(:last-child) {\n    margin-bottom: $toast-padding-x;\n  }\n\n  &.showing {\n    opacity: 1;\n  }\n\n  &.show {\n    display: block;\n    opacity: 1;\n  }\n\n  &.hide {\n    display: none;\n  }\n}\n\n.toast-header {\n  display: flex;\n  align-items: center;\n  padding: $toast-padding-y $toast-padding-x;\n  color: $toast-header-color;\n  background-color: $toast-header-background-color;\n  background-clip: padding-box;\n  border-bottom: $toast-border-width solid $toast-header-border-color;\n  @include border-top-radius(subtract($toast-border-radius, $toast-border-width));\n}\n\n.toast-body {\n  padding: $toast-padding-x; // apply to both vertical and horizontal\n}\n","// .modal-open      - body class for killing the scroll\n// .modal           - container to scroll within\n// .modal-dialog    - positioning shell for the actual modal\n// .modal-content   - actual modal w/ bg and corners and stuff\n\n\n.modal-open {\n  // Kill the scroll on the body\n  overflow: hidden;\n\n  .modal {\n    overflow-x: hidden;\n    overflow-y: auto;\n  }\n}\n\n// Container that the modal scrolls within\n.modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex-modal;\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  // Prevent Chrome on Windows from adding a focus outline. For details, see\n  // https://github.com/twbs/bootstrap/pull/10951.\n  outline: 0;\n  // We deliberately don't use `-webkit-overflow-scrolling: touch;` due to a\n  // gnarly iOS Safari bug: https://bugs.webkit.org/show_bug.cgi?id=158342\n  // See also https://github.com/twbs/bootstrap/issues/17695\n}\n\n// Shell div to position the modal with bottom padding\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: $modal-dialog-margin;\n  // allow clicks to pass through for custom click handling to close modal\n  pointer-events: none;\n\n  // When fading in the modal, animate it to slide down\n  .modal.fade & {\n    @include transition($modal-transition);\n    transform: $modal-fade-transform;\n  }\n  .modal.show & {\n    transform: $modal-show-transform;\n  }\n\n  // When trying to close, animate focus to scale\n  .modal.modal-static & {\n    transform: $modal-scale-transform;\n  }\n}\n\n.modal-dialog-scrollable {\n  display: flex; // IE10/11\n  max-height: subtract(100%, $modal-dialog-margin * 2);\n\n  .modal-content {\n    max-height: subtract(100vh, $modal-dialog-margin * 2); // IE10/11\n    overflow: hidden;\n  }\n\n  .modal-header,\n  .modal-footer {\n    flex-shrink: 0;\n  }\n\n  .modal-body {\n    overflow-y: auto;\n  }\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: subtract(100%, $modal-dialog-margin * 2);\n\n  // Ensure `modal-dialog-centered` extends the full height of the view (IE10/11)\n  &::before {\n    display: block; // IE10\n    height: subtract(100vh, $modal-dialog-margin * 2);\n    height: min-content; // Reset height to 0 except on IE\n    content: \"\";\n  }\n\n  // Ensure `.modal-body` shows scrollbar (IE10/11)\n  &.modal-dialog-scrollable {\n    flex-direction: column;\n    justify-content: center;\n    height: 100%;\n\n    .modal-content {\n      max-height: none;\n    }\n\n    &::before {\n      content: none;\n    }\n  }\n}\n\n// Actual modal\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%; // Ensure `.modal-content` extends the full width of the parent `.modal-dialog`\n  // counteract the pointer-events: none; in the .modal-dialog\n  color: $modal-content-color;\n  pointer-events: auto;\n  background-color: $modal-content-bg;\n  background-clip: padding-box;\n  border: $modal-content-border-width solid $modal-content-border-color;\n  @include border-radius($modal-content-border-radius);\n  @include box-shadow($modal-content-box-shadow-xs);\n  // Remove focus outline from opened modal\n  outline: 0;\n}\n\n// Modal background\n.modal-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex-modal-backdrop;\n  width: 100vw;\n  height: 100vh;\n  background-color: $modal-backdrop-bg;\n\n  // Fade for backdrop\n  &.fade { opacity: 0; }\n  &.show { opacity: $modal-backdrop-opacity; }\n}\n\n// Modal header\n// Top section of the modal w/ title and dismiss\n.modal-header {\n  display: flex;\n  align-items: flex-start; // so the close btn always stays on the upper right corner\n  justify-content: space-between; // Put modal header elements (title and dismiss) on opposite ends\n  padding: $modal-header-padding;\n  border-bottom: $modal-header-border-width solid $modal-header-border-color;\n  @include border-top-radius($modal-content-inner-border-radius);\n\n  .close {\n    padding: $modal-header-padding;\n    // auto on the left force icon to the right even when there is no .modal-title\n    margin: (-$modal-header-padding-y) (-$modal-header-padding-x) (-$modal-header-padding-y) auto;\n  }\n}\n\n// Title text within header\n.modal-title {\n  margin-bottom: 0;\n  line-height: $modal-title-line-height;\n}\n\n// Modal body\n// Where all modal content resides (sibling of .modal-header and .modal-footer)\n.modal-body {\n  position: relative;\n  // Enable `flex-grow: 1` so that the body take up as much space as possible\n  // when there should be a fixed height on `.modal-dialog`.\n  flex: 1 1 auto;\n  padding: $modal-inner-padding;\n}\n\n// Footer (for actions)\n.modal-footer {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center; // vertically center\n  justify-content: flex-end; // Right align buttons with flex property because text-align doesn't work on flex items\n  padding: $modal-inner-padding - $modal-footer-margin-between * .5;\n  border-top: $modal-footer-border-width solid $modal-footer-border-color;\n  @include border-bottom-radius($modal-content-inner-border-radius);\n\n  // Place margin between footer elements\n  // This solution is far from ideal because of the universal selector usage,\n  // but is needed to fix https://github.com/twbs/bootstrap/issues/24800\n  > * {\n    margin: $modal-footer-margin-between * .5;\n  }\n}\n\n// Measure scrollbar width for padding body during modal show/hide\n.modal-scrollbar-measure {\n  position: absolute;\n  top: -9999px;\n  width: 50px;\n  height: 50px;\n  overflow: scroll;\n}\n\n// Scale up the modal\n@include media-breakpoint-up(sm) {\n  // Automatically set modal's width for larger viewports\n  .modal-dialog {\n    max-width: $modal-md;\n    margin: $modal-dialog-margin-y-sm-up auto;\n  }\n\n  .modal-dialog-scrollable {\n    max-height: subtract(100%, $modal-dialog-margin-y-sm-up * 2);\n\n    .modal-content {\n      max-height: subtract(100vh, $modal-dialog-margin-y-sm-up * 2);\n    }\n  }\n\n  .modal-dialog-centered {\n    min-height: subtract(100%, $modal-dialog-margin-y-sm-up * 2);\n\n    &::before {\n      height: subtract(100vh, $modal-dialog-margin-y-sm-up * 2);\n      height: min-content;\n    }\n  }\n\n  .modal-content {\n    @include box-shadow($modal-content-box-shadow-sm-up);\n  }\n\n  .modal-sm { max-width: $modal-sm; }\n}\n\n@include media-breakpoint-up(lg) {\n  .modal-lg,\n  .modal-xl {\n    max-width: $modal-lg;\n  }\n}\n\n@include media-breakpoint-up(xl) {\n  .modal-xl { max-width: $modal-xl; }\n}\n","// Base class\n.tooltip {\n  position: absolute;\n  z-index: $zindex-tooltip;\n  display: block;\n  margin: $tooltip-margin;\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size($tooltip-font-size);\n  // Allow breaking very long words so they don't overflow the tooltip's bounds\n  word-wrap: break-word;\n  opacity: 0;\n\n  &.show { opacity: $tooltip-opacity; }\n\n  .arrow {\n    position: absolute;\n    display: block;\n    width: $tooltip-arrow-width;\n    height: $tooltip-arrow-height;\n\n    &::before {\n      position: absolute;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-tooltip-top {\n  padding: $tooltip-arrow-height 0;\n\n  .arrow {\n    bottom: 0;\n\n    &::before {\n      top: 0;\n      border-width: $tooltip-arrow-height ($tooltip-arrow-width * .5) 0;\n      border-top-color: $tooltip-arrow-color;\n    }\n  }\n}\n\n.bs-tooltip-right {\n  padding: 0 $tooltip-arrow-height;\n\n  .arrow {\n    left: 0;\n    width: $tooltip-arrow-height;\n    height: $tooltip-arrow-width;\n\n    &::before {\n      right: 0;\n      border-width: ($tooltip-arrow-width * .5) $tooltip-arrow-height ($tooltip-arrow-width * .5) 0;\n      border-right-color: $tooltip-arrow-color;\n    }\n  }\n}\n\n.bs-tooltip-bottom {\n  padding: $tooltip-arrow-height 0;\n\n  .arrow {\n    top: 0;\n\n    &::before {\n      bottom: 0;\n      border-width: 0 ($tooltip-arrow-width * .5) $tooltip-arrow-height;\n      border-bottom-color: $tooltip-arrow-color;\n    }\n  }\n}\n\n.bs-tooltip-left {\n  padding: 0 $tooltip-arrow-height;\n\n  .arrow {\n    right: 0;\n    width: $tooltip-arrow-height;\n    height: $tooltip-arrow-width;\n\n    &::before {\n      left: 0;\n      border-width: ($tooltip-arrow-width * .5) 0 ($tooltip-arrow-width * .5) $tooltip-arrow-height;\n      border-left-color: $tooltip-arrow-color;\n    }\n  }\n}\n\n.bs-tooltip-auto {\n  &[x-placement^=\"top\"] {\n    @extend .bs-tooltip-top;\n  }\n  &[x-placement^=\"right\"] {\n    @extend .bs-tooltip-right;\n  }\n  &[x-placement^=\"bottom\"] {\n    @extend .bs-tooltip-bottom;\n  }\n  &[x-placement^=\"left\"] {\n    @extend .bs-tooltip-left;\n  }\n}\n\n// Wrapper for the tooltip content\n.tooltip-inner {\n  max-width: $tooltip-max-width;\n  padding: $tooltip-padding-y $tooltip-padding-x;\n  color: $tooltip-color;\n  text-align: center;\n  background-color: $tooltip-bg;\n  @include border-radius($tooltip-border-radius);\n}\n","@mixin reset-text() {\n  font-family: $font-family-base;\n  // We deliberately do NOT reset font-size or word-wrap.\n  font-style: normal;\n  font-weight: $font-weight-normal;\n  line-height: $line-height-base;\n  text-align: left; // Fallback for where `start` is not supported\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n}\n",".popover {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: $zindex-popover;\n  display: block;\n  max-width: $popover-max-width;\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size($popover-font-size);\n  // Allow breaking very long words so they don't overflow the popover's bounds\n  word-wrap: break-word;\n  background-color: $popover-bg;\n  background-clip: padding-box;\n  border: $popover-border-width solid $popover-border-color;\n  @include border-radius($popover-border-radius);\n  @include box-shadow($popover-box-shadow);\n\n  .arrow {\n    position: absolute;\n    display: block;\n    width: $popover-arrow-width;\n    height: $popover-arrow-height;\n    margin: 0 $popover-border-radius;\n\n    &::before,\n    &::after {\n      position: absolute;\n      display: block;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-popover-top {\n  margin-bottom: $popover-arrow-height;\n\n  > .arrow {\n    bottom: subtract(-$popover-arrow-height, $popover-border-width);\n\n    &::before {\n      bottom: 0;\n      border-width: $popover-arrow-height ($popover-arrow-width * .5) 0;\n      border-top-color: $popover-arrow-outer-color;\n    }\n\n    &::after {\n      bottom: $popover-border-width;\n      border-width: $popover-arrow-height ($popover-arrow-width * .5) 0;\n      border-top-color: $popover-arrow-color;\n    }\n  }\n}\n\n.bs-popover-right {\n  margin-left: $popover-arrow-height;\n\n  > .arrow {\n    left: subtract(-$popover-arrow-height, $popover-border-width);\n    width: $popover-arrow-height;\n    height: $popover-arrow-width;\n    margin: $popover-border-radius 0; // make sure the arrow does not touch the popover's rounded corners\n\n    &::before {\n      left: 0;\n      border-width: ($popover-arrow-width * .5) $popover-arrow-height ($popover-arrow-width * .5) 0;\n      border-right-color: $popover-arrow-outer-color;\n    }\n\n    &::after {\n      left: $popover-border-width;\n      border-width: ($popover-arrow-width * .5) $popover-arrow-height ($popover-arrow-width * .5) 0;\n      border-right-color: $popover-arrow-color;\n    }\n  }\n}\n\n.bs-popover-bottom {\n  margin-top: $popover-arrow-height;\n\n  > .arrow {\n    top: subtract(-$popover-arrow-height, $popover-border-width);\n\n    &::before {\n      top: 0;\n      border-width: 0 ($popover-arrow-width * .5) $popover-arrow-height ($popover-arrow-width * .5);\n      border-bottom-color: $popover-arrow-outer-color;\n    }\n\n    &::after {\n      top: $popover-border-width;\n      border-width: 0 ($popover-arrow-width * .5) $popover-arrow-height ($popover-arrow-width * .5);\n      border-bottom-color: $popover-arrow-color;\n    }\n  }\n\n  // This will remove the popover-header's border just below the arrow\n  .popover-header::before {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    display: block;\n    width: $popover-arrow-width;\n    margin-left: -$popover-arrow-width * .5;\n    content: \"\";\n    border-bottom: $popover-border-width solid $popover-header-bg;\n  }\n}\n\n.bs-popover-left {\n  margin-right: $popover-arrow-height;\n\n  > .arrow {\n    right: subtract(-$popover-arrow-height, $popover-border-width);\n    width: $popover-arrow-height;\n    height: $popover-arrow-width;\n    margin: $popover-border-radius 0; // make sure the arrow does not touch the popover's rounded corners\n\n    &::before {\n      right: 0;\n      border-width: ($popover-arrow-width * .5) 0 ($popover-arrow-width * .5) $popover-arrow-height;\n      border-left-color: $popover-arrow-outer-color;\n    }\n\n    &::after {\n      right: $popover-border-width;\n      border-width: ($popover-arrow-width * .5) 0 ($popover-arrow-width * .5) $popover-arrow-height;\n      border-left-color: $popover-arrow-color;\n    }\n  }\n}\n\n.bs-popover-auto {\n  &[x-placement^=\"top\"] {\n    @extend .bs-popover-top;\n  }\n  &[x-placement^=\"right\"] {\n    @extend .bs-popover-right;\n  }\n  &[x-placement^=\"bottom\"] {\n    @extend .bs-popover-bottom;\n  }\n  &[x-placement^=\"left\"] {\n    @extend .bs-popover-left;\n  }\n}\n\n\n// Offset the popover to account for the popover arrow\n.popover-header {\n  padding: $popover-header-padding-y $popover-header-padding-x;\n  margin-bottom: 0; // Reset the default from Reboot\n  @include font-size($font-size-base);\n  color: $popover-header-color;\n  background-color: $popover-header-bg;\n  border-bottom: $popover-border-width solid darken($popover-header-bg, 5%);\n  @include border-top-radius($popover-inner-border-radius);\n\n  &:empty {\n    display: none;\n  }\n}\n\n.popover-body {\n  padding: $popover-body-padding-y $popover-body-padding-x;\n  color: $popover-body-color;\n}\n","// Notes on the classes:\n//\n// 1. .carousel.pointer-event should ideally be pan-y (to allow for users to scroll vertically)\n//    even when their scroll action started on a carousel, but for compatibility (with Firefox)\n//    we're preventing all actions instead\n// 2. The .carousel-item-left and .carousel-item-right is used to indicate where\n//    the active slide is heading.\n// 3. .active.carousel-item is the current slide.\n// 4. .active.carousel-item-left and .active.carousel-item-right is the current\n//    slide in its in-transition state. Only one of these occurs at a time.\n// 5. .carousel-item-next.carousel-item-left and .carousel-item-prev.carousel-item-right\n//    is the upcoming slide in transition.\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  @include clearfix();\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  @include transition($carousel-transition);\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n.carousel-item-next:not(.carousel-item-left),\n.active.carousel-item-right {\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-right),\n.active.carousel-item-left {\n  transform: translateX(-100%);\n}\n\n\n//\n// Alternate transitions\n//\n\n.carousel-fade {\n  .carousel-item {\n    opacity: 0;\n    transition-property: opacity;\n    transform: none;\n  }\n\n  .carousel-item.active,\n  .carousel-item-next.carousel-item-left,\n  .carousel-item-prev.carousel-item-right {\n    z-index: 1;\n    opacity: 1;\n  }\n\n  .active.carousel-item-left,\n  .active.carousel-item-right {\n    z-index: 0;\n    opacity: 0;\n    @include transition(opacity 0s $carousel-transition-duration);\n  }\n}\n\n\n//\n// Left/right controls for nav\n//\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  // Use flex for alignment (1-3)\n  display: flex; // 1. allow flex styles\n  align-items: center; // 2. vertically center contents\n  justify-content: center; // 3. horizontally center contents\n  width: $carousel-control-width;\n  padding: 0;\n  color: $carousel-control-color;\n  text-align: center;\n  background: none;\n  border: 0;\n  opacity: $carousel-control-opacity;\n  @include transition($carousel-control-transition);\n\n  // Hover/focus state\n  @include hover-focus() {\n    color: $carousel-control-color;\n    text-decoration: none;\n    outline: 0;\n    opacity: $carousel-control-hover-opacity;\n  }\n}\n.carousel-control-prev {\n  left: 0;\n  @if $enable-gradients {\n    background-image: linear-gradient(90deg, rgba($black, .25), rgba($black, .001));\n  }\n}\n.carousel-control-next {\n  right: 0;\n  @if $enable-gradients {\n    background-image: linear-gradient(270deg, rgba($black, .25), rgba($black, .001));\n  }\n}\n\n// Icons for within\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: $carousel-control-icon-width;\n  height: $carousel-control-icon-width;\n  background: 50% / 100% 100% no-repeat;\n}\n.carousel-control-prev-icon {\n  background-image: escape-svg($carousel-control-prev-icon-bg);\n}\n.carousel-control-next-icon {\n  background-image: escape-svg($carousel-control-next-icon-bg);\n}\n\n\n// Optional indicator pips\n//\n// Add an ordered list with the following class and add a list item for each\n// slide your carousel holds.\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 15;\n  display: flex;\n  justify-content: center;\n  padding-left: 0; // override <ol> default\n  // Use the .carousel-control's width as margin so we don't overlay those\n  margin-right: $carousel-control-width;\n  margin-left: $carousel-control-width;\n  list-style: none;\n\n  li {\n    box-sizing: content-box;\n    flex: 0 1 auto;\n    width: $carousel-indicator-width;\n    height: $carousel-indicator-height;\n    margin-right: $carousel-indicator-spacer;\n    margin-left: $carousel-indicator-spacer;\n    text-indent: -999px;\n    cursor: pointer;\n    background-color: $carousel-indicator-active-bg;\n    background-clip: padding-box;\n    // Use transparent borders to increase the hit area by 10px on top and bottom.\n    border-top: $carousel-indicator-hit-area-height solid transparent;\n    border-bottom: $carousel-indicator-hit-area-height solid transparent;\n    opacity: .5;\n    @include transition($carousel-indicator-transition);\n  }\n\n  .active {\n    opacity: 1;\n  }\n}\n\n\n// Optional captions\n//\n//\n\n.carousel-caption {\n  position: absolute;\n  right: (100% - $carousel-caption-width) * .5;\n  bottom: 20px;\n  left: (100% - $carousel-caption-width) * .5;\n  z-index: 10;\n  padding-top: 20px;\n  padding-bottom: 20px;\n  color: $carousel-caption-color;\n  text-align: center;\n}\n","@mixin clearfix() {\n  &::after {\n    display: block;\n    clear: both;\n    content: \"\";\n  }\n}\n","//\n// Rotating border\n//\n\n@keyframes spinner-border {\n  to { transform: rotate(360deg); }\n}\n\n.spinner-border {\n  display: inline-block;\n  width: $spinner-width;\n  height: $spinner-height;\n  vertical-align: $spinner-vertical-align;\n  border: $spinner-border-width solid currentcolor;\n  border-right-color: transparent;\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 50%;\n  animation: .75s linear infinite spinner-border;\n}\n\n.spinner-border-sm {\n  width: $spinner-width-sm;\n  height: $spinner-height-sm;\n  border-width: $spinner-border-width-sm;\n}\n\n//\n// Growing circle\n//\n\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n\n.spinner-grow {\n  display: inline-block;\n  width: $spinner-width;\n  height: $spinner-height;\n  vertical-align: $spinner-vertical-align;\n  background-color: currentcolor;\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 50%;\n  opacity: 0;\n  animation: .75s linear infinite spinner-grow;\n}\n\n.spinner-grow-sm {\n  width: $spinner-width-sm;\n  height: $spinner-height-sm;\n}\n\n@if $enable-prefers-reduced-motion-media-query {\n  @media (prefers-reduced-motion: reduce) {\n    .spinner-border,\n    .spinner-grow {\n      animation-duration: 1.5s;\n    }\n  }\n}\n","// stylelint-disable declaration-no-important\n\n.align-baseline    { vertical-align: baseline !important; } // Browser default\n.align-top         { vertical-align: top !important; }\n.align-middle      { vertical-align: middle !important; }\n.align-bottom      { vertical-align: bottom !important; }\n.align-text-bottom { vertical-align: text-bottom !important; }\n.align-text-top    { vertical-align: text-top !important; }\n","// stylelint-disable declaration-no-important\n\n// Contextual backgrounds\n\n@mixin bg-variant($parent, $color, $ignore-warning: false) {\n  #{$parent} {\n    background-color: $color !important;\n  }\n  a#{$parent},\n  button#{$parent} {\n    @include hover-focus() {\n      background-color: darken($color, 10%) !important;\n    }\n  }\n  @include deprecate(\"The `bg-variant` mixin\", \"v4.4.0\", \"v5\", $ignore-warning);\n}\n\n@mixin bg-gradient-variant($parent, $color, $ignore-warning: false) {\n  #{$parent} {\n    background: $color linear-gradient(180deg, mix($body-bg, $color, 15%), $color) repeat-x !important;\n  }\n  @include deprecate(\"The `bg-gradient-variant` mixin\", \"v4.5.0\", \"v5\", $ignore-warning);\n}\n","// stylelint-disable declaration-no-important\n\n@each $color, $value in $theme-colors {\n  @include bg-variant(\".bg-#{$color}\", $value, true);\n}\n\n@if $enable-gradients {\n  @each $color, $value in $theme-colors {\n    @include bg-gradient-variant(\".bg-gradient-#{$color}\", $value, true);\n  }\n}\n\n.bg-white {\n  background-color: $white !important;\n}\n\n.bg-transparent {\n  background-color: transparent !important;\n}\n","// stylelint-disable property-disallowed-list, declaration-no-important\n\n//\n// Border\n//\n\n.border         { border: $border-width solid $border-color !important; }\n.border-top     { border-top: $border-width solid $border-color !important; }\n.border-right   { border-right: $border-width solid $border-color !important; }\n.border-bottom  { border-bottom: $border-width solid $border-color !important; }\n.border-left    { border-left: $border-width solid $border-color !important; }\n\n.border-0        { border: 0 !important; }\n.border-top-0    { border-top: 0 !important; }\n.border-right-0  { border-right: 0 !important; }\n.border-bottom-0 { border-bottom: 0 !important; }\n.border-left-0   { border-left: 0 !important; }\n\n@each $color, $value in $theme-colors {\n  .border-#{$color} {\n    border-color: $value !important;\n  }\n}\n\n.border-white {\n  border-color: $white !important;\n}\n\n//\n// Border-radius\n//\n\n.rounded-sm {\n  border-radius: $border-radius-sm !important;\n}\n\n.rounded {\n  border-radius: $border-radius !important;\n}\n\n.rounded-top {\n  border-top-left-radius: $border-radius !important;\n  border-top-right-radius: $border-radius !important;\n}\n\n.rounded-right {\n  border-top-right-radius: $border-radius !important;\n  border-bottom-right-radius: $border-radius !important;\n}\n\n.rounded-bottom {\n  border-bottom-right-radius: $border-radius !important;\n  border-bottom-left-radius: $border-radius !important;\n}\n\n.rounded-left {\n  border-top-left-radius: $border-radius !important;\n  border-bottom-left-radius: $border-radius !important;\n}\n\n.rounded-lg {\n  border-radius: $border-radius-lg !important;\n}\n\n.rounded-circle {\n  border-radius: 50% !important;\n}\n\n.rounded-pill {\n  border-radius: $rounded-pill !important;\n}\n\n.rounded-0 {\n  border-radius: 0 !important;\n}\n","// stylelint-disable declaration-no-important\n\n//\n// Utilities for common `display` values\n//\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    @each $value in $displays {\n      .d#{$infix}-#{$value} { display: $value !important; }\n    }\n  }\n}\n\n\n//\n// Utilities for toggling `display` in print\n//\n\n@media print {\n  @each $value in $displays {\n    .d-print-#{$value} { display: $value !important; }\n  }\n}\n","// Credit: Nicolas Gallagher and SUIT CSS.\n\n.embed-responsive {\n  position: relative;\n  display: block;\n  width: 100%;\n  padding: 0;\n  overflow: hidden;\n\n  &::before {\n    display: block;\n    content: \"\";\n  }\n\n  .embed-responsive-item,\n  iframe,\n  embed,\n  object,\n  video {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    border: 0;\n  }\n}\n\n@each $embed-responsive-aspect-ratio in $embed-responsive-aspect-ratios {\n  $embed-responsive-aspect-ratio-x: nth($embed-responsive-aspect-ratio, 1);\n  $embed-responsive-aspect-ratio-y: nth($embed-responsive-aspect-ratio, 2);\n\n  .embed-responsive-#{$embed-responsive-aspect-ratio-x}by#{$embed-responsive-aspect-ratio-y} {\n    &::before {\n      padding-top: percentage(divide($embed-responsive-aspect-ratio-y, $embed-responsive-aspect-ratio-x));\n    }\n  }\n}\n","// stylelint-disable declaration-no-important\n\n// Flex variation\n//\n// Custom styles for additional flex alignment options.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .flex#{$infix}-row            { flex-direction: row !important; }\n    .flex#{$infix}-column         { flex-direction: column !important; }\n    .flex#{$infix}-row-reverse    { flex-direction: row-reverse !important; }\n    .flex#{$infix}-column-reverse { flex-direction: column-reverse !important; }\n\n    .flex#{$infix}-wrap         { flex-wrap: wrap !important; }\n    .flex#{$infix}-nowrap       { flex-wrap: nowrap !important; }\n    .flex#{$infix}-wrap-reverse { flex-wrap: wrap-reverse !important; }\n    .flex#{$infix}-fill         { flex: 1 1 auto !important; }\n    .flex#{$infix}-grow-0       { flex-grow: 0 !important; }\n    .flex#{$infix}-grow-1       { flex-grow: 1 !important; }\n    .flex#{$infix}-shrink-0     { flex-shrink: 0 !important; }\n    .flex#{$infix}-shrink-1     { flex-shrink: 1 !important; }\n\n    .justify-content#{$infix}-start   { justify-content: flex-start !important; }\n    .justify-content#{$infix}-end     { justify-content: flex-end !important; }\n    .justify-content#{$infix}-center  { justify-content: center !important; }\n    .justify-content#{$infix}-between { justify-content: space-between !important; }\n    .justify-content#{$infix}-around  { justify-content: space-around !important; }\n\n    .align-items#{$infix}-start    { align-items: flex-start !important; }\n    .align-items#{$infix}-end      { align-items: flex-end !important; }\n    .align-items#{$infix}-center   { align-items: center !important; }\n    .align-items#{$infix}-baseline { align-items: baseline !important; }\n    .align-items#{$infix}-stretch  { align-items: stretch !important; }\n\n    .align-content#{$infix}-start   { align-content: flex-start !important; }\n    .align-content#{$infix}-end     { align-content: flex-end !important; }\n    .align-content#{$infix}-center  { align-content: center !important; }\n    .align-content#{$infix}-between { align-content: space-between !important; }\n    .align-content#{$infix}-around  { align-content: space-around !important; }\n    .align-content#{$infix}-stretch { align-content: stretch !important; }\n\n    .align-self#{$infix}-auto     { align-self: auto !important; }\n    .align-self#{$infix}-start    { align-self: flex-start !important; }\n    .align-self#{$infix}-end      { align-self: flex-end !important; }\n    .align-self#{$infix}-center   { align-self: center !important; }\n    .align-self#{$infix}-baseline { align-self: baseline !important; }\n    .align-self#{$infix}-stretch  { align-self: stretch !important; }\n  }\n}\n","// stylelint-disable declaration-no-important\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .float#{$infix}-left  { float: left !important; }\n    .float#{$infix}-right { float: right !important; }\n    .float#{$infix}-none  { float: none !important; }\n  }\n}\n","// stylelint-disable declaration-no-important\n\n@each $value in $user-selects {\n  .user-select-#{$value} { user-select: $value !important; }\n}\n","// stylelint-disable declaration-no-important\n\n@each $value in $overflows {\n  .overflow-#{$value} { overflow: $value !important; }\n}\n","// stylelint-disable declaration-no-important\n\n// Common values\n@each $position in $positions {\n  .position-#{$position} { position: $position !important; }\n}\n\n// Shorthand\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.sticky-top {\n  @supports (position: sticky) {\n    position: sticky;\n    top: 0;\n    z-index: $zindex-sticky;\n  }\n}\n","//\n// Screenreaders\n//\n\n.sr-only {\n  @include sr-only();\n}\n\n.sr-only-focusable {\n  @include sr-only-focusable();\n}\n","// Only display content to screen readers\n//\n// See: https://www.a11yproject.com/posts/2013-01-11-how-to-hide-content/\n// See: https://kittygiraudel.com/2016/10/13/css-hide-and-seek/\n\n@mixin sr-only() {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px; // Fix for https://github.com/twbs/bootstrap/issues/25686\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n// Use in conjunction with .sr-only to only display content when it's focused.\n//\n// Useful for \"Skip to main content\" links; see https://www.w3.org/TR/2013/NOTE-WCAG20-TECHS-20130905/G1\n//\n// Credit: HTML5 Boilerplate\n\n@mixin sr-only-focusable() {\n  &:active,\n  &:focus {\n    position: static;\n    width: auto;\n    height: auto;\n    overflow: visible;\n    clip: auto;\n    white-space: normal;\n  }\n}\n","// stylelint-disable declaration-no-important\n\n.shadow-sm { box-shadow: $box-shadow-sm !important; }\n.shadow { box-shadow: $box-shadow !important; }\n.shadow-lg { box-shadow: $box-shadow-lg !important; }\n.shadow-none { box-shadow: none !important; }\n","// stylelint-disable declaration-no-important\n\n// Width and height\n\n@each $prop, $abbrev in (width: w, height: h) {\n  @each $size, $length in $sizes {\n    .#{$abbrev}-#{$size} { #{$prop}: $length !important; }\n  }\n}\n\n.mw-100 { max-width: 100% !important; }\n.mh-100 { max-height: 100% !important; }\n\n// Viewport additional helpers\n\n.min-vw-100 { min-width: 100vw !important; }\n.min-vh-100 { min-height: 100vh !important; }\n\n.vw-100 { width: 100vw !important; }\n.vh-100 { height: 100vh !important; }\n","// stylelint-disable declaration-no-important\n\n// Margin and Padding\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    @each $prop, $abbrev in (margin: m, padding: p) {\n      @each $size, $length in $spacers {\n        .#{$abbrev}#{$infix}-#{$size} { #{$prop}: $length !important; }\n        .#{$abbrev}t#{$infix}-#{$size},\n        .#{$abbrev}y#{$infix}-#{$size} {\n          #{$prop}-top: $length !important;\n        }\n        .#{$abbrev}r#{$infix}-#{$size},\n        .#{$abbrev}x#{$infix}-#{$size} {\n          #{$prop}-right: $length !important;\n        }\n        .#{$abbrev}b#{$infix}-#{$size},\n        .#{$abbrev}y#{$infix}-#{$size} {\n          #{$prop}-bottom: $length !important;\n        }\n        .#{$abbrev}l#{$infix}-#{$size},\n        .#{$abbrev}x#{$infix}-#{$size} {\n          #{$prop}-left: $length !important;\n        }\n      }\n    }\n\n    // Negative margins (e.g., where `.mb-n1` is negative version of `.mb-1`)\n    @each $size, $length in $spacers {\n      @if \"#{$size}\" != \"0\" {\n        .m#{$infix}-n#{$size} { margin: -$length !important; }\n        .mt#{$infix}-n#{$size},\n        .my#{$infix}-n#{$size} {\n          margin-top: -$length !important;\n        }\n        .mr#{$infix}-n#{$size},\n        .mx#{$infix}-n#{$size} {\n          margin-right: -$length !important;\n        }\n        .mb#{$infix}-n#{$size},\n        .my#{$infix}-n#{$size} {\n          margin-bottom: -$length !important;\n        }\n        .ml#{$infix}-n#{$size},\n        .mx#{$infix}-n#{$size} {\n          margin-left: -$length !important;\n        }\n      }\n    }\n\n    // Some special margin utils\n    .m#{$infix}-auto { margin: auto !important; }\n    .mt#{$infix}-auto,\n    .my#{$infix}-auto {\n      margin-top: auto !important;\n    }\n    .mr#{$infix}-auto,\n    .mx#{$infix}-auto {\n      margin-right: auto !important;\n    }\n    .mb#{$infix}-auto,\n    .my#{$infix}-auto {\n      margin-bottom: auto !important;\n    }\n    .ml#{$infix}-auto,\n    .mx#{$infix}-auto {\n      margin-left: auto !important;\n    }\n  }\n}\n","//\n// Stretched link\n//\n\n.stretched-link {\n  &::after {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 1;\n    // Just in case `pointer-events: none` is set on a parent\n    pointer-events: auto;\n    content: \"\";\n    // IE10 bugfix, see https://stackoverflow.com/questions/16947967/ie10-hover-pseudo-class-doesnt-work-without-background-color\n    background-color: rgba(0, 0, 0, 0);\n  }\n}\n","// stylelint-disable declaration-no-important\n\n//\n// Text\n//\n\n.text-monospace { font-family: $font-family-monospace !important; }\n\n// Alignment\n\n.text-justify  { text-align: justify !important; }\n.text-wrap     { white-space: normal !important; }\n.text-nowrap   { white-space: nowrap !important; }\n.text-truncate { @include text-truncate(); }\n\n// Responsive alignment\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .text#{$infix}-left   { text-align: left !important; }\n    .text#{$infix}-right  { text-align: right !important; }\n    .text#{$infix}-center { text-align: center !important; }\n  }\n}\n\n// Transformation\n\n.text-lowercase  { text-transform: lowercase !important; }\n.text-uppercase  { text-transform: uppercase !important; }\n.text-capitalize { text-transform: capitalize !important; }\n\n// Weight and italics\n\n.font-weight-light   { font-weight: $font-weight-light !important; }\n.font-weight-lighter { font-weight: $font-weight-lighter !important; }\n.font-weight-normal  { font-weight: $font-weight-normal !important; }\n.font-weight-bold    { font-weight: $font-weight-bold !important; }\n.font-weight-bolder  { font-weight: $font-weight-bolder !important; }\n.font-italic         { font-style: italic !important; }\n\n// Contextual colors\n\n.text-white { color: $white !important; }\n\n@each $color, $value in $theme-colors {\n  @include text-emphasis-variant(\".text-#{$color}\", $value, true);\n}\n\n.text-body { color: $body-color !important; }\n.text-muted { color: $text-muted !important; }\n\n.text-black-50 { color: rgba($black, .5) !important; }\n.text-white-50 { color: rgba($white, .5) !important; }\n\n// Misc\n\n.text-hide {\n  @include text-hide($ignore-warning: true);\n}\n\n.text-decoration-none { text-decoration: none !important; }\n\n.text-break {\n  word-break: break-word !important; // Deprecated, but avoids issues with flex containers\n  word-wrap: break-word !important; // Used instead of `overflow-wrap` for IE & Edge Legacy\n}\n\n// Reset\n\n.text-reset { color: inherit !important; }\n","// Text truncate\n// Requires inline-block or block for proper styling\n\n@mixin text-truncate() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n","// stylelint-disable declaration-no-important\n\n// Typography\n\n@mixin text-emphasis-variant($parent, $color, $ignore-warning: false) {\n  #{$parent} {\n    color: $color !important;\n  }\n  @if $emphasized-link-hover-darken-percentage != 0 {\n    a#{$parent} {\n      @include hover-focus() {\n        color: darken($color, $emphasized-link-hover-darken-percentage) !important;\n      }\n    }\n  }\n  @include deprecate(\"`text-emphasis-variant()`\", \"v4.4.0\", \"v5\", $ignore-warning);\n}\n","// CSS image replacement\n@mixin text-hide($ignore-warning: false) {\n  // stylelint-disable-next-line font-family-no-missing-generic-family-keyword\n  font: 0/0 a;\n  color: transparent;\n  text-shadow: none;\n  background-color: transparent;\n  border: 0;\n\n  @include deprecate(\"`text-hide()`\", \"v4.1.0\", \"v5\", $ignore-warning);\n}\n","// stylelint-disable declaration-no-important\n\n//\n// Visibility utilities\n//\n\n.visible {\n  visibility: visible !important;\n}\n\n.invisible {\n  visibility: hidden !important;\n}\n","// stylelint-disable declaration-no-important, selector-no-qualifying-type\n\n// Source: https://github.com/h5bp/main.css/blob/master/src/_print.css\n\n// ==========================================================================\n// Print styles.\n// Inlined to avoid the additional HTTP request:\n// https://www.phpied.com/delay-loading-your-print-css/\n// ==========================================================================\n\n@if $enable-print-styles {\n  @media print {\n    *,\n    *::before,\n    *::after {\n      // Bootstrap specific; comment out `color` and `background`\n      //color: $black !important; // Black prints faster\n      text-shadow: none !important;\n      //background: transparent !important;\n      box-shadow: none !important;\n    }\n\n    a {\n      &:not(.btn) {\n        text-decoration: underline;\n      }\n    }\n\n    // Bootstrap specific; comment the following selector out\n    //a[href]::after {\n    //  content: \" (\" attr(href) \")\";\n    //}\n\n    abbr[title]::after {\n      content: \" (\" attr(title) \")\";\n    }\n\n    // Bootstrap specific; comment the following selector out\n    //\n    // Don't show links that are fragment identifiers,\n    // or use the `javascript:` pseudo protocol\n    //\n\n    //a[href^=\"#\"]::after,\n    //a[href^=\"javascript:\"]::after {\n    // content: \"\";\n    //}\n\n    pre {\n      white-space: pre-wrap !important;\n    }\n    pre,\n    blockquote {\n      border: $border-width solid $gray-500; // Bootstrap custom code; using `$border-width` instead of 1px\n      page-break-inside: avoid;\n    }\n\n    tr,\n    img {\n      page-break-inside: avoid;\n    }\n\n    p,\n    h2,\n    h3 {\n      orphans: 3;\n      widows: 3;\n    }\n\n    h2,\n    h3 {\n      page-break-after: avoid;\n    }\n\n    // Bootstrap specific changes start\n\n    // Specify a size and min-width to make printing closer across browsers.\n    // We don't set margin here because it breaks `size` in Chrome. We also\n    // don't use `!important` on `size` as it breaks in Chrome.\n    @page {\n      size: $print-page-size;\n    }\n    body {\n      min-width: $print-body-min-width !important;\n    }\n    .container {\n      min-width: $print-body-min-width !important;\n    }\n\n    // Bootstrap components\n    .navbar {\n      display: none;\n    }\n    .badge {\n      border: $border-width solid $black;\n    }\n\n    .table {\n      border-collapse: collapse !important;\n\n      td,\n      th {\n        background-color: $white !important;\n      }\n    }\n\n    .table-bordered {\n      th,\n      td {\n        border: 1px solid $gray-300 !important;\n      }\n    }\n\n    .table-dark {\n      color: inherit;\n\n      th,\n      td,\n      thead th,\n      tbody + tbody {\n        border-color: $table-border-color;\n      }\n    }\n\n    .table .thead-dark th {\n      color: inherit;\n      border-color: $table-border-color;\n    }\n\n    // Bootstrap specific changes end\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
